import { _ as useViewModel, a as ReportViewer_default, c as useUIPermitter, d as RouteInfo, f as Router, g as provideViewModel, h as _plugin_vue_export_helper_default, i as useNotificationRegistryFactory, l as provideEventManager, m as useApplicationContext, n as useCustomViewManager, o as WebView_default, p as provideApplicationContext, r as provideNotificationRegistryFactory, s as provideUIPermitter, t as provideCustomViewManager, u as useEventManager, v as viewModelKey } from "./useCustomViewManager-B2Yw4NwO.js";
import { AiSuggestionIndicator, Avatar, Badge, Badge as Badge$1, BooleanCombobox, BooleanCombobox as BooleanCombobox$1, Button, Button as Button$1, ButtonsLayout, ButtonsLayout as ButtonsLayout$1, Card, Card as Card$1, Carousel, Chart, Checkbox, Chip, Chip as Chip$1, CollectionViewGroup, Combobox, ContextMenu, DataType, Datagrid, DatagridCollectionChangedEventArgs, DatagridCollectionView, DatagridNoDataOverlay, Divider, Divider as Divider$1, DocumentationButton, DocumentationButton as DocumentationButton$1, Dropdown, DropdownMenu, DropdownMenuItem, DynamicCheckbox, DynamicCheckbox as DynamicCheckbox$1, DynamicCombobox, DynamicCombobox as DynamicCombobox$1, GridLayout, GroupBox, Heading, HorizontalLayout, HorizontalLayout as HorizontalLayout$1, HtmlViewer, Image as Image$1, Image as Image$2, InputColor, InputColor as InputColor$1, InputDate, InputDate as InputDate$1, InputDateTime, InputDateTime as InputDateTime$1, InputLabel, InputLocalizableString, InputLocalizableString as InputLocalizableString$1, InputMask, InputMask as InputMask$1, InputMessage, InputNumber, InputNumber as InputNumber$1, InputNumberCalculable, InputNumberCalculable as InputNumberCalculable$1, InputPassword, InputPassword as InputPassword$1, InputSliderDiscrete, InputSliderDiscrete as InputSliderDiscrete$1, InputTime, InputTime as InputTime$1, ListBox, LoadDataOnScroll, LoadDataOnScroll as LoadDataOnScroll$1, LoadingOverlay, LottieImage, MarkdownViewer, Message, Message as Message$1, Modal, Modal as Modal$1, MultiSelect, MultiSelect as MultiSelect$1, NeosAutomation, NeosGrid, NeosLayout, NeosStyle, NeosTooltip, NotifyCollectionChangedAction, ObservableArray, PaginationBar, Popover, PopoverWithTarget, PrimeDatePicker, ProgressBar, ProgressIndicator, PropertyGroupDescription, ResponsiveDatagridWrapper, SelectableListHeader, SortDescription, SpaceValues, Spinner, Spinner as Spinner$1, Splitter, SplitterPanel, Switch, TabItem, Tabs, Text as Text$1, Text as Text$2, Textbox, Textbox as Textbox$1, Timeline, Toast, TreeView, VerticalLayout, VerticalLayout as VerticalLayout$1, VirtualRepeat, VirtualRepeat as VirtualRepeat$1, ZIndex, configureWijmo, convertTextAlignToAlignItems, focusExceptOnTouchDevice, focusableElementEmits, focusableElementProps, hideAllPopovers, inputEmits, inputProps, isAutomationMode, isDropdownActive, isTouchDevice, plugin, provideGlobalResourceManager, provideImages, provideLocalizator, provideThemeManager, setAutomationMode, setLayoutOverflowFixOption, textPropsDefaults, triggerChangeOnActiveInput, useButtonContainerSpace, useComponentAutomationProperties, useGlobalResourceManager, useInput, useLocalizator, useModal, usePressEvents, usePreventPopoverHide, useThemeManager, useToast, useUILocale } from "@neos/design-system";
import { ApplicationContext, ContentAlign, CustomViewManager, ExpressionSort, FetchApiClient, FetchError, FileReference, FileUploadState, Filter, FilterComponent, FilterCondition, FilterLogicalOperator, FilterOperation, FilterOperator, FilterValue, Frame, FrameDisplayMode, GroupingExecutionSide, ListChangedType, ListLoadingState, LookupSearchMode, LookupTemplateMode, MenuItem, Model, NavigationOptions, NavigationParameters, NavigationResult, NavigationResultState, NavigationTarget, NotificationConnection, ObservableList, PropertyLoadState, ReactiveDevice, ReferenceRetrievingTrigger, RelationType, Reporting, ServerGroup, Sort, SortDirection, StyleRuleContentDisplayMode, ToggleOverlayOptions, UIPermitter, ValidationMessage, ValidationRuleSeverityLevel, ValidationRuleValidationTypes, ViewModelActionDisplayMode, ViewModelActionLocation, ViewModelActionType, ViewModelEntityViewParameter, ViewModelError, ViewModelMessageButton, ViewModelMessageButtonType, ViewModelMessageType, ViewModelPropertyBase, ViewModelStandardAction, ViewModelToastButton, allOperators, collectParameterViolations, collectPropertyViolations, evaluateFilterValidationRules, findUIPermitter, formatValue, formatValues, getApiClient, getApiClientBaseUrl, getConditionForValidation, getGlobalLocalStorage, getGlobalSearchFunction, getLookupDisplayProperty, getLookupEditingUIViewId, getLookupPropertyFilter, getLookupPropertyPath, getLookupSearchFilter, getLookupSearchProperty, getThemeForVsCode, groupFilterViolations, hasReactivity, initMonacoForVsCodeAsync, initVsCodeOptions, isArrayFilterOperator, isEnumMember, isFilterOperatorOnLookupValueProperty, isInputValueWithWildcards, isLookupContainsSearchActive, isStandardFilterOperator, navigate, provideForVsCode, recursiveFindMenuItem, registerApiClient, registerApplicationContext, registerUIPermitter, reportEvents, runWithEvent, setReactivity, uiViewEvents } from "@neos/core";
import { Comment, Fragment, Teleport, Text as Text$3, Transition, computed, createApp as createApp$1, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineAsyncComponent, defineComponent, getCurrentInstance, guardReactiveProps, h, inject, isRef, markRaw, mergeDefaults, mergeModels, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, onBeforeMount, onBeforeUnmount, onErrorCaptured, onMounted, onScopeDispose, onUnmounted, openBlock, provide, ref, render, renderList, renderSlot, resolveComponent, resolveDynamicComponent, shallowRef, toDisplayString, toHandlers, toRaw, toRef, toRefs, unref, useAttrs, useId, useModel, useSlots, useTemplateRef, vModelCheckbox, vModelRadio, vShow, watch, watchEffect, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import { onClickOutside, reactiveComputed, useCurrentElement, useElementBounding, useEventListener, useMediaQuery, useMouse, useVModel, useWindowFocus, watchDebounced, watchTriggerable } from "@vueuse/core";
import { ConsoleLogger, DataType as DataType$1, EventManager, InvariantDateTime, Localizator, OpenModeType, PopupPosition, PopupSize, ResourceManager, ShortcutTrigger, StringComparison, ThemeManager, compareArray, createGuid, createRegistry, dateOnlyToDateTime, dateTimeToDateOnly, defaultFormatDateOnly, defaultFormatDateTime, equals, escapeHtml, escapeRegExp, findLastIndex, getApplicationInsights, getBaseUrl, getDataTypeIcon, getGlobalResourceManager, getPropertyByPath, initializeApplicationInsights, initializeDefaultLocale, isDateDataType, isEnumDataType, isEquivalentValues, moveElementFirst, postMessageToVsCode, registerEventManager, registerGlobalResourceManager, registerLocalizator, registerThemeManager, remove, setTimeOfDay, stringFormat, stripLastUrlSegment } from "@neos/shared";
import { LRUCache } from "lru-cache";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
//#region src/utils/viewModelActionDropdown.ts
function getActionDropdownItems(viewModel, actions, item, items, execute, isVisible) {
	const dropdownItems = [];
	for (const action of actions) {
		if (action.beginGroup) addSeparator(dropdownItems);
		if (!isActionVisible(viewModel, item, items, isVisible, action)) continue;
		const dropdownSubItems = getActionDropdownItems(viewModel, viewModel.actions.filterByLocation(ViewModelActionLocation.childOf, action.name), item, items, execute, isVisible);
		const printSettings = action.printSettings && Reporting.canNavigateToPrintSettings(viewModel.uiPermitter) ? action.printSettings : void 0;
		const hasDropdownSubItems = dropdownSubItems.length > 0;
		dropdownItems.push({
			label: action.caption,
			sublabel: action.keyboardShortcut,
			icon: action.iconName,
			badge: action.getBadge(item, items),
			badgeSeverity: action.badgeSeverity,
			disabled: action.isDisabled(item, items),
			attributes: {
				title: getActionTooltip(action),
				"data-action-name": action.name,
				"data-standard-action": action.isStandardAction
			},
			printSettings,
			items: hasDropdownSubItems ? dropdownSubItems : void 0,
			command: hasDropdownSubItems ? void 0 : (event) => execute(action, event.originalEvent)
		});
	}
	removeLastSeparator(dropdownItems);
	setFallbackIcon(dropdownItems);
	return dropdownItems;
}
function addSeparator(dropdownItems) {
	const lastDropdownItem = dropdownItems[dropdownItems.length - 1];
	if (lastDropdownItem && !lastDropdownItem.separator) dropdownItems.push({ separator: true });
}
function removeLastSeparator(dropdownItems) {
	if (dropdownItems[dropdownItems.length - 1]?.separator) dropdownItems.pop();
}
function setFallbackIcon(dropdownItems) {
	if (dropdownItems.some((i) => i.icon)) for (const dropdownItem of dropdownItems) dropdownItem.icon ??= "empty";
}
function isActionVisible(viewModel, item, items, isVisible, action) {
	return (!isVisible || isVisible(action)) && viewModel.canExecuteAction(action) && action.getVisible(item, items);
}
function getActionTooltip(action, tooltip) {
	let description = tooltip ?? action.description;
	const keyboardShortcut = action.keyboardShortcut;
	if (keyboardShortcut) description += ` (${keyboardShortcut})`;
	return description;
}
//#endregion
//#region src/utils/viewModelCurrentItem.ts
/**
* Updates the current item in the view model if necessary.
* @param item The item to set as the current item.
*/
async function updateCurrentItem(item) {
	if (item?.$viewModel == null || item === item.$viewModel.current) return;
	if (item.$selected) await item.$viewModel.requestChangingPositionAsync(item.$viewModel.datasource.indexOf(item));
	else await item.$viewModel.setCurrentAndSelectAsync(item);
}
//#endregion
//#region src/components/Buttons/ActionButton/ActionButton.ts?vue&type=script&src=true&lang.ts
var commonBaseButtonElementProps = {
	tooltip: {
		type: String,
		default: void 0
	},
	contentAlign: {
		type: String,
		default: "start"
	}
};
function hasRenderedContent(nodes) {
	return nodes.some((node) => {
		if (node.type === Comment) return false;
		if (node.type === Fragment) return hasRenderedContent(node.children);
		return true;
	});
}
function slotHasVisibleText(nodes) {
	return nodes.some((node) => {
		if (node.type === Text$3 || node.type === Text$2) return true;
		if (typeof node.children === "string") return node.children.trim().length > 0;
		if (Array.isArray(node.children)) return slotHasVisibleText(node.children);
		return false;
	});
}
var ActionButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ActionButton",
	components: {
		Badge: Badge$1,
		Button: Button$1,
		DropdownMenu,
		DropdownMenuItem,
		Image: Image$2,
		Text: Text$2
	},
	props: {
		action: {
			type: Object,
			default: void 0
		},
		actionName: {
			type: String,
			default: void 0
		},
		item: {
			type: Object,
			default: void 0
		},
		ignoreSelectedItems: {
			type: Boolean,
			default: false
		},
		add: {
			type: Boolean,
			default: true
		},
		clone: {
			type: Boolean,
			default: true
		},
		dataExport: {
			type: Boolean,
			default: false
		},
		remove: {
			type: Boolean,
			default: true
		},
		...focusableElementProps,
		...commonBaseButtonElementProps,
		size: {
			type: String,
			default: void 0
		},
		animated: {
			type: Boolean,
			default: true
		},
		variant: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		label: {
			type: String,
			default: void 0
		},
		badge: {
			type: String,
			default: void 0
		},
		badgeSeverity: {
			type: String,
			default: void 0
		}
	},
	emits: [...focusableElementEmits],
	setup(props, { emit }) {
		const root = ref();
		const slots = useSlots();
		const slotNodes = computed(() => slots.default?.() ?? []);
		const hasContent = computed(() => hasRenderedContent(slotNodes.value));
		const hasVisibleText = computed(() => slotHasVisibleText(slotNodes.value));
		const { translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		const currentAction = computed(() => props.actionName ? viewModel.getAction(props.actionName) : props.action);
		const currentItem = computed(() => props.item ?? viewModel.current);
		const currentItems = computed(() => {
			if (props.ignoreSelectedItems) return currentItem.value ? [currentItem.value] : [];
			return viewModel.selectedItems;
		});
		const actionSize = computed(() => props.size ?? currentAction.value.size);
		const actionShowsLabel = computed(() => currentAction.value.displayMode !== ViewModelActionDisplayMode.icon);
		const actionShowsIcon = computed(() => currentAction.value.iconName !== void 0 && currentAction.value.displayMode !== ViewModelActionDisplayMode.text);
		const resolvedLabel = computed(() => props.label ?? (actionShowsLabel.value ? currentAction.value.caption : void 0));
		const resolvedIcon = computed(() => props.icon ?? (actionShowsIcon.value ? currentAction.value.iconName : void 0));
		const buttonLabel = computed(() => hasContent.value ? void 0 : resolvedLabel.value);
		const buttonIcon = computed(() => hasContent.value ? void 0 : resolvedIcon.value);
		const accessibleLabel = computed(() => props.label ?? currentAction.value.caption);
		const ariaLabel = computed(() => {
			if (!hasContent.value) return buttonLabel.value ?? accessibleLabel.value;
			return hasVisibleText.value ? props.label : accessibleLabel.value;
		});
		const showLabel = computed(() => buttonLabel.value !== void 0);
		const showIcon = computed(() => buttonIcon.value !== void 0);
		const buttonVariant = computed(() => props.variant ?? currentAction.value.style);
		const buttonTooltip = computed(() => getActionTooltip(currentAction.value, props.tooltip));
		const visible = computed(() => isActionVisible(currentAction.value));
		const disabled = computed(() => isActionDisabled(currentAction.value));
		const loading = ref(false);
		const focused = useVModel(props, "focused", emit);
		const buttonBadge = computed(() => props.badge ?? currentAction.value.getBadge(currentItem.value, currentItems.value));
		const buttonBadgeSeverity = computed(() => props.badgeSeverity ?? currentAction.value.badgeSeverity);
		const dividerStyle = computed(() => ({ backgroundColor: disabled.value ? `var(--button-${buttonVariant.value}-disabled-border)` : `var(--button-${buttonVariant.value}-border)` }));
		const isDropdownButton = computed(() => currentAction.value.actionType === ViewModelActionType.none);
		const isSplitButton = computed(() => !isDropdownButton.value && dropdownItems.value.length > 0);
		const dropdownMenu = ref();
		const dropdownItems = computed(() => {
			const subActions = viewModel.actions.filterByLocation(ViewModelActionLocation.childOf, currentAction.value.name);
			return getActionDropdownItems(viewModel, subActions, currentItem.value, currentItems.value, (action, event) => {
				dropdownMenu.value.hide();
				runAction(action, event);
			}, isActionVisibleWithProps);
		});
		function isActionVisibleWithProps(action) {
			if (!props.add && action.name === ViewModelStandardAction.add) return false;
			if (!props.clone && action.name === ViewModelStandardAction.clone) return false;
			if (!props.dataExport && action.name === ViewModelStandardAction.export) return false;
			if (!props.remove && action.name === ViewModelStandardAction.remove) return false;
			return true;
		}
		function isActionVisible(action) {
			if (!isActionVisibleWithProps(action)) return false;
			if (isDropdownButton.value && dropdownItems.value.length === 0) return false;
			return viewModel.canExecuteAction(action) && action.getVisible(currentItem.value, currentItems.value);
		}
		function isActionDisabled(action) {
			return action.isDisabled(currentItem.value, currentItems.value);
		}
		async function handleClick(action, event) {
			await updateCurrentItem(props.item);
			if (isDropdownButton.value) dropdownMenu.value.toggle(event);
			else await runAction(action, event);
		}
		async function runAction(action, event) {
			try {
				loading.value = true;
				await action.run(currentItem.value, currentItems.value, event);
			} finally {
				loading.value = false;
			}
		}
		function handleSplitButtonClick() {
			dropdownMenu.value.toggle({ currentTarget: root.value });
		}
		function handlePrintSettingsButtonClick(printSettings) {
			navigate(viewModel.eventManager, Reporting.getPrintSettingsNavigationOptions(printSettings));
		}
		useComponentAutomationProperties(root, currentAction.value.isStandardAction ? `${currentAction.value.name}Button` : void 0);
		return {
			actionSize,
			ariaLabel,
			buttonBadge,
			buttonBadgeSeverity,
			buttonIcon,
			buttonLabel,
			buttonTooltip,
			buttonVariant,
			currentAction,
			currentItem,
			disabled,
			dividerStyle,
			dropdownItems,
			dropdownMenu,
			focused,
			handleClick,
			handlePrintSettingsButtonClick,
			handleSplitButtonClick,
			hasContent,
			isDropdownButton,
			isSplitButton,
			loading,
			root,
			showIcon,
			showLabel,
			translate,
			visible
		};
	}
});
//#endregion
//#region src/components/Buttons/ActionButton/ActionButton.vue
var _hoisted_1$22 = ["data-standard-action", "data-action-name"];
function _sfc_render$25(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Badge = resolveComponent("Badge");
	const _component_Text = resolveComponent("Text");
	const _component_Button = resolveComponent("Button");
	const _component_DropdownMenuItem = resolveComponent("DropdownMenuItem");
	const _component_DropdownMenu = resolveComponent("DropdownMenu");
	return _ctx.visible ? (openBlock(), createElementBlock("div", {
		key: 0,
		ref: "root",
		class: "action-button",
		"data-standard-action": _ctx.currentAction.isStandardAction,
		"data-action-name": _ctx.currentAction.name
	}, [
		createVNode(_component_Button, {
			focused: _ctx.focused,
			"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => _ctx.focused = $event),
			variant: _ctx.buttonVariant,
			size: _ctx.actionSize,
			label: _ctx.buttonLabel,
			"aria-label": _ctx.ariaLabel,
			icon: _ctx.buttonIcon,
			tooltip: _ctx.buttonTooltip,
			"content-align": _ctx.contentAlign,
			autofocus: _ctx.autofocus,
			loading: _ctx.loading,
			disabled: _ctx.disabled,
			badge: _ctx.buttonBadge,
			"badge-severity": _ctx.buttonBadgeSeverity,
			animated: _ctx.animated,
			class: normalizeClass(["action-button-base", { "split-action-button": _ctx.isSplitButton }]),
			onClick: _cache[1] || (_cache[1] = (e) => _ctx.handleClick(_ctx.currentAction, e))
		}, {
			default: withCtx(() => [_ctx.hasContent ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [renderSlot(_ctx.$slots, "default", {}, void 0, true), _ctx.isDropdownButton ? (openBlock(), createBlock(_component_Image, {
				key: 0,
				name: "chevronDown",
				size: _ctx.actionSize
			}, null, 8, ["size"])) : createCommentVNode("", true)], 64)) : _ctx.isDropdownButton ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
				_ctx.showIcon ? (openBlock(), createBlock(_component_Image, {
					key: 0,
					name: _ctx.buttonIcon,
					size: _ctx.actionSize
				}, null, 8, ["name", "size"])) : createCommentVNode("", true),
				_ctx.buttonBadge && !_ctx.showLabel ? (openBlock(), createBlock(_component_Badge, {
					key: 1,
					value: _ctx.buttonBadge,
					severity: _ctx.buttonBadgeSeverity
				}, null, 8, ["value", "severity"])) : createCommentVNode("", true),
				_ctx.showLabel ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
					createVNode(_component_Text, { class: "action-dropdown-button-label" }, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.buttonLabel), 1)]),
						_: 1
					}),
					_ctx.buttonBadge ? (openBlock(), createBlock(_component_Badge, {
						key: 0,
						value: _ctx.buttonBadge,
						severity: _ctx.buttonBadgeSeverity
					}, null, 8, ["value", "severity"])) : createCommentVNode("", true),
					createVNode(_component_Image, {
						name: "chevronDown",
						size: _ctx.actionSize
					}, null, 8, ["size"])
				], 64)) : createCommentVNode("", true)
			], 64)) : createCommentVNode("", true)]),
			_: 3
		}, 8, [
			"focused",
			"variant",
			"size",
			"label",
			"aria-label",
			"icon",
			"tooltip",
			"content-align",
			"autofocus",
			"loading",
			"disabled",
			"badge",
			"badge-severity",
			"animated",
			"class"
		]),
		_ctx.isSplitButton ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
			class: "split-button-divider",
			style: normalizeStyle(_ctx.dividerStyle)
		}, null, 4), createVNode(_component_Button, {
			variant: _ctx.buttonVariant,
			size: _ctx.actionSize,
			icon: "chevronDown",
			loading: _ctx.currentAction.inProgress,
			disabled: _ctx.disabled,
			animated: _ctx.animated,
			class: "split-button",
			onClick: _cache[2] || (_cache[2] = ($event) => _ctx.handleSplitButtonClick())
		}, null, 8, [
			"variant",
			"size",
			"loading",
			"disabled",
			"animated"
		])], 64)) : createCommentVNode("", true),
		_ctx.isDropdownButton || _ctx.isSplitButton ? (openBlock(), createBlock(_component_DropdownMenu, {
			key: 1,
			ref: "dropdownMenu",
			items: _ctx.dropdownItems,
			class: "actions-menu",
			size: _ctx.actionSize,
			"item-class": "actions-menu-item"
		}, {
			item: withCtx(({ item, props, hasSubmenu, size }) => [item.printSettings ? (openBlock(), createBlock(_component_DropdownMenuItem, {
				key: 0,
				props,
				item,
				"has-submenu": hasSubmenu,
				size
			}, {
				default: withCtx(() => [createVNode(_component_Button, {
					variant: "ghost",
					icon: "cog",
					size: "small",
					tooltip: _ctx.translate("PrintSettings"),
					"content-align": "center",
					class: "dropdown-menu-item-additional-button print-settings-menu-item-button",
					onClick: withModifiers(($event) => _ctx.handlePrintSettingsButtonClick(item.printSettings), ["stop"])
				}, null, 8, ["tooltip", "onClick"])]),
				_: 2
			}, 1032, [
				"props",
				"item",
				"has-submenu",
				"size"
			])) : createCommentVNode("", true)]),
			_: 1
		}, 8, ["items", "size"])) : createCommentVNode("", true)
	], 8, _hoisted_1$22)) : createCommentVNode("", true);
}
var ActionButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ActionButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$25], ["__scopeId", "data-v-a4f29fdc"]]);
//#endregion
//#region src/components/ActionPanel/ActionPanel.ts?vue&type=script&src=true&lang.ts
var ActionPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ActionPanel",
	components: {
		ActionButton: ActionButton_default,
		Divider: Divider$1,
		Text: Text$2,
		VerticalLayout: VerticalLayout$1
	},
	setup() {
		const viewModel = useViewModel();
		useComponentAutomationProperties();
		return { actionPanelActions: computed(() => {
			const groups = /* @__PURE__ */ new Map();
			const actions = viewModel.actions.filterByLocationAndItem(ViewModelActionLocation.panel, void 0, viewModel.current, viewModel.selectedItems);
			for (const action of actions) {
				const groupName = action.group ?? "";
				const group = groups.get(groupName);
				if (group) group.push(action);
				else groups.set(groupName, [action]);
			}
			return groups;
		}) };
	}
});
//#endregion
//#region src/components/ActionPanel/ActionPanel.vue
function _sfc_render$24(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_Divider = resolveComponent("Divider");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		class: "action-panel",
		space: "none"
	}, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.actionPanelActions, ([group, actions], i) => {
			return openBlock(), createBlock(_component_VerticalLayout, {
				key: group,
				class: "action-panel-group"
			}, {
				default: withCtx(() => [
					group ? (openBlock(), createBlock(_component_Text, {
						key: 0,
						class: "action-panel-group-caption",
						weight: "strong"
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(group), 1)]),
						_: 2
					}, 1024)) : createCommentVNode("", true),
					(openBlock(true), createElementBlock(Fragment, null, renderList(actions, (action) => {
						return openBlock(), createBlock(_component_ActionButton, {
							key: action.name,
							action
						}, null, 8, ["action"]);
					}), 128)),
					i !== _ctx.actionPanelActions.size - 1 ? (openBlock(), createBlock(_component_Divider, { key: 1 })) : createCommentVNode("", true)
				]),
				_: 2
			}, 1024);
		}), 128))]),
		_: 1
	});
}
var ActionPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ActionPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$24]]);
//#endregion
//#region src/components/BoundDocumentationButton/BoundDocumentationButton.vue
var BoundDocumentationButton_default = /* @__PURE__ */ defineComponent({
	__name: "BoundDocumentationButton",
	props: { propertyName: {} },
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		const property = computed(() => viewModel.getProperty(props.propertyName));
		const documentation = computed(() => property.value.documentation ?? "");
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DocumentationButton$1), {
				title: property.value.caption,
				text: documentation.value
			}, null, 8, ["title", "text"]);
		};
	}
});
//#endregion
//#region src/composables/useFormattedValue.ts
function useFormattedValue(property, item) {
	const value = computed(() => item.value ? property.value.getValue(item.value) : null);
	const format = computed(() => property.value.getFormat(item.value));
	const formattedValue = shallowRef(property.value.formatValueSync(value.value, item.value, format.value));
	watch([
		property,
		item,
		value,
		format
	], async ([p, i, v, f]) => {
		formattedValue.value = await p.formatValue(v, i, f);
	}, { immediate: property.value.hasAsyncFormattedValue() });
	return formattedValue;
}
//#endregion
//#region src/composables/useViewModelProperty.ts
function useViewModelProperty(props) {
	const viewModel = useViewModel();
	const item = computed(() => props.item !== void 0 ? props.item : viewModel.current);
	const property = computed(() => viewModel.getProperty(props.propertyName));
	const visible = computed(() => property.value.displayable && property.value.getFormVisible(item.value));
	const required = computed(() => {
		if (item.value?.isVirtual && property.value.dataType !== DataType$1.boolean) return false;
		return property.value.getRequired(item.value);
	});
	const aiSuggestion = computed(() => {
		if (!item.value) return;
		const suggestion = item.value.$appliedSuggestions.get(property.value.camelCaseName);
		if (!suggestion) return;
		return {
			text: suggestion.text,
			suggestedValue: suggestion.suggestedValue
		};
	});
	function handleAiApply() {
		if (item.value) viewModel.acceptAutoSuggest(item.value, property.value.camelCaseName);
	}
	function handleAiCancel() {
		if (item.value) viewModel.cancelAutoSuggest(item.value, property.value.camelCaseName);
	}
	return {
		viewModel,
		item,
		property,
		visible,
		required,
		aiSuggestion,
		handleAiApply,
		handleAiCancel
	};
}
//#endregion
//#region src/components/BoundText/BoundText.vue
var BoundText_default = /* @__PURE__ */ defineComponent({
	__name: "BoundText",
	props: /*@__PURE__*/ mergeDefaults({
		propertyName: {},
		item: {},
		size: {},
		weight: {},
		orientation: {},
		tooltip: {},
		maxLines: {}
	}, {
		...textPropsDefaults,
		orientation: "horizontal",
		tooltip: void 0,
		maxLines: void 0
	}),
	setup(__props) {
		const { property, item, visible } = useViewModelProperty(__props);
		const formattedValue = useFormattedValue(property, item);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(Text$2), {
				key: 0,
				size: __props.size,
				weight: __props.weight,
				orientation: __props.orientation,
				"max-lines": __props.maxLines
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(unref(formattedValue)), 1)]),
				_: 1
			}, 8, [
				"size",
				"weight",
				"orientation",
				"max-lines"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/composables/useCustomViewButton.ts
function useCustomViewButton(viewModel) {
	const customViewDropdownMenu = ref();
	const loading = ref(false);
	const visible = computed(() => {
		if (!viewModel.isMain) return false;
		if (viewModel.initialized && !viewModel.isCustomViewEnabled) return false;
		if (!viewModel.applicationContext.userIdentifier) return false;
		if (viewModel.customViewManager.userCustomViewMode === void 0 || viewModel.customViewManager.userCustomViewMode === "Auto") return false;
		return true;
	});
	const selectedView = computed(() => viewModel.currentCustomViewId ? viewModel.customViewManager.getCustomViewsOfUIView(viewModel.uiViewName).find((view) => view.id === viewModel.currentCustomViewId) : void 0);
	const selectedViewName = computed(() => selectedView.value ? viewModel.localizator.translate(selectedView.value.name) : void 0);
	const buttonIcon = computed(() => selectedView.value ? "CustomViewSelected" : "CustomView");
	const buttonTooltip = computed(() => selectedView.value ? stringFormat(viewModel.globalResourceManager.get("CustomViewSelected"), selectedViewName.value) : viewModel.globalResourceManager.get("CustomViews"));
	async function handleCustomViewButtonClick(event) {
		customViewDropdownMenu.value.toggle({ currentTarget: event.currentTarget });
	}
	return {
		buttonIcon,
		buttonTooltip,
		customViewDropdownMenu,
		handleCustomViewButtonClick,
		loading,
		selectedView,
		selectedViewName,
		visible
	};
}
//#endregion
//#region src/composables/useCustomViewSaveButton.ts
function useCustomViewSaveButton(viewModel) {
	const hasWriteAccess = computed(() => viewModel.customViewManager.userCustomViewMode !== void 0 && viewModel.customViewManager.userCustomViewMode !== "ReadOnly");
	function isCurrentUserCustomView(customView) {
		return customView.userId.toLowerCase() === viewModel.applicationContext.userIdentifier.toLowerCase();
	}
	function canEditCustomView(customView) {
		return hasWriteAccess.value && isCurrentUserCustomView(customView);
	}
	function translateCustomViewName(customView) {
		return viewModel.localizator.translateLocalizableString(customView.name);
	}
	async function createCustomView() {
		await viewModel.customViewManager.addCustomViewAsync(viewModel);
	}
	async function saveCustomView(customView) {
		viewModel.waitingOverlayMessage = stringFormat(viewModel.globalResourceManager.get("CustomViewSaving"), translateCustomViewName(customView));
		await viewModel.customViewManager.editCustomViewAsync(viewModel, customView, true, () => {
			viewModel.waitingOverlayMessage = void 0;
		});
	}
	return {
		hasWriteAccess,
		canEditCustomView,
		translateCustomViewName,
		createCustomView,
		saveCustomView
	};
}
//#endregion
//#region src/components/CustomViewDropdownMenu/CustomViewDropdownMenu.vue
var CustomViewDropdownMenu_default = /* @__PURE__ */ defineComponent({
	__name: "CustomViewDropdownMenu",
	props: /*@__PURE__*/ mergeModels({ size: { default: "medium" } }, {
		"loading": { type: Boolean },
		"loadingModifiers": {}
	}),
	emits: ["update:loading"],
	setup(__props, { expose: __expose }) {
		const props = __props;
		const loading = useModel(__props, "loading");
		__expose({ toggle });
		const dropdownMenuElement = useTemplateRef("dropdownMenu");
		const { translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		const { hasWriteAccess, canEditCustomView, translateCustomViewName, createCustomView, saveCustomView } = useCustomViewSaveButton(viewModel);
		const customViews = computed(() => viewModel.customViewManager.getCustomViewsOfUIView(viewModel.uiViewName));
		const canAssignDefaultCustomView = computed(() => viewModel.customViewManager.userCanAssignDefaultCustomView);
		const selectedView = computed(() => viewModel.currentCustomViewId ? customViews.value.find(isSelectedCustomView) : void 0);
		const dropdownMenuItems = computed(() => {
			const items = [];
			if (customViews.value.length > 0) items.push(...customViews.value.map(createCustomViewMenuItem));
			else items.push({
				label: translate("NoCustomViews"),
				icon: "Info",
				command: () => dropdownMenuElement.value.hide(),
				attributes: { "data-command": "NO_CUSTOM_VIEWS" }
			});
			if (hasWriteAccess.value || selectedView.value) items.push({ separator: true });
			if (hasWriteAccess.value) items.push({
				label: translate("CreateCustomView"),
				icon: "Add",
				command: () => executeCommand(() => createCustomView()),
				attributes: { "data-command": "CREATE" }
			});
			if (selectedView.value) items.push({
				label: translate("SelectOriginalView"),
				icon: "Reset",
				command: () => executeCommand(() => selectCustomViewAsync(void 0)),
				attributes: { "data-command": "RESET" }
			});
			return items;
		});
		const dropdownMenuItemImageStyle = computed(() => `width: var(--image-${props.size}-size); height: var(--image-${props.size}-size);`);
		async function toggle(event) {
			await initAsync();
			dropdownMenuElement.value.toggle(event);
		}
		async function initAsync() {
			loading.value = true;
			try {
				await viewModel.customViewManager.getCustomViewsAsync(viewModel);
			} finally {
				loading.value = false;
			}
		}
		function isSelectedCustomView(customView) {
			return customView.id === viewModel.currentCustomViewId;
		}
		function createCustomViewMenuItem(customView) {
			const isSelected = isSelectedCustomView(customView);
			const label = translateCustomViewName(customView);
			const canEdit = canEditCustomView(customView);
			return {
				customView,
				label,
				command: () => executeCommand(() => selectCustomViewAsync(customView)),
				attributes: {
					"data-custom-view": label,
					"data-selected-custom-view": isSelected,
					"data-default-custom-view": customView.isDefault
				},
				captionWeight: isSelected ? "stronger" : "regular",
				defaultButtonIcon: customView.isDefault ? "CustomViewDefaultView" : "CustomViewSetDefaultView",
				defaultButtonTooltip: translate(customView.isDefault ? "UnsetDefaultCustomView" : "SetDefaultCustomView"),
				canSave: canEdit && isSelected,
				canEdit
			};
		}
		async function selectCustomViewAsync(customView) {
			await viewModel.customViewManager.selectCustomViewAsync(viewModel, customView);
		}
		async function handleDefaultCustomViewButtonClick(customView) {
			await executeCommand(async () => {
				await viewModel.customViewManager.persistDefaultCustomViewAsync(customView.uiViewName, customView.id);
			}, false);
		}
		async function handleSaveCustomViewButtonClick(customView) {
			dropdownMenuElement.value.hide();
			await saveCustomView(customView);
		}
		async function handleEditCustomViewButtonClick(customView) {
			await executeCommand(async () => {
				await viewModel.customViewManager.editCustomViewAsync(viewModel, customView, isSelectedCustomView(customView));
			});
		}
		async function handleRemoveCustomViewButtonClick(customView) {
			await executeCommand(async () => {
				await viewModel.customViewManager.deleteCustomViewAsync(viewModel, customView);
			});
		}
		async function executeCommand(fn, hideDropdown = true) {
			loading.value = true;
			if (hideDropdown) dropdownMenuElement.value.hide();
			try {
				await fn();
			} finally {
				loading.value = false;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DropdownMenu), {
				ref: "dropdownMenu",
				items: dropdownMenuItems.value,
				class: "custom-view-menu",
				size: __props.size
			}, {
				item: withCtx(({ item, props: itemProps }) => [item.customView ? (openBlock(), createBlock(unref(HorizontalLayout$1), mergeProps({
					key: 0,
					"vertical-align": "center",
					wrap: false
				}, {
					...itemProps.action,
					...item.attributes
				}), {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
						space: "extrasmall",
						"vertical-align": "center",
						wrap: false,
						class: "neos-fill-parent-width"
					}, {
						default: withCtx(() => [
							createVNode(unref(HorizontalLayout$1), {
								"vertical-align": "center",
								wrap: false,
								class: "neos-fill-parent-width"
							}, {
								default: withCtx(() => [canAssignDefaultCustomView.value ? (openBlock(), createBlock(unref(Button$1), {
									key: 0,
									variant: "ghost",
									icon: item.defaultButtonIcon,
									size: "small",
									"content-align": "center",
									tooltip: item.defaultButtonTooltip,
									class: "dropdown-menu-item-additional-button custom-view-menu-item-default-button",
									onClick: withModifiers(($event) => handleDefaultCustomViewButtonClick(item.customView), ["stop"])
								}, null, 8, [
									"icon",
									"tooltip",
									"onClick"
								])) : (openBlock(), createElementBlock("div", {
									key: 1,
									class: "dropdown-menu-item-image empty",
									style: normalizeStyle(dropdownMenuItemImageStyle.value)
								}, null, 4)), createVNode(unref(Text$2), {
									weight: item.captionWeight,
									class: "custom-view-menu-item-caption",
									"max-lines": 1
								}, {
									default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1)]),
									_: 2
								}, 1032, ["weight"])]),
								_: 2
							}, 1024),
							item.canSave ? (openBlock(), createBlock(unref(Button$1), {
								key: 0,
								variant: "ghost",
								icon: "save",
								size: "small",
								"content-align": "center",
								tooltip: unref(translate)("SaveCustomView"),
								class: "dropdown-menu-item-additional-button custom-view-menu-item-save-button",
								onClick: withModifiers(($event) => handleSaveCustomViewButtonClick(item.customView), ["stop"])
							}, null, 8, ["tooltip", "onClick"])) : createCommentVNode("", true),
							item.canEdit ? (openBlock(), createBlock(unref(Button$1), {
								key: 1,
								variant: "ghost",
								icon: "edit",
								size: "small",
								"content-align": "center",
								tooltip: unref(translate)("EditCustomView"),
								class: "dropdown-menu-item-additional-button custom-view-menu-item-edit-button",
								onClick: withModifiers(($event) => handleEditCustomViewButtonClick(item.customView), ["stop"])
							}, null, 8, ["tooltip", "onClick"])) : createCommentVNode("", true),
							item.canEdit ? (openBlock(), createBlock(unref(Button$1), {
								key: 2,
								variant: "ghost",
								icon: "remove",
								size: "small",
								"content-align": "center",
								class: "dropdown-menu-item-additional-button custom-view-menu-item-remove-button",
								tooltip: unref(translate)("RemoveCustomView"),
								onClick: withModifiers(($event) => handleRemoveCustomViewButtonClick(item.customView), ["stop"])
							}, null, 8, ["tooltip", "onClick"])) : createCommentVNode("", true)
						]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1040)) : createCommentVNode("", true)]),
				_: 1
			}, 8, ["items", "size"]);
		};
	}
});
//#endregion
//#region src/components/Buttons/CustomViewButton/CustomViewButton.vue
var CustomViewButton_default = /* @__PURE__ */ defineComponent({
	__name: "CustomViewButton",
	props: {
		size: { default: void 0 },
		animated: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const { buttonIcon, buttonTooltip, customViewDropdownMenu, handleCustomViewButtonClick, loading, selectedView, visible } = useCustomViewButton(useViewModel());
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Button$1), {
				ref: "root",
				animated: __props.animated,
				"data-custom-view-applied": !!unref(selectedView),
				icon: unref(buttonIcon),
				loading: unref(loading),
				size: __props.size,
				tooltip: unref(buttonTooltip),
				class: "custom-view-button",
				onClick: unref(handleCustomViewButtonClick)
			}, null, 8, [
				"animated",
				"data-custom-view-applied",
				"icon",
				"loading",
				"size",
				"tooltip",
				"onClick"
			]), createVNode(CustomViewDropdownMenu_default, {
				ref: (el) => customViewDropdownMenu.value = el,
				loading: unref(loading),
				"onUpdate:loading": _cache[0] || (_cache[0] = ($event) => isRef(loading) ? loading.value = $event : null),
				size: __props.size
			}, null, 8, ["loading", "size"])], 64)) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/Buttons/MethodButton/MethodButton.vue
var MethodButton_default = /* @__PURE__ */ defineComponent({
	__name: "MethodButton",
	props: {
		method: {},
		propagateClick: {
			type: Boolean,
			default: false
		},
		item: { default: void 0 },
		animated: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const inProgress = ref(false);
		async function handleClick(e) {
			if (props.item instanceof Model) await updateCurrentItem(props.item);
			if (!props.propagateClick) e.stopPropagation();
			try {
				inProgress.value = true;
				await runWithEvent(e, () => props.method(props.item));
			} finally {
				inProgress.value = false;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Button$1), {
				loading: inProgress.value,
				animated: __props.animated,
				onClick: handleClick
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, ["loading", "animated"]);
		};
	}
});
//#endregion
//#region src/components/Buttons/ToggleOverlayButton/ToggleOverlayButton.vue
var ToggleOverlayButton_default = /* @__PURE__ */ defineComponent({
	__name: "ToggleOverlayButton",
	props: {
		overlayId: {},
		animated: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		function handleClick(event) {
			viewModel.toggleOverlay(new ToggleOverlayOptions(props.overlayId).withEvent(event));
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Button$1), {
				animated: __props.animated,
				onClick: handleClick
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, ["animated"]);
		};
	}
});
//#endregion
//#region src/components/Context/Context.ts?vue&type=script&src=true&lang.ts
var Context_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Context",
	props: { viewModel: {
		type: Object,
		required: true
	} },
	setup(props) {
		provideViewModel(props.viewModel);
	}
});
//#endregion
//#region src/components/Context/Context.vue
function _sfc_render$23(_ctx, _cache, $props, $setup, $data, $options) {
	return renderSlot(_ctx.$slots, "default");
}
var Context_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Context_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$23]]);
//#endregion
//#region src/components/CustomViewPicker/CustomViewPicker.vue
var CustomViewPicker_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "CustomViewPicker",
	props: { headingLevel: { default: 1 } },
	setup(__props) {
		const viewModel = useViewModel();
		const { translate } = useGlobalResourceManager();
		const { buttonIcon, buttonTooltip, customViewDropdownMenu, handleCustomViewButtonClick, selectedView, selectedViewName, visible } = useCustomViewButton(viewModel);
		const { hasWriteAccess, canEditCustomView, createCustomView, saveCustomView } = useCustomViewSaveButton(viewModel);
		const layoutChanged = ref(false);
		const labelWeight = computed(() => selectedView.value ? "stronger" : "regular");
		const label = computed(() => selectedViewName.value ?? translate("OriginalView"));
		const displaySaveButton = computed(() => {
			if (!layoutChanged.value) return false;
			return selectedView.value ? canEditCustomView(selectedView.value) : hasWriteAccess.value;
		});
		onMounted(() => {
			uiViewEvents.layoutUpdated.add(handleLayoutUpdated);
		});
		onUnmounted(() => {
			uiViewEvents.layoutUpdated.remove(handleLayoutUpdated);
		});
		watch(() => selectedView.value, () => {
			layoutChanged.value = false;
		});
		function handleLayoutUpdated(args) {
			if (args.viewModel === viewModel) layoutChanged.value = true;
		}
		async function handleSaveButtonClick() {
			if (selectedView.value) await saveCustomView(selectedView.value);
			else await createCustomView();
		}
		const saveButtonTooltip = computed(() => selectedView.value ? translate("SaveCustomView") : translate("CreateCustomView"));
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
				key: 0,
				"vertical-align": "center",
				wrap: false,
				class: "custom-view-picker"
			}, {
				default: withCtx(() => [createVNode(unref(Button$1), {
					size: "small",
					"data-custom-view-applied": !!unref(selectedView),
					tooltip: unref(buttonTooltip),
					class: "custom-view-picker-button",
					onClick: unref(handleCustomViewButtonClick)
				}, {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
						"vertical-align": "center",
						wrap: false,
						class: "custom-view-picker-container"
					}, {
						default: withCtx(() => [
							createVNode(unref(Image$2), {
								name: unref(buttonIcon),
								class: "custom-view-picker-image"
							}, null, 8, ["name"]),
							createVNode(unref(Text$2), {
								weight: labelWeight.value,
								class: "custom-view-picker-label"
							}, {
								default: withCtx(() => [createTextVNode(toDisplayString(label.value), 1)]),
								_: 1
							}, 8, ["weight"]),
							createVNode(unref(Image$2), { name: "chevronDown" })
						]),
						_: 1
					}), createVNode(CustomViewDropdownMenu_default, { ref: (el) => customViewDropdownMenu.value = el }, null, 512)]),
					_: 1
				}, 8, [
					"data-custom-view-applied",
					"tooltip",
					"onClick"
				]), displaySaveButton.value ? (openBlock(), createBlock(unref(Button$1), {
					key: 0,
					size: "small",
					icon: "customViewSave",
					"icon-size": "medium",
					tooltip: saveButtonTooltip.value,
					class: "custom-view-picker-save-button",
					onClick: handleSaveButtonClick
				}, null, 8, ["tooltip"])) : createCommentVNode("", true)]),
				_: 1
			})) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-3f9f3fcc"]]);
//#endregion
//#region src/composables/useEmitEvenUnmounted.ts
function useEmitEvenUnmounted(emit) {
	const instance = getCurrentInstance();
	const emitEvenUnmounted = (event, ...args) => {
		const isUnmounted = instance.isUnmounted;
		instance.isUnmounted = false;
		emit(event, ...args);
		instance.isUnmounted = isUnmounted;
	};
	return emitEvenUnmounted;
}
//#endregion
//#region src/composables/useLookupDisplayValue.ts
function useLookupDisplayValue(props, viewModel, displayProperty, inputValue) {
	const internalDisplayValue = ref();
	const hasAdditionalData = computed(() => !props.isReference && props.definition.displayProperty && (!props.definition.allowFreeValue || !props.validate));
	const displayValue = computed(() => {
		if (!hasAdditionalData.value) return;
		if (props.property && props.item) return props.property.getLookupDisplayPropertyValueSync(props.item);
		return internalDisplayValue.value;
	});
	const formattedDisplayValue = computed(() => displayValue.value !== void 0 ? formatValue(displayValue.value, displayProperty.value, viewModel) : void 0);
	const isLoadingDisplayValue = computed(() => props.property && props.item && props.property.hasRunningLookupDisplayPropertyValueInvalidation(props.item));
	watch(() => props.modelValue, () => {
		internalDisplayValue.value = void 0;
	});
	watch(formattedDisplayValue, (value) => {
		if (value !== void 0) inputValue.value = value;
	});
	function setDisplayValue(item, displayValue) {
		if (!hasAdditionalData.value) return;
		if (props.property && item) props.property.setLookupDisplayPropertyValue(item, displayValue);
		else internalDisplayValue.value = displayValue;
	}
	return {
		displayValue,
		formattedDisplayValue,
		setDisplayValue,
		isLoadingDisplayValue
	};
}
//#endregion
//#region src/composables/useLookupExhaustiveListInCombobox.ts
function useLookupExhaustiveListInCombobox(props, viewModel, displayValue, apiClient, persistValue) {
	let comboboxExhaustiveListIsFullyLoaded = false;
	const comboboxExhaustiveListIsLoading = ref(false);
	const comboboxExhaustiveListOfOptions = ref(getInitialListOfOptions());
	watch([() => props.modelValue, displayValue], () => {
		if (!comboboxExhaustiveListIsFullyLoaded) comboboxExhaustiveListOfOptions.value = getInitialListOfOptions();
	});
	function getInitialListOfOptions() {
		if (props.definition.mainMode !== "ExhaustiveListInCombobox" || props.modelValue == null) return [];
		if (props.isReference) return [props.modelValue];
		if (props.definition.displayProperty) return [{
			[props.definition.valueProperty.camelCaseName]: props.modelValue,
			[props.definition.displayProperty.camelCaseName]: displayValue.value
		}];
		return [{ [props.definition.valueProperty.camelCaseName]: props.modelValue }];
	}
	const comboboxModelValueEx = computed({
		get: () => {
			if (props.modelValue == null) return null;
			const searchedValue = props.isReference ? getPropertyByPath(props.modelValue, props.definition.valueProperty.camelCaseName) : props.modelValue;
			return comboboxExhaustiveListOfOptions.value.find((v) => getPropertyByPath(v, props.definition.valueProperty.camelCaseName) === searchedValue);
		},
		set: (value) => persistValue(props.item, value)
	});
	async function handleLazyLoadExhaustiveListInCombobox() {
		try {
			comboboxExhaustiveListIsLoading.value = true;
			comboboxExhaustiveListOfOptions.value = (await loadAllItems(props.item)).data ?? getInitialListOfOptions();
			comboboxExhaustiveListIsFullyLoaded = true;
		} finally {
			comboboxExhaustiveListIsLoading.value = false;
		}
	}
	async function loadAllItems(item) {
		if (viewModel && props.property) return viewModel.loadReferenceDataAsync({
			apiClient,
			property: props.property,
			item,
			trigger: ReferenceRetrievingTrigger.lookupSuggestions,
			inputValue: null,
			path: props.definition.searchEntityViewName,
			filter: void 0,
			sorts: [],
			pageNumber: 1,
			recordsByPage: 2147483647
		});
		return apiClient.getAllAsync({
			path: props.definition.searchEntityViewName,
			pageNumber: 1,
			recordsByPage: 2147483647
		});
	}
	return {
		comboboxExhaustiveListIsLoading,
		comboboxExhaustiveListOfOptions,
		comboboxModelValueEx,
		handleLazyLoadExhaustiveListInCombobox
	};
}
//#endregion
//#region src/composables/useLookupSuggestions.ts
function useLookupSuggestions(props, viewModel, displayProperty) {
	const apiClient = new FetchApiClient(viewModel.apiClient.baseUrl, viewModel.applicationContext, viewModel.eventManager, viewModel.globalResourceManager);
	apiClient.setAcceptLanguageHeader(viewModel.localizator.currentCulture);
	apiClient.setHeader("neos-ui-view-name", props.definition.searchUIViewName);
	const suggestions = ref([]);
	const currentSuggestionIndex = ref(-1);
	async function loadItems(options) {
		await init();
		const filter = options.filter ?? getSearchFilter(options.inputValue);
		const sorts = options.sorts ?? getSorts(options.inputValue);
		const pageNumber = options.pageNumber ?? 1;
		const recordsByPage = options.recordsByPage ?? 10;
		const includeTotalCount = options.trigger === ReferenceRetrievingTrigger.lookupSuggestions && props.definition.includeCountInSuggestions === true ? void 0 : false;
		if (props.property) return viewModel.loadReferenceDataAsync({
			property: props.property,
			item: options.item,
			trigger: options.trigger,
			inputValue: options.inputValue,
			apiClient,
			path: props.definition.searchEntityViewName,
			filter,
			includeTotalCount,
			signal: options.signal,
			sorts,
			pageNumber,
			recordsByPage
		});
		return apiClient.getAllAsync({
			path: props.definition.searchEntityViewName,
			filter: filter && !filter.isEmpty ? filter.toODataString() : void 0,
			includeTotalCount,
			signal: options.signal,
			sorts,
			pageNumber,
			recordsByPage
		});
	}
	async function init() {
		if (props.definition.suggestionProperties && props.definition.suggestionProperties.length > 1) await props.definition.resourceManager.load(viewModel.localizator);
	}
	function getSearchFilter(inputValue) {
		return inputValue ? getLookupSearchFilter(props.definition, inputValue, viewModel.localizator.currentLanguage) : void 0;
	}
	function shouldNormalizePropertySort(searchProperty) {
		return searchProperty.dataType === void 0 || searchProperty.dataType === DataType$1.string || searchProperty.dataType === DataType$1.localizableString;
	}
	function getStartsWithValue(inputValue) {
		if (!inputValue) return;
		if (props.definition.searchMode === LookupSearchMode.quickSearch || props.definition.filterOperator === FilterOperator.contains) return inputValue;
		if (isInputValueWithWildcards(inputValue)) return inputValue.substring(1, inputValue.length - 1);
	}
	function createSearchPropertySort(searchProperty, searchPropertyPath) {
		if (shouldNormalizePropertySort(searchProperty)) return new ExpressionSort(`search.normalize(${searchPropertyPath.replaceAll(".", "/")}) asc`);
		return new Sort(searchProperty.camelCaseName, SortDirection.asc, searchPropertyPath);
	}
	function getSorts(inputValue) {
		const sorts = [];
		const searchProperty = getLookupSearchProperty(props.definition);
		const shouldSortOnlyBySearchProperty = props.definition.searchMode !== LookupSearchMode.quickSearch && props.definition.searchProperty !== void 0 && props.definition.searchProperty.camelCaseName !== displayProperty.value.camelCaseName;
		const startsWithValue = getStartsWithValue(inputValue);
		const searchPropertyPath = getLookupPropertyPath(searchProperty, viewModel.localizator.currentLanguage);
		if (shouldSortOnlyBySearchProperty) {
			sorts.push(createSearchPropertySort(searchProperty, searchPropertyPath));
			return sorts;
		}
		if (startsWithValue) sorts.push(new ExpressionSort(`startswith(search.normalize(${searchPropertyPath.replaceAll(".", "/")}),search.normalize('${startsWithValue.replaceAll("'", "''")}')) desc`));
		sorts.push(createSearchPropertySort(searchProperty, searchPropertyPath));
		return sorts;
	}
	function handleSuggestionsKeyboardNavigation(event, suggestions) {
		if (suggestions.length === 0) return false;
		event.preventDefault();
		if (event.key === "ArrowDown" && currentSuggestionIndex.value < suggestions.length - 1) currentSuggestionIndex.value++;
		else if (event.key === "ArrowUp" && currentSuggestionIndex.value > 0) currentSuggestionIndex.value--;
		return true;
	}
	return {
		apiClient,
		suggestions,
		currentSuggestionIndex,
		loadItems,
		getSearchFilter,
		handleSuggestionsKeyboardNavigation
	};
}
//#endregion
//#region src/composables/useValidationMessage.ts
function useValidationMessage(property, item) {
	const message = computed(() => item.value?.getValidationMessage(property.value.camelCaseName));
	return {
		messageText: computed(() => message.value?.shortText ?? message.value?.text),
		messageSeverity: computed(() => convertValidationMessageSeverity(message.value?.severityLevel))
	};
}
function convertValidationMessageSeverity(severityLevel) {
	switch (severityLevel) {
		case ValidationRuleSeverityLevel.information: return "information";
		case ValidationRuleSeverityLevel.warning: return "warning";
		case ValidationRuleSeverityLevel.error: return "error";
		default: return;
	}
}
//#endregion
//#region src/components/LookupModalButton/LookupModalButton.vue
var LookupModalButton_default = /* @__PURE__ */ defineComponent({
	__name: "LookupModalButton",
	props: {
		definition: {},
		property: {},
		inputValue: {},
		onModalOpen: {},
		item: { default: void 0 },
		disabled: {
			type: Boolean,
			default: false
		}
	},
	setup(__props, { expose: __expose }) {
		const props = __props;
		const viewModel = useViewModel();
		const showLookupButton = computed(() => viewModel.uiPermitter.canRead(props.definition.searchUIViewName));
		async function openModal() {
			const navigationOptions = new NavigationOptions(props.definition.searchUIViewName).onTarget(NavigationTarget.popup).withParameter("neos-lookup-input", props.inputValue).withPopupSize(PopupSize.full).withLookupContext({
				templateMode: props.definition.useUIViewTemplate ? LookupTemplateMode.own : LookupTemplateMode.default,
				viewModel,
				property: props.property,
				item: props.item
			}).withDontExecuteUIViewRules(props.definition.dontExecuteUIViewRules);
			props.onModalOpen(navigationOptions);
			await viewModel.navigateAsync(navigationOptions);
		}
		__expose({ openModal });
		return (_ctx, _cache) => {
			return !__props.disabled && showLookupButton.value ? (openBlock(), createBlock(unref(Button$1), {
				key: 0,
				class: "lookup-button",
				variant: "ghost",
				size: "small",
				icon: "search",
				tabindex: "-1",
				onClick: openModal
			})) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/LookupSuggestions/LookupSuggestions.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$21 = {
	key: 0,
	class: "lookup-suggestion-no-result"
};
var _hoisted_2$13 = {
	key: 1,
	class: "lookup-suggestion-table"
};
var _hoisted_3$8 = { class: "lookup-suggestion-table-header-row" };
var _hoisted_4$4 = { key: 0 };
var _hoisted_5$3 = [
	"data-selected",
	"title",
	"onClick"
];
var _hoisted_6$1 = {
	key: 0,
	class: "lookup-suggestion-table-selection-cell"
};
var _hoisted_7 = ["checked"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["title", "onClick"];
var _hoisted_10 = ["checked"];
var _hoisted_11 = ["innerHTML"];
//#endregion
//#region src/components/LookupSuggestions/LookupSuggestions.vue
var LookupSuggestions_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "LookupSuggestions",
	props: {
		definition: {},
		displayProperty: {},
		inputValue: {},
		loading: { type: Boolean },
		suggestions: {},
		currentSuggestionIndex: {},
		multiSelectionOptions: { default: void 0 },
		hasMoreData: {
			type: Boolean,
			default: false
		},
		onLoad: {
			type: Function,
			default: void 0
		}
	},
	emits: ["select", "loadMore"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const localizator = useLocalizator();
		const { globalResourceManager, translate } = useGlobalResourceManager();
		const showSuggestionTable = computed(() => props.definition.suggestionProperties && props.definition.suggestionProperties.length > 1 && props.suggestions.length > 0);
		const showNoResultMessage = computed(() => props.suggestions.length === 0 && !props.loading && !props.definition.allowFreeValue);
		function getSuggestionClass(suggestion, index) {
			return { "lookup-current-suggestion": index === props.currentSuggestionIndex || props.multiSelectionOptions?.isSelected(suggestion) };
		}
		function getSuggestionHtml(suggestion, lookupProperty) {
			lookupProperty ??= props.definition.suggestionProperties && props.definition.suggestionProperties.length === 1 ? props.definition.suggestionProperties[0] : props.displayProperty;
			const propertyValue = getValueFromProperty(lookupProperty, suggestion);
			if (!propertyValue) return propertyValue;
			const escapedPropertyValue = escapeHtml(propertyValue);
			if (!props.inputValue || lookupProperty.camelCaseName !== props.displayProperty.camelCaseName) return escapedPropertyValue;
			const escapedInputValue = escapeHtml(props.inputValue);
			const matchExpression = new RegExp(escapeRegExp(escapedInputValue), "ig");
			return escapedPropertyValue.replace(matchExpression, (match) => `<span class="lookup-suggestion-match">${match}</span>`);
		}
		function getValueFromProperty(lookupProperty, suggestion) {
			return formatValue(getPropertyByPath(suggestion, lookupProperty.camelCaseName), lookupProperty, {
				globalResourceManager,
				localizator
			});
		}
		function handleSuggestionClick(suggestion) {
			if (props.loading) return;
			emit("select", suggestion);
		}
		function isSelected(suggestion) {
			return props.multiSelectionOptions?.isSelected(suggestion) ?? false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				space: "none",
				class: normalizeClass(["lookup-suggestions", { "lookup-suggestions-loading": __props.loading }])
			}, {
				default: withCtx(() => [createVNode(unref(LoadDataOnScroll$1), {
					"has-more-data": __props.hasMoreData,
					"on-load": __props.onLoad,
					"spinner-size": "large"
				}, {
					default: withCtx(() => [
						renderSlot(_ctx.$slots, "header", {}, void 0, true),
						showNoResultMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$21, [createVNode(unref(Text$2), null, {
							default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("NoResultFound")), 1)]),
							_: 1
						})])) : createCommentVNode("", true),
						showSuggestionTable.value ? (openBlock(), createElementBlock("table", _hoisted_2$13, [createElementVNode("thead", null, [createElementVNode("tr", _hoisted_3$8, [__props.multiSelectionOptions ? (openBlock(), createElementBlock("th", _hoisted_4$4)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.suggestionProperties, (suggestionProperty) => {
							return openBlock(), createElementBlock("th", { key: suggestionProperty.camelCaseName }, toDisplayString(suggestionProperty.caption), 1);
						}), 128))])]), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.suggestions, (suggestion, index) => {
							return openBlock(), createElementBlock("tr", {
								key: index,
								class: normalizeClass(["lookup-suggestion lookup-suggestion-table-row", getSuggestionClass(suggestion, index)]),
								"data-selected": isSelected(suggestion),
								title: getValueFromProperty(__props.displayProperty, suggestion),
								onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
								onClick: ($event) => handleSuggestionClick(suggestion)
							}, [__props.multiSelectionOptions ? (openBlock(), createElementBlock("td", _hoisted_6$1, [createElementVNode("input", {
								type: "checkbox",
								checked: isSelected(suggestion),
								tabindex: "-1"
							}, null, 8, _hoisted_7)])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.suggestionProperties, (suggestionProperty) => {
								return openBlock(), createElementBlock("td", {
									key: suggestionProperty.camelCaseName,
									innerHTML: getSuggestionHtml(suggestion, suggestionProperty)
								}, null, 8, _hoisted_8);
							}), 128))], 42, _hoisted_5$3);
						}), 128))])) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(__props.suggestions, (suggestion, index) => {
							return openBlock(), createElementBlock("div", {
								key: index,
								class: normalizeClass(["lookup-suggestion lookup-suggestion-list-item", getSuggestionClass(suggestion, index)]),
								title: getValueFromProperty(__props.displayProperty, suggestion),
								onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent"])),
								onClick: ($event) => handleSuggestionClick(suggestion)
							}, [__props.multiSelectionOptions ? (openBlock(), createElementBlock("input", {
								key: 0,
								type: "checkbox",
								checked: isSelected(suggestion),
								tabindex: "-1"
							}, null, 8, _hoisted_10)) : createCommentVNode("", true), createElementVNode("div", { innerHTML: getSuggestionHtml(suggestion) }, null, 8, _hoisted_11)], 42, _hoisted_9);
						}), 128)),
						renderSlot(_ctx.$slots, "footer", {}, void 0, true)
					]),
					_: 3
				}, 8, ["has-more-data", "on-load"])]),
				_: 3
			}, 8, ["class"]);
		};
	}
}), [["__scopeId", "data-v-4e71a45b"]]);
//#endregion
//#region src/components/Lookup/Lookup.ts?vue&type=script&src=true&lang.ts
var Lookup_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Lookup",
	components: {
		Button: Button$1,
		Combobox,
		Divider: Divider$1,
		Dropdown,
		Image: Image$2,
		LookupModalButton: LookupModalButton_default,
		LookupSuggestions: LookupSuggestions_default,
		Spinner: Spinner$1,
		Text: Text$2,
		Textbox: Textbox$1
	},
	props: {
		...inputProps,
		isReference: {
			type: Boolean,
			required: true
		},
		referenceEntityViewName: {
			type: String,
			default: void 0
		},
		definition: {
			type: Object,
			required: true
		},
		modelValue: {
			type: [
				String,
				Number,
				Object
			],
			default: null
		},
		property: {
			type: Object,
			default: void 0
		},
		item: {
			type: Object,
			default: void 0
		},
		disableSuggest: {
			type: Boolean,
			default: false
		},
		suggestMinCharNumber: {
			type: Number,
			default: 1
		},
		validate: {
			type: Boolean,
			default: true
		},
		multiSelectionProperty: {
			type: String,
			default: void 0
		},
		invalidValue: {
			type: String,
			default: void 0
		}
	},
	emits: [
		...inputEmits,
		"update:invalidValue",
		"toggleDelegateEditToComponent",
		"toggleModal",
		"asyncValidating"
	],
	setup(props, { emit }) {
		let suggestionsRequestSequence = 0;
		let shouldUpdateInputWithDisplayProperty = false;
		let preventValidationOnBlur = false;
		let shouldUnregisterAfterValidation = false;
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		useComponentAutomationProperties();
		const emitEvenUnmounted = useEmitEvenUnmounted(emit);
		const viewModel = useViewModel();
		const displayProperty = computed(() => getLookupDisplayProperty(props.definition));
		const validationProperty = computed(() => props.definition.validationProperty ?? displayProperty.value);
		const referenceEntityViewName = computed(() => props.referenceEntityViewName ?? props.definition.searchEntityViewName);
		const canCreate = computed(() => props.definition.creationUIViewName !== void 0 && viewModel.uiPermitter.canCreate(props.definition.creationUIViewName));
		const canUpdate = computed(() => props.definition.editingUIViewName !== void 0 && viewModel.uiPermitter.canUpdate(props.definition.editingUIViewName));
		const inputValue = ref(null);
		const inputReference = shallowRef();
		const unboundValidationMessage = shallowRef();
		const suggestionsLoadingHandler = shallowRef();
		const suggestionsAbortController = shallowRef();
		const suggestionTriggerHandle = shallowRef();
		const textbox = shallowRef(null);
		const dropdown = shallowRef(null);
		const modalButton = shallowRef(null);
		const freeValueSuggestion = computed(() => props.definition.allowFreeValue && !findExactMatchSuggestion(suggestions.value) ? inputValue.value : void 0);
		const suggestionsPageNumber = ref(1);
		const suggestionsRecordsByPage = 10;
		const hasMoreSuggestions = ref(false);
		const totalRecordCount = ref(0);
		const valid = ref(true);
		const isValidating = ref(false);
		const isDisabled = computed(() => props.disabled || props.readonly);
		const isInDatagrid = computed(() => props.inputDisplayMode === "datagrid");
		const { apiClient, suggestions, currentSuggestionIndex, loadItems, getSearchFilter, handleSuggestionsKeyboardNavigation } = useLookupSuggestions(props, viewModel, displayProperty);
		const { displayValue, formattedDisplayValue, setDisplayValue, isLoadingDisplayValue } = useLookupDisplayValue(props, viewModel, displayProperty, inputValue);
		const { comboboxExhaustiveListIsLoading, comboboxExhaustiveListOfOptions, comboboxModelValueEx, handleLazyLoadExhaustiveListInCombobox } = useLookupExhaustiveListInCombobox(props, viewModel, displayValue, apiClient, async (item, value) => {
			if (value == null) await persistNewValue(item, null, true);
			else await persistNewReferenceValue(item, value);
		});
		const showEditingButton = computed(() => canUpdate.value && isValidInput.value && !isFreeValue.value);
		const isValidInput = computed(() => inputValue.value && valid.value && inputValue.value !== props.invalidValue);
		const isFreeValue = computed(() => props.definition.allowFreeValue && !inputReference.value);
		const showCreateButton = computed(() => canCreate.value && inputValue.value && (!valid.value || inputValue.value === props.invalidValue));
		const isLoadingSuggestions = computed(() => suggestionTriggerHandle.value !== void 0 || suggestionsLoadingHandler.value !== void 0);
		const isLoading = computed(() => isLoadingSuggestions.value || isValidating.value || isLoadingDisplayValue.value);
		const computedMessageText = computed(() => props.messageText ?? unboundValidationMessage.value?.text);
		const computedMessageSeverity = computed(() => props.messageSeverity ?? convertValidationMessageSeverity(unboundValidationMessage.value?.severityLevel));
		const showSuggestions = ref(false);
		const showSuggestionsCount = computed(() => totalRecordCount.value > 0 && totalRecordCount.value > suggestions.value.length);
		const showSuggestionsContainsTip = computed(() => {
			if (suggestions.value.length > 0 || isLoading.value) return false;
			return props.definition.searchMode !== LookupSearchMode.quickSearch && inputValue.value && !isLookupContainsSearchActive(props.definition, inputValue.value);
		});
		let unregisterViewModelValidatingHandler;
		const lookupFreeValue = computed(() => getLookupFreeValue(props.item));
		watch([
			() => props.modelValue,
			() => props.invalidValue,
			lookupFreeValue,
			() => {
				if (props.isReference && props.modelValue != null) return getPropertyByPath(props.modelValue, displayProperty.value.camelCaseName);
			}
		], ([value]) => initValue(props.item, value), { immediate: true });
		watch(() => props.required, (required) => {
			if (!required) invalidateUnboundValidationMessage();
		});
		onMounted(() => {
			emitEvenUnmounted("toggleDelegateEditToComponent", true);
			if (props.validate) {
				viewModel.validatingEvent.add(viewModelValidatingHandler);
				unregisterViewModelValidatingHandler = () => viewModel.validatingEvent.remove(viewModelValidatingHandler);
			}
		});
		onUnmounted(() => {
			if (isValidating.value) clearPendingSuggestionTrigger();
			else invalidateSuggestionsRequest();
			emitEvenUnmounted("toggleDelegateEditToComponent", false);
			if (props.validate) {
				if (isValidating.value) shouldUnregisterAfterValidation = true;
				else unregisterViewModelValidatingHandler();
			}
		});
		function invalidateSuggestionsRequest() {
			suggestionsRequestSequence++;
			suggestionsAbortController.value?.abort();
			suggestionsAbortController.value = void 0;
			suggestionsLoadingHandler.value = void 0;
			clearPendingSuggestionTrigger();
		}
		function clearPendingSuggestionTrigger() {
			if (suggestionTriggerHandle.value !== void 0) {
				clearTimeout(suggestionTriggerHandle.value);
				suggestionTriggerHandle.value = void 0;
			}
		}
		function resetSuggestionsState() {
			showSuggestions.value = false;
			currentSuggestionIndex.value = -1;
			suggestions.value = [];
			hasMoreSuggestions.value = false;
			totalRecordCount.value = 0;
		}
		function clearSuggestionHandle() {
			invalidateSuggestionsRequest();
			resetSuggestionsState();
		}
		async function initValue(item, newValue) {
			valid.value = true;
			clearSuggestionHandle();
			unboundValidationMessage.value = void 0;
			if (props.invalidValue != null) {
				inputValue.value = props.invalidValue;
				return;
			}
			if (!newValue) {
				valid.value = !props.required;
				inputValue.value = getLookupFreeValue(item);
				inputReference.value = void 0;
				return;
			}
			if (props.isReference && typeof newValue === "object") {
				inputValue.value = getValueFromProperty(displayProperty.value, newValue);
				inputReference.value = newValue;
				return;
			}
			if (formattedDisplayValue.value !== void 0) {
				inputValue.value = formattedDisplayValue.value;
				return;
			}
			if (props.definition.valueProperty === displayProperty.value) {
				inputValue.value = formatValue(newValue, displayProperty.value, viewModel);
				inputReference.value = void 0;
				return;
			}
			if (await initValueWithLoadedReference(item, newValue)) return;
			if (props.definition.allowFreeValue) {
				inputReference.value = void 0;
				inputValue.value = newValue;
			}
		}
		async function initValueWithLoadedReference(item, newValue) {
			shouldUpdateInputWithDisplayProperty = true;
			const res = await loadItems({
				trigger: ReferenceRetrievingTrigger.lookupValidation,
				item,
				inputValue: inputValue.value,
				filter: Filter.create(props.definition.valueProperty.camelCaseName, FilterOperator.equal, newValue),
				sorts: [],
				recordsByPage: 1
			});
			if (!shouldUpdateInputWithDisplayProperty) return true;
			shouldUpdateInputWithDisplayProperty = false;
			const refValue = res.data?.shift();
			if (!refValue) return false;
			inputValue.value = getValueFromProperty(displayProperty.value, refValue);
			inputReference.value = refValue;
			setDisplayValue(item, getPropertyByPath(refValue, displayProperty.value.camelCaseName));
			return true;
		}
		function getLookupFreeValue(item) {
			if (props.property?.lookupFreeValuePropertyName && item) return viewModel.getProperty(props.property.lookupFreeValuePropertyName).getValue(item);
			return null;
		}
		function focusTextbox() {
			textbox.value && focusExceptOnTouchDevice(textbox.value.$el.querySelector("input"));
		}
		function isTextboxFocused() {
			return textbox.value && document.activeElement && textbox.value.$el.contains(document.activeElement);
		}
		function updateOriginalValue(item) {
			if (!item || !props.property) return;
			if (item.$unboundProperties.has(props.property.camelCaseName)) return;
			if (!viewModel.hasChanges) item.setOriginalValue(props.property.camelCaseName, props.modelValue);
		}
		async function handleInput(newValue) {
			const item = props.item;
			shouldUpdateInputWithDisplayProperty = false;
			inputValue.value = newValue;
			inputReference.value = void 0;
			valid.value = false;
			updateOriginalValue(item);
			if (props.disableSuggest) return;
			if (newValue === void 0 || newValue === null || newValue.length < props.suggestMinCharNumber) {
				clearSuggestionHandle();
				return;
			}
			clearPendingSuggestionTrigger();
			invalidateSuggestionsRequest();
			currentSuggestionIndex.value = -1;
			showSuggestions.value = isTextboxFocused() && suggestions.value.length > 0;
			suggestionTriggerHandle.value = setTimeout(() => {
				suggestionTriggerHandle.value = void 0;
				suggestionsLoadingHandler.value = loadAndDisplaySuggestions(item);
				suggestionsLoadingHandler.value.catch(() => void 0);
			}, 400);
		}
		function handleKeyDown(event) {
			switch (event.key) {
				case "ArrowDown":
				case "ArrowUp":
					if (handleSuggestionsKeyboardNavigation(event, suggestions.value)) {
						const suggestion = suggestions.value[currentSuggestionIndex.value];
						if (suggestion) {
							inputValue.value = getValueFromProperty(displayProperty.value, suggestion);
							setTimeout(() => selectAllInputText());
						}
					}
					return;
				case "Enter":
					handleEnterKeyDown(props.item);
					break;
				case "Escape": resetValue(props.item);
			}
			if (event.key !== "Tab" && event.key !== "Shift") currentSuggestionIndex.value = -1;
		}
		async function handleEnterKeyDown(item) {
			if (!valid.value) try {
				await validateInput(item);
				invalidateUnboundValidationMessage();
			} catch (error) {
				viewModel.showError(error);
			}
		}
		function resetValue(item) {
			clearSuggestionHandle();
			unboundValidationMessage.value = void 0;
			emitInvalidValue(item, null);
			initValue(item, props.modelValue);
		}
		function handleActionMousedown() {
			preventValidationOnBlur = true;
		}
		function handleComboboxShow() {
			emitEvenUnmounted("toggleModal", true);
			handleLazyLoadExhaustiveListInCombobox();
		}
		function handleComboboxHide() {
			emitEvenUnmounted("toggleModal", false);
		}
		async function handleFocusout(event) {
			if (event.currentTarget.contains(event.relatedTarget)) return;
			if (preventValidationOnBlur) {
				preventValidationOnBlur = false;
				return;
			}
			if (valid.value) clearSuggestionHandle();
			else try {
				await validateInput(props.item);
				invalidateUnboundValidationMessage();
			} catch (error) {
				viewModel.showError(error);
			}
		}
		function getValueFromProperty(lookupProperty, item) {
			return formatValue(getPropertyByPath(item, lookupProperty.camelCaseName), lookupProperty, viewModel);
		}
		function selectAllInputText() {
			const input = (textbox.value?.$el)?.querySelector("input");
			if (!input) return;
			input.setSelectionRange(0, input.value.length);
		}
		async function applySuggestion(suggestion, item = props.item) {
			try {
				const oldValue = props.modelValue;
				await persistNewReferenceValue(item, suggestion);
				if (oldValue === props.modelValue) initValue(item, props.modelValue);
			} finally {
				clearSuggestionHandle();
			}
		}
		async function selectSuggestion(item) {
			if (isLoadingSuggestions.value) return false;
			if (currentSuggestionIndex.value >= 0) {
				await applySuggestion(suggestions.value[currentSuggestionIndex.value], item);
				return true;
			}
			if (suggestions.value.length > 0) {
				const matchingSuggestion = findExactMatchSuggestion(suggestions.value);
				if (matchingSuggestion !== void 0) {
					await applySuggestion(matchingSuggestion, item);
					return true;
				}
				if (suggestions.value.length === 1 && !props.definition.allowFreeValue) {
					await applySuggestion(suggestions.value[0], item);
					return true;
				}
			}
			return false;
		}
		async function validateInput(item) {
			isValidating.value = true;
			let asyncValidating = false;
			try {
				const pendingSuggestionsLoadingHandler = suggestionsLoadingHandler.value;
				if (await handleImmediateValidation(item)) return;
				valid.value = false;
				asyncValidating = true;
				emitAsyncValidatingEvent(true);
				if (await tryApplyValidatedSuggestion(item, pendingSuggestionsLoadingHandler)) return;
				if (await tryPersistValidatedReference(item)) return;
				if (props.validate) await persistNewValue(item, inputValue.value, false);
				else resetValue(item);
			} finally {
				emitAsyncValidatingEvent(false, asyncValidating);
				if (shouldUnregisterAfterValidation) unregisterViewModelValidatingHandler();
				isValidating.value = false;
			}
		}
		async function handleImmediateValidation(item) {
			if (await selectSuggestion(item)) return true;
			clearPendingSuggestionTrigger();
			resetSuggestionsState();
			if (!inputValue.value) {
				invalidateSuggestionsRequest();
				valid.value = true;
				await persistNewValue(item, null, true);
				return true;
			}
			if (!props.definition.allowFreeValue) return false;
			invalidateSuggestionsRequest();
			await persistNewValue(item, inputValue.value, true, void 0, props.property?.lookupFreeValuePropertyName != void 0);
			return true;
		}
		async function tryApplyValidatedSuggestion(item, pendingSuggestionsLoadingHandler) {
			let suggestionsResult;
			try {
				suggestionsResult = pendingSuggestionsLoadingHandler ? await pendingSuggestionsLoadingHandler : await loadValidItems(item, inputValue.value);
			} catch (error) {
				if (error instanceof Error && error.name === "AbortError") return false;
				try {
					suggestionsResult = await loadValidItems(item, inputValue.value);
				} catch (fallbackError) {
					if (fallbackError instanceof Error && fallbackError.name === "AbortError") return false;
					throw fallbackError;
				}
			}
			if (suggestionsResult.length === 0) return false;
			const matchingSuggestion = suggestionsResult.length === 1 ? suggestionsResult[0] : findExactMatchSuggestion(suggestionsResult);
			if (matchingSuggestion === void 0) return false;
			await applySuggestion(matchingSuggestion, item);
			resetValue(item);
			return true;
		}
		async function tryPersistValidatedReference(item) {
			if (displayProperty.value === validationProperty.value) return false;
			let validationResult;
			try {
				validationResult = await loadValidItems(item, inputValue.value, getLookupPropertyFilter(validationProperty.value, FilterOperator.equal, inputValue.value, viewModel.localizator.currentLanguage));
			} catch (error) {
				if (error instanceof Error && error.name === "AbortError") return false;
				throw error;
			}
			const validReference = validationResult[0];
			if (!validReference) return false;
			await persistNewReferenceValue(item, validReference);
			return true;
		}
		function emitAsyncValidatingEvent(newValue, oldValue) {
			if (newValue || oldValue) emitEvenUnmounted("asyncValidating", newValue);
			return newValue;
		}
		async function viewModelValidatingHandler(validationTypes) {
			if (!valid.value && validationTypes & ValidationRuleValidationTypes.reportErrors) try {
				await validateInput(props.item);
				invalidateUnboundValidationMessage();
				if (unboundValidationMessage.value) viewModel.customValidationMessages.push(unboundValidationMessage.value);
			} catch (error) {
				viewModel.showError(error);
			}
		}
		function invalidateUnboundValidationMessage() {
			let value;
			if (props.validate && !props.property) {
				value = getUnboundInvalidValueMessage();
				value ??= getUnboundRequiredValueMessage();
			}
			unboundValidationMessage.value = value;
			return value;
		}
		function findExactMatchSuggestion(availableSuggestions) {
			const propertyPath = getLookupPropertyPath(displayProperty.value, viewModel.localizator.currentLanguage);
			const exactMatches = availableSuggestions.filter((s) => equals(getPropertyByPath(s, propertyPath), inputValue.value, StringComparison.OrdinalIgnoreCase));
			if (exactMatches.length === 0 || exactMatches.length > 1) return;
			return exactMatches[0];
		}
		function getUnboundRequiredValueMessage() {
			if (props.required && !inputValue.value) {
				const validationMessage = new ValidationMessage(ValidationRuleSeverityLevel.error, props.label ? translate("ValidationMessage_RequiredFieldValue_Text", props.label) : translate("ValidationMessage_RequiredFieldValue_ShortText"));
				validationMessage.shortText = props.label ? translate("ValidationMessage_RequiredFieldValue_ShortText") : void 0;
				return validationMessage;
			}
		}
		function getUnboundInvalidValueMessage() {
			if (!valid.value && inputValue.value) {
				const validationMessage = new ValidationMessage(ValidationRuleSeverityLevel.error, props.label ? translate("ValidationMessage_InvalidFieldValue_Text", inputValue.value, props.label) : translate("ValidationMessage_InvalidFieldValue_ShortText"));
				validationMessage.shortText = props.label ? translate("ValidationMessage_InvalidFieldValue_ShortText", inputValue.value) : void 0;
				return validationMessage;
			}
		}
		async function loadValidItems(item, inputValue, filter) {
			return (await loadItems({
				trigger: ReferenceRetrievingTrigger.lookupValidation,
				item,
				inputValue,
				filter
			})).data ?? [];
		}
		async function loadAndDisplaySuggestions(item) {
			return loadSuggestionsPage(item, 1, false);
		}
		function handleLoadMoreSuggestionsButtonClick() {
			suggestionsLoadingHandler.value = loadSuggestionsPage(props.item, suggestionsPageNumber.value + 1, true);
		}
		async function loadSuggestionsPage(item, pageNumber, append) {
			const requestSequence = ++suggestionsRequestSequence;
			suggestionsAbortController.value?.abort();
			const abortController = new AbortController();
			suggestionsAbortController.value = abortController;
			try {
				const res = await loadItems({
					trigger: ReferenceRetrievingTrigger.lookupSuggestions,
					item,
					inputValue: inputValue.value,
					pageNumber,
					recordsByPage: suggestionsRecordsByPage,
					signal: abortController.signal
				});
				if (requestSequence !== suggestionsRequestSequence) return suggestions.value;
				applySuggestionsResponse(res, pageNumber, append);
				if (!append) {
					showSuggestions.value = isTextboxFocused();
					updateDropdownStyle();
				}
				return suggestions.value;
			} catch (error) {
				if (requestSequence !== suggestionsRequestSequence || error instanceof Error && error.name === "AbortError") return suggestions.value;
				if (append) {
					hasMoreSuggestions.value = false;
					viewModel.showError(error);
					return suggestions.value;
				}
				resetSuggestionsState();
				throw error;
			} finally {
				if (requestSequence === suggestionsRequestSequence) {
					suggestionsLoadingHandler.value = void 0;
					suggestionsAbortController.value = void 0;
				}
			}
		}
		function applySuggestionsResponse(res, pageNumber, append) {
			if (res.succeeded) {
				suggestions.value = append ? [...suggestions.value, ...res.data] : res.data;
				hasMoreSuggestions.value = res.hasMoreData;
				totalRecordCount.value = res.totalRecordCount ?? 0;
				suggestionsPageNumber.value = pageNumber;
			} else if (append) {
				hasMoreSuggestions.value = false;
				viewModel.showApiError(res.error);
			} else resetSuggestionsState();
		}
		async function persistNewReferenceValue(item, referenceValue, lookupNavigation = 0, forceDirectPersist = false) {
			const newReferenceValue = await getReferenceValue(lookupNavigation, referenceValue);
			if (newReferenceValue == void 0) {
				await persistNewValue(item, null, true, null, false, forceDirectPersist);
				return;
			}
			let newValue = newReferenceValue;
			let newDisplayValue = null;
			let selectedLookupItemValue;
			if (!props.isReference) {
				newValue = getPropertyByPath(newReferenceValue, props.definition.valueProperty.camelCaseName);
				if (props.definition.displayProperty) newDisplayValue = getPropertyByPath(referenceValue, props.definition.displayProperty.camelCaseName);
			} else if (props.property) {
				const subViewModel = viewModel.findSubViewModel(props.property.camelCaseName);
				if (subViewModel) {
					selectedLookupItemValue = new subViewModel.creator(newReferenceValue);
					newValue = selectedLookupItemValue;
				}
			}
			await runReferenceSelectedRuleAsync(item, () => selectedLookupItemValue ?? new props.definition.creator(newReferenceValue));
			await persistNewValue(item, newValue, true, newDisplayValue, false, forceDirectPersist);
		}
		async function runReferenceSelectedRuleAsync(item, getValue) {
			if (props.property) {
				const value = getValue ? getValue() : null;
				if (item && value) item.$selectedLookupItem = {
					propertyName: props.property.camelCaseName,
					value
				};
				await viewModel.runReferenceSelectedRuleAsync(props.property.camelCaseName, {
					item,
					value
				});
			}
		}
		async function getReferenceValue(lookupNavigation, reference) {
			if (shouldLoadReference(lookupNavigation)) {
				let useApiGet;
				if (referenceEntityViewName.value !== props.definition.searchEntityViewName) useApiGet = props.property?.referenceEntityViewHasApiGet ?? false;
				else useApiGet = props.definition.searchEntityViewHasApiGet;
				if (useApiGet) return getReferenceValueFromApiGet(reference);
				return getReferenceValueFromApiGetAll(reference);
			}
			return reference;
		}
		async function getReferenceValueFromApiGet(reference) {
			const keyValues = [];
			for (const keyProperty of props.definition.keyProperties) keyValues.push(getPropertyByPath(reference, keyProperty));
			return (await apiClient.getAsync({
				path: referenceEntityViewName.value,
				id: FetchApiClient.getId(keyValues)
			})).data;
		}
		async function getReferenceValueFromApiGetAll(reference) {
			const keyFilter = new Filter();
			for (const key of props.definition.keyProperties) keyFilter.add(Filter.create(key, FilterOperator.equal, getPropertyByPath(reference, key)));
			return (await apiClient.getAllAsync({
				path: referenceEntityViewName.value,
				filter: keyFilter.toODataString(),
				pageNumber: 1,
				recordsByPage: 1
			})).data?.[0];
		}
		async function persistNewValue(item, newValue, newValid, newDisplayValue, fromFreeValue = false, forceDirectPersist = false) {
			valid.value = newValid;
			if (valid.value) {
				if (newValue == null) await runReferenceSelectedRuleAsync(item, null);
				suspendPropertyValueInvalidations(item);
				emitNewValue(item, newValue, fromFreeValue, forceDirectPersist);
				if (forceDirectPersist) persistInvalidValueDirectly(item, null);
				else emitInvalidValue(item, null);
				resumePropertyValueInvalidations(item);
				setDisplayValue(item, newDisplayValue);
			} else {
				if (item) item.$selectedLookupItem = void 0;
				emitInvalidValue(item, inputValue.value);
			}
		}
		function suspendPropertyValueInvalidations(item) {
			if (item && props.property) item.suspendPropertyValueInvalidations(props.property.camelCaseName);
		}
		function resumePropertyValueInvalidations(item) {
			if (item && props.property) item.resumePropertyValueInvalidations(props.property.camelCaseName);
		}
		function shouldPersistValueDirectly(item) {
			return item !== void 0 && (item !== props.item || isInDatagrid.value);
		}
		function emitNewValue(item, newValue, fromFreeValue, forceDirectPersist) {
			if (item) {
				if (fromFreeValue) {
					setLookupFreeValue(item, newValue);
					return;
				}
				if (newValue === null) setLookupFreeValue(item, null);
			}
			if (props.property && item && (forceDirectPersist || shouldPersistValueDirectly(item))) props.property.setValue(item, newValue);
			else emitEvenUnmounted("update:modelValue", newValue);
		}
		function persistInvalidValueDirectly(item, invalidValue) {
			if (props.property && item) item.setInvalidValue(props.property.camelCaseName, invalidValue);
		}
		function emitInvalidValue(item, invalidValue) {
			if (props.property && shouldPersistValueDirectly(item)) item.setInvalidValue(props.property.camelCaseName, invalidValue);
			else emitEvenUnmounted("update:invalidValue", invalidValue);
		}
		function setLookupFreeValue(item, newValue) {
			if (!props.property?.lookupFreeValuePropertyName) return;
			viewModel.getProperty(props.property.lookupFreeValuePropertyName).setValue(item, newValue);
		}
		function shouldLoadReference(lookupNavigation) {
			let entityViewName;
			switch (lookupNavigation) {
				case 1:
					entityViewName = props.definition.creationEntityViewName;
					break;
				case 2:
					entityViewName = props.definition.editingEntityViewName;
					break;
				default: entityViewName = props.definition.searchEntityViewName;
			}
			return entityViewName !== referenceEntityViewName.value;
		}
		function openCreationUI() {
			const targetItem = props.item;
			const navigationOptions = new NavigationOptions(props.definition.creationUIViewName).withCreationMode(true).withParameter("neos-lookup-input", inputValue.value);
			navigationOptions.inheritViewContext = false;
			navigationOptions.itemAddedCallback = creationUiItemAddedCallback;
			navigationOptions.dataSavedCallback = async (sender, result, monoRecordInstance) => uiSavedCallback(1, sender, result, monoRecordInstance, targetItem);
			navigationOptions.callback = uiClosedCallback;
			setNavigationTarget(navigationOptions, props.definition.creationOpenMode);
			viewModel.navigateAsync(navigationOptions);
			clearSuggestionHandle();
		}
		function openEditingUI() {
			const targetItem = props.item;
			const navigationOptions = new NavigationOptions(props.definition.editingUIViewName).withId(getLookupEditingUIViewId(props.definition.keyProperties, props.isReference, props.modelValue));
			navigationOptions.inheritViewContext = false;
			navigationOptions.dataSavedCallback = async (sender, result, monoRecordInstance) => uiSavedCallback(2, sender, result, monoRecordInstance, targetItem);
			navigationOptions.callback = uiClosedCallback;
			setNavigationTarget(navigationOptions, props.definition.editingOpenMode);
			viewModel.navigateAsync(navigationOptions);
			clearSuggestionHandle();
		}
		/**
		* Sets the navigation target of navigation options based on the lookup definition.
		* @param navigationOptions
		* @param openMode
		*/
		function setNavigationTarget(navigationOptions, openMode) {
			navigationOptions.target = convertToNavigationTarget(openMode);
			navigationOptions.popupSize = convertToPopupSize(openMode);
		}
		function convertToNavigationTarget(openMode) {
			switch (openMode) {
				case OpenModeType.newFrame: return NavigationTarget.newFrame;
				case OpenModeType.nestedFrame: return NavigationTarget.nestedFrame;
				case OpenModeType.popupAutoSize: return NavigationTarget.popup;
				case OpenModeType.popupFullSize: return NavigationTarget.popup;
				case OpenModeType.sameFrame: return NavigationTarget.sameFrame;
				default: return NavigationTarget.default;
			}
		}
		function convertToPopupSize(openMode) {
			return openMode == OpenModeType.popupFullSize ? PopupSize.full : PopupSize.auto;
		}
		function creationUiItemAddedCallback(result) {
			let value = null;
			switch (displayProperty.value.dataType) {
				case DataType$1.string:
				case DataType$1.guid:
					value = inputValue.value;
					break;
				case DataType$1.integer:
				case DataType$1.long:
					value = Number.parseInt(inputValue.value, 10);
					if (Number.isNaN(value)) value = null;
					break;
				case DataType$1.decimal:
					value = Number.parseFloat(inputValue.value);
					if (Number.isNaN(value)) value = null;
					break;
				case DataType$1.localizableString: value = { [viewModel.localizator.localizableStringCurrentLanguage]: inputValue.value };
			}
			result.item[displayProperty.value.camelCaseName] = value;
		}
		async function uiSavedCallback(lookupNavigation, sender, result, monoRecordInstance, targetItem) {
			if (!result.hasSucceeded) return;
			if ((lookupNavigation === 1 ? result.createdItems : result.modifiedItems).length > 0 && monoRecordInstance) await persistNewReferenceValue(targetItem, monoRecordInstance.toApiRequestData(false), lookupNavigation, true);
			if (lookupNavigation === 1) await sender.closeAsync();
		}
		function uiClosedCallback() {
			setIsModalOpen(false);
		}
		function setIsModalOpen(value) {
			emitEvenUnmounted("toggleModal", value);
			if (!value) nextTick(() => focusTextbox());
			else clearSuggestionHandle();
		}
		function getModalFilter() {
			if (inputReference.value) return;
			if (!inputValue.value || formatValue(props.modelValue, props.definition.valueProperty, viewModel) === inputValue.value || props.invalidValue === inputValue.value || formattedDisplayValue.value === inputValue.value) return;
			return getSearchFilter(inputValue.value);
		}
		function openModal() {
			modalButton.value?.openModal();
		}
		function onModalOpen(options) {
			setIsModalOpen(true);
			const targetItem = props.item;
			options.withFilter(getModalFilter()).withParameter("neos-lookup-multi-selection", !!props.multiSelectionProperty && props.modelValue == null).withParameter("neos-lookup-adding-ui-view-name", props.definition.creationUIViewName).withParameter("neos-lookup-adding-ui-view-target", convertToNavigationTarget(props.definition.creationOpenMode)).withParameter("neos-lookup-adding-ui-view-popup-size", convertToPopupSize(props.definition.creationOpenMode)).withParameter("neos-lookup-adding-ui-view-saved-callback", async (sender, result, monoRecordInstance) => uiSavedCallback(1, sender, result, monoRecordInstance, targetItem)).withCallback(async (r) => {
				if (r.state === NavigationResultState.ok) {
					if (props.multiSelectionProperty && Array.isArray(r.value)) {
						emitEvenUnmounted("update:modelValue", r.value.map((v) => getPropertyByPath(v, props.multiSelectionProperty)));
						return;
					}
					await persistNewReferenceValue(props.item, r.value);
				}
				uiClosedCallback();
			}).withTitle(props.label ?? props.property?.caption);
		}
		function surroundInputValueWithWildcard() {
			clearSuggestionHandle();
			inputValue.value = `*${inputValue.value}*`;
			handleInput(inputValue.value);
		}
		async function updateDropdownStyle() {
			const currentDropdown = dropdown.value;
			if (!currentDropdown) return;
			if (currentDropdown.content) {
				currentDropdown.content.scrollTo?.({ top: 0 });
				currentDropdown.content.style.maxHeight = "";
				currentDropdown.content.style.maxWidth = "";
			}
			currentDropdown.updateDropdownStyle();
			await nextTick();
			if (currentDropdown.content) {
				const rect = currentDropdown.content.getBoundingClientRect();
				currentDropdown.content.style.maxHeight = `${rect.height}px`;
				currentDropdown.content.style.maxWidth = `${rect.width}px`;
			}
		}
		return {
			applySuggestion,
			canCreate,
			comboboxExhaustiveListIsLoading,
			comboboxExhaustiveListOfOptions,
			comboboxModelValueEx,
			computedMessageSeverity,
			computedMessageText,
			currentSuggestionIndex,
			displayProperty,
			dropdown,
			focused,
			freeValueSuggestion,
			handleActionMousedown,
			handleAiApply: () => emit("aiApply"),
			handleAiCancel: () => emit("aiCancel"),
			handleComboboxHide,
			handleComboboxShow,
			handleFocusout,
			handleInput,
			handleKeyDown,
			handleLoadMoreSuggestionsButtonClick,
			hasMoreSuggestions,
			inputValue,
			isDisabled,
			isLoading,
			isLoadingSuggestions,
			isValidating,
			modalButton,
			onModalOpen,
			openCreationUI,
			openEditingUI,
			openModal,
			showCreateButton,
			showEditingButton,
			showSuggestions,
			showSuggestionsContainsTip,
			showSuggestionsCount,
			suggestions,
			surroundInputValueWithWildcard,
			textbox,
			totalRecordCount,
			translate
		};
	}
});
//#endregion
//#region src/components/Lookup/Lookup.vue
var _hoisted_1$20 = ["data-validating"];
var _hoisted_2$12 = {
	key: 0,
	class: "lookup-suggestion-free-value"
};
function _sfc_render$22(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Combobox = resolveComponent("Combobox");
	const _component_Button = resolveComponent("Button");
	const _component_LookupModalButton = resolveComponent("LookupModalButton");
	const _component_Spinner = resolveComponent("Spinner");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_Text = resolveComponent("Text");
	const _component_Image = resolveComponent("Image");
	const _component_Divider = resolveComponent("Divider");
	const _component_LookupSuggestions = resolveComponent("LookupSuggestions");
	const _component_Dropdown = resolveComponent("Dropdown");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["lookup neos-input", { "neos-datagrid-input": _ctx.inputDisplayMode === "datagrid" }]),
		"data-validating": _ctx.isValidating
	}, [_ctx.definition.mainMode === "ExhaustiveListInCombobox" ? (openBlock(), createBlock(_component_Combobox, {
		key: 0,
		modelValue: _ctx.comboboxModelValueEx,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.comboboxModelValueEx = $event),
		focused: _ctx.focused,
		"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => _ctx.focused = $event),
		values: _ctx.comboboxExhaustiveListOfOptions,
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		placeholder: _ctx.placeholder,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.computedMessageText,
		"message-severity": _ctx.computedMessageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		loading: _ctx.comboboxExhaustiveListIsLoading,
		"display-property": _ctx.displayProperty?.camelCaseName,
		"ai-suggestion": _ctx.aiSuggestion,
		onShow: _ctx.handleComboboxShow,
		onHide: _ctx.handleComboboxHide,
		onAiApply: _ctx.handleAiApply,
		onAiCancel: _ctx.handleAiCancel
	}, null, 8, [
		"modelValue",
		"focused",
		"values",
		"label",
		"label-position",
		"placeholder",
		"disabled",
		"readonly",
		"required",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"loading",
		"display-property",
		"ai-suggestion",
		"onShow",
		"onHide",
		"onAiApply",
		"onAiCancel"
	])) : (openBlock(), createBlock(_component_Textbox, {
		key: 1,
		ref: "textbox",
		focused: _ctx.focused,
		"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => _ctx.focused = $event),
		"model-value": _ctx.inputValue,
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		placeholder: _ctx.placeholder,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.computedMessageText,
		"message-severity": _ctx.computedMessageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"character-casing": _ctx.displayProperty.characterCasing,
		"white-space-handling": _ctx.displayProperty.whiteSpaceHandling,
		"ai-suggestion": _ctx.aiSuggestion,
		onInput: _cache[3] || (_cache[3] = ($event) => _ctx.handleInput($event.target.value)),
		onKeydown: _ctx.handleKeyDown,
		onFocusout: _ctx.handleFocusout,
		onAiApply: _ctx.handleAiApply,
		onAiCancel: _ctx.handleAiCancel
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true), _ctx.showEditingButton ? (openBlock(), createBlock(_component_Button, {
			key: 0,
			class: "lookup-button lookup-button-edit",
			variant: "ghost",
			size: "small",
			icon: "open",
			tabindex: "-1",
			onMousedown: _ctx.handleActionMousedown,
			onClick: _ctx.openEditingUI
		}, null, 8, ["onMousedown", "onClick"])) : !_ctx.isDisabled && _ctx.showCreateButton ? (openBlock(), createBlock(_component_Button, {
			key: 1,
			class: "lookup-button lookup-button-create",
			size: "small",
			icon: "add",
			variant: "ghost",
			tabindex: "-1",
			onMousedown: _ctx.handleActionMousedown,
			onClick: _ctx.openCreationUI
		}, null, 8, ["onMousedown", "onClick"])) : createCommentVNode("", true)]),
		default: withCtx(() => [createVNode(_component_LookupModalButton, {
			ref: "modalButton",
			definition: _ctx.definition,
			property: _ctx.property,
			item: _ctx.item,
			"input-value": _ctx.inputValue,
			disabled: _ctx.isDisabled,
			"on-modal-open": _ctx.onModalOpen,
			onMousedown: _ctx.handleActionMousedown
		}, null, 8, [
			"definition",
			"property",
			"item",
			"input-value",
			"disabled",
			"on-modal-open",
			"onMousedown"
		]), withDirectives(createVNode(_component_Spinner, {
			size: "small",
			class: "lookup-loading"
		}, null, 512), [[vShow, _ctx.isLoading]])]),
		_: 3
	}, 8, [
		"focused",
		"model-value",
		"label",
		"label-position",
		"placeholder",
		"disabled",
		"readonly",
		"required",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"character-casing",
		"white-space-handling",
		"ai-suggestion",
		"onKeydown",
		"onFocusout",
		"onAiApply",
		"onAiCancel"
	])), _ctx.textbox ? (openBlock(), createBlock(_component_Dropdown, {
		key: 2,
		ref: "dropdown",
		active: _ctx.showSuggestions,
		"onUpdate:active": _cache[12] || (_cache[12] = ($event) => _ctx.showSuggestions = $event),
		element: _ctx.textbox?.$el,
		"limit-width-to-anchor": "min",
		"custom-class": "lookup-dropdown"
	}, {
		default: withCtx(() => [createVNode(_component_LookupSuggestions, {
			"input-value": _ctx.inputValue,
			definition: _ctx.definition,
			"display-property": _ctx.displayProperty,
			loading: _ctx.isLoadingSuggestions,
			suggestions: _ctx.suggestions,
			"current-suggestion-index": _ctx.currentSuggestionIndex,
			onOpenModal: _ctx.openModal,
			onSelect: _ctx.applySuggestion
		}, {
			header: withCtx(() => [_ctx.freeValueSuggestion ? (openBlock(), createElementBlock("div", _hoisted_2$12, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.freeValueSuggestion), 1)]),
				_: 1
			})])) : createCommentVNode("", true)]),
			footer: withCtx(() => [
				_ctx.hasMoreSuggestions ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "lookup-suggestion-action lookup-suggestion-load-more",
					onMousedown: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent"])),
					onClick: _cache[5] || (_cache[5] = (...args) => _ctx.handleLoadMoreSuggestionsButtonClick && _ctx.handleLoadMoreSuggestionsButtonClick(...args))
				}, [createVNode(_component_Image, {
					name: "dotsHorizontal",
					size: "small"
				}), _ctx.showSuggestionsCount ? (openBlock(), createBlock(_component_Text, {
					key: 0,
					size: "extrasmall",
					class: "lookup-suggestion-count"
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate("LookupSuggestionsCount", _ctx.suggestions.length, _ctx.totalRecordCount)), 1)]),
					_: 1
				})) : createCommentVNode("", true)], 32)) : createCommentVNode("", true),
				_ctx.suggestions ? (openBlock(), createBlock(_component_Divider, { key: 1 })) : createCommentVNode("", true),
				_ctx.showSuggestionsContainsTip ? (openBlock(), createElementBlock("div", {
					key: 2,
					class: "lookup-suggestion-action lookup-suggestions-contains-tip",
					onMousedown: _cache[6] || (_cache[6] = withModifiers((...args) => _ctx.handleActionMousedown && _ctx.handleActionMousedown(...args), ["prevent"])),
					onClick: _cache[7] || (_cache[7] = (...args) => _ctx.surroundInputValueWithWildcard && _ctx.surroundInputValueWithWildcard(...args))
				}, [createVNode(_component_Image, {
					name: "bulb",
					size: "small"
				}), createElementVNode("span", null, toDisplayString(_ctx.translate("LookupStartsWithTip", _ctx.inputValue)), 1)], 32)) : createCommentVNode("", true),
				createElementVNode("div", {
					class: "lookup-suggestion-action lookup-suggestion-search",
					onMousedown: _cache[8] || (_cache[8] = withModifiers((...args) => _ctx.handleActionMousedown && _ctx.handleActionMousedown(...args), ["prevent"])),
					onClick: _cache[9] || (_cache[9] = (...args) => _ctx.openModal && _ctx.openModal(...args))
				}, [createVNode(_component_Image, {
					name: "search",
					size: "small"
				}), createElementVNode("span", null, toDisplayString(_ctx.translate("LookupSearch")), 1)], 32),
				_ctx.canCreate ? (openBlock(), createElementBlock("div", {
					key: 3,
					class: "lookup-suggestion-action lookup-suggestion-create",
					onMousedown: _cache[10] || (_cache[10] = withModifiers((...args) => _ctx.handleActionMousedown && _ctx.handleActionMousedown(...args), ["prevent"])),
					onClick: _cache[11] || (_cache[11] = (...args) => _ctx.openCreationUI && _ctx.openCreationUI(...args))
				}, [createVNode(_component_Image, {
					name: "add",
					size: "small"
				}), createElementVNode("span", null, toDisplayString(_ctx.translate("Add")), 1)], 32)) : createCommentVNode("", true)
			]),
			_: 1
		}, 8, [
			"input-value",
			"definition",
			"display-property",
			"loading",
			"suggestions",
			"current-suggestion-index",
			"onOpenModal",
			"onSelect"
		])]),
		_: 1
	}, 8, ["active", "element"])) : createCommentVNode("", true)], 10, _hoisted_1$20);
}
var Lookup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Lookup_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$22], ["__scopeId", "data-v-1c2dde65"]]);
//#endregion
//#region src/utils/smartTranslate.ts
function getSmartTranslateFunction(applicationContext, eventManager, globalResourceManager, apiClient) {
	if (!applicationContext.get("SmartLocalizableString")) return;
	return async (data) => {
		const res = await apiClient.postAsync({
			path: "$neos/ai/generate-localizable-string",
			data
		});
		if (!res.succeeded) eventManager.emit("viewModel:showError", ViewModelError.fromApiError(globalResourceManager, res.error));
		return res.succeeded ? res.data : data;
	};
}
//#endregion
//#region src/utils/editPropertyComponent.ts
function getAiSuggestion(property, item) {
	const suggestion = item.$appliedSuggestions.get(property.camelCaseName);
	if (!suggestion) return;
	return {
		text: suggestion.text,
		suggestedValue: suggestion.suggestedValue
	};
}
function getEditPropertyComponent(property, item, cardMode, inputNumberType) {
	if (property.lookupDefinition) return Lookup_default;
	switch (property.dataType) {
		case DataType$1.boolean:
			if (property.getRequired(item)) return cardMode ? Switch : void 0;
			return BooleanCombobox$1;
		case DataType$1.color: return InputColor$1;
		case DataType$1.dataType:
		case DataType$1.enum: return Combobox;
		case DataType$1.autoIncrementedInteger:
		case DataType$1.decimal:
		case DataType$1.integer:
		case DataType$1.long: return inputNumberType === "calculable" ? InputNumberCalculable$1 : InputNumber$1;
		case DataType$1.date: return InputDate$1;
		case DataType$1.dateTime:
		case DataType$1.invariantDateTime: return InputDateTime$1;
		case DataType$1.localizableString: return InputLocalizableString$1;
		case DataType$1.string: return Textbox$1;
	}
}
function getEditPropertyComponentProps(property, item) {
	if (property.lookupDefinition) return {
		definition: property.lookupDefinition,
		property,
		item,
		isReference: property.dataType === void 0,
		referenceEntityViewName: property.referenceEntityViewName,
		invalidValue: item.getInvalidValue(property.camelCaseName),
		required: property.getRequired(item),
		aiSuggestion: getAiSuggestion(property, item)
	};
	switch (property.dataType) {
		case DataType$1.boolean: return {
			required: property.getRequired(item),
			aiSuggestion: getAiSuggestion(property, item)
		};
		case DataType$1.dataType:
		case DataType$1.enum: return {
			values: property.getEnabledEnumMembers(item),
			valueProperty: "name",
			displayProperty: "caption",
			required: property.getRequired(item),
			aiSuggestion: getAiSuggestion(property, item)
		};
		case DataType$1.string: return {
			maxLength: property.maxLength,
			multiLines: property.multiLines,
			characterCasing: property.characterCasing,
			whiteSpaceHandling: property.whiteSpaceHandling,
			aiSuggestion: getAiSuggestion(property, item)
		};
		case DataType$1.localizableString: return {
			label: property.datagridCaption,
			maxLength: property.maxLength,
			multiLines: property.multiLines,
			required: property.getRequired(item),
			smartTranslate: getSmartTranslateFunction(property.owner.applicationContext, property.owner.eventManager, property.owner.globalResourceManager, property.owner.apiClient),
			aiSuggestion: getAiSuggestion(property, item)
		};
		case DataType$1.decimal:
		case DataType$1.integer:
		case DataType$1.long: return {
			format: property.getFormat(item),
			aiSuggestion: getAiSuggestion(property, item)
		};
		case DataType$1.date:
		case DataType$1.dateTime:
		case DataType$1.invariantDateTime: return {
			format: property.getFormat(item),
			invalidValue: item.getInvalidValue(property.camelCaseName),
			aiSuggestion: getAiSuggestion(property, item)
		};
	}
	return { aiSuggestion: getAiSuggestion(property, item) };
}
function getEditPropertyComponentListeners(property, item, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly, onAiApply, onAiCancel) {
	const updateInvalidValue = (value) => item.setInvalidValue(property.camelCaseName, value);
	const baseListeners = {};
	if (onAiApply) baseListeners["aiApply"] = onAiApply;
	if (onAiCancel) baseListeners["aiCancel"] = onAiCancel;
	if (property.lookupDefinition) return {
		...baseListeners,
		toggleDelegateEditToComponent,
		toggleModal: toggleStayInEditMode,
		asyncValidating: toggleReadOnly
	};
	if (property.dataType === DataType$1.localizableString) return {
		...baseListeners,
		toggleModal: toggleStayInEditMode
	};
	if (property.dataType === DataType$1.dataType || property.dataType === DataType$1.enum || property.dataType === DataType$1.boolean && !property.getRequired(item)) return {
		...baseListeners,
		show: () => toggleStayInEditMode?.(true),
		hide: () => toggleStayInEditMode?.(false)
	};
	if (property.dataType === DataType$1.date || property.dataType === DataType$1.dateTime || property.dataType === DataType$1.invariantDateTime) return {
		...baseListeners,
		"update:invalidValue": updateInvalidValue,
		togglePopover: toggleStayInEditMode
	};
	return baseListeners;
}
//#endregion
//#region src/components/Label/Label.vue
var Label_default = /* @__PURE__ */ defineComponent({
	__name: "Label",
	props: {
		propertyName: {},
		item: {},
		size: {},
		weight: {},
		displayPropertyValue: {
			type: Boolean,
			default: false
		},
		requiredIndicator: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const { property, item, visible, required, aiSuggestion, handleAiApply, handleAiCancel } = useViewModelProperty(props);
		const formattedValue = useFormattedValue(property, item);
		const isRequired = computed(() => props.requiredIndicator && property.value.dataType !== DataType$1.boolean && required.value);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputLabel), {
				key: 0,
				label: unref(property).caption,
				required: isRequired.value,
				size: __props.size,
				weight: __props.weight,
				documentation: unref(property).documentation,
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, {
				default: withCtx(() => [__props.displayPropertyValue ? (openBlock(), createBlock(unref(Text$2), {
					key: 0,
					size: __props.size,
					weight: __props.weight
				}, {
					default: withCtx(() => [createTextVNode(": " + toDisplayString(unref(formattedValue)), 1)]),
					_: 1
				}, 8, ["size", "weight"])) : createCommentVNode("", true)]),
				_: 1
			}, 8, [
				"label",
				"required",
				"size",
				"weight",
				"documentation",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/DataCards/DataCard.vue
var DataCard_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DataCard",
	props: {
		last: { type: Boolean },
		current: { type: Boolean },
		selected: { type: Boolean }
	},
	emits: ["press", "longPress"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const { onPressStart, onPressEnd, onPressCancel } = usePressEvents({
			onPress() {
				emit("press");
			},
			onLongPress() {
				emit("longPress");
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Card$1), {
				space: "extrasmall",
				class: "data-card",
				"data-last": __props.last,
				"data-current": __props.current,
				"data-selected": __props.selected,
				onPointerdown: unref(onPressStart),
				onPointerup: unref(onPressEnd),
				onPointercancel: unref(onPressCancel),
				onPointerleave: unref(onPressCancel)
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, [
				"data-last",
				"data-current",
				"data-selected",
				"onPointerdown",
				"onPointerup",
				"onPointercancel",
				"onPointerleave"
			]);
		};
	}
}), [["__scopeId", "data-v-2b591ca5"]]);
//#endregion
//#region src/components/DataCards/DataCards.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$19 = { class: "data-card-content" };
//#endregion
//#region src/components/DataCards/DataCards.vue
var DataCards_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DataCards",
	props: {
		editable: { type: Boolean },
		headerPropertyName: {}
	},
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		const { translate } = useGlobalResourceManager();
		const isGrouped = computed(() => viewModel.groupDescriptions.length > 0);
		async function onRemoveGrouping() {
			viewModel.groupDescriptions = [];
			await viewModel.refreshGroupsAsync();
		}
		const virtualRepeat = useTemplateRef("virtualRepeat");
		const properties = computed(() => {
			let properties = viewModel.getDatagridProperties().filter((p) => p.datagridVisible);
			if (props.headerPropertyName) properties = properties.filter((p) => p.camelCaseName !== props.headerPropertyName);
			return properties;
		});
		const allowInlineEdit = computed(() => props.editable && !viewModel.canNeverExecuteEditAction);
		onMounted(() => viewModel.datasourceListChangedEvent.add(onDatasourceListChanged));
		onUnmounted(() => viewModel.datasourceListChangedEvent.remove(onDatasourceListChanged));
		async function onDatasourceListChanged(_viewModel, args) {
			if (virtualRepeat.value && args.type === ListChangedType.itemAdded && args.index !== void 0) virtualRepeat.value.scrollToIndex(args.index);
		}
		async function onScrollEnd() {
			await viewModel.loadMoreData();
		}
		async function onCardPress(item) {
			if (viewModel.current === item || await viewModel.requestChangingPositionAsync(viewModel.datasource.indexOf(item))) {
				await viewModel.selectOnlyItemAsync(item);
				if (viewModel.lookupContext) await viewModel.returnItemAsync(item);
				else if (viewModel.editingUIViewName) await viewModel.navigateAsync(viewModel.getEditingUIViewNavigationOptions(item));
			}
		}
		async function onCardLongPress(item) {
			await viewModel.requestChangingPositionAsync(viewModel.datasource.indexOf(item));
			await viewModel.toggleItemSelectionAsync(item);
		}
		function isLastItem(index) {
			return index === viewModel.datasource.length - 1;
		}
		function isCurrentItem(index) {
			return viewModel.position === index;
		}
		function isSelectedItem(item) {
			return viewModel.isSelected(item);
		}
		function getEditPropertyComponent$1(property, item) {
			return getEditPropertyComponent(property, item, true, viewModel.behavior.datagridInputNumberType);
		}
		function isEditableProperty(property, item) {
			return allowInlineEdit.value && !property.isExpressionCode && viewModel.getUpdateAllowed(item) && !property.getReadOnly(item);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				class: "data-cards neos-fill-parent-height",
				"data-editable": allowInlineEdit.value
			}, {
				default: withCtx(() => [isGrouped.value ? (openBlock(), createBlock(unref(DatagridNoDataOverlay), {
					key: 0,
					message: unref(translate)("DataCardsGroupingNotSupported")
				}, {
					action: withCtx(() => [createVNode(unref(Button$1), {
						label: unref(translate)("RemoveGrouping"),
						variant: "primary",
						onClick: onRemoveGrouping
					}, null, 8, ["label"])]),
					_: 1
				}, 8, ["message"])) : (openBlock(), createBlock(unref(VirtualRepeat$1), {
					key: 1,
					ref_key: "virtualRepeat",
					ref: virtualRepeat,
					data: unref(viewModel).datasource,
					onScrollEnd
				}, {
					default: withCtx(({ item, index }) => [createVNode(DataCard_default, {
						last: isLastItem(index),
						current: isCurrentItem(index),
						selected: isSelectedItem(item),
						onPress: ($event) => onCardPress(item),
						onLongPress: ($event) => onCardLongPress(item)
					}, {
						default: withCtx(() => [__props.headerPropertyName ? (openBlock(), createBlock(BoundText_default, {
							key: 0,
							item,
							"property-name": __props.headerPropertyName,
							size: "extralarge",
							weight: "strong",
							class: "data-card-header-property"
						}, null, 8, ["item", "property-name"])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "card", { item }, () => [createElementVNode("div", _hoisted_1$19, [(openBlock(true), createElementBlock(Fragment, null, renderList(properties.value, (property) => {
							return openBlock(), createElementBlock(Fragment, { key: property.camelCaseName }, [createVNode(Label_default, {
								item,
								"property-name": property.camelCaseName,
								"required-indicator": false,
								weight: "strong"
							}, null, 8, ["item", "property-name"]), isEditableProperty(property, item) ? (openBlock(), createBlock(resolveDynamicComponent(getEditPropertyComponent$1(property, item)), mergeProps({
								key: 0,
								modelValue: item[property.camelCaseName],
								"onUpdate:modelValue": ($event) => item[property.camelCaseName] = $event,
								"label-position": "hidden"
							}, { ref_for: true }, unref(getEditPropertyComponentProps)(property, item), toHandlers(unref(getEditPropertyComponentListeners)(property, item))), null, 16, ["modelValue", "onUpdate:modelValue"])) : (openBlock(), createBlock(BoundText_default, {
								key: 1,
								item,
								"property-name": property.camelCaseName
							}, null, 8, ["item", "property-name"]))], 64);
						}), 128))])], true)]),
						_: 2
					}, 1032, [
						"last",
						"current",
						"selected",
						"onPress",
						"onLongPress"
					])]),
					_: 3
				}, 8, ["data"]))]),
				_: 3
			}, 8, ["data-editable"]);
		};
	}
}), [["__scopeId", "data-v-d51a4d66"]]);
//#endregion
//#region src/utils/ViewModelCollectionViewGroup.ts
var ViewModelCollectionViewGroup = class ViewModelCollectionViewGroup extends CollectionViewGroup {
	/**
	* Initializes a view model collection view group.
	*
	* @param viewModel - View model collection view.
	* @param group - Group.
	* @param groupDescription - Group description.
	*/
	constructor(owner, group, groupDescription) {
		super(groupDescription, group.value, group.groupDescription.level, group.groupDescription.isLastLevel);
		this.owner = owner;
		this.group = group;
		if (this.group.expanded) {
			this.populate();
			this.opened = true;
		} else this.opened = false;
	}
	/**
	* Gets a value indicating whether the group is collapsed.
	*/
	get isCollapsed() {
		return !this.group.expanded;
	}
	async toggle(expanded, top) {
		this.group.expanded = expanded;
		if (this.group.expanded && !this.opened) {
			if (this.group instanceof ServerGroup) await this.loadData(top);
			else this.populate();
			this.opened = true;
		}
	}
	async loadData(top) {
		if (this.group instanceof ServerGroup && await this.group.loadData(top)) this.populate();
	}
	/**
	* Calculates an aggregate value for the items in this group.
	*/
	getAggregate(aggType, binding) {
		return this.group.summaries[binding];
	}
	populate() {
		this._items = this.group.items;
		this._groups = this.group.groups.map((group) => new ViewModelCollectionViewGroup(this.owner, group, this.owner.groupDescriptions[group.groupDescription.level]));
		this.owner.collectionChanged.raise(this, DatagridCollectionChangedEventArgs.reset);
	}
};
//#endregion
//#region src/composables/useDatagridCellFormatting.ts
var images = {
	en: "i-twemoji-flag-united-kingdom",
	fr: "i-twemoji-flag-france",
	es: "i-twemoji-flag-spain",
	de: "i-twemoji-flag-germany",
	it: "i-twemoji-flag-italy"
};
var emojiRegex = /\p{Emoji}/u;
var DataGridFxIcon = "<svg class=\"datagrid-fx\" style=\"height: 1rem; width: 1rem;\" viewBox=\"0 0 24 24\"><path style=\"fill: var(--neutral-600);\" d=\"M12.42,5.29C11.32,5.19 10.35,6 10.25,7.11L10,10H12.82V12H9.82L9.38,17.07C9.18,19.27 7.24,20.9 5.04,20.7C3.79,20.59 2.66,19.9 2,18.83L3.5,17.33C3.83,18.38 4.96,18.97 6,18.63C6.78,18.39 7.33,17.7 7.4,16.89L7.82,12H4.82V10H8L8.27,6.93C8.46,4.73 10.39,3.1 12.6,3.28C13.86,3.39 15,4.09 15.66,5.17L14.16,6.67C13.91,5.9 13.23,5.36 12.42,5.29M22,13.65L20.59,12.24L17.76,15.07L14.93,12.24L13.5,13.65L16.35,16.5L13.5,19.31L14.93,20.72L17.76,17.89L20.59,20.72L22,19.31L19.17,16.5L22,13.65Z\"></path></svg>";
function formatDatagridCell(viewModel, property, item, element, readOnly, autoRowHeight = false) {
	if (item instanceof ViewModelCollectionViewGroup) formatGroupCell(viewModel, property, item, element, autoRowHeight);
	else formatItemCell(viewModel, property, item, element, readOnly, autoRowHeight);
}
function formatItemCell(viewModel, property, item, element, readOnly, autoRowHeight) {
	if (formatInvalidValue(property, item, element)) return;
	const value = property.getValue(item);
	if (formatExpressionCell(property, element, value)) return;
	if (isCheckbox(property, item, readOnly)) return;
	formatPropertyCell(viewModel, property, item, element, value);
	if (readOnly) {
		if (property.lookupDefinition) formatLookupLinkCell(viewModel, property, element, value, property.lookupDefinition);
		else formatEditingLinkCell(viewModel, property, item, element);
	}
	formatEllipsisCell(viewModel, property, element, autoRowHeight, true);
}
function formatGroupCell(viewModel, property, group, element, autoRowHeight) {
	const groupButton = getGroupButton(element);
	formatPropertyCell(viewModel, property, group.group.data, element, group.group.value);
	formatEllipsisCell(viewModel, property, element, autoRowHeight, false);
	restoreGroupButton(viewModel, property, element, group.group.value, groupButton);
}
function formatPropertyCell(viewModel, property, item, element, value) {
	if (property.lookupDefinition) {
		if (!property.dataType) {
			formatLookupReferenceCell(viewModel, element, value, property.lookupDefinition);
			return;
		}
		if (value == void 0 && property.lookupFreeValuePropertyName && item[property.lookupFreeValuePropertyName]) {
			formatCell(viewModel, viewModel.getProperty(property.lookupFreeValuePropertyName).getFormatOptions(item), element, item[property.lookupFreeValuePropertyName]);
			return;
		}
		if (property.lookupDefinition.displayProperty) {
			formatLookupScalarCell(viewModel, property, item, element, value, property.lookupDefinition.displayProperty);
			return;
		}
	}
	formatCell(viewModel, property.getFormatOptions(item), element, value);
	if (property.multiLines) {
		element.style.whiteSpace = "pre-wrap";
		element.style.lineHeight = "normal";
	}
}
function formatLookupReferenceCell(viewModel, element, value, lookupDefinition) {
	if (value && typeof value === "object") {
		const displayProperty = getLookupDisplayProperty(lookupDefinition);
		value = getPropertyByPath(value, displayProperty.camelCaseName);
		formatCell(viewModel, displayProperty, element, value);
	} else element.textContent = "";
}
function formatLookupScalarCell(viewModel, property, item, element, value, displayProperty) {
	if (value == null) {
		element.textContent = "";
		return;
	}
	formatDisplayValue(property.getLookupDisplayPropertyValueSync(item));
	if (item instanceof Model) {
		if (property.hasRunningLookupDisplayPropertyValueInvalidation(item)) property.getLookupDisplayPropertyValue(item).then(formatDisplayValue);
		else if (!property.lookupDisplayProperty && !property.hasLookupDisplayPropertyValue(item)) item.invalidateValueProperty(property.camelCaseName, false).then(() => formatDisplayValue(property.getLookupDisplayPropertyValueSync(item)));
	}
	function formatDisplayValue(displayValue) {
		if (displayValue !== void 0) formatCell(viewModel, displayProperty, element, displayValue);
		else element.textContent = `<${value}>`;
	}
}
function formatCell(viewModel, options, element, value) {
	switch (options.dataType) {
		case DataType$1.color:
			formatColorCell(element, value);
			break;
		case DataType$1.file:
			formatFileCell(element, value);
			break;
		case DataType$1.localizableString:
			formatLocalizableStringCell(viewModel, element, value);
			break;
		default: element.textContent = formatValue(value, options, viewModel);
	}
}
function formatInvalidValue(property, item, element) {
	const invalidValue = item.getInvalidValue(property.camelCaseName);
	if (invalidValue !== null) {
		element.textContent = invalidValue;
		return true;
	}
	return false;
}
function formatExpressionCell(property, element, value) {
	if (property.isExpressionCode && property.dataType !== DataType$1.boolean && typeof value === "string" && value.startsWith("=")) {
		element.innerHTML = DataGridFxIcon;
		return true;
	}
	return false;
}
function isCheckbox(property, item, readOnly) {
	return property.dataType === DataType$1.boolean && (readOnly || property.getRequired(item));
}
function formatColorCell(element, value) {
	if (value) {
		const stringValue = value;
		element.innerHTML = `<div class="color-cell"><div class='colorbox' style='background:${stringValue}' /></div><div>${stringValue}</div></div>`;
	} else element.textContent = "";
}
function formatFileCell(element, value) {
	if (value instanceof FileReference) {
		const button = document.createElement("button");
		button.className = "datagrid-file-cell-button";
		button.innerHTML = `<div data-src='${value.url}' class="image i-mdi-eye image-small"></div>`;
		button.tabIndex = -1;
		button.addEventListener("click", () => {
			window.open(value.url, "_blank");
		});
		button.addEventListener("mousedown", (e) => e.stopPropagation());
		element.replaceChildren(button);
	} else element.textContent = "";
}
function formatLocalizableStringCell(viewModel, element, value) {
	element.innerHTML = "";
	if (value && typeof value === "object") {
		const translations = value;
		const currentLanguageValue = translations[viewModel.localizator.localizableStringCurrentLanguage];
		if (currentLanguageValue) {
			element.textContent = currentLanguageValue;
			return;
		}
		const defaultLanguageValue = translations[viewModel.localizator.localizableStringDefaultLanguage];
		if (defaultLanguageValue) element.innerHTML = `<div class="datagrid-localizable-string-cell"><div>${document.createTextNode(defaultLanguageValue).textContent}</div><div class="image ${images[viewModel.localizator.localizableStringDefaultLanguage]} image-small"></div></div>`;
	}
}
function formatLookupLinkCell(viewModel, property, element, value, lookupDefinition) {
	if (viewModel.lookupContext?.templateMode !== LookupTemplateMode.default && lookupDefinition.editingUIViewName) formatLinkCell(viewModel, element, () => new NavigationOptions(lookupDefinition.editingUIViewName).withId(getLookupEditingUIViewId(lookupDefinition.keyProperties, !property.dataType, value)));
}
function formatEditingLinkCell(viewModel, property, item, element) {
	if (viewModel.lookupContext?.templateMode !== LookupTemplateMode.default && viewModel.editingUIViewName && property.name === viewModel.editingLinkPropertyName) formatLinkCell(viewModel, element, () => new NavigationOptions(viewModel.editingUIViewName).withId(item.$key));
}
function formatLinkCell(viewModel, element, getNavigationOptions) {
	const button = document.createElement("button");
	button.className = "datagrid-link-cell-button";
	button.textContent = element.textContent;
	button.tabIndex = -1;
	button.addEventListener("click", (e) => {
		const target = e.ctrlKey ? NavigationTarget.newFrame : NavigationTarget.default;
		viewModel.navigateAsync(getNavigationOptions().onTarget(target));
	});
	button.addEventListener("mousedown", (e) => e.stopPropagation());
	element.replaceChildren(button);
}
function formatEllipsisCell(viewModel, property, element, autoRowHeight, align) {
	let ellipsis = viewModel.behavior.datagridEllipsis && property.ellipsis;
	ellipsis &&= !property.multiLines || !autoRowHeight;
	if (ellipsis && element.textContent) {
		let childElement = element.firstElementChild;
		if (!childElement) {
			childElement = document.createElement("span");
			childElement.innerHTML = element.innerHTML;
			element.replaceChildren(childElement);
		}
		childElement.classList.add("datagrid-ellipsis-cell");
		childElement.title = element.textContent;
		if (align) childElement.style.textAlign = property.getTextAlign();
	}
}
function getGroupButton(element) {
	return element.querySelector(".wj-elem-collapse");
}
function restoreGroupButton(viewModel, property, element, value, groupButton) {
	if (groupButton) {
		element.prepend(groupButton);
		if (property.dataType !== DataType$1.boolean && (value === void 0 || value === null)) element.insertAdjacentHTML("beforeend", `<span style="color: var(--input-placeholder);">${viewModel.globalResourceManager.get("Undefined")}</span>`);
	}
}
function formatDatagridCellWithStyleRules(viewModel, property, item, element, appContext, themeManager) {
	const result = viewModel.evaluateStyleRules(item, property.name);
	if (result) {
		setElementColorStyle(element, result, themeManager.currentTheme.colorScheme);
		setElementTextStyle(element, result);
		setElementIcon(element, result, appContext);
		setElementHorizontalAlign(property, element, result);
	} else {
		resetElementStyle(element);
		resetElementHorizontalAlign(property, element);
	}
}
function setAiSuggestionIndicator(viewModel, property, item, element, appContext) {
	const suggestion = item.$appliedSuggestions.get(property.camelCaseName);
	const existingIndicator = element.querySelector(".ai-suggestion-indicator-container");
	if (!suggestion) {
		if (existingIndicator) existingIndicator.remove();
		return;
	}
	if (existingIndicator) return;
	const container = document.createElement("div");
	container.className = "ai-suggestion-indicator-container";
	container.style.display = "flex";
	container.style.flexGrow = "1";
	container.style.alignItems = "center";
	container.style.gap = SpaceValues["extrasmall"];
	const indicatorWrapper = document.createElement("span");
	const vnode = h(AiSuggestionIndicator, {
		suggestion: {
			text: suggestion.text,
			suggestedValue: suggestion.suggestedValue
		},
		animated: false,
		onApply: () => viewModel.acceptAutoSuggest(item, property.camelCaseName),
		onCancel: () => viewModel.cancelAutoSuggest(item, property.camelCaseName)
	});
	vnode.appContext = appContext;
	render(vnode, indicatorWrapper);
	container.append(indicatorWrapper);
	const content = document.createElement("div");
	const currentValue = property.getValue(item);
	if (currentValue !== null && currentValue !== void 0 && currentValue !== "") content.append(...element.childNodes);
	else if (suggestion.suggestedValue !== null && suggestion.suggestedValue !== void 0) {
		content.textContent = formatValue(suggestion.suggestedValue, property.getFormatOptions(item), viewModel);
		content.style.color = "var(--input-placeholder)";
		content.style.fontStyle = "italic";
	}
	container.append(content);
	element.replaceChildren(container);
}
function setNotLoadedIndicator(property, item, element) {
	if (property.isLoaded(item)) return;
	element.textContent = "—";
	element.style.color = "var(--input-placeholder)";
}
function setElementColorStyle(element, result, colorScheme) {
	if (colorScheme === "dark") {
		element.style.backgroundColor = result.darkBackgroundColor ?? result.lightBackgroundColor ?? "";
		element.style.color = result.darkForegroundColor ?? result.lightForegroundColor ?? "";
	} else {
		element.style.backgroundColor = result.lightBackgroundColor ?? result.darkBackgroundColor ?? "";
		element.style.color = result.lightForegroundColor ?? result.darkForegroundColor ?? "";
	}
}
function setElementTextStyle(element, result) {
	element.style.fontWeight = result.bold ? "bold" : "";
	element.style.fontStyle = result.italic ? "italic" : "";
	if (result.underline && result.strikethrough) element.style.textDecoration = "underline line-through";
	else if (result.underline) element.style.textDecoration = "underline";
	else if (result.strikethrough) element.style.textDecoration = "line-through";
	else element.style.textDecoration = "";
}
function setElementIcon(element, result, appContext) {
	if (result.iconName) {
		const container = document.createElement("div");
		container.style.display = "flex";
		container.style.flexGrow = "1";
		container.style.alignItems = "center";
		container.style.gap = SpaceValues["small"];
		if (emojiRegex.test(result.iconName)) {
			const emoji = document.createElement("span");
			emoji.className = "datagrid-emoji";
			emoji.textContent = result.iconName;
			container.append(emoji);
		} else {
			const image = h(Image$2, { name: result.iconName });
			image.appContext = appContext;
			render(image, container);
		}
		if (result.contentDisplayMode !== StyleRuleContentDisplayMode.icon) {
			const content = document.createElement("div");
			content.append(...element.childNodes);
			if (result.contentDisplayMode === StyleRuleContentDisplayMode.iconAfterText) container.prepend(content);
			else container.append(content);
		}
		element.replaceChildren(container);
	}
}
function setElementHorizontalAlign(property, element, result) {
	const childElement = element.firstElementChild;
	if (childElement?.style.textAlign) switch (result.horizontalAlign) {
		case ContentAlign.start:
			childElement.style.textAlign = "start";
			break;
		case ContentAlign.center:
			childElement.style.textAlign = "center";
			break;
		case ContentAlign.end:
			childElement.style.textAlign = "end";
			break;
		default: childElement.style.textAlign = property.getTextAlign();
	}
	else switch (result.horizontalAlign) {
		case ContentAlign.start:
			element.style.alignItems = "flex-start";
			break;
		case ContentAlign.center:
			element.style.alignItems = "center";
			break;
		case ContentAlign.end:
			element.style.alignItems = "flex-end";
			break;
		default: element.style.alignItems = convertTextAlignToAlignItems(property.getTextAlign(), false);
	}
}
function resetElementStyle(element) {
	element.style.backgroundColor = "";
	element.style.color = "";
	element.style.fontWeight = "";
	element.style.fontStyle = "";
	element.style.textDecoration = "";
}
function resetElementHorizontalAlign(property, element) {
	const childElement = element.firstElementChild;
	const textAlign = property.getTextAlign();
	if (childElement?.style.textAlign) childElement.style.textAlign = textAlign;
	else element.style.alignItems = convertTextAlignToAlignItems(textAlign, false);
}
//#endregion
//#region src/composables/useDatagridFooter.ts
function useDatagridFooter(props, slots, viewModel, allowInfiniteScrolling) {
	const showFooterCounts = computed(() => {
		if (props.footerCounts !== void 0) return props.footerCounts;
		return viewModel.groupDescriptions.length === 0 && allowInfiniteScrolling.value && !viewModel.parentRelation;
	});
	const footerActions = computed(() => viewModel.actions.filterByLocation(ViewModelActionLocation.datagridFooter));
	return {
		footerActions,
		showFooter: computed(() => showFooterCounts.value || !!slots.footer || footerActions.value.length > 0),
		showFooterCounts
	};
}
//#endregion
//#region src/composables/useDatagridNotLoadedBanner.ts
var COUNT_FALLBACK_THRESHOLD = 4;
function joinCaptions(captions, and) {
	const quoted = captions.map((caption) => `'${caption}'`);
	if (quoted.length === 1) return quoted[0];
	const last = quoted.pop();
	return `${quoted.join(", ")} ${and} ${last}`;
}
function useDatagridNotLoadedBanner(viewModel) {
	const notLoadedVisibleCaptions = computed(() => viewModel.getDatagridProperties().filter((property) => property.datagridVisible && property.loadState !== PropertyLoadState.loaded).map((property) => property.datagridCaption));
	const showBanner = computed(() => notLoadedVisibleCaptions.value.length > 0);
	const bannerText = computed(() => {
		const captions = notLoadedVisibleCaptions.value;
		if (captions.length >= COUNT_FALLBACK_THRESHOLD) return stringFormat(viewModel.globalResourceManager.get("DatagridNotLoadedColumnsCountMessage"), captions.length);
		const and = viewModel.globalResourceManager.get("And").toLocaleLowerCase();
		const messageKey = captions.length === 1 ? "DatagridNotLoadedColumnMessage" : "DatagridNotLoadedColumnsMessage";
		return stringFormat(viewModel.globalResourceManager.get(messageKey), joinCaptions(captions, and));
	});
	async function refresh() {
		await viewModel.loadDataAsync();
	}
	return {
		showBanner,
		bannerText,
		refresh
	};
}
//#endregion
//#region src/navigation/enterKeyActsAsTab.ts
var focusSelector = [
	"input:not([disabled]):not([readonly]):not([type=\"hidden\"])",
	"select:not([disabled])",
	"button:not([disabled])",
	"a[href]",
	"[contenteditable=\"true\"]",
	"[tabindex]:not([tabindex=\"-1\"])",
	".wj-flexgrid"
].join(", ");
function isEnterKeyActsAsTabEnabled(applicationContext) {
	return applicationContext.getValue("UserEnterKeyActsAsTab", false);
}
function shouldHandleEnterKeyActsAsTab(event, applicationContext) {
	return event.key === "Enter" && !event.isComposing && !event.defaultPrevented && !event.altKey && !event.ctrlKey && !event.metaKey && !isExcludedElement(document.activeElement) && isEnterKeyActsAsTabEnabled(applicationContext);
}
function handleEnterKeyActsAsTab(event) {
	const activeElement = document.activeElement;
	const targetFocusableElement = getAdjacentFocusableElement(activeElement, event.shiftKey ? -1 : 1);
	if (!targetFocusableElement) return false;
	event.preventDefault();
	event.stopImmediatePropagation();
	targetFocusableElement.focus();
	return true;
}
function getAdjacentFocusableElement(activeElement, offset) {
	const rootElement = getFocusRoot(activeElement);
	const focusableElements = [...rootElement.matches(focusSelector) ? [rootElement] : [], ...rootElement.querySelectorAll(focusSelector)].filter(isVisibleFocusableElement);
	const activeFocusableElement = getFocusableElement(activeElement);
	const activeElementIndex = focusableElements.indexOf(activeFocusableElement);
	if (activeElementIndex === -1 || focusableElements.length === 0) return;
	return focusableElements[(activeElementIndex + offset + focusableElements.length) % focusableElements.length];
}
function isVisibleFocusableElement(element) {
	if (element.tabIndex < 0) return false;
	let currentElement = element;
	while (currentElement) {
		const style = window.getComputedStyle(currentElement);
		if (currentElement.hidden || style.display === "none" || style.visibility === "hidden" || style.visibility === "collapse") return false;
		currentElement = currentElement.parentElement;
	}
	return true;
}
function getFocusRoot(activeElement) {
	return activeElement.closest(".modal") ?? document.body;
}
function getFocusableElement(activeElement) {
	if (activeElement.matches(focusSelector)) return activeElement;
	return activeElement.closest(focusSelector) ?? activeElement;
}
function isExcludedElement(element) {
	return element?.closest("button, .quick-search") !== null;
}
//#endregion
//#region src/utils/ViewModelCollectionView.ts
var ViewModelCollectionView = class extends DatagridCollectionView {
	/**
	* Initializes a ViewModelCollectionView.
	* @param viewModel - ViewModel.
	*/
	constructor(viewModel, datasource) {
		super();
		this._isDatasourceChanging = false;
		this._useEntityViewDefaultSort = true;
		this.viewModel = viewModel;
		this.sourceCollection = datasource ?? viewModel.datasource;
		this.items = this.sourceCollection;
		this.currentPosition = viewModel.position;
		this.groupDescriptions = new ObservableArray(this.getViewModelGroupDescriptions());
		this.sortDescriptions = new ObservableArray(this.getViewModelSortDescriptions());
		this.groups = viewModel.groups.map((group) => new ViewModelCollectionViewGroup(this, group, this.groupDescriptions[group.groupDescription.level]));
		this._sortDescriptionsHandler = this.handleSortDescriptionsChanged.bind(this);
		this.sortDescriptions.collectionChanged.addHandler(this._sortDescriptionsHandler);
		this._groupDescriptionsHandler = this.handleGroupDescriptionsChanged.bind(this);
		this.groupDescriptions.collectionChanged.addHandler(this._groupDescriptionsHandler);
		if (datasource instanceof ObservableList) {
			this._listChangedHandler = this.handleListChanged.bind(this);
			datasource.listChangedEvent.add(this._listChangedHandler);
		} else if (!datasource) {
			this._datasourceChangedHandler = this.handleDatasourceChanged.bind(this);
			this.viewModel.datasourceChangedEvent.add(this._datasourceChangedHandler);
			this._datasourceListChangedHandler = this.handleDatasourceListChanged.bind(this);
			this.viewModel.datasourceListChangedEvent.add(this._datasourceListChangedHandler);
			this._positionChangedHandler = this.handlePositionChanged.bind(this);
			this.viewModel.positionChangedEvent.add(this._positionChangedHandler);
			this._groupsChangedHandler = this.handleGroupsChanged.bind(this);
			this.viewModel.groups.changedEvent.add(this._groupsChangedHandler);
			this._clientSideFilteredDatasourceChangedHandler = this.handleClientSideFilteredDatasourceChanged.bind(this);
			this.viewModel.clientSideFilteredDatasourceChangedEvent.add(this._clientSideFilteredDatasourceChangedHandler);
			this._validatedHandler = this.handleValidated.bind(this);
			this.viewModel.validatedEvent.add(this._validatedHandler);
			this._itemPropertyMetadataChangedHandler = this.handleItemPropertyMetadataChanged.bind(this);
			this.viewModel.itemPropertyMetadataChangedEvent.add(this._itemPropertyMetadataChangedHandler);
		}
	}
	/**
	* Gets the current item.
	*/
	get currentItem() {
		return this.viewModel.current;
	}
	/**
	* Gets the current add item.
	*/
	get currentAddItem() {
		return this.viewModel.addNewItem;
	}
	/**
	* Gets the current add item.
	*/
	get isAddingNew() {
		return this.viewModel.isAddingAddNewItem;
	}
	/**
	* Disposes.
	*/
	dispose() {
		this.sortDescriptions.collectionChanged.removeHandler(this._sortDescriptionsHandler);
		this.groupDescriptions.collectionChanged.removeHandler(this._groupDescriptionsHandler);
		if (this._listChangedHandler && this.sourceCollection instanceof ObservableList) this.sourceCollection.listChangedEvent.remove(this._listChangedHandler);
		else {
			this.viewModel.datasourceChangedEvent.remove(this._datasourceChangedHandler);
			this.viewModel.datasourceListChangedEvent.remove(this._datasourceListChangedHandler);
			this.viewModel.positionChangedEvent.remove(this._positionChangedHandler);
			this.viewModel.groups.changedEvent.remove(this._groupsChangedHandler);
			this.viewModel.clientSideFilteredDatasourceChangedEvent.remove(this._clientSideFilteredDatasourceChangedHandler);
			this.viewModel.validatedEvent.remove(this._validatedHandler);
			this.viewModel.itemPropertyMetadataChangedEvent.remove(this._itemPropertyMetadataChangedHandler);
		}
	}
	/**
	* Handles the datasource changed event.
	*/
	handleDatasourceChanged(datasource) {
		this.sourceCollection = datasource;
		this.items = this.sourceCollection;
	}
	/**
	* Handles the datasource list changed event.
	*/
	handleDatasourceListChanged(viewModel, args) {
		if (this.items === this.sourceCollection) {
			this.sourceCollection = viewModel.datasource;
			this.items = this.sourceCollection;
		} else if (!this.updateItemsWithListChangedArgs(args)) return;
		this._isDatasourceChanging = true;
		if (this.viewModel.lastAddedItem) this.lastAddedItem = this.viewModel.lastAddedItem;
		if (args.type === ListChangedType.reset) {
			this.groupDescriptions.splice(0, this.groupDescriptions.length, ...this.getViewModelGroupDescriptions());
			this.sortDescriptions.splice(0, this.sortDescriptions.length, ...this.getViewModelSortDescriptions());
		}
		this.collectionChanged.raise(this, this.convertListChangedArgsToCollectionChangedArgs(args));
		this._isDatasourceChanging = false;
	}
	getViewModelGroupDescriptions() {
		return this.viewModel.groupDescriptions.map((property) => new PropertyGroupDescription(property));
	}
	getViewModelSortDescriptions() {
		let sort = this.viewModel.dataSorts;
		if (this._useEntityViewDefaultSort && sort.length === 0 && this.viewModel.entityViewDefaultSort) sort = this.viewModel.entityViewDefaultSort.filter((s) => {
			const property = this.viewModel.findProperty(s.propertyName);
			return property && property.displayable && property.sortable;
		});
		return sort.map((s) => new SortDescription(s.propertyName, s.direction === SortDirection.asc));
	}
	updateItemsWithListChangedArgs(args) {
		if (args.type === ListChangedType.itemAdded) {
			this.items.push(args.item);
			args.index = this.items.length - 1;
			return true;
		}
		if (args.item) {
			args.index = this.items.indexOf(args.item);
			if (args.index === -1) return false;
			if (args.type === ListChangedType.itemRemoved) this.items.splice(args.index, 1);
		}
		return true;
	}
	/**
	* Handles the list changed event.
	*/
	handleListChanged(args) {
		this.collectionChanged.raise(this, this.convertListChangedArgsToCollectionChangedArgs(args));
	}
	/**
	* Handles the position changed event.
	*/
	handlePositionChanged(position) {
		this.currentPosition = position;
	}
	/**
	* Handles the groups changed event.
	*/
	handleGroupsChanged(groups) {
		this.groups = groups.map((group) => new ViewModelCollectionViewGroup(this, group, this.groupDescriptions[group.groupDescription.level]));
		this.collectionChanged.raise(this, DatagridCollectionChangedEventArgs.reset);
	}
	/**
	* Handles the client-side filtered datasource changed event.
	*/
	handleClientSideFilteredDatasourceChanged(filteredDatasource) {
		this.items = filteredDatasource ?? this.sourceCollection;
		this.collectionChanged.raise(this, DatagridCollectionChangedEventArgs.reset);
	}
	/**
	* Handles the sort descriptions changed event.
	* @param descriptions - Descriptions.
	*/
	async handleSortDescriptionsChanged(descriptions) {
		if (this._isDatasourceChanging) return;
		this._useEntityViewDefaultSort = false;
		this.viewModel.clearSort();
		for (const description of descriptions) this.viewModel.setSort(description.property, description.ascending ? SortDirection.asc : SortDirection.desc);
		await this.viewModel.sortAsync(true);
		if (this.viewModel.clientSideFilter) this.viewModel.clientSideFilterData(false);
		uiViewEvents.layoutUpdated.raiseDebounced(this.viewModel);
	}
	/**
	* Handles the group descriptions changed event.
	* @param descriptions - Descriptions.
	*/
	async handleGroupDescriptionsChanged(descriptions) {
		if (this._isDatasourceChanging) return;
		this.viewModel.groupDescriptions = descriptions.map((description) => description.propertyName);
		await this.viewModel.refreshGroupsAsync();
		if (this.viewModel.groupDescriptions.length === 0) this.handleGroupsChanged(this.viewModel.groups);
		uiViewEvents.layoutUpdated.raiseDebounced(this.viewModel);
	}
	/**
	* Handles the validated event.
	*/
	async handleValidated() {
		this.collectionChanged.raise(this, DatagridCollectionChangedEventArgs.reset);
	}
	/**
	* Handles the item property metadata changed event.
	* @param args - The event args.
	*/
	handleItemPropertyMetadataChanged(args) {
		const index = this.items.indexOf(args.item);
		if (index === -1) return;
		this.collectionChanged.raise(this, new DatagridCollectionChangedEventArgs(NotifyCollectionChangedAction.Change, args.item, index, args.propertyName, void 0, true));
	}
	/**
	* Converts the list changed args to the collection changed args.
	*/
	convertListChangedArgsToCollectionChangedArgs(args) {
		switch (args.type) {
			case ListChangedType.itemAdded: return new DatagridCollectionChangedEventArgs(NotifyCollectionChangedAction.Add, args.item, args.index);
			case ListChangedType.itemRemoved: return new DatagridCollectionChangedEventArgs(NotifyCollectionChangedAction.Remove, args.item, args.index);
			case ListChangedType.itemChanged: return new DatagridCollectionChangedEventArgs(NotifyCollectionChangedAction.Change, args.item, args.index, args.itemChangedArgs.propertyName, args.itemChangedArgs.value);
			default: return DatagridCollectionChangedEventArgs.reset;
		}
	}
};
//#endregion
//#region src/components/DatagridFooter/DatagridFooter.vue
var DatagridFooter_default = /* @__PURE__ */ defineComponent({
	__name: "DatagridFooter",
	props: {
		source: {},
		counts: { type: Boolean },
		selectionColumn: { type: Boolean },
		actions: {}
	},
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const themeManager = useThemeManager(false);
		const viewModel = useViewModel();
		const buttonContainerSpace = useButtonContainerSpace(themeManager);
		const loadedItemsTooltip = computed(() => translate("DatagridFooterLoadedItems", viewModel.datasource.length));
		const selectedItemsCount = computed(() => props.source ? props.source.filter((item) => item.$selected).length : viewModel.selectedItems.length);
		const totalRecordCount = computed(() => props.source ? props.source.length : viewModel.totalRecordCount);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(HorizontalLayout$1), {
				wrap: false,
				class: "neos-fill-parent-height"
			}, {
				default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
					wrap: false,
					class: "neos-fill-parent-width"
				}, {
					default: withCtx(() => [__props.counts ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
						key: 0,
						"vertical-align": "center",
						class: "datagrid-footer-counts"
					}, {
						default: withCtx(() => [__props.selectionColumn ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(HorizontalLayout$1), {
							space: "extrasmall",
							"vertical-align": "center"
						}, {
							default: withCtx(() => [createVNode(unref(Text$2), { weight: "strong" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(selectedItemsCount.value), 1)]),
								_: 1
							}), createVNode(unref(Text$2), null, {
								default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("DatagridFooterSelectedItems")), 1)]),
								_: 1
							})]),
							_: 1
						}), createVNode(unref(Text$2), null, {
							default: withCtx(() => [..._cache[0] || (_cache[0] = [createTextVNode("/", -1)])]),
							_: 1
						})], 64)) : createCommentVNode("", true), createVNode(unref(HorizontalLayout$1), {
							space: "extrasmall",
							"vertical-align": "center",
							title: loadedItemsTooltip.value
						}, {
							default: withCtx(() => [createVNode(unref(Text$2), { weight: "strong" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(totalRecordCount.value), 1)]),
								_: 1
							}), createVNode(unref(Text$2), null, {
								default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("DatagridFooterItems")), 1)]),
								_: 1
							})]),
							_: 1
						}, 8, ["title"])]),
						_: 1
					})) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default")]),
					_: 3
				}), __props.actions.length > 0 ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
					key: 0,
					align: "right",
					"vertical-align": "center",
					space: unref(buttonContainerSpace),
					wrap: false,
					class: "datagrid-footer-buttons"
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.actions, (action) => {
						return openBlock(), createBlock(ActionButton_default, {
							key: action.name,
							action
						}, null, 8, ["action"]);
					}), 128))]),
					_: 1
				}, 8, ["space"])) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
});
//#endregion
//#region src/components/DatagridNotLoadedBanner/DatagridNotLoadedBanner.vue
var DatagridNotLoadedBanner_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DatagridNotLoadedBanner",
	props: { viewModel: {} },
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const { showBanner, bannerText, refresh } = useDatagridNotLoadedBanner(props.viewModel);
		return (_ctx, _cache) => {
			return unref(showBanner) ? (openBlock(), createBlock(unref(Message$1), {
				key: 0,
				class: "datagrid-not-loaded-banner",
				severity: "info",
				closable: false
			}, {
				default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
					align: "space-between",
					"vertical-align": "center",
					class: "neos-fill-parent-width"
				}, {
					default: withCtx(() => [createVNode(unref(Text$2), null, {
						default: withCtx(() => [createTextVNode(toDisplayString(unref(bannerText)), 1)]),
						_: 1
					}), createVNode(unref(Button$1), {
						label: unref(translate)("Refresh"),
						variant: "primary",
						icon: "refresh",
						size: "small",
						onClick: unref(refresh)
					}, null, 8, ["label", "onClick"])]),
					_: 1
				})]),
				_: 1
			})) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-9fa31151"]]);
//#endregion
//#region src/composables/useImageDelegatedLoading.ts
var unreferencedUrlsCache = new LRUCache({
	max: 50,
	dispose: (value) => {
		if (value.referenceCount == 0) URL.revokeObjectURL(value.blobUrl);
	},
	ttl: 36e5,
	allowStale: false,
	updateAgeOnGet: true,
	updateAgeOnHas: true
});
var referencedUrlsCache = /* @__PURE__ */ new Map();
var CacheEntry = class {
	get referenceCount() {
		return this._referenceCount;
	}
	constructor(url, blobUrl) {
		this.url = url;
		this.blobUrl = blobUrl;
		this._referenceCount = 0;
	}
	incrementReferenceCount() {
		this._referenceCount++;
		if (this._referenceCount == 1) {
			referencedUrlsCache.set(this.url, this);
			unreferencedUrlsCache.delete(this.url);
		}
	}
	decrementReferenceCount() {
		this._referenceCount--;
		if (this._referenceCount == 0) {
			referencedUrlsCache.delete(this.url);
			unreferencedUrlsCache.set(this.url, this);
		}
	}
	static find(url) {
		const cacheEntry = referencedUrlsCache.get(url);
		if (cacheEntry) return cacheEntry;
		return unreferencedUrlsCache.get(url);
	}
};
function useImageDelegatedLoading(applicationContext, props, source) {
	const originalSource = computed(() => source?.value);
	const componentSource = ref();
	let componentCacheEntry;
	let disposed = false;
	function resetComponentCacheEntry() {
		if (componentCacheEntry) {
			componentCacheEntry.decrementReferenceCount();
			componentCacheEntry = void 0;
		}
	}
	watch([originalSource, () => props.delegatedLoading], async ([source, delegatedLoading]) => {
		componentSource.value = void 0;
		if (!delegatedLoading || source === void 0) {
			resetComponentCacheEntry();
			componentSource.value = source;
			return;
		}
		const cacheEntry = CacheEntry.find(source);
		if (cacheEntry) {
			resetComponentCacheEntry();
			componentCacheEntry = cacheEntry;
		} else {
			let blob;
			try {
				const res = await FetchApiClient.fetchWithTimeout(new Request(source, {
					method: "GET",
					headers: FetchApiClient.getHeaders(applicationContext),
					mode: "cors"
				}), FetchApiClient.getDefaultTimeout(applicationContext.webApiTimeout));
				if (disposed) return;
				blob = await res.blob();
				if (disposed) return;
			} catch (error) {
				console.error("Error fetching image:", error);
				componentSource.value = " ";
				return;
			}
			const blobUrl = URL.createObjectURL(blob);
			resetComponentCacheEntry();
			componentCacheEntry = new CacheEntry(source, blobUrl);
		}
		componentCacheEntry.incrementReferenceCount();
		componentSource.value = componentCacheEntry.blobUrl;
	}, { immediate: true });
	onScopeDispose(() => {
		disposed = true;
		resetComponentCacheEntry();
	});
	return { componentSource };
}
//#endregion
//#region src/components/ImageViewer/ImageViewer.ts?vue&type=script&src=true&lang.ts
var ImageViewer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ImageViewer",
	components: { Spinner: Spinner$1 },
	props: {
		value: {
			type: FileReference,
			default: null
		},
		delegatedLoading: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		const applicationContext = useApplicationContext();
		const src = computed(() => props.value?.url);
		const { componentSource } = useImageDelegatedLoading(applicationContext, props, src);
		const isLoading = ref(false);
		const isValid = ref(false);
		const onLoad = () => {
			isLoading.value = false;
			isValid.value = true;
		};
		const onError = () => {
			isLoading.value = false;
			isValid.value = false;
		};
		watch(src, (value) => {
			isValid.value = value === void 0;
			isLoading.value = value !== void 0 && (props.delegatedLoading ? componentSource.value === void 0 : false);
		}, { immediate: true });
		return {
			src,
			componentSource,
			onLoad,
			onError,
			isLoading,
			isValid
		};
	}
});
//#endregion
//#region src/components/ImageViewer/ImageViewer.vue
var _hoisted_1$18 = ["alt", "src"];
function _sfc_render$21(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Spinner = resolveComponent("Spinner");
	return openBlock(), createElementBlock(Fragment, null, [withDirectives(createElementVNode("img", {
		class: normalizeClass({
			"is-valid": _ctx.isValid,
			"image-cell": true
		}),
		alt: _ctx.src,
		src: _ctx.componentSource,
		onLoad: _cache[0] || (_cache[0] = (...args) => _ctx.onLoad && _ctx.onLoad(...args)),
		onError: _cache[1] || (_cache[1] = (...args) => _ctx.onError && _ctx.onError(...args))
	}, null, 42, _hoisted_1$18), [[vShow, !_ctx.isLoading && _ctx.componentSource]]), _ctx.isLoading ? (openBlock(), createBlock(_component_Spinner, {
		key: 0,
		class: "image-spinner"
	})) : createCommentVNode("", true)], 64);
}
var ImageViewer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ImageViewer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$21]]);
//#endregion
//#region src/components/Datagrid/Datagrid.ts?vue&type=script&src=true&lang.ts
function toDataAttribute(value) {
	return value || void 0;
}
function convertDataTypeToDatagridDataType(dataType) {
	switch (dataType) {
		case DataType$1.autoIncrementedInteger:
		case DataType$1.decimal:
		case DataType$1.integer:
		case DataType$1.long: return DataType.Number;
		case DataType$1.boolean: return DataType.Boolean;
		case DataType$1.date:
		case DataType$1.dateTime:
		case DataType$1.invariantDateTime: return DataType.Date;
		case DataType$1.localizableString: return DataType.Object;
		case DataType$1.stringArray: return DataType.Array;
		default: return DataType.String;
	}
}
function getDisplayComponent(property) {
	if (property.dataType == DataType$1.image) return ImageViewer_default;
}
function mapPropertiesToDatagridColumns(viewModel, slots, inputNumberType) {
	const properties = viewModel.getDatagridProperties();
	const propertiesWithSameDatagridCaption = new Set(properties.filter((p) => p.caption !== p.datagridCaption && properties.some((p2) => p !== p2 && p2.datagridCaption === p.datagridCaption)).map((p) => p.camelCaseName));
	return properties.map((p) => ({
		name: p.camelCaseName,
		get caption() {
			return p.datagridCaption;
		},
		pickerCaption: propertiesWithSameDatagridCaption.has(p.camelCaseName) ? `${p.datagridCaption} (${p.caption})` : void 0,
		dataType: p.dataType ? convertDataTypeToDatagridDataType(p.dataType) : void 0,
		visible: p.datagridVisible,
		get notLoaded() {
			return p.loadState !== PropertyLoadState.loaded;
		},
		get sortable() {
			if (!p.sortable) return false;
			if (viewModel.groupDescriptions.length > 0) {
				if (viewModel.groupDescriptions[0] !== p.camelCaseName) return false;
				if (viewModel.groupDescriptions.includes(p.camelCaseName) && p.dataType && !p.lookupDisplayProperty && !!p.lookupDefinition?.displayProperty) return false;
			}
			return p.serverSideSortable || viewModel.getClientSideSort();
		},
		groupable: p.groupable,
		editMode: p.dataType !== DataType$1.boolean,
		isExpressionCode: p.isExpressionCode,
		displayText: (v, i) => p.formatValue(v, i),
		displayTextSync: (v, i) => p.formatValueSync(v, i),
		readOnly: (i) => !viewModel.getUpdateAllowed(i) || p.getReadOnly(i),
		tabStop: (i) => p.getTabStop(i),
		format: p.getFormat(void 0),
		frozen: p.datagridFrozen,
		movable: p.datagridMovable,
		minInitialWidth: p.getMinInitialWidth(),
		width: p.datagridWidth,
		minWidth: p.datagridMinWidth ?? 28,
		maxWidth: p.datagridMaxWidth,
		get documentation() {
			return p.documentation;
		},
		tag: p,
		summaryTypes: p.summaryTypes,
		totalSummaryType: p.totalSummaryType,
		groupSummaryType: p.groupSummaryType,
		align: p.getTextAlign(),
		displayTemplate: !!slots[`${p.camelCaseName}-display`],
		editComponent: getEditPropertyComponent(p, void 0, false, inputNumberType ?? viewModel.behavior.datagridInputNumberType),
		displayComponent: getDisplayComponent(p)
	}));
}
function onStyleRuleApplicationConditionChanged(viewModel, cb) {
	const styleRuleApplicationConditionCache = /* @__PURE__ */ new WeakMap();
	watchEffect(() => {
		const styleRules = viewModel.getAllStyleRules();
		if (styleRules.length === 0) return;
		for (const item of viewModel.datasource) {
			const oldValues = styleRuleApplicationConditionCache.get(item);
			const newValues = [];
			for (const styleRule of styleRules) newValues.push(styleRule.canEvaluateItem(item));
			styleRuleApplicationConditionCache.set(item, newValues);
			if (!oldValues || !compareArray(newValues, oldValues)) {
				cb();
				return;
			}
		}
	});
}
var Datagrid_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Datagrid",
	components: {
		ActionButton: ActionButton_default,
		Button: Button$1,
		DatagridFooter: DatagridFooter_default,
		DatagridNotLoadedBanner: DatagridNotLoadedBanner_default,
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		ImageViewer: ImageViewer_default,
		InnerDatagrid: Datagrid,
		LottieImage,
		Text: Text$2,
		VerticalLayout: VerticalLayout$1
	},
	props: {
		source: {
			type: Array,
			default: void 0
		},
		editable: {
			type: Boolean,
			default: false
		},
		groupable: {
			type: Boolean,
			default: true
		},
		indicatorColumn: {
			type: Boolean,
			default: true
		},
		selectionColumn: {
			type: Boolean,
			default: true
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		noDataOverlay: {
			type: Boolean,
			default: true
		},
		rowHeight: {
			type: Number,
			default: void 0
		},
		autoRowHeight: {
			type: Boolean,
			default: false
		},
		addRow: {
			type: Boolean,
			default: true
		},
		booleanDisplayMode: {
			type: String,
			default: "checkbox"
		},
		resizeColumnsOnRefresh: {
			type: Boolean,
			default: false
		},
		infiniteScrolling: {
			type: Boolean,
			default: void 0
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		},
		summaryTag: {
			type: Boolean,
			default: true
		},
		rowDetailVisibilityMode: {
			type: String,
			default: "single"
		},
		rowDetailExpandedByDefault: {
			type: Boolean,
			default: false
		},
		rowDragover: {
			type: Function,
			default: void 0
		},
		rowDrop: {
			type: Function,
			default: void 0
		},
		colspan: {
			type: Function,
			default: void 0
		},
		footerCounts: {
			type: Boolean,
			default: void 0
		},
		inputNumberType: {
			type: String,
			default: null
		}
	},
	setup(props, { slots }) {
		const instance = getCurrentInstance();
		const datagrid = ref();
		const { translate } = useGlobalResourceManager();
		const themeManager = useThemeManager();
		const viewModel = useViewModel();
		const columns = computed(() => mapPropertiesToDatagridColumns(viewModel, slots, props.inputNumberType));
		const collectionView = new ViewModelCollectionView(viewModel, props.source);
		const allowInlineEdit = computed(() => props.editable && !viewModel.canNeverExecuteEditAction);
		const allowFullInteraction = computed(() => !allowInfiniteScrolling.value || viewModel.fullDataLoaded);
		const allowAddRow = computed(() => {
			if (!props.addRow) return false;
			return allowInlineEdit.value && allowFullInteraction.value && !viewModel.canNeverExecuteAddAction && viewModel.canExecuteAddAction(false);
		});
		const allowGrouping = computed(() => props.groupable && !allowInlineEdit.value && viewModel.entityViewName !== void 0 && viewModel.parentRelation === void 0);
		const allowInfiniteScrolling = computed(() => {
			if (viewModel.groupDescriptions.length > 0) return viewModel.groupingBehavior.executionSide == GroupingExecutionSide.server;
			return props.infiniteScrolling ?? viewModel.behavior.datagridInfiniteScrolling;
		});
		const enterKeyActsAsTab = computed(() => isEnterKeyActsAsTabEnabled(viewModel.applicationContext));
		const ready = computed(() => isViewModelReady(viewModel));
		const showLoadDataOverlay = computed(() => !viewModel.loadDataOnStart && viewModel.datasource.loadingState === ListLoadingState.notLoaded && viewModel.datasource.length === 0);
		const showNoDataOverlay = computed(() => props.noDataOverlay && !viewModel.loadingMeOrSomeParent);
		const hasEditingUIView = computed(() => viewModel.lookupContext?.templateMode !== LookupTemplateMode.default && viewModel.editingUIViewName !== void 0 && viewModel.uiPermitter.canRead(viewModel.editingUIViewName));
		const showEditButton = computed(() => props.indicatorColumn && hasEditingUIView.value && viewModel.editingLinkPropertyName === void 0);
		const overriddenColspan = computed(() => props.colspan ? (args) => props.colspan({
			...args,
			propertyName: args.column.tag.name
		}) : void 0);
		const { showFooter, showFooterCounts, footerActions } = useDatagridFooter(props, slots, viewModel, allowInfiniteScrolling);
		const { showBanner: showNotLoadedBanner } = useDatagridNotLoadedBanner(viewModel);
		const showFooterContainer = computed(() => showFooter.value || showNotLoadedBanner.value);
		const rowHeightOrDefault = ref();
		const { trigger: triggerRowHeightOrDefault } = watchTriggerable(() => props.rowHeight, (v) => rowHeightOrDefault.value = v ?? themeManager.getThemeValue("datagrid-row-height", {
			convert: Number,
			defaultValue: 56
		}), { immediate: true });
		onStyleRuleApplicationConditionChanged(viewModel, () => datagrid.value?.refresh());
		themeManager.changedEvent.add(handleThemeChanged);
		viewModel.eventManager.on("customview:changed", customViewChanged);
		onBeforeUnmount(() => {
			collectionView.dispose();
			themeManager.changedEvent.remove(handleThemeChanged);
			viewModel.eventManager.off("customview:changed", customViewChanged);
		});
		function customViewChanged(owner) {
			if (datagrid.value && owner === viewModel) datagrid.value.resetColumns();
		}
		function handleThemeChanged() {
			triggerRowHeightOrDefault();
		}
		async function handleRowSelect(item, selected) {
			if (selected) await viewModel.selectItemAsync(item);
			else await viewModel.unselectItemAsync(item);
		}
		async function handleHeaderSelectorCheck(checked) {
			if (checked) {
				if (!viewModel.fullDataLoaded) {
					if ((await viewModel.showMessageAsync(ViewModelMessageType.warning, translate("DatagridPartialSelectionWarningTitle"), translate("DatagridPartialSelectionWarningText", viewModel.datasource.length, viewModel.datasource.totalRecordCount), new ViewModelMessageButton(ViewModelMessageButtonType.yes, void 0, void 0, void 0, true), new ViewModelMessageButton(ViewModelMessageButtonType.no))).buttonType === ViewModelMessageButtonType.no) return false;
				}
				await viewModel.selectItemsAsync(collectionView.items);
			} else await viewModel.unselectItemsAsync(collectionView.items);
			return true;
		}
		function handleEditDoubleClick(event, item) {
			if (hasEditingUIView.value) navigateToEditingUIView(event, item);
		}
		function handleEditButtonClick(event, item) {
			navigateToEditingUIView(event, item);
		}
		async function navigateToEditingUIView(event, item) {
			if (viewModel.current === item || await viewModel.requestChangingPositionAsync(viewModel.datasource.indexOf(item))) {
				const target = event.ctrlKey ? NavigationTarget.newFrame : NavigationTarget.default;
				await viewModel.navigateAsync(viewModel.getEditingUIViewNavigationOptions(item).onTarget(target));
			}
		}
		async function handlePositionChanging(index, callback) {
			callback(!await viewModel.requestChangingPositionAsync(index));
		}
		async function handleAddRowAdding(callback) {
			callback(await viewModel.addAddNewItem());
		}
		async function handleAddRowCommitting(cancelable, callback) {
			callback(await viewModel.commitAddNewItem(cancelable));
		}
		async function handleLoadRows(top, group) {
			top = Math.max(top, viewModel.recordsByPage);
			if (group) await group.loadData(top);
			else await viewModel.loadMoreData(top);
		}
		async function handleToggleGroup(group, expanded, top) {
			await group.toggle(expanded, top);
		}
		function getRowIndicatorImageProps(item) {
			if (!(item instanceof Model)) return {
				"data-add-row": true,
				name: "asterisk",
				size: "extrasmall"
			};
			const props = {
				"data-add-row": toDataAttribute(viewModel.addNewItem === item),
				"data-current-row": toDataAttribute(viewModel.current === item),
				"data-error-row": toDataAttribute(item.hasValidationMessages(ValidationRuleSeverityLevel.error)),
				"data-warning-row": toDataAttribute(item.hasValidationMessages(ValidationRuleSeverityLevel.warning)),
				"data-information-row": toDataAttribute(item.hasValidationMessages(ValidationRuleSeverityLevel.information)),
				"data-changed-row": toDataAttribute(item.hasChanges())
			};
			if (props["data-add-row"]) {
				props.name = "asterisk";
				props.size = "extrasmall";
			} else if (props["data-current-row"]) props.name = "chevronRightCircle";
			else if (props["data-error-row"]) props.name = "error";
			else if (props["data-warning-row"]) props.name = "warning";
			else if (props["data-information-row"]) props.name = "info";
			else if (props["data-changed-row"]) props.name = "circle";
			else props.name = void 0;
			return props;
		}
		function formatCell(column, item, element, readOnly, autoRowHeight) {
			if (item instanceof ViewModelCollectionViewGroup || !column.displayTemplate && !column.displayComponent) formatDatagridCell(viewModel, column.tag, item, element, readOnly, autoRowHeight);
			if (item instanceof Model) {
				formatDatagridCellWithStyleRules(viewModel, column.tag, item, element, instance.appContext, themeManager);
				setAiSuggestionIndicator(viewModel, column.tag, item, element, instance.appContext);
				setNotLoadedIndicator(column.tag, item, element);
			}
		}
		function validateCell(item, column, callback) {
			if (column) callback(getItemPropertyValidationMessage(item, column.tag.camelCaseName));
			else callback(getItemValidationMessage(item, ValidationRuleSeverityLevel.error) ?? getItemValidationMessage(item, ValidationRuleSeverityLevel.warning) ?? getItemValidationMessage(item, ValidationRuleSeverityLevel.information));
		}
		function getItemPropertyValidationMessage(item, propertyName) {
			const message = item.getValidationMessage(propertyName);
			return message ? {
				text: message.shortText ?? message.text,
				severity: convertValidationMessageSeverity(message.severityLevel)
			} : void 0;
		}
		function getItemValidationMessage(item, severityLevel) {
			const validationMessages = item.getValidationMessages(severityLevel);
			return validationMessages.length > 0 ? {
				text: viewModel.formatValidationMessages(validationMessages),
				severity: convertValidationMessageSeverity(severityLevel)
			} : void 0;
		}
		function handleRowClick(item) {
			if (viewModel.lookupContext) viewModel.returnItemAsync(item);
		}
		function handleColumnsChanged(columns) {
			for (const column of columns) {
				column.tag.datagridVisible = column.visible;
				column.tag.datagridPosition = column.position;
				column.tag.datagridWidth = column.width;
			}
			uiViewEvents.layoutUpdated.raiseDebounced(viewModel);
		}
		function getEditPropertyComponentPropsFn(item) {
			return (propertyName) => getEditPropertyComponentProps(viewModel.getProperty(propertyName), item);
		}
		function getEditPropertyComponentListenersFn(item, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly) {
			return (propertyName) => {
				const property = viewModel.getProperty(propertyName);
				return getEditPropertyComponentListeners(property, item, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly, () => viewModel.acceptAutoSuggest(item, property.camelCaseName), () => viewModel.cancelAutoSuggest(item, property.camelCaseName));
			};
		}
		function getRowActions(item) {
			return viewModel.actions.filterByLocationAndItem(ViewModelActionLocation.datagridRow, void 0, item, [item]);
		}
		function getRowContextMenuItems(item, close) {
			const actions = viewModel.actions.filterByLocation(ViewModelActionLocation.datagridRowContextMenu);
			const items = viewModel.selectedItems;
			return getActionDropdownItems(viewModel, actions, item, items, (action, event) => {
				close();
				action.run(item, items, event);
			});
		}
		function isViewModelReady(viewModel) {
			if (!viewModel.isIdleAfterInitialization) return false;
			if (viewModel.parentViewModel) return isViewModelReady(viewModel.parentViewModel);
			return true;
		}
		return {
			allowAddRow,
			allowFullInteraction,
			allowGrouping,
			allowInfiniteScrolling,
			allowInlineEdit,
			collectionView,
			columns,
			datagrid,
			enterKeyActsAsTab,
			footerActions,
			formatCell,
			getEditPropertyComponentListeners,
			getEditPropertyComponentListenersFn,
			getEditPropertyComponentProps,
			getEditPropertyComponentPropsFn,
			getRowActions,
			getRowContextMenuItems,
			getRowIndicatorImageProps,
			handleAddRowAdding,
			handleAddRowCommitting,
			handleColumnsChanged,
			handleEditButtonClick,
			handleEditDoubleClick,
			handleHeaderSelectorCheck,
			handleLoadRows,
			handlePositionChanging,
			handleRowClick,
			handleRowSelect,
			handleToggleGroup,
			overriddenColspan,
			ready,
			rowHeightOrDefault,
			showEditButton,
			showFooter,
			showFooterContainer,
			showFooterCounts,
			showLoadDataOverlay,
			showNoDataOverlay,
			translate,
			validateCell,
			viewModel
		};
	}
});
//#endregion
//#region src/components/Datagrid/Datagrid.vue
function _sfc_render$20(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_LottieImage = resolveComponent("LottieImage");
	const _component_Text = resolveComponent("Text");
	const _component_Button = resolveComponent("Button");
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_Image = resolveComponent("Image");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_DatagridNotLoadedBanner = resolveComponent("DatagridNotLoadedBanner");
	const _component_DatagridFooter = resolveComponent("DatagridFooter");
	const _component_InnerDatagrid = resolveComponent("InnerDatagrid");
	return withDirectives((openBlock(), createBlock(_component_InnerDatagrid, {
		ref: "datagrid",
		columns: _ctx.columns,
		"get-row-context-menu-items": _ctx.getRowContextMenuItems,
		source: _ctx.collectionView,
		editable: _ctx.allowInlineEdit,
		"add-row": _ctx.allowAddRow,
		groupable: _ctx.allowGrouping,
		"selection-binding": "$selected",
		"selection-column": _ctx.selectionColumn,
		"selection-column-header": _ctx.allowFullInteraction,
		"on-selection-column-header-check": _ctx.handleHeaderSelectorCheck,
		"group-panel-visible": _ctx.groupPanelVisible,
		"no-data-overlay": _ctx.showNoDataOverlay,
		"row-height": _ctx.rowHeightOrDefault,
		"auto-row-height": _ctx.autoRowHeight,
		"infinite-scrolling": _ctx.allowInfiniteScrolling,
		"enter-key-acts-as-tab": _ctx.enterKeyActsAsTab,
		summaries: _ctx.viewModel.datasource.summaries,
		loading: _ctx.viewModel.loadingMeOrSomeParent,
		"boolean-display-mode": _ctx.booleanDisplayMode,
		"resize-columns-on-first-load": !_ctx.viewModel.loadDataOnStart,
		"resize-columns-on-refresh": _ctx.resizeColumnsOnRefresh,
		exportable: _ctx.exportable,
		"column-picker": _ctx.columnPicker,
		"summary-tag": _ctx.summaryTag,
		"row-detail-visibility-mode": _ctx.rowDetailVisibilityMode,
		"row-detail-expanded-by-default": _ctx.rowDetailExpandedByDefault,
		"row-dragover": _ctx.rowDragover,
		"row-drop": _ctx.rowDrop,
		colspan: _ctx.overriddenColspan,
		onRowSelect: _ctx.handleRowSelect,
		onFormatCell: _ctx.formatCell,
		onValidateCell: _ctx.validateCell,
		onRowDoubleClick: _ctx.handleEditDoubleClick,
		onRowClick: _ctx.handleRowClick,
		onPositionChanging: _ctx.handlePositionChanging,
		onAddRowAdding: _ctx.handleAddRowAdding,
		onAddRowCommitting: _ctx.handleAddRowCommitting,
		onLoadRows: _ctx.handleLoadRows,
		onToggleGroup: _ctx.handleToggleGroup,
		onColumnsChanged: _ctx.handleColumnsChanged
	}, createSlots({
		"no-data-action": withCtx(() => [createVNode(_component_ActionButton, {
			"action-name": "Add",
			class: "datagrid-add-data-button"
		})]),
		"row-actions": withCtx(({ item }) => [createVNode(_component_HorizontalLayout, {
			"vertical-align": "center",
			class: "neos-fill-parent-height neos-fill-parent-width"
		}, {
			default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getRowActions(item), (action) => {
				return openBlock(), createBlock(_component_ActionButton, {
					key: action.name,
					action,
					size: "small",
					item,
					animated: false,
					"ignore-selected-items": true
				}, null, 8, ["action", "item"]);
			}), 128))]),
			_: 2
		}, 1024)]),
		_: 2
	}, [
		_ctx.showLoadDataOverlay ? {
			name: "no-data",
			fn: withCtx(() => [
				createVNode(_component_LottieImage, {
					name: "datagridLoadData",
					"data-promise": () => import("./DatagridLoadData-D3rAG0cd.js"),
					class: "datagrid-load-data-image"
				}),
				createVNode(_component_Text, { size: "large" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate("YouHaveNotDoneAnyResearch")), 1)]),
					_: 1
				}),
				createVNode(_component_Button, {
					label: _ctx.translate("StartSearch"),
					variant: "primary",
					class: "datagrid-load-data-button",
					onClick: _cache[0] || (_cache[0] = ($event) => _ctx.viewModel.loadDataAsync())
				}, null, 8, ["label"])
			]),
			key: "0"
		} : void 0,
		_ctx.indicatorColumn ? {
			name: "row-indicator",
			fn: withCtx(({ item }) => [createVNode(_component_Image, mergeProps({ size: "small" }, _ctx.getRowIndicatorImageProps(item)), null, 16)]),
			key: "1"
		} : void 0,
		_ctx.showEditButton ? {
			name: "row-action",
			fn: withCtx(({ item }) => [item && !item.$new ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				variant: "link",
				icon: "edit",
				size: "small",
				class: "datagrid-button-edit",
				onMousedown: withModifiers((event) => _ctx.handleEditButtonClick(event, item), ["left"])
			}, null, 8, ["onMousedown"])) : createCommentVNode("", true)]),
			key: "2"
		} : void 0,
		renderList(_ctx.columns.filter((c) => _ctx.$slots[`${c.name}-display`] || c.displayComponent), (column) => {
			return {
				name: `${column.name}-display`,
				fn: withCtx(({ cell }) => [renderSlot(_ctx.$slots, `${column.name}-display`, { cell }, () => [(openBlock(), createBlock(resolveDynamicComponent(column.displayComponent), { value: cell.item[column.name] }, null, 8, ["value"]))], true)])
			};
		}),
		renderList(_ctx.columns.filter((c) => _ctx.$slots[`${c.name}-edit`] || c.editComponent), (column) => {
			return {
				name: `${column.name}-edit`,
				fn: withCtx(({ cell, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly }) => [renderSlot(_ctx.$slots, `${column.name}-edit`, {
					cell,
					getEditComponentProps: _ctx.getEditPropertyComponentPropsFn(cell.item),
					toggleStayInEditMode,
					getEditComponentListeners: _ctx.getEditPropertyComponentListenersFn(cell.item, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly)
				}, () => [(openBlock(), createBlock(resolveDynamicComponent(column.editComponent), mergeProps({
					modelValue: cell.value,
					"onUpdate:modelValue": ($event) => cell.value = $event,
					"input-display-mode": "datagrid"
				}, _ctx.getEditPropertyComponentProps(column.tag, cell.item), toHandlers(_ctx.getEditPropertyComponentListenersFn(cell.item, toggleDelegateEditToComponent, toggleStayInEditMode, toggleReadOnly)(column.tag.camelCaseName))), null, 16, ["modelValue", "onUpdate:modelValue"]))], true)])
			};
		}),
		_ctx.$slots["row-detail"] ? {
			name: "row-detail",
			fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "row-detail", { item }, void 0, true)]),
			key: "3"
		} : void 0,
		_ctx.showFooterContainer ? {
			name: "footer",
			fn: withCtx(() => [createVNode(_component_DatagridNotLoadedBanner, { "view-model": _ctx.viewModel }, null, 8, ["view-model"]), _ctx.showFooter ? (openBlock(), createBlock(_component_DatagridFooter, {
				key: 0,
				source: _ctx.source,
				counts: _ctx.showFooterCounts,
				actions: _ctx.footerActions,
				"selection-column": _ctx.selectionColumn
			}, createSlots({ _: 2 }, [_ctx.$slots.footer ? {
				name: "default",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "footer", {}, void 0, true)]),
				key: "0"
			} : void 0]), 1032, [
				"source",
				"counts",
				"actions",
				"selection-column"
			])) : createCommentVNode("", true)]),
			key: "4"
		} : void 0
	]), 1032, [
		"columns",
		"get-row-context-menu-items",
		"source",
		"editable",
		"add-row",
		"groupable",
		"selection-column",
		"selection-column-header",
		"on-selection-column-header-check",
		"group-panel-visible",
		"no-data-overlay",
		"row-height",
		"auto-row-height",
		"infinite-scrolling",
		"enter-key-acts-as-tab",
		"summaries",
		"loading",
		"boolean-display-mode",
		"resize-columns-on-first-load",
		"resize-columns-on-refresh",
		"exportable",
		"column-picker",
		"summary-tag",
		"row-detail-visibility-mode",
		"row-detail-expanded-by-default",
		"row-dragover",
		"row-drop",
		"colspan",
		"onRowSelect",
		"onFormatCell",
		"onValidateCell",
		"onRowDoubleClick",
		"onRowClick",
		"onPositionChanging",
		"onAddRowAdding",
		"onAddRowCommitting",
		"onLoadRows",
		"onToggleGroup",
		"onColumnsChanged"
	])), [[vShow, _ctx.ready]]);
}
var Datagrid_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Datagrid_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$20], ["__scopeId", "data-v-c02e379c"]]);
//#endregion
//#region src/components/Datagrid/ResponsiveDatagrid.vue
var ResponsiveDatagrid_default = /* @__PURE__ */ defineComponent({
	__name: "ResponsiveDatagrid",
	props: {
		source: { default: void 0 },
		editable: {
			type: Boolean,
			default: void 0
		},
		groupable: {
			type: Boolean,
			default: void 0
		},
		indicatorColumn: {
			type: Boolean,
			default: void 0
		},
		selectionColumn: {
			type: Boolean,
			default: void 0
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		noDataOverlay: {
			type: Boolean,
			default: void 0
		},
		rowHeight: { default: void 0 },
		autoRowHeight: {
			type: Boolean,
			default: void 0
		},
		addRow: {
			type: Boolean,
			default: void 0
		},
		booleanDisplayMode: { default: void 0 },
		resizeColumnsOnRefresh: {
			type: Boolean,
			default: void 0
		},
		infiniteScrolling: {
			type: Boolean,
			default: void 0
		},
		exportable: {
			type: Boolean,
			default: void 0
		},
		columnPicker: {
			type: Boolean,
			default: void 0
		},
		summaryTag: {
			type: Boolean,
			default: void 0
		},
		rowDetailVisibilityMode: { default: void 0 },
		rowDetailExpandedByDefault: {
			type: Boolean,
			default: void 0
		},
		rowDragover: {
			type: Function,
			default: void 0
		},
		rowDrop: {
			type: Function,
			default: void 0
		},
		colspan: {
			type: Function,
			default: void 0
		},
		footerCounts: {
			type: Boolean,
			default: void 0
		},
		cardMode: {
			type: Boolean,
			default: void 0
		},
		cardModeScope: { default: void 0 },
		cardModeBreakpoint: { default: void 0 },
		cardModeHeaderPropertyName: { default: void 0 },
		inputNumberType: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ResponsiveDatagridWrapper), {
				"card-mode": __props.cardMode,
				"card-mode-scope": props.cardModeScope,
				"card-mode-breakpoint": props.cardModeBreakpoint
			}, {
				datagrid: withCtx(() => [createVNode(Datagrid_default, {
					source: __props.source,
					editable: __props.editable,
					groupable: __props.groupable,
					"indicator-column": __props.indicatorColumn,
					"selection-column": __props.selectionColumn,
					"group-panel-visible": __props.groupPanelVisible,
					"no-data-overlay": __props.noDataOverlay,
					"row-height": __props.rowHeight,
					"auto-row-height": __props.autoRowHeight,
					"add-row": __props.addRow,
					"boolean-display-mode": __props.booleanDisplayMode,
					"resize-columns-on-refresh": __props.resizeColumnsOnRefresh,
					"infinite-scrolling": __props.infiniteScrolling,
					exportable: __props.exportable,
					"column-picker": __props.columnPicker,
					"summary-tag": __props.summaryTag,
					"row-detail-visibility-mode": __props.rowDetailVisibilityMode,
					"row-detail-expanded-by-default": __props.rowDetailExpandedByDefault,
					"row-dragover": __props.rowDragover,
					"row-drop": __props.rowDrop,
					colspan: __props.colspan,
					"footer-counts": __props.footerCounts,
					"input-number-type": __props.inputNumberType
				}, createSlots({ _: 2 }, [renderList(_ctx.$slots, (_, slotName) => {
					return {
						name: slotName,
						fn: withCtx((slotProps) => [renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps)))])
					};
				})]), 1032, [
					"source",
					"editable",
					"groupable",
					"indicator-column",
					"selection-column",
					"group-panel-visible",
					"no-data-overlay",
					"row-height",
					"auto-row-height",
					"add-row",
					"boolean-display-mode",
					"resize-columns-on-refresh",
					"infinite-scrolling",
					"exportable",
					"column-picker",
					"summary-tag",
					"row-detail-visibility-mode",
					"row-detail-expanded-by-default",
					"row-dragover",
					"row-drop",
					"colspan",
					"footer-counts",
					"input-number-type"
				])]),
				"data-cards": withCtx(() => [createVNode(DataCards_default, {
					editable: __props.editable,
					"header-property-name": __props.cardModeHeaderPropertyName
				}, createSlots({ _: 2 }, [_ctx.$slots.card ? {
					name: "card",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "card", { item })]),
					key: "0"
				} : void 0]), 1032, ["editable", "header-property-name"])]),
				_: 3
			}, 8, [
				"card-mode",
				"card-mode-scope",
				"card-mode-breakpoint"
			]);
		};
	}
});
//#endregion
//#region src/composables/useEditableFilterChipSizes.ts
function useEditableFilterChipSizes(props) {
	return {
		chipSize: computed(() => props.size === "extrasmall" || props.size === "small" ? "small" : "medium"),
		chipSecondaryIconSize: computed(() => props.size === "extrasmall" || props.size === "small" ? "extrasmall" : "small")
	};
}
//#endregion
//#region src/filter/FilterBuilderItem.ts
var FilterBuilderItem = class {
	constructor(visible, readOnly, active, parent) {
		this.visible = visible;
		this.readOnly = readOnly;
		this.active = active;
		this.parent = parent;
	}
	get canConvertToFilter() {
		return true;
	}
};
//#endregion
//#region src/components/FilterDate/FilterDate.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$17 = ["disabled", "data-mode"];
var _hoisted_2$11 = ["disabled", "data-mode"];
//#endregion
//#region src/components/FilterDate/FilterDate.vue
var FilterDate_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterDate",
	props: /*@__PURE__*/ mergeModels({
		property: {},
		readonly: {
			type: Boolean,
			default: false
		},
		advanced: {
			type: Boolean,
			default: true
		}
	}, {
		"modelValue": { default: null },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		function isFilterValue(value) {
			return value instanceof FilterValue;
		}
		const dateFilterOperations = [
			FilterOperation.today,
			FilterOperation.addDays,
			FilterOperation.addMonths,
			FilterOperation.addYears,
			FilterOperation.startOfWeek,
			FilterOperation.startOfMonth,
			FilterOperation.startOfYear,
			FilterOperation.endOfWeek,
			FilterOperation.endOfMonth,
			FilterOperation.endOfYear
		];
		const dateTimeFilterOperations = [
			FilterOperation.today,
			FilterOperation.addDays,
			FilterOperation.addMonths,
			FilterOperation.addYears,
			FilterOperation.startOfDay,
			FilterOperation.startOfWeek,
			FilterOperation.startOfMonth,
			FilterOperation.startOfYear,
			FilterOperation.endOfDay,
			FilterOperation.endOfWeek,
			FilterOperation.endOfMonth,
			FilterOperation.endOfYear
		];
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const { translate } = useGlobalResourceManager();
		const isDateTime = computed(() => props.property.dataType === DataType$1.dateTime || props.property.dataType === DataType$1.invariantDateTime);
		const operations = computed(() => {
			return (isDateTime.value ? dateTimeFilterOperations : dateFilterOperations).map((o) => ({
				value: o,
				caption: translate(`FilterOperation_${o}`),
				x: o === FilterOperation.addDays || o === FilterOperation.addMonths || o === FilterOperation.addYears
			}));
		});
		const radioInputName = `${useId()}_mode`;
		const showX = computed(() => hasX(operationValue.value));
		const showRelativeControls = computed(() => props.advanced || isFilterValue(modelValue.value));
		const absoluteModeReadOnly = computed(() => props.readonly || mode.value !== "absolute");
		const relativeModeReadOnly = computed(() => props.readonly || mode.value !== "relative");
		const mode = computed({
			get: () => isFilterValue(modelValue.value) ? "relative" : "absolute",
			set(newMode) {
				emitNewValue(newMode, dateValue.value, operationValue.value, xValue.value);
			}
		});
		const dateValue = computed({
			get() {
				if (modelValue.value instanceof Date) return modelValue.value;
				if (typeof modelValue.value === "string") return dateOnlyToDateTime(modelValue.value);
				return null;
			},
			set(value) {
				const newAbsoluteValue = value && isDateTime.value && !(modelValue.value instanceof Date) ? dateTimeToDateOnly(value) : value;
				emitNewValue(mode.value, newAbsoluteValue, operationValue.value, xValue.value);
			}
		});
		const timeValue = computed({
			get: () => isDateTime.value && modelValue.value instanceof Date ? modelValue.value : null,
			set(value) {
				let newAbsoluteValue;
				if (value && typeof modelValue.value === "string") newAbsoluteValue = setTimeOfDay(dateOnlyToDateTime(modelValue.value), value);
				else if (!value && modelValue.value instanceof Date) newAbsoluteValue = dateTimeToDateOnly(modelValue.value);
				else newAbsoluteValue = value;
				emitNewValue(mode.value, newAbsoluteValue, operationValue.value, xValue.value);
			}
		});
		const operationValue = computed({
			get: () => modelValue.value instanceof FilterValue ? modelValue.value.operation : FilterOperation.today,
			set(newOperation) {
				emitNewValue(mode.value, dateValue.value, newOperation, xValue.value);
			}
		});
		const xValue = computed({
			get() {
				if (isFilterValue(modelValue.value)) {
					const [arg0, arg1] = modelValue.value.args;
					if (typeof arg1 === "number") return arg1;
					if (typeof arg0 === "number") return arg0;
					if (showX.value) return 1;
				}
				return null;
			},
			set(newX) {
				emitNewValue(mode.value, dateValue.value, operationValue.value, newX);
			}
		});
		function emitNewValue(mode, absoluteValue, operation, x) {
			if (mode === "absolute" && shouldEmitAbsoluteDate(absoluteValue)) modelValue.value = getNewAbsoluteValue(absoluteValue);
			else if (mode === "relative") {
				const filterValue = getNewFilterValue(operation, x);
				if (shouldEmitNewFilterValue(filterValue)) modelValue.value = filterValue;
			}
		}
		function shouldEmitAbsoluteDate(date) {
			if (modelValue.value instanceof Date && date instanceof Date && modelValue.value.getTime() === date.getTime()) return false;
			return modelValue.value !== date;
		}
		function shouldEmitNewFilterValue(filterValue) {
			return !(modelValue.value instanceof FilterValue) || !modelValue.value.equals(filterValue);
		}
		function getNewAbsoluteValue(value) {
			return props.property.dataType === DataType$1.invariantDateTime && value instanceof Date ? new InvariantDateTime(value) : value;
		}
		function getNewFilterValue(operation, x) {
			const args = hasX(operation) ? [x ?? 1] : [];
			return new FilterValue(operation, ...args);
		}
		function hasX(operation) {
			return operations.value.find((o) => o.value === operation)?.x;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				class: "filter-date",
				"data-time": isDateTime.value,
				"data-readonly": __props.readonly
			}, {
				default: withCtx(() => [createVNode(unref(VerticalLayout$1), { align: "stretch" }, {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
						default: withCtx(() => [
							createElementVNode("label", null, [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
								default: withCtx(() => [withDirectives(createElementVNode("input", {
									"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => mode.value = $event),
									type: "radio",
									name: radioInputName,
									value: "absolute",
									disabled: __props.readonly,
									"data-mode": mode.value
								}, null, 8, _hoisted_1$17), [[vModelRadio, mode.value]]), createVNode(unref(Text$2), null, {
									default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("FixedDate")), 1)]),
									_: 1
								})]),
								_: 1
							})]),
							createVNode(unref(InputDate$1), {
								modelValue: dateValue.value,
								"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => dateValue.value = $event),
								readonly: absoluteModeReadOnly.value,
								focused: true,
								class: "filter-date-date"
							}, null, 8, ["modelValue", "readonly"]),
							isDateTime.value ? (openBlock(), createBlock(unref(InputTime$1), {
								key: 0,
								modelValue: timeValue.value,
								"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => timeValue.value = $event),
								readonly: absoluteModeReadOnly.value,
								class: "filter-date-time"
							}, null, 8, ["modelValue", "readonly"])) : createCommentVNode("", true)
						]),
						_: 1
					}), showRelativeControls.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
						default: withCtx(() => [createElementVNode("label", null, [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
							default: withCtx(() => [withDirectives(createElementVNode("input", {
								"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => mode.value = $event),
								type: "radio",
								name: radioInputName,
								value: "relative",
								disabled: __props.readonly,
								"data-mode": mode.value
							}, null, 8, _hoisted_2$11), [[vModelRadio, mode.value]]), createVNode(unref(Text$2), null, {
								default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("RelativeDate")), 1)]),
								_: 1
							})]),
							_: 1
						})]), createVNode(unref(Combobox), {
							modelValue: operationValue.value,
							"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => operationValue.value = $event),
							values: operations.value,
							required: "",
							"value-property": "value",
							"display-property": "caption",
							readonly: relativeModeReadOnly.value,
							class: "filter-date-operation"
						}, null, 8, [
							"modelValue",
							"values",
							"readonly"
						])]),
						_: 1
					}), withDirectives(createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
						default: withCtx(() => [createVNode(unref(InputNumber$1), {
							modelValue: xValue.value,
							"onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => xValue.value = $event),
							label: "X",
							"label-position": "left",
							readonly: relativeModeReadOnly.value,
							class: "filter-date-x"
						}, null, 8, ["modelValue", "readonly"])]),
						_: 1
					}, 512), [[vShow, showX.value]])], 64)) : createCommentVNode("", true)]),
					_: 1
				}), renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["data-time", "data-readonly"]);
		};
	}
}), [["__scopeId", "data-v-5141ab89"]]);
//#endregion
//#region src/components/EditableFilterDate/FilterDateCalendarValue.ts
function isCalendarDateOperation(value) {
	return value.operation === FilterOperation.specificMonth || value.operation === FilterOperation.specificYear;
}
function convertFilterValueDate(value) {
	if (value instanceof FilterValue && isCalendarDateOperation(value)) return convertRangeValueToDate(value, true);
	return value;
}
function convertRangeValueToDate(value, nullable) {
	if (value instanceof Date) return value;
	if (value instanceof FilterValue) {
		const filterValue = value.toValue();
		if (filterValue instanceof Date) return filterValue;
		if (typeof filterValue === "string") return dateOnlyToDateTime(filterValue);
	}
	if (typeof value === "string") return dateOnlyToDateTime(value);
	return nullable ? null : /* @__PURE__ */ new Date();
}
var FilterDateCalendarValue = class FilterDateCalendarValue {
	constructor(viewMode, values) {
		this.toCalendarDateRange = () => {
			return [convertRangeValueToDate(this.start, false), convertRangeValueToDate(this.end, true)];
		};
		this.toCalendarDate = () => {
			return convertRangeValueToDate(this.start, true);
		};
		this.razDate = () => {
			this.values = null;
			this.viewMode = FilterComponent.default;
		};
		this.setStartDate = (date) => {
			this.values = Array.isArray(this.values) ? [date, this.end] : date;
			this.viewMode = FilterComponent.default;
		};
		this.setEndDate = (date) => {
			this.values = [this.start, date];
			this.viewMode = FilterComponent.default;
		};
		this.setDateRange = (dateRange, viewMode) => {
			switch (viewMode) {
				case FilterComponent.calendarMonth:
					this.values = [dateRange[0] ? new FilterValue(FilterOperation.specificMonth, dateRange[0]) : null, dateRange[1] ? new FilterValue(FilterOperation.specificMonth, dateRange[1]) : null];
					break;
				case FilterComponent.calendarYear:
					this.values = [dateRange[0] ? new FilterValue(FilterOperation.specificYear, dateRange[0]) : null, dateRange[1] ? new FilterValue(FilterOperation.specificYear, dateRange[1]) : null];
					break;
				default: this.values = [dateRange[0], dateRange[1]];
			}
		};
		this.setDateCalendar = (date, viewMode) => {
			switch (viewMode) {
				case FilterComponent.calendarMonth:
					this.values = new FilterValue(FilterOperation.specificMonth, date);
					break;
				case FilterComponent.calendarYear:
					this.values = new FilterValue(FilterOperation.specificYear, date);
					break;
				default: this.values = date;
			}
		};
		this.values = values;
		this.viewMode = viewMode;
	}
	static fromModel(value) {
		return new FilterDateCalendarValue(FilterComponent.default, value);
	}
	getStartDate() {
		if (this.start instanceof FilterValue && isCalendarDateOperation(this.start)) {
			if (this.start.operation === FilterOperation.specificYear) return this.start.toStartOfDateValue("year");
			return this.start.toStartOfDateValue("month");
		}
		return convertFilterValueDate(this.start);
	}
	getEndDate() {
		if (this.end instanceof FilterValue && isCalendarDateOperation(this.end)) {
			if (this.end.operation === FilterOperation.specificYear) return this.end.toEndOfDateValue("year");
			return this.end.toEndOfDateValue("month");
		}
		return convertFilterValueDate(this.end);
	}
	toModel() {
		return this.values;
	}
	get start() {
		if (Array.isArray(this.values)) return this.values[0];
		return this.values;
	}
	get end() {
		if (Array.isArray(this.values)) return this.values[1];
		return null;
	}
};
//#endregion
//#region src/components/EditableFilterDate/EditableFilterDate.vue
var EditableFilterDate_default = /* @__PURE__ */ defineComponent({
	__name: "EditableFilterDate",
	props: /*@__PURE__*/ mergeModels({
		property: {},
		selectionMode: {},
		readonly: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: null },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const props = __props;
		function formatDisplayDate(value) {
			if (value instanceof FilterValue) return value.args[0] ? value.toString() : "";
			if (value instanceof Date) return defaultFormatDateOnly(value);
			return defaultFormatDateOnly(dateOnlyToDateTime(value));
		}
		function isCalendarRange(value) {
			return Array.isArray(value);
		}
		const viewMode = computed(() => {
			switch (props.property.userFilterComponent) {
				case FilterComponent.calendarMonth: return "month";
				case FilterComponent.calendarYear: return "year";
				case FilterComponent.calendarDay: return "date";
				default: return;
			}
		});
		const isAdvanced = computed(() => props.property.userFilterComponent === FilterComponent.advanced);
		const modelValue = useModel(__props, "modelValue");
		const fromModel = () => FilterDateCalendarValue.fromModel(modelValue.value);
		const { translate } = useGlobalResourceManager();
		const calendarValue = computed({
			get() {
				if (!modelValue.value) return null;
				if (props.selectionMode === "range") return fromModel().toCalendarDateRange();
				return fromModel().toCalendarDate();
			},
			set(value) {
				const updatedModel = fromModel();
				if (value === null) updatedModel.razDate();
				else {
					const filterView = props.property.userFilterComponent;
					if (isCalendarRange(value)) updatedModel.setDateRange(value, filterView);
					else if (value instanceof Date) updatedModel.setDateCalendar(value, filterView);
				}
				modelValue.value = updatedModel.toModel();
			}
		});
		const valueStart = computed({
			get() {
				return fromModel().getStartDate();
			},
			set(value) {
				const updatedModel = fromModel();
				updatedModel.setStartDate(value);
				modelValue.value = updatedModel.toModel();
			}
		});
		const valueEnd = computed({
			get() {
				return fromModel().getEndDate();
			},
			set(value) {
				const updatedModel = fromModel();
				updatedModel.setEndDate(value);
				modelValue.value = updatedModel.toModel();
			}
		});
		const messageDateRange = computed(() => {
			const calendarDates = modelValue.value;
			if (!calendarDates || !Array.isArray(calendarDates)) return "";
			const startDate = calendarDates[0] ? formatDisplayDate(calendarDates[0]) : "";
			const endDate = calendarDates[1] ? formatDisplayDate(calendarDates[1]) : "";
			if (!endDate) return startDate;
			return `${startDate} - ${endDate}`;
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), { class: "editable-filter-date" }, {
				default: withCtx(() => [viewMode.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(PrimeDatePicker), {
					modelValue: calendarValue.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => calendarValue.value = $event),
					inline: "",
					view: viewMode.value,
					"selection-mode": __props.selectionMode,
					"show-other-months": false,
					"number-of-months": viewMode.value == "date" ? 2 : 1
				}, null, 8, [
					"modelValue",
					"view",
					"selection-mode",
					"number-of-months"
				]), createVNode(unref(Text$2), {
					size: "small",
					"max-lines": 1,
					class: "input-message",
					style: {
						"min-height": "1em",
						"line-height": "1em"
					}
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(messageDateRange.value), 1)]),
					_: 1
				})], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(FilterDate_default, {
					modelValue: valueStart.value,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => valueStart.value = $event),
					property: __props.property,
					readonly: __props.readonly,
					advanced: isAdvanced.value,
					"data-value": "1"
				}, null, 8, [
					"modelValue",
					"property",
					"readonly",
					"advanced"
				]), __props.selectionMode === "range" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Text$2), null, {
					default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("And_LowerCase")), 1)]),
					_: 1
				}), createVNode(FilterDate_default, {
					modelValue: valueEnd.value,
					"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => valueEnd.value = $event),
					property: __props.property,
					readonly: __props.readonly,
					advanced: isAdvanced.value,
					"data-value": "2"
				}, null, 8, [
					"modelValue",
					"property",
					"readonly",
					"advanced"
				])], 64)) : createCommentVNode("", true)], 64))]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/EditableFilterDateHeader/EditableFilterDateHeader.vue
var EditableFilterDateHeader_default = /* @__PURE__ */ defineComponent({
	__name: "EditableFilterDateHeader",
	props: { property: {} },
	setup(__props) {
		const props = __props;
		const icon = computed(() => props.property.userFilterComponent == FilterComponent.default ? "calendar" : "calendarStart");
		function handleToggleDisplayMode() {
			props.property.toggleFilterDateComponentView();
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Button$1), {
				class: "editable-filter-date-header-toggle-button",
				size: "medium",
				variant: "ghost",
				icon: icon.value,
				tabindex: "-1",
				onClick: handleToggleDisplayMode
			}, null, 8, ["icon"]);
		};
	}
});
//#endregion
//#region src/components/FilterArray/FilterArray.vue
var FilterArray_default = /* @__PURE__ */ defineComponent({
	__name: "FilterArray",
	props: /*@__PURE__*/ mergeModels({
		attribute: {},
		readonly: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: () => [null] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["toggleModal"], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const operator = FilterOperator.equal;
		const editingComponent = computed(() => getFilterComponent(props.attribute, operator));
		const editingComponentProps = computed(() => getFilterComponentProps(props.attribute, operator));
		function updateValue(index, value) {
			if (Array.isArray(value)) modelValue.value = [.../* @__PURE__ */ new Set([...modelValue.value, ...value])];
			else {
				const newValue = [...modelValue.value];
				newValue[index] = value;
				modelValue.value = newValue;
			}
		}
		function handleAddButtonClick() {
			modelValue.value = [...modelValue.value, null];
		}
		function handleRemoveButtonClick(index) {
			modelValue.value = modelValue.value.filter((_, i) => i !== index);
		}
		function toggleModal(value) {
			emit("toggleModal", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				class: "filter-array",
				"data-readonly": __props.readonly
			}, {
				default: withCtx(() => [createVNode(unref(VerticalLayout$1), { align: "left" }, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(modelValue.value, (value, index) => {
						return openBlock(), createBlock(unref(HorizontalLayout$1), {
							key: index,
							"vertical-align": "center",
							class: "filter-array-item",
							"data-index": index
						}, {
							default: withCtx(() => [createVNode(unref(Button$1), {
								disabled: __props.readonly || modelValue.value.length === 1,
								icon: "remove",
								size: "small",
								variant: "ghost-danger",
								class: "filter-array-item-remove-button",
								onClick: ($event) => handleRemoveButtonClick(index)
							}, null, 8, ["disabled", "onClick"]), (openBlock(), createBlock(resolveDynamicComponent(editingComponent.value), mergeProps({
								"model-value": value,
								readonly: __props.readonly
							}, { ref_for: true }, editingComponentProps.value, {
								focused: index === 0,
								class: "filter-array-item-component",
								"onUpdate:modelValue": (value) => updateValue(index, value),
								onToggleModal: toggleModal
							}), null, 16, [
								"model-value",
								"readonly",
								"focused",
								"onUpdate:modelValue"
							]))]),
							_: 2
						}, 1032, ["data-index"]);
					}), 128)), !__props.readonly ? (openBlock(), createBlock(unref(Button$1), {
						key: 0,
						icon: "add",
						size: "small",
						variant: "ghost",
						class: "filter-array-add-button",
						onClick: _cache[0] || (_cache[0] = ($event) => handleAddButtonClick())
					})) : createCommentVNode("", true)]),
					_: 1
				})]),
				_: 1
			}, 8, ["data-readonly"]);
		};
	}
});
//#endregion
//#region src/components/FilterArrayInput/FilterArrayInput.vue
var FilterArrayInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterArrayInput",
	props: /*@__PURE__*/ mergeModels({
		attribute: {},
		readonly: {
			type: Boolean,
			default: false
		},
		messageText: {},
		messageSeverity: {}
	}, {
		"modelValue": { default: () => [] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["update:modelValue", "toggleModal"], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const displayValue = computed(() => formatValues(modelValue.value, props.attribute, props.attribute.owner).join(", "));
		const displayClearButton = computed(() => modelValue.value.length > 0);
		const textboxElement = ref();
		const popover = ref();
		const filterArrayValue = ref();
		const { preventPopoverHide, setPreventPopoverHide } = usePreventPopoverHide();
		function togglePopover(event) {
			filterArrayValue.value = modelValue.value.length > 0 ? [...modelValue.value] : [null];
			popover.value.toggle(event, { positionTarget: textboxElement.value.$el });
		}
		function handleTextboxClick(event) {
			if (event.target instanceof HTMLInputElement) togglePopover(event);
		}
		function handlePopoverShow() {
			emit("toggleModal", true);
		}
		function handlePopoverHide() {
			const values = filterArrayValue.value.filter((v) => v != null);
			if (!isEquivalentValues(values, modelValue.value)) emit("update:modelValue", values.length > 0 ? values : void 0);
			emit("toggleModal", false);
		}
		function handleClearButtonClick() {
			emit("update:modelValue", void 0);
		}
		function handleOkButtonClick() {
			popover.value.hide();
		}
		function handleCancelButtonClick() {
			filterArrayValue.value = [...modelValue.value];
			popover.value.hide();
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Textbox$1), {
				ref_key: "textboxElement",
				ref: textboxElement,
				"model-value": displayValue.value,
				readonly: true,
				tooltip: displayValue.value,
				class: "filter-array-input",
				"data-readonly": __props.readonly,
				"message-text": __props.messageText,
				"message-severity": __props.messageSeverity,
				"message-position": "hidden",
				onClick: handleTextboxClick
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				default: withCtx(() => [
					createVNode(unref(Button$1), {
						variant: "ghost",
						size: "small",
						icon: "dotsHorizontal",
						class: "filter-array-input-toggle-popover-button",
						tabindex: "-1",
						onClick: withModifiers(togglePopover, ["stop"])
					}),
					!__props.readonly ? withDirectives((openBlock(), createBlock(unref(Button$1), {
						key: 0,
						class: "input-clear-button",
						size: "small",
						variant: "ghost",
						icon: "erase",
						tabindex: "-1",
						onClick: _cache[0] || (_cache[0] = ($event) => handleClearButtonClick())
					}, null, 512)), [[vShow, displayClearButton.value]]) : createCommentVNode("", true),
					createVNode(unref(Popover), {
						ref_key: "popover",
						ref: popover,
						class: "filter-array-input-popover",
						"prevent-hide": unref(preventPopoverHide),
						onShow: handlePopoverShow,
						onHide: handlePopoverHide
					}, {
						default: withCtx(() => [createVNode(unref(VerticalLayout$1), { space: "medium" }, {
							default: withCtx(() => [
								__props.messageText ? (openBlock(), createBlock(unref(InputMessage), {
									key: 0,
									text: __props.messageText,
									severity: __props.messageSeverity,
									"max-lines": 0,
									class: "filter-array-input-validation-message"
								}, null, 8, ["text", "severity"])) : createCommentVNode("", true),
								createVNode(FilterArray_default, {
									modelValue: filterArrayValue.value,
									"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => filterArrayValue.value = $event),
									attribute: __props.attribute,
									readonly: __props.readonly,
									onToggleModal: unref(setPreventPopoverHide)
								}, null, 8, [
									"modelValue",
									"attribute",
									"readonly",
									"onToggleModal"
								]),
								!__props.readonly ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(unref(Divider$1), { class: "popover-divider" }), createVNode(unref(HorizontalLayout$1), { align: "right" }, {
									default: withCtx(() => [createVNode(unref(Button$1), {
										icon: "validate",
										label: unref(translate)("Ok"),
										disabled: __props.readonly,
										size: "small",
										variant: "primary",
										class: "filter-array-input-popover-ok-button",
										onClick: _cache[2] || (_cache[2] = ($event) => handleOkButtonClick())
									}, null, 8, ["label", "disabled"]), createVNode(unref(Button$1), {
										icon: "close",
										label: unref(translate)("Cancel"),
										disabled: __props.readonly,
										size: "small",
										class: "filter-array-input-popover-cancel-button",
										onClick: _cache[3] || (_cache[3] = ($event) => handleCancelButtonClick())
									}, null, 8, ["label", "disabled"])]),
									_: 1
								})], 64)) : createCommentVNode("", true)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["prevent-hide"])
				]),
				_: 3
			}, 8, [
				"model-value",
				"tooltip",
				"data-readonly",
				"message-text",
				"message-severity"
			]);
		};
	}
}), [["__scopeId", "data-v-00b06903"]]);
//#endregion
//#region src/components/FilterDateInput/FilterDateInput.ts?vue&type=script&src=true&lang.ts
function isFilterValue(value) {
	return value instanceof FilterValue;
}
var FilterDateInput_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "FilterDateInput",
	components: {
		Button: Button$1,
		Divider: Divider$1,
		FilterDate: FilterDate_default,
		Popover,
		HorizontalLayout: HorizontalLayout$1,
		InputDate: InputDate$1,
		InputMessage,
		VerticalLayout: VerticalLayout$1
	},
	props: {
		modelValue: {
			type: [
				Date,
				String,
				Object
			],
			default: null
		},
		property: {
			type: Object,
			required: true
		},
		readonly: {
			type: Boolean,
			default: false
		},
		messageText: {
			type: String,
			default: void 0
		},
		messageSeverity: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:modelValue", "toggleModal"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const inplaceElement = ref();
		const inplaceValue = computed({
			get() {
				if (props.modelValue instanceof Date) return props.modelValue;
				if (typeof props.modelValue === "string") return dateOnlyToDateTime(props.modelValue);
				return null;
			},
			set(value) {
				emit("update:modelValue", value ? dateTimeToDateOnly(value) : null);
			}
		});
		const inplaceInvalidValue = computed(() => isFilterValue(props.modelValue) ? props.modelValue.toString() : null);
		const inplaceReadonly = computed(() => props.readonly || isFilterValue(props.modelValue));
		const inplaceCalendar = computed(() => !isFilterValue(props.modelValue));
		const inplaceFormat = computed(() => {
			if (props.property.dataType === DataType$1.invariantDateTime || props.property.dataType === DataType$1.dateTime) return typeof props.modelValue === "string" ? "d" : "g";
			return "d";
		});
		const filterDateValue = ref();
		const popover = ref();
		function togglePopover(event) {
			filterDateValue.value = props.modelValue;
			popover.value.toggle(event, { positionTarget: inplaceElement.value.$el });
		}
		function handlePopoverShow() {
			emit("toggleModal", true);
		}
		function handlePopoverHide() {
			emit("toggleModal", false);
			if (filterDateValue.value !== props.modelValue) emit("update:modelValue", filterDateValue.value);
		}
		function handleOkButtonClick() {
			popover.value.hide();
		}
		function handleCancelButtonClick() {
			filterDateValue.value = props.modelValue;
			popover.value.hide();
		}
		return {
			translate,
			inplaceElement,
			inplaceValue,
			inplaceInvalidValue,
			inplaceReadonly,
			inplaceCalendar,
			inplaceFormat,
			filterDateValue,
			popover,
			togglePopover,
			handlePopoverShow,
			handlePopoverHide,
			handleOkButtonClick,
			handleCancelButtonClick
		};
	}
});
//#endregion
//#region src/components/FilterDateInput/FilterDateInput.vue
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_InputMessage = resolveComponent("InputMessage");
	const _component_FilterDate = resolveComponent("FilterDate");
	const _component_Divider = resolveComponent("Divider");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_Popover = resolveComponent("Popover");
	const _component_InputDate = resolveComponent("InputDate");
	return openBlock(), createBlock(_component_InputDate, {
		ref: "inplaceElement",
		modelValue: _ctx.inplaceValue,
		"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.inplaceValue = $event),
		readonly: _ctx.inplaceReadonly,
		"invalid-value": _ctx.inplaceInvalidValue,
		calendar: _ctx.inplaceCalendar,
		format: _ctx.inplaceFormat,
		time: false,
		"data-readonly": _ctx.readonly,
		"message-text": _ctx.messageText,
		"message-severity": _ctx.messageSeverity,
		"message-position": "hidden",
		class: "filter-date-input"
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
		default: withCtx(() => [createVNode(_component_Button, {
			variant: "ghost",
			size: "small",
			icon: "dotsHorizontal",
			class: "filter-date-input-toggle-popover-button",
			tabindex: "-1",
			onClick: _ctx.togglePopover
		}, null, 8, ["onClick"]), createVNode(_component_Popover, {
			ref: "popover",
			class: "filter-date-input-popover",
			onShow: _ctx.handlePopoverShow,
			onHide: _ctx.handlePopoverHide
		}, {
			default: withCtx(() => [createVNode(_component_VerticalLayout, { space: "medium" }, {
				default: withCtx(() => [
					_ctx.messageText ? (openBlock(), createBlock(_component_InputMessage, {
						key: 0,
						text: _ctx.messageText,
						severity: _ctx.messageSeverity,
						"max-lines": 0,
						class: "filter-date-input-validation-message"
					}, null, 8, ["text", "severity"])) : createCommentVNode("", true),
					createVNode(_component_FilterDate, {
						modelValue: _ctx.filterDateValue,
						"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filterDateValue = $event),
						property: _ctx.property,
						readonly: _ctx.readonly
					}, null, 8, [
						"modelValue",
						"property",
						"readonly"
					]),
					!_ctx.readonly ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(_component_Divider, { class: "popover-divider" }), createVNode(_component_HorizontalLayout, { align: "right" }, {
						default: withCtx(() => [createVNode(_component_Button, {
							icon: "validate",
							label: _ctx.translate("Ok"),
							disabled: _ctx.readonly,
							size: "small",
							variant: "primary",
							class: "filter-date-input-popover-ok-button",
							onClick: _cache[1] || (_cache[1] = ($event) => _ctx.handleOkButtonClick())
						}, null, 8, ["label", "disabled"]), createVNode(_component_Button, {
							icon: "close",
							label: _ctx.translate("Cancel"),
							disabled: _ctx.readonly,
							size: "small",
							class: "filter-date-input-popover-cancel-button",
							onClick: _cache[2] || (_cache[2] = ($event) => _ctx.handleCancelButtonClick())
						}, null, 8, ["label", "disabled"])]),
						_: 1
					})], 64)) : createCommentVNode("", true)
				]),
				_: 1
			})]),
			_: 1
		}, 8, ["onShow", "onHide"])]),
		_: 3
	}, 8, [
		"modelValue",
		"readonly",
		"invalid-value",
		"calendar",
		"format",
		"data-readonly",
		"message-text",
		"message-severity"
	]);
}
var FilterDateInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FilterDateInput_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$19], ["__scopeId", "data-v-bd6b307b"]]);
//#endregion
//#region src/components/FilterLookup/FilterLookup.vue
var FilterLookup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterLookup",
	props: /*@__PURE__*/ mergeModels({
		property: {},
		definition: {},
		readonly: { type: Boolean }
	}, {
		"modelValue": { default: () => [] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["toggleModal"], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const inputValue = ref(null);
		const searchText = ref(null);
		const suggestionsId = `${useId()}-suggestions`;
		const pending = ref(false);
		const viewModel = useViewModel();
		const displayProperty = computed(() => getLookupDisplayProperty(props.definition));
		const loading = ref(false);
		const hasMoreData = ref(true);
		const selectedSuggestions = ref([]);
		const { suggestions, currentSuggestionIndex, loadItems, handleSuggestionsKeyboardNavigation } = useLookupSuggestions(props, viewModel, displayProperty);
		const showSelected = ref(false);
		const filteredSuggestions = computed(() => props.readonly || showSelected.value ? selectedSuggestions.value : suggestions.value);
		const hasMoreSuggestions = computed(() => !props.readonly && !showSelected.value && hasMoreData.value);
		let handle = -1;
		async function handleInput(value) {
			showSelected.value = false;
			pending.value = true;
			clearTimeout(handle);
			handle = window.setTimeout(async () => {
				inputValue.value = value;
				try {
					await loadSuggestions(1);
				} finally {
					pending.value = false;
				}
			}, 400);
		}
		onUnmounted(() => {
			clearTimeout(handle);
		});
		async function loadSuggestions(pageNumber) {
			loading.value = true;
			try {
				const res = await loadItems({
					trigger: ReferenceRetrievingTrigger.lookupSuggestions,
					item: void 0,
					inputValue: inputValue.value,
					pageNumber
				});
				if (res.succeeded) {
					suggestions.value = pageNumber === 1 ? res.data : [...suggestions.value, ...res.data];
					hasMoreData.value = res.hasMoreData;
					reconcileSelectedSuggestions(res.data);
				} else {
					if (pageNumber === 1) suggestions.value = [];
					hasMoreData.value = false;
				}
			} finally {
				loading.value = false;
			}
		}
		function isSelected(suggestion) {
			const value = getValueProperty(suggestion);
			return modelValue.value.includes(value);
		}
		function handleSelect(suggestion) {
			const value = getValueProperty(suggestion);
			if (modelValue.value.includes(value)) {
				modelValue.value = modelValue.value.filter((item) => item !== value);
				reconcileSelectedSuggestions();
			} else {
				modelValue.value = [...modelValue.value, value];
				reconcileSelectedSuggestions([suggestion]);
			}
		}
		function handleKeyDown(event) {
			switch (event.key) {
				case "Enter":
					event.stopPropagation();
					break;
				case "ArrowDown":
				case "ArrowUp":
					handleSuggestionsKeyboardNavigation(event, filteredSuggestions.value);
					break;
				case " ": {
					if (event.target instanceof HTMLInputElement) return;
					event.preventDefault();
					const suggestion = filteredSuggestions.value[currentSuggestionIndex.value];
					if (suggestion) handleSelect(suggestion);
					break;
				}
			}
		}
		function onModalOpen(options) {
			emit("toggleModal", true);
			options.withParameter("neos-lookup-multi-selection", true).withCallback(async (r) => {
				if (r.state === NavigationResultState.ok) {
					const newSuggestions = [];
					const values = Array.isArray(r.value) ? r.value : [r.value];
					for (const item of values) if (!isSelected(item)) newSuggestions.push(item);
					if (newSuggestions.length > 0) {
						modelValue.value = [...modelValue.value, ...newSuggestions.map(getValueProperty)];
						reconcileSelectedSuggestions(newSuggestions);
					}
				}
				emit("toggleModal", false);
			});
		}
		const container = useTemplateRef("container");
		function updateContainerMinWidth() {
			const element = container.value?.$el;
			if (!element) return;
			element.style.width = `${element.offsetWidth}px`;
		}
		watch(modelValue, () => loadMissingSelectedSuggestions());
		function reconcileSelectedSuggestions(additionalSuggestions = []) {
			if (modelValue.value.length === 0) {
				selectedSuggestions.value = [];
				showSelected.value = false;
				return;
			}
			const suggestionsByValue = /* @__PURE__ */ new Map();
			function addSelectedSuggestionsToMap(suggestions) {
				for (const suggestion of suggestions) {
					const value = getValueProperty(suggestion);
					if (modelValue.value.includes(value) && !suggestionsByValue.has(value)) suggestionsByValue.set(value, suggestion);
				}
			}
			addSelectedSuggestionsToMap(additionalSuggestions);
			addSelectedSuggestionsToMap(selectedSuggestions.value);
			addSelectedSuggestionsToMap(suggestions.value);
			const newSelectedSuggestions = [];
			for (const selectedValue of modelValue.value) {
				const suggestion = suggestionsByValue.get(selectedValue);
				if (suggestion) newSelectedSuggestions.push(suggestion);
			}
			selectedSuggestions.value = newSelectedSuggestions;
			if (selectedSuggestions.value.length === 0) showSelected.value = false;
		}
		async function loadMissingSelectedSuggestions() {
			reconcileSelectedSuggestions();
			const loadedSelectedValues = new Set(selectedSuggestions.value.map((suggestion) => getValueProperty(suggestion)));
			const selectedSuggestionsToLoad = modelValue.value.filter((selectedValue) => !loadedSelectedValues.has(selectedValue));
			if (selectedSuggestionsToLoad.length === 0) return;
			const res = await loadItems({
				trigger: ReferenceRetrievingTrigger.lookupSuggestions,
				item: void 0,
				inputValue: null,
				filter: Filter.create(props.definition.valueProperty.camelCaseName, FilterOperator.in, selectedSuggestionsToLoad)
			});
			if (res.succeeded && res.data.length > 0) reconcileSelectedSuggestions(res.data);
		}
		async function onLoad() {
			await loadSuggestions(Math.floor(suggestions.value.length / 10) + 1);
			updateContainerMinWidth();
		}
		async function toggleShowSelected() {
			await loadMissingSelectedSuggestions();
			showSelected.value = !showSelected.value;
		}
		function getValueProperty(item) {
			return getPropertyByPath(item, props.definition.valueProperty.camelCaseName);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				ref_key: "container",
				ref: container,
				class: "filter-lookup",
				"data-pending": pending.value,
				onKeydown: handleKeyDown
			}, {
				default: withCtx(() => [!__props.readonly ? (openBlock(), createBlock(unref(SelectableListHeader), {
					key: 0,
					modelValue: searchText.value,
					"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => searchText.value = $event), handleInput],
					"list-id": suggestionsId,
					loading: loading.value,
					autofocus: true,
					"selected-count": modelValue.value.length,
					"show-selected": showSelected.value,
					onToggleShowSelected: toggleShowSelected
				}, {
					actions: withCtx(() => [createVNode(LookupModalButton_default, {
						definition: __props.definition,
						property: __props.property,
						"input-value": inputValue.value,
						"on-modal-open": onModalOpen
					}, null, 8, [
						"definition",
						"property",
						"input-value"
					])]),
					_: 1
				}, 8, [
					"modelValue",
					"loading",
					"selected-count",
					"show-selected"
				])) : createCommentVNode("", true), createVNode(LookupSuggestions_default, {
					id: suggestionsId,
					"input-value": inputValue.value,
					definition: __props.definition,
					"display-property": displayProperty.value,
					tabindex: 0,
					loading: loading.value,
					suggestions: filteredSuggestions.value,
					"current-suggestion-index": unref(currentSuggestionIndex),
					"multi-selection-options": { isSelected },
					"has-more-data": hasMoreSuggestions.value,
					"on-load": onLoad,
					class: "filter-lookup-suggestions neos-fill-parent-height",
					onSelect: handleSelect
				}, null, 8, [
					"input-value",
					"definition",
					"display-property",
					"loading",
					"suggestions",
					"current-suggestion-index",
					"multi-selection-options",
					"has-more-data"
				])]),
				_: 1
			}, 8, ["data-pending"]);
		};
	}
}), [["__scopeId", "data-v-de665e45"]]);
//#endregion
//#region src/components/FilterLookupInput/FilterLookupInput.vue
var FilterLookupInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterLookupInput",
	props: /*@__PURE__*/ mergeModels({
		property: {},
		definition: {},
		readonly: { type: Boolean },
		messageText: {},
		messageSeverity: {}
	}, {
		"modelValue": { default: () => [] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["update:modelValue", "toggleModal"], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const displayValue = ref("");
		watch([() => props.property, () => modelValue.value], ([property, values]) => updateDisplayValue(property, values), { immediate: true });
		const displayClearButton = computed(() => modelValue.value.length > 0);
		const textboxElement = ref();
		const popover = ref();
		const filterArrayValue = ref();
		const { preventPopoverHide, setPreventPopoverHide } = usePreventPopoverHide();
		async function updateDisplayValue(property, values) {
			const owner = property.owner;
			if (isLookupPropertyWithDisplayProperty(property)) {
				displayValue.value = "";
				displayValue.value = (await getLookupDisplayPropertyValues(property, values)).join(", ");
			} else displayValue.value = formatValues(values, property, owner).join(", ");
		}
		function togglePopover(event) {
			filterArrayValue.value = modelValue.value.length > 0 ? [...modelValue.value] : [null];
			popover.value.toggle(event, { positionTarget: textboxElement.value.$el });
		}
		function handleTextboxClick(event) {
			if (event.target instanceof HTMLInputElement) togglePopover(event);
		}
		function handlePopoverShow() {
			emit("toggleModal", true);
		}
		function handlePopoverHide() {
			const values = filterArrayValue.value.filter((v) => v != null);
			if (!isEquivalentValues(values, modelValue.value)) emit("update:modelValue", values.length > 0 ? values : void 0);
			emit("toggleModal", false);
		}
		function handleClearButtonClick() {
			emit("update:modelValue", void 0);
		}
		function handleOkButtonClick() {
			popover.value.hide();
		}
		function handleCancelButtonClick() {
			filterArrayValue.value = [...modelValue.value];
			popover.value.hide();
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Textbox$1), {
				ref_key: "textboxElement",
				ref: textboxElement,
				"model-value": displayValue.value,
				readonly: true,
				tooltip: displayValue.value,
				class: "filter-lookup-input",
				"data-readonly": __props.readonly,
				"message-text": __props.messageText,
				"message-severity": __props.messageSeverity,
				"message-position": "hidden",
				onClick: handleTextboxClick
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				default: withCtx(() => [
					createVNode(unref(Button$1), {
						variant: "ghost",
						size: "small",
						icon: "dotsHorizontal",
						class: "filter-lookup-input-toggle-popover-button",
						tabindex: "-1",
						onClick: withModifiers(togglePopover, ["stop"])
					}),
					!__props.readonly ? withDirectives((openBlock(), createBlock(unref(Button$1), {
						key: 0,
						class: "input-clear-button",
						size: "small",
						variant: "ghost",
						icon: "erase",
						tabindex: "-1",
						onClick: _cache[0] || (_cache[0] = ($event) => handleClearButtonClick())
					}, null, 512)), [[vShow, displayClearButton.value]]) : createCommentVNode("", true),
					createVNode(unref(Popover), {
						ref_key: "popover",
						ref: popover,
						class: "filter-lookup-input-popover",
						"prevent-hide": unref(preventPopoverHide),
						onShow: handlePopoverShow,
						onHide: handlePopoverHide
					}, {
						default: withCtx(() => [createVNode(unref(VerticalLayout$1), { space: "medium" }, {
							default: withCtx(() => [
								__props.messageText ? (openBlock(), createBlock(unref(InputMessage), {
									key: 0,
									text: __props.messageText,
									severity: __props.messageSeverity,
									"max-lines": 0,
									class: "filter-lookup-input-validation-message"
								}, null, 8, ["text", "severity"])) : createCommentVNode("", true),
								createVNode(FilterLookup_default, {
									modelValue: filterArrayValue.value,
									"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => filterArrayValue.value = $event),
									property: __props.property,
									definition: __props.definition,
									readonly: __props.readonly,
									onToggleModal: unref(setPreventPopoverHide)
								}, null, 8, [
									"modelValue",
									"property",
									"definition",
									"readonly",
									"onToggleModal"
								]),
								!__props.readonly ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(unref(Divider$1), { class: "popover-divider" }), createVNode(unref(HorizontalLayout$1), { align: "right" }, {
									default: withCtx(() => [createVNode(unref(Button$1), {
										icon: "validate",
										label: unref(translate)("Ok"),
										disabled: __props.readonly,
										size: "small",
										variant: "primary",
										class: "filter-lookup-input-popover-ok-button",
										onClick: _cache[2] || (_cache[2] = ($event) => handleOkButtonClick())
									}, null, 8, ["label", "disabled"]), createVNode(unref(Button$1), {
										icon: "close",
										label: unref(translate)("Cancel"),
										disabled: __props.readonly,
										size: "small",
										class: "filter-lookup-input-popover-cancel-button",
										onClick: _cache[3] || (_cache[3] = ($event) => handleCancelButtonClick())
									}, null, 8, ["label", "disabled"])]),
									_: 1
								})], 64)) : createCommentVNode("", true)
							]),
							_: 1
						})]),
						_: 1
					}, 8, ["prevent-hide"])
				]),
				_: 3
			}, 8, [
				"model-value",
				"tooltip",
				"data-readonly",
				"message-text",
				"message-severity"
			]);
		};
	}
}), [["__scopeId", "data-v-55721fde"]]);
//#endregion
//#region src/filter/useFilterComponent.ts
function getHeaderComponent(attribute) {
	return attribute instanceof ViewModelPropertyBase && isDateDataType(attribute.getFilterDataType()) ? EditableFilterDateHeader_default : void 0;
}
function getHeaderComponentProps(attribute) {
	return attribute instanceof ViewModelPropertyBase && isDateDataType(attribute.getFilterDataType()) ? { property: attribute } : void 0;
}
function getFilterComponent(attribute, operator, inline = false) {
	if (isProperty(attribute) && attribute.lookupDefinition) return getLookupFilterComponent(operator, inline);
	const dataType = attribute.getFilterDataType();
	if (!isEnumFilterDataType(dataType) && isArrayFilterOperator(operator)) return inline ? FilterArray_default : FilterArrayInput_default;
	switch (dataType) {
		case DataType$1.decimal:
		case DataType$1.integer:
		case DataType$1.autoIncrementedInteger:
		case DataType$1.long: return InputNumber$1;
		case DataType$1.date:
		case DataType$1.dateTime:
		case DataType$1.invariantDateTime: return inline ? EditableFilterDate_default : FilterDateInput_default;
		case DataType$1.boolean:
		case DataType$1.enum:
		case DataType$1.dataType: return inline ? ListBox : MultiSelect$1;
		default: return Textbox$1;
	}
}
function getLookupFilterComponent(operator, inline) {
	if (isFilterOperatorOnLookupValueProperty(operator)) return inline ? FilterLookup_default : FilterLookupInput_default;
	return Lookup_default;
}
function getFilterComponentProps(attribute, operator, inline = false, liveUpdate = false) {
	const emitImmediately = inline || liveUpdate;
	if (isProperty(attribute) && attribute.lookupDefinition) return getFilterLookupComponentProps(attribute, operator);
	const dataType = attribute.getFilterDataType();
	if (isArrayFilterOperator(operator) && !isEnumFilterDataType(dataType)) return { attribute };
	switch (dataType) {
		case DataType$1.decimal:
		case DataType$1.integer:
		case DataType$1.autoIncrementedInteger:
		case DataType$1.long: {
			const props = { format: attribute.getFilterFormat() };
			if (emitImmediately) props.updateMode = "immediate";
			return props;
		}
		case DataType$1.date:
		case DataType$1.dateTime:
		case DataType$1.invariantDateTime: {
			const props = { property: attribute };
			if (inline) props.selectionMode = operator === FilterOperator.between ? "range" : "single";
			return props;
		}
		case DataType$1.enum:
		case DataType$1.dataType: {
			const props = {
				values: attribute.getFilterEnumMembers(),
				displayProperty: "caption"
			};
			if (inline) {
				props.multiple = isArrayFilterOperator(operator);
				props.keyProperty = "name";
			}
			return props;
		}
		case DataType$1.boolean: {
			const props = {
				values: isProperty(attribute) && attribute.isExpressionCode ? [
					{
						name: "true",
						caption: getGlobalResourceManager(void 0).get("Yes")
					},
					{
						name: "false",
						caption: getGlobalResourceManager(void 0).get("No")
					},
					{
						name: "=",
						caption: getGlobalResourceManager(void 0).get("Expression")
					}
				] : [{
					name: true,
					caption: getGlobalResourceManager(void 0).get("Yes")
				}, {
					name: false,
					caption: getGlobalResourceManager(void 0).get("No")
				}],
				displayProperty: "caption"
			};
			if (inline) props.keyProperty = "name";
			return props;
		}
		case DataType$1.localizableString: return isProperty(attribute) ? {
			maxLength: attribute.maxLength,
			whiteSpaceHandling: attribute.whiteSpaceHandling,
			...emitImmediately ? { updateMode: "immediate" } : {}
		} : { ...emitImmediately ? { updateMode: "immediate" } : {} };
		case DataType$1.string: return isProperty(attribute) ? {
			maxLength: attribute.maxLength,
			characterCasing: attribute.characterCasing,
			whiteSpaceHandling: attribute.whiteSpaceHandling,
			...emitImmediately ? { updateMode: "immediate" } : {}
		} : { ...emitImmediately ? { updateMode: "immediate" } : {} };
		default: return { ...emitImmediately ? { updateMode: "immediate" } : {} };
	}
}
function getFilterLookupComponentProps(property, operator) {
	if (isFilterOperatorOnLookupValueProperty(operator)) return {
		property,
		definition: property.lookupDefinition
	};
	const definition = {
		...property.lookupDefinition,
		valueProperty: getLookupDisplayProperty(property.lookupDefinition),
		displayProperty: void 0,
		creationUIViewName: void 0,
		editingUIViewName: void 0
	};
	if (allowLookupFreeValue(definition.valueProperty.dataType)) definition.allowFreeValue = true;
	return {
		definition,
		property,
		isReference: false,
		validate: false,
		multiSelectionProperty: property.lookupDefinition.valueProperty.camelCaseName
	};
}
function allowLookupFreeValue(dataType) {
	return dataType === DataType$1.string || dataType === DataType$1.localizableString;
}
function isProperty(attribute) {
	return attribute instanceof ViewModelPropertyBase;
}
function isEnumFilterDataType(dataType) {
	return dataType === DataType$1.boolean || isEnumDataType(dataType);
}
function getFilterDataTypeIcon(attribute) {
	if (attribute.filterIcon) return attribute.filterIcon;
	return getDataTypeIcon(attribute.getFilterDataType(), isProperty(attribute) && !!attribute.lookupDefinition);
}
//#endregion
//#region src/filter/useFilterAttribute.ts
function useFilterAttribute(attribute, operator, inline = false, validationMessage = ref(void 0), liveUpdate = false) {
	const headerComponent = computed(() => getHeaderComponent(attribute.value));
	const headerComponentProps = computed(() => getHeaderComponentProps(attribute.value));
	const editingComponent = computed(() => getFilterComponent(attribute.value, operator.value, inline));
	const editingComponentProps = computed(() => getFilterComponentProps(attribute.value, operator.value, inline, liveUpdate));
	const required = computed(() => attribute.value.filterRequired);
	const hasUnfulfilledRequirement = computed(() => attribute.value.filterRequirementUnfulfilled);
	const messageText = computed(() => {
		if (hasUnfulfilledRequirement.value) return "";
		return validationMessage.value?.text;
	});
	const messageSeverity = computed(() => {
		if (hasUnfulfilledRequirement.value) return "error";
		return validationMessage.value ? convertValidationMessageSeverity(validationMessage.value.severityLevel) : void 0;
	});
	const operators = computed(() => attribute.value instanceof ViewModelEntityViewParameter ? [{
		...allOperators[getParameterOperator(attribute.value)],
		value: getParameterOperator(attribute.value)
	}] : getPropertyFilterOperators(attribute.value));
	const showValue = computed(() => operator.value !== FilterOperator.isNull && operator.value !== FilterOperator.isNotNull && isStandardFilterOperator(operator.value));
	const showValue2 = computed(() => attribute.value instanceof ViewModelPropertyBase && operator.value === FilterOperator.between && !(inline && isDateDataType(attribute.value.dataType)));
	if (attribute.value instanceof ViewModelPropertyBase) watch(operator, (selectedOperator) => {
		attribute.value.filterDefaultOperator = selectedOperator;
	});
	return {
		operators,
		editingComponent,
		editingComponentProps,
		showValue,
		showValue2,
		required,
		messageText,
		messageSeverity,
		headerComponent,
		headerComponentProps
	};
}
function getParameterOperator(parameter) {
	return hasEditableFilterValue2Parameter(parameter) ? FilterOperator.between : parameter.filterDefaultOperator;
}
function hasEditableFilterValue2Parameter(parameter) {
	return parameter.filterValue2Parameter instanceof ViewModelEntityViewParameter && isDateDataType(parameter.dataType) && isDateDataType(parameter.filterValue2Parameter.dataType);
}
function normalizeConditionOperator(property, operator, value1) {
	if (!isStandardFilterOperator(operator)) return operator;
	if (property.lookupDefinition && Array.isArray(value1)) return normalizeLookupConditionOperatorWithArrayValue(property, operator, value1);
	return operator;
}
function normalizeLookupConditionOperatorWithArrayValue(property, operator, value1) {
	const hasOperator = (op) => op in property.getFilterOperators();
	if (value1.length > 1) {
		if (operator === FilterOperator.notEqual && hasOperator(FilterOperator.notIn)) return FilterOperator.notIn;
		if (operator === FilterOperator.equal && hasOperator(FilterOperator.in)) return FilterOperator.in;
		return operator;
	}
	if (operator === FilterOperator.notIn && hasOperator(FilterOperator.notEqual)) return FilterOperator.notEqual;
	if (operator === FilterOperator.in && hasOperator(FilterOperator.equal)) return FilterOperator.equal;
	return operator;
}
function normalizeConditionValues(property, operator, value1, value2) {
	if (!isStandardFilterOperator(operator)) return [value1, value2];
	if (property.lookupDefinition) return normalizeConditionLookupValues(operator, value1);
	value1 = normalizeConditionValue(property, operator, value1);
	value2 = normalizeConditionValue(property, operator, value2);
	const isArrayOperator = isArrayFilterOperator(operator);
	if (isArrayOperator || isEnumFilterDataType(property.getFilterDataType())) {
		let array = Array.isArray(value1) ? value1 : [value1, value2];
		array = array.filter((v) => v != null);
		if (!isArrayOperator) array = array.slice(-1);
		return [array.length > 0 ? array : void 0, void 0];
	}
	if (Array.isArray(value1)) return [value1[0], value1[1]];
	return [value1, value2];
}
function normalizeConditionLookupValues(operator, value) {
	const isArrayExpected = isFilterOperatorOnLookupValueProperty(operator);
	const isArrayValue = Array.isArray(value);
	let shouldReset = isArrayExpected && isArrayValue && value.length > 1 && !isArrayFilterOperator(operator);
	shouldReset ||= isArrayExpected && !isArrayValue;
	shouldReset ||= !isArrayExpected && isArrayValue;
	return [shouldReset ? void 0 : value, void 0];
}
function normalizeConditionValue(property, operator, value) {
	if (Array.isArray(value)) return normalizeConditionArrayValue(property, operator, value);
	return value;
}
function normalizeConditionArrayValue(property, operator, value) {
	if (property.dataType === DataType$1.boolean && value.length > 0) return [normalizeConditionValue(property, operator, value[value.length - 1])];
	return value.map((v) => normalizeConditionValue(property, operator, v));
}
function getPropertyFilterOperators(property) {
	const operators = property.getFilterOperators();
	Object.keys(operators).forEach((value) => {
		if (!property.filterOperators.includes(value)) delete operators[value];
	});
	return Object.keys(operators).map((value) => ({
		value,
		...operators[value]
	}));
}
function isLookupPropertyWithDisplayProperty(attribute) {
	return attribute instanceof ViewModelPropertyBase && !!attribute.lookupDefinition && !!attribute.lookupDefinition.displayProperty;
}
async function getLookupDisplayPropertyValues(property, values) {
	if (values.length === 0) return [];
	const displayPropertyValues = await loadLookupDisplayPropertyValues(property.owner.apiClient, property.lookupDefinition, values);
	return displayPropertyValues ? formatValues(displayPropertyValues, property.lookupDefinition.displayProperty, property.owner) : formatValues(values, property, property.owner).map((v) => `<${v}>`);
}
async function loadLookupDisplayPropertyValues(apiClient, lookup, values) {
	try {
		const filter = values.length > 1 ? Filter.create(lookup.valueProperty.camelCaseName, FilterOperator.in, values) : Filter.create(lookup.valueProperty.camelCaseName, FilterOperator.equal, values[0]);
		const response = await apiClient.getAllAsync({
			path: lookup.searchEntityViewName,
			filter: filter.toODataString(),
			pageNumber: 1,
			recordsByPage: values.length
		});
		if (response.succeeded) return response.data.map((item) => getPropertyByPath(item, lookup.displayProperty.camelCaseName));
		return;
	} catch {
		return;
	}
}
function getParameterFilterValue(parameter, value = parameter.value) {
	if (parameter.dataType === DataType$1.date) return typeof value === "string" && value.length > 0 ? dateOnlyToDateTime(value) : value;
	if (parameter.dataType === DataType$1.boolean) {
		if (value === true) return [{
			name: value,
			caption: parameter.owner.globalResourceManager.get("Yes")
		}];
		if (value === false) return [{
			name: value,
			caption: parameter.owner.globalResourceManager.get("No")
		}];
		return [];
	}
	if (parameter.dataType === DataType$1.enum && parameter.enum) return parameter.enum.getEnumMembers().filter((v) => value == v.name);
	return value;
}
function getParameterValueFromFilterValue(parameter, value, rangePosition = "start") {
	if (parameter.dataType === DataType$1.date) {
		if (value instanceof FilterValue) return getDateOnlyParameterValue(value, rangePosition);
		return value instanceof Date ? dateTimeToDateOnly(value) : value;
	}
	if (Array.isArray(value) && (parameter.dataType === DataType$1.boolean || parameter.dataType === DataType$1.enum)) {
		value = value[0];
		return isEnumMember(value) ? value.name : value;
	}
	return value;
}
function getDateOnlyParameterValue(value, rangePosition) {
	switch (value.operation) {
		case FilterOperation.specificMonth: return rangePosition === "end" ? value.toEndOfDateValue("month") : value.toStartOfDateValue("month");
		case FilterOperation.specificYear: return rangePosition === "end" ? value.toEndOfDateValue("year") : value.toStartOfDateValue("year");
		default: return value;
	}
}
//#endregion
//#region src/filter/FilterBuilderCondition.ts
var FilterBuilderCondition = class FilterBuilderCondition extends FilterBuilderItem {
	constructor(attribute, operator, value1, value2, visible, readOnly, active, parent) {
		super(visible, readOnly, active, parent);
		this.attribute = attribute;
		this.operator = operator;
		this.value1 = value1;
		this.value2 = value2;
	}
	get canConvertToFilter() {
		return this.attribute instanceof ViewModelPropertyBase;
	}
	get text1() {
		return this.getDisplayValue(this.value1);
	}
	get text2() {
		return this.getDisplayValue(this.value2);
	}
	static fromAttribute(attribute, parent) {
		return attribute instanceof ViewModelEntityViewParameter ? FilterBuilderCondition.fromParameter(attribute, attribute.value, parent) : FilterBuilderCondition.fromProperty(attribute, parent);
	}
	static fromProperty(property, parent) {
		return new FilterBuilderCondition(property, property.filterDefaultOperator, void 0, void 0, parent.visible, parent.readOnly, parent.active, parent);
	}
	static fromParameter(parameter, value, parent) {
		const operator = getParameterOperator(parameter);
		return new FilterBuilderCondition(parameter, operator, getParameterFilterValue(parameter, value), operator === "between" && hasEditableFilterValue2Parameter(parameter) ? getParameterFilterValue(parameter.filterValue2Parameter) : void 0, parent.visible, parent.readOnly, parent.active, parent);
	}
	static fromFilterCondition(condition, property, parent) {
		const { operator, value1, value2 } = property.extractOperatorAndValuesFromFilterCondition(condition);
		return new FilterBuilderCondition(property, operator, value1, value2, condition.visible, condition.readOnly, condition.active, parent);
	}
	updateFromFilterCondition(property, condition) {
		const { operator, value1, value2 } = property.extractOperatorAndValuesFromFilterCondition(condition);
		this.attribute = property;
		this.operator = operator;
		this.value1 = value1;
		this.value2 = value2;
		this.visible = condition.visible;
		this.readOnly = condition.readOnly;
		this.active = condition.active;
	}
	async toFilter() {
		if (!this.canConvertToFilter) throw new Error("Cannot convert to filter");
		const filter = await this.attribute.createFilterCondition(this.operator, this.value1, this.value2, true);
		filter.visible = this.visible;
		filter.readOnly = this.readOnly;
		filter.active = this.active;
		return filter;
	}
	getDisplayValue(value) {
		if (Array.isArray(value)) {
			if (isEnumFilterDataType(this.attribute.getFilterDataType())) return value.map((m) => m.caption).join(", ");
			return formatValues(value, this.attribute, this.attribute.owner).join(", ");
		}
		return formatValue(value, this.attribute, this.attribute.owner);
	}
};
//#endregion
//#region src/filter/FilterBuilderNamedFilter.ts
var FilterBuilderNamedFilter = class extends FilterBuilderItem {
	constructor(definition, visible, readOnly, active, parent) {
		super(visible, readOnly, active, parent);
		this.definition = definition;
	}
	async toFilter() {
		const filter = await this.definition.getFilter();
		filter.visible = this.visible;
		filter.readOnly = this.readOnly;
		filter.active = this.active;
		return filter;
	}
};
//#endregion
//#region src/filter/FilterBuilderGroup.ts
var FilterBuilderGroup = class FilterBuilderGroup extends FilterBuilderItem {
	constructor(logicalOperator, visible, readOnly, active, parent) {
		super(visible, readOnly, active, parent);
		this.items = [];
		this.logicalOperator = logicalOperator;
	}
	get complex() {
		/**
		* A group is complex when :
		* - It has an OR operator.
		* - It has a child group.
		* - It has duplicate properties.
		*/
		if (this.logicalOperator === FilterLogicalOperator.or || this.items.some((item) => item instanceof FilterBuilderGroup)) return true;
		const attributes = /* @__PURE__ */ new Set();
		for (const item of this.items) {
			const condition = item;
			if (attributes.has(condition.attribute)) return true;
			attributes.add(condition.attribute);
		}
		return false;
	}
	static create(filter, parameters, options) {
		const filterGroup = FilterBuilderGroup.fromRootFilter(filter, options);
		const parametersGroup = FilterBuilderGroup.fromParameters(parameters, options);
		if (parametersGroup.items.length === 0) return filterGroup;
		if (parametersGroup.logicalOperator === filterGroup.logicalOperator) {
			parametersGroup.visible = filterGroup.visible;
			parametersGroup.readOnly = filterGroup.readOnly;
			parametersGroup.active = filterGroup.active;
			for (const item of filterGroup.items) {
				item.parent = parametersGroup;
				parametersGroup.items.push(item);
			}
		} else parametersGroup.items.push(filterGroup);
		return parametersGroup;
	}
	static fromRootFilter(filter, options) {
		if (filter.namedFilterId) return this.fromNamedFilter(filter, options);
		if (filter.condition) return FilterBuilderGroup.fromFilterCondition(filter.logicalOperator, filter.condition, options);
		return this.fromFilter(filter, void 0, options);
	}
	static fromNamedFilter(filter, options) {
		const group = new FilterBuilderGroup(FilterLogicalOperator.and, filter.visible, filter.readOnly, filter.active, void 0);
		group.addNamedFilter(filter, options.namedFilters);
		return group;
	}
	static fromFilterCondition(logicalOperator, condition, options) {
		const properties = options.attributes.filter((a) => a instanceof ViewModelPropertyBase);
		const group = new FilterBuilderGroup(logicalOperator, condition.visible, condition.readOnly, condition.active, void 0);
		if (options.addVisiblePropertiesInPanel) group.addVisiblePropertyConditions(properties);
		const property = properties.find((p) => p.isFilterPath(condition.propertyPath));
		if (property) group.addPropertyCondition(property, condition, { updateIfExists: true });
		return group;
	}
	static fromFilter(filter, parent, options) {
		const properties = options.attributes.filter((a) => a instanceof ViewModelPropertyBase);
		const group = new FilterBuilderGroup(filter.logicalOperator, filter.visible, filter.readOnly, filter.active, parent);
		const addVisiblePropertyConditions = options.addVisiblePropertiesInPanel && !parent && filter.isSimple;
		if (addVisiblePropertyConditions) group.addVisiblePropertyConditions(properties);
		for (const child of filter.children) if (child.namedFilterId) group.addNamedFilter(child, options.namedFilters);
		else if (child.condition) {
			const property = properties.find((p) => p.isFilterPath(child.condition.propertyPath));
			if (property) group.addPropertyCondition(property, child.condition, { updateIfExists: addVisiblePropertyConditions });
		} else {
			const childGroup = FilterBuilderGroup.fromFilter(child, group, options);
			group.items.push(childGroup);
		}
		return group;
	}
	static fromParameters(parameterValues, options) {
		const parameters = options.attributes.filter((a) => a instanceof ViewModelEntityViewParameter);
		const secondaryParameters = new Set(parameters.filter(hasEditableFilterValue2Parameter).map((parameter) => parameter.filterValue2Parameter).filter((parameter) => parameter instanceof ViewModelEntityViewParameter));
		const parameterMap = new Map(parameters.map((p) => [p.camelCaseName, p]));
		const group = new FilterBuilderGroup(FilterLogicalOperator.and, true, false, true, void 0);
		for (const [parameterName, parameterValue] of Object.entries(parameterValues)) {
			const parameter = parameterMap.get(parameterName);
			if (parameter && !secondaryParameters.has(parameter)) group.items.push(FilterBuilderCondition.fromParameter(parameter, parameterValue, group));
		}
		return group;
	}
	findConditionByAttribute(attribute) {
		for (const item of this.items) if (item instanceof FilterBuilderCondition && item.attribute === attribute) return item;
	}
	async toFilter() {
		const childFilters = await Promise.all(this.items.filter((i) => i.canConvertToFilter).map((item) => item.toFilter()));
		const filter = new Filter(void 0, this.logicalOperator, ...childFilters);
		filter.visible = this.visible;
		filter.readOnly = this.readOnly;
		filter.active = this.active;
		return filter;
	}
	getParameterValues() {
		const values = {};
		for (const item of this.items) if (item instanceof FilterBuilderCondition && item.attribute instanceof ViewModelEntityViewParameter) {
			values[item.attribute.camelCaseName] = getParameterValueFromFilterValue(item.attribute, item.value1, "start");
			if (hasEditableFilterValue2Parameter(item.attribute)) values[item.attribute.filterValue2Parameter.camelCaseName] = getParameterValueFromFilterValue(item.attribute.filterValue2Parameter, item.value2, "end");
		}
		return values;
	}
	hasNamedFilter(namedFilter) {
		return this.items.some((item) => item instanceof FilterBuilderNamedFilter && item.definition.id === namedFilter.id);
	}
	addVisiblePropertyConditions(properties) {
		const visibleProperties = properties.filter((p) => p.filterVisibleInPanel).sort((p1, p2) => p1.filterPositionInPanel - p2.filterPositionInPanel);
		for (const property of visibleProperties) {
			const condition = FilterBuilderCondition.fromProperty(property, this);
			this.items.push(condition);
		}
	}
	addPropertyCondition(property, condition, options) {
		if (options.updateIfExists) {
			const filterBuilderCondition = this.findConditionByAttribute(property);
			if (filterBuilderCondition instanceof FilterBuilderCondition && filterBuilderCondition.attribute instanceof ViewModelPropertyBase) {
				filterBuilderCondition.updateFromFilterCondition(property, condition);
				filterBuilderCondition.visible ||= this.visible;
				filterBuilderCondition.readOnly ||= this.readOnly;
				filterBuilderCondition.active ||= this.active;
				return;
			}
		}
		this.items.push(FilterBuilderCondition.fromFilterCondition(condition, property, this));
	}
	addNamedFilter(filter, namedFilters) {
		const namedFilter = namedFilters.find((nf) => nf.id === filter.namedFilterId);
		if (namedFilter) this.items.push(new FilterBuilderNamedFilter(namedFilter, filter.visible, filter.readOnly, filter.active, this));
	}
};
//#endregion
//#region src/filter/useFilterBuilderAddDropdownMenu.ts
function useFilterBuilderAddDropdownMenu(globalResourceManager, attributes, namedFilters, advancedMode, rootGroup, emitNewData) {
	const addDropdownMenu = ref();
	const addDropdownMenuItems = ref([]);
	function toggleAddDropdownMenu(group, target) {
		const namedFiltersMenuItem = getNamedFiltersMenuItem(globalResourceManager, namedFilters.value.filter((namedFilter) => !group.hasNamedFilter(namedFilter)), (namedFilter) => {
			group.items.push(new FilterBuilderNamedFilter(namedFilter, group.visible, group.readOnly, group.active, group));
			emitNewData();
			addDropdownMenu.value.hide();
		});
		addDropdownMenuItems.value = advancedMode.value ? createAdvancedModeMenuItems(group, namedFiltersMenuItem) : createAttributeMenuItems(group, namedFiltersMenuItem);
		addDropdownMenu.value.toggle({ currentTarget: target });
	}
	function createAdvancedModeMenuItems(group, namedFiltersMenuItem) {
		const items = [];
		const property = attributes.value.find((a) => a instanceof ViewModelPropertyBase);
		if (property) items.push({
			label: globalResourceManager.get("AddCondition"),
			icon: "addCondition",
			attributes: { "data-command": "ADD_CONDITION" },
			async command() {
				group.items.push(FilterBuilderCondition.fromProperty(property, group));
				emitNewData();
				addDropdownMenu.value.hide();
			}
		});
		items.push({
			label: globalResourceManager.get("AddGroup"),
			icon: "addGroup",
			attributes: { "data-command": "ADD_GROUP" },
			async command() {
				group.items.push(new FilterBuilderGroup(FilterLogicalOperator.and, group.visible, group.readOnly, group.active, group));
				emitNewData();
				addDropdownMenu.value.hide();
			}
		});
		if (namedFiltersMenuItem) items.push({ separator: true }, namedFiltersMenuItem);
		return items;
	}
	function createAttributeMenuItems(group, namedFiltersMenuItem) {
		const menuItems = [];
		if (namedFiltersMenuItem) menuItems.push(namedFiltersMenuItem);
		const attributeMenuItems = attributes.value.filter((attribute) => attribute instanceof ViewModelPropertyBase && !rootGroup.value.findConditionByAttribute(attribute)).map((property) => ({
			label: property.filterCaption,
			icon: getFilterDataTypeIcon(property),
			attributes: { "data-attribute": property.name },
			async command() {
				const length = group.items.push(FilterBuilderCondition.fromProperty(property, group));
				property.filterVisibleInPanel = true;
				property.filterPositionInPanel = length - 1;
				addDropdownMenu.value.hide();
			}
		}));
		if (attributeMenuItems.length > 0) {
			if (menuItems.length > 0) menuItems.push({ separator: true });
			menuItems.push(...attributeMenuItems);
		}
		return menuItems;
	}
	return {
		addDropdownMenu,
		addDropdownMenuItems,
		toggleAddDropdownMenu
	};
}
function getNamedFiltersMenuItem(globalResourceManager, namedFilters, command) {
	if (namedFilters.length === 0) return;
	return {
		label: globalResourceManager.get("NamedFilters"),
		icon: "bookmarkOutline",
		items: namedFilters.map((namedFilter) => ({
			label: namedFilter.name,
			attributes: { "data-named-filter": namedFilter.id },
			command: () => command(namedFilter)
		})),
		attributes: { "data-command": "NAMED_FILTERS" }
	};
}
//#endregion
//#region src/filter/useFilterCommitQueue.ts
var filterCommitQueueKey = Symbol("FilterCommitQueue");
function createFilterCommitQueue() {
	const queue = [];
	let running = false;
	async function drain() {
		if (running) return;
		running = true;
		try {
			for (let entry = queue.shift(); entry !== void 0; entry = queue.shift()) try {
				await entry.run();
			} catch {}
		} finally {
			running = false;
		}
	}
	function enqueue(run, coalesceKey) {
		if (coalesceKey !== void 0) {
			const existingIndex = queue.findIndex((entry) => entry.key === coalesceKey);
			if (existingIndex !== -1) queue.splice(existingIndex, 1);
		}
		queue.push({
			key: coalesceKey,
			run
		});
		drain();
	}
	return { enqueue };
}
function provideFilterCommitQueue() {
	const queue = createFilterCommitQueue();
	provide(filterCommitQueueKey, queue);
	return queue;
}
var immediateCommitQueue = { enqueue(run) {
	run();
} };
function useFilterCommitQueue() {
	return inject(filterCommitQueueKey, immediateCommitQueue);
}
//#endregion
//#region src/filter/useFilterBuilderContext.ts
var filterBuilderContextKey = Symbol("FilterBuilderContext");
function provideFilterBuilderContext(context) {
	provide(filterBuilderContextKey, context);
	return context;
}
function useFilterBuilderContext() {
	const context = inject(filterBuilderContextKey);
	if (!context) throw new Error("Filter builder context not provided");
	return context;
}
//#endregion
//#region src/components/FilterBuilderConditionEntry/FilterBuilderConditionEntry.vue
var FilterBuilderConditionEntry_default = /* @__PURE__ */ defineComponent({
	__name: "FilterBuilderConditionEntry",
	props: {
		condition: {},
		readOnly: { type: Boolean }
	},
	setup(__props) {
		const props = __props;
		const { attributes, advancedMode, updateCondition, remove, toggleModal } = useFilterBuilderContext();
		const { operators, editingComponent, editingComponentProps, showValue, showValue2, required, messageText, messageSeverity } = useFilterAttribute(computed(() => props.condition.attribute), computed(() => props.condition.operator), false, void 0, true);
		const currentAttributes = computed(() => props.condition.attribute instanceof ViewModelEntityViewParameter ? [props.condition.attribute] : attributes.value.filter((a) => a instanceof ViewModelPropertyBase));
		const currentAttribute = computed({
			get: () => attributes.value.find((p) => p.name === props.condition.attribute.name),
			set: (attribute) => updateCondition(props.condition, attribute, props.condition.operator, null, null)
		});
		const currentOperator = computed({
			get: () => props.condition.operator,
			set: (operator) => updateCondition(props.condition, props.condition.attribute, operator, props.condition.value1, props.condition.value2)
		});
		const currentValue1 = computed({
			get: () => props.condition.value1,
			set: (value) => updateCondition(props.condition, props.condition.attribute, props.condition.operator, value, props.condition.value2)
		});
		const currentValue2 = computed({
			get: () => props.condition.value2,
			set: (value) => updateCondition(props.condition, props.condition.attribute, props.condition.operator, props.condition.value1, value)
		});
		const isReadOnly = computed(() => props.readOnly || props.condition.readOnly);
		const attributeAndOperatorReadOnly = computed(() => isReadOnly.value || props.condition.attribute instanceof ViewModelEntityViewParameter);
		const attributeReadOnly = computed(() => !advancedMode.value || attributeAndOperatorReadOnly.value);
		function handleRemoveClick() {
			remove(props.condition);
		}
		return (_ctx, _cache) => {
			return __props.condition.visible ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
				key: 0,
				"vertical-align": "center",
				class: "filter-builder-entry filter-builder-condition",
				"data-attribute": currentAttribute.value.name,
				"data-read-only": attributeAndOperatorReadOnly.value
			}, {
				default: withCtx(() => [
					!attributeAndOperatorReadOnly.value ? (openBlock(), createBlock(unref(Button$1), {
						key: 0,
						icon: "remove",
						size: "small",
						variant: "ghost-danger",
						class: "filter-builder-condition-remove-button",
						onClick: handleRemoveClick
					})) : createCommentVNode("", true),
					createVNode(unref(Combobox), {
						modelValue: currentAttribute.value,
						"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentAttribute.value = $event),
						values: currentAttributes.value,
						required: "",
						"display-property": "filterCaption",
						readonly: attributeReadOnly.value,
						caret: unref(advancedMode),
						"data-advanced-mode": unref(advancedMode),
						class: "filter-builder-condition-combobox filter-builder-condition-attribute"
					}, {
						option: withCtx(({ option }) => [createVNode(unref(Text$2), {
							class: "filter-builder-condition-attribute-option",
							"data-attribute": option.name
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(option.caption), 1)]),
							_: 2
						}, 1032, ["data-attribute"])]),
						_: 1
					}, 8, [
						"modelValue",
						"values",
						"readonly",
						"caret",
						"data-advanced-mode"
					]),
					createVNode(unref(Combobox), {
						modelValue: currentOperator.value,
						"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => currentOperator.value = $event),
						values: unref(operators),
						required: "",
						"value-property": "value",
						"display-property": "lowerCaseCaption",
						readonly: attributeAndOperatorReadOnly.value,
						class: "filter-builder-condition-combobox filter-builder-condition-operator"
					}, {
						option: withCtx(({ option }) => [createVNode(unref(HorizontalLayout$1), {
							space: "small",
							class: "filter-builder-condition-operator-option",
							"vertical-align": "center",
							"data-operator": option.value
						}, {
							default: withCtx(() => [createVNode(unref(Image$2), {
								name: option.image,
								size: "small"
							}, null, 8, ["name"]), createVNode(unref(Text$2), null, {
								default: withCtx(() => [createTextVNode(toDisplayString(option.lowerCaseCaption), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1032, ["data-operator"])]),
						_: 1
					}, 8, [
						"modelValue",
						"values",
						"readonly"
					]),
					unref(editingComponent) ? (openBlock(), createBlock(unref(HorizontalLayout$1), { key: 1 }, {
						default: withCtx(() => [unref(showValue) ? (openBlock(), createBlock(resolveDynamicComponent(unref(editingComponent)), mergeProps({
							key: 0,
							modelValue: currentValue1.value,
							"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => currentValue1.value = $event)
						}, unref(editingComponentProps), {
							readonly: isReadOnly.value,
							required: unref(required),
							"message-text": unref(messageText),
							"message-severity": unref(messageSeverity),
							class: "filter-builder-condition-editing-component",
							"data-value": "1",
							onToggleModal: unref(toggleModal)
						}), null, 16, [
							"modelValue",
							"readonly",
							"required",
							"message-text",
							"message-severity",
							"onToggleModal"
						])) : createCommentVNode("", true), unref(showValue2) ? (openBlock(), createBlock(resolveDynamicComponent(unref(editingComponent)), mergeProps({
							key: 1,
							modelValue: currentValue2.value,
							"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => currentValue2.value = $event)
						}, unref(editingComponentProps), {
							readonly: isReadOnly.value,
							required: unref(required),
							"message-text": unref(messageText),
							"message-severity": unref(messageSeverity),
							class: "filter-builder-condition-editing-component",
							"data-value": "2"
						}), null, 16, [
							"modelValue",
							"readonly",
							"required",
							"message-text",
							"message-severity"
						])) : createCommentVNode("", true)]),
						_: 1
					})) : createCommentVNode("", true)
				]),
				_: 1
			}, 8, ["data-attribute", "data-read-only"])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FilterBuilderNamedFilterEntry/FilterBuilderNamedFilterEntry.vue
var FilterBuilderNamedFilterEntry_default = /* @__PURE__ */ defineComponent({
	__name: "FilterBuilderNamedFilterEntry",
	props: {
		namedFilter: {},
		readOnly: { type: Boolean }
	},
	setup(__props) {
		const props = __props;
		const { attributes, namedFilters, remove } = useFilterBuilderContext();
		const group = ref();
		const isReadOnly = computed(() => props.readOnly || props.namedFilter.readOnly);
		const toggleButtonIcon = computed(() => group.value ? "eyeOff" : "eye");
		function handleRemoveClick() {
			remove(props.namedFilter);
		}
		async function handleToggleClick() {
			if (group.value) group.value = void 0;
			else {
				const filter = await props.namedFilter.definition.getFilter();
				delete filter.namedFilterId;
				group.value = FilterBuilderGroup.create(filter, {}, {
					attributes: attributes.value,
					namedFilters: namedFilters.value,
					addVisiblePropertiesInPanel: false
				});
			}
		}
		return (_ctx, _cache) => {
			return __props.namedFilter.visible ? (openBlock(), createBlock(unref(VerticalLayout$1), {
				key: 0,
				space: "none",
				class: "filter-builder-entry filter-builder-named-filter",
				"data-read-only": isReadOnly.value
			}, {
				default: withCtx(() => [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
					default: withCtx(() => [
						!isReadOnly.value ? (openBlock(), createBlock(unref(Button$1), {
							key: 0,
							icon: "remove",
							size: "small",
							variant: "ghost-danger",
							class: "filter-builder-named-filter-remove-button",
							onClick: handleRemoveClick
						})) : createCommentVNode("", true),
						createVNode(unref(Text$2), { class: "filter-builder-named-filter-name" }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.namedFilter.definition.name), 1)]),
							_: 1
						}),
						createVNode(unref(Button$1), {
							icon: toggleButtonIcon.value,
							size: "small",
							variant: "ghost",
							class: "filter-builder-named-filter-toggle-button",
							onClick: handleToggleClick
						}, null, 8, ["icon"])
					]),
					_: 1
				}), group.value ? (openBlock(), createBlock(FilterBuilderGroupEntry_default, {
					key: 0,
					group: group.value,
					"read-only": true,
					"advanced-mode": true,
					class: "filter-builder-named-filter-group"
				}, null, 8, ["group"])) : createCommentVNode("", true)]),
				_: 1
			}, 8, ["data-read-only"])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FilterBuilderGroupEntry/FilterBuilderGroupEntry.vue
var FilterBuilderGroupEntry_default = /* @__PURE__ */ defineComponent({
	__name: "FilterBuilderGroupEntry",
	props: {
		group: {},
		readOnly: { type: Boolean }
	},
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const { advancedMode, updateGroup, add, remove } = useFilterBuilderContext();
		const addButton = ref();
		const logicalOperators = ref([{
			value: FilterLogicalOperator.and,
			caption: translate("And")
		}, {
			value: FilterLogicalOperator.or,
			caption: translate("Or")
		}]);
		const currentLogicalOperator = computed({
			get: () => logicalOperators.value.find((o) => o.value === props.group.logicalOperator),
			set: (logicalOperator) => updateGroup(props.group, logicalOperator.value)
		});
		const childEntryClass = computed(() => props.group.parent ? "filter-builder-child-entry" : void 0);
		const isReadOnly = computed(() => props.readOnly || props.group.readOnly);
		const isAdvancedMode = computed(() => advancedMode.value);
		const canRemove = computed(() => props.group.parent && !isReadOnly.value);
		const logicalOperatorReadOnly = computed(() => isReadOnly.value || props.group.items.some((i) => i instanceof FilterBuilderCondition && i.attribute instanceof ViewModelEntityViewParameter));
		function handleAddClick() {
			add(props.group, addButton.value.$el);
		}
		function handleRemoveClick() {
			remove(props.group);
		}
		return (_ctx, _cache) => {
			const _component_FilterBuilderGroupEntry = resolveComponent("FilterBuilderGroupEntry", true);
			return __props.group.visible ? (openBlock(), createBlock(unref(VerticalLayout$1), {
				key: 0,
				class: "filter-builder-entry filter-builder-group",
				"data-read-only": isReadOnly.value
			}, {
				default: withCtx(() => [isAdvancedMode.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
					key: 0,
					"vertical-align": "center"
				}, {
					default: withCtx(() => [
						canRemove.value ? (openBlock(), createBlock(unref(Button$1), {
							key: 0,
							icon: "remove",
							size: "small",
							variant: "ghost-danger",
							class: "filter-builder-group-remove-button",
							onClick: handleRemoveClick
						})) : createCommentVNode("", true),
						createVNode(unref(Combobox), {
							modelValue: currentLogicalOperator.value,
							"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentLogicalOperator.value = $event),
							values: logicalOperators.value,
							readonly: logicalOperatorReadOnly.value,
							required: "",
							"display-property": "caption",
							class: "filter-builder-group-logical-operator"
						}, null, 8, [
							"modelValue",
							"values",
							"readonly"
						]),
						!isReadOnly.value ? (openBlock(), createBlock(unref(Button$1), {
							key: 1,
							ref_key: "addButton",
							ref: addButton,
							icon: "add",
							size: "small",
							variant: "ghost",
							class: "filter-builder-group-add-button",
							onClick: handleAddClick
						}, null, 512)) : createCommentVNode("", true)
					]),
					_: 1
				})) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.group.items, (item) => {
					return openBlock(), createElementBlock(Fragment, null, [item instanceof unref(FilterBuilderGroup) ? (openBlock(), createBlock(_component_FilterBuilderGroupEntry, {
						key: 0,
						group: item,
						class: normalizeClass(childEntryClass.value),
						"read-only": __props.readOnly
					}, null, 8, [
						"group",
						"class",
						"read-only"
					])) : item instanceof unref(FilterBuilderNamedFilter) ? (openBlock(), createBlock(FilterBuilderNamedFilterEntry_default, {
						key: 1,
						"named-filter": item,
						class: normalizeClass(childEntryClass.value),
						"read-only": __props.readOnly
					}, null, 8, [
						"named-filter",
						"class",
						"read-only"
					])) : (openBlock(), createBlock(FilterBuilderConditionEntry_default, {
						key: 2,
						condition: item,
						class: normalizeClass(childEntryClass.value),
						"read-only": __props.readOnly
					}, null, 8, [
						"condition",
						"class",
						"read-only"
					]))], 64);
				}), 256))]),
				_: 1
			}, 8, ["data-read-only"])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FilterBuilder/FilterBuilder.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$16 = ["disabled"];
var _hoisted_2$10 = { for: "filter-builder-advanced-mode-checkbox" };
//#endregion
//#region src/components/FilterBuilder/FilterBuilder.vue
var FilterBuilder_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterBuilder",
	props: /*@__PURE__*/ mergeModels({
		parameters: { default: () => ({}) },
		viewModel: { default: void 0 },
		advancedMode: {
			type: [Boolean, String],
			default: true
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: () => new Filter() },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["update:parameters", "toggleModal"], ["update:modelValue"]),
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const emit = __emit;
		useComponentAutomationProperties();
		const { globalResourceManager, translate } = useGlobalResourceManager();
		const viewModel = props.viewModel ?? useViewModel();
		const filterText = computed(() => !modelValue.value.isEmpty ? modelValue.value.toText(viewModel.localizator.currentCulture, false, viewModel) : void 0);
		const attributes = computed(() => viewModel.getFilterableAttributes().sort((p1, p2) => p1.filterCaption.localeCompare(p2.filterCaption)));
		const namedFilters = computed(() => viewModel.namedFilters);
		const initialRootGroup = FilterBuilderGroup.create(modelValue.value, props.parameters, {
			attributes: attributes.value,
			namedFilters: namedFilters.value,
			addVisiblePropertiesInPanel: !props.viewModel
		});
		const rootGroup = ref(initialRootGroup);
		const advancedModeLocked = computed(() => props.advancedMode === "only" || rootGroup.value.complex);
		const isAdvancedMode = ref(advancedModeLocked.value);
		const advancedModeTooltip = computed(() => advancedModeLocked.value ? translate("FilterBuilder_CannotDisableAdvancedMode") : void 0);
		const canAdd = computed(() => !props.readOnly && !isAdvancedMode.value);
		const addButton = ref();
		function emitAndTrackNewData() {
			trackPendingUpdate(emitNewData());
		}
		const { addDropdownMenu, addDropdownMenuItems, toggleAddDropdownMenu } = useFilterBuilderAddDropdownMenu(globalResourceManager, attributes, namedFilters, isAdvancedMode, rootGroup, emitAndTrackNewData);
		const noFilter = computed(() => rootGroup.value.items.length === 0 && !isAdvancedMode.value && !props.viewModel);
		const displayAdvancedModeCheckbox = computed(() => !props.readOnly && props.advancedMode === true);
		let lastEmittedFilter;
		watch(() => modelValue.value, (filter, oldFilter) => {
			if (filter === lastEmittedFilter) return;
			if (!filter.equals(oldFilter)) {
				rootGroup.value = FilterBuilderGroup.create(filter, props.parameters, {
					attributes: attributes.value,
					namedFilters: namedFilters.value,
					addVisiblePropertiesInPanel: false
				});
				isAdvancedMode.value ||= rootGroup.value.complex;
			}
		});
		provideFilterBuilderContext({
			attributes,
			namedFilters,
			advancedMode: isAdvancedMode,
			add(group, target) {
				toggleAddDropdownMenu(group, target);
			},
			remove(item) {
				if (item.parent) {
					item.parent.items.splice(item.parent.items.indexOf(item), 1);
					trackPendingUpdate(emitNewData());
				}
				if (!isAdvancedMode.value && item instanceof FilterBuilderCondition) {
					item.attribute.filterVisibleInPanel = false;
					item.attribute.filterPositionInPanel = -1;
				}
			},
			updateGroup(group, logicalOperator) {
				group.logicalOperator = logicalOperator;
				trackPendingUpdate(emitNewData());
			},
			updateCondition(condition, attribute, operator, value1, value2) {
				condition.attribute = attribute;
				if (condition.attribute instanceof ViewModelEntityViewParameter) {
					condition.operator = operator;
					condition.value1 = value1;
					condition.value2 = value2;
				} else {
					const property = condition.attribute;
					condition.operator = normalizeConditionOperator(property, property.getFilterOperatorOrDefault(operator), value1);
					if (!isAdvancedMode.value) property.filterDefaultOperator = condition.operator;
					const [newValue1, newValue2] = normalizeConditionValues(property, condition.operator, value1, value2);
					condition.value1 = newValue1;
					condition.value2 = newValue2;
				}
				trackPendingUpdate(emitNewData());
			},
			toggleModal(value) {
				emit("toggleModal", value);
			}
		});
		let emitNewDataSequence = 0;
		const pendingUpdateCount = ref(0);
		const isPendingUpdate = computed(() => pendingUpdateCount.value > 0);
		async function emitNewData() {
			const sequence = ++emitNewDataSequence;
			pendingUpdateCount.value++;
			try {
				isAdvancedMode.value ||= rootGroup.value.complex;
				let newFilter;
				try {
					newFilter = await rootGroup.value.toFilter();
				} catch {
					return;
				}
				if (sequence !== emitNewDataSequence) return;
				updateWorkingFilter(newFilter.clone());
				const quickSearchFilter = modelValue.value.find("isMatch");
				if (quickSearchFilter) newFilter.add(quickSearchFilter);
				lastEmittedFilter = newFilter;
				modelValue.value = newFilter;
				emit("update:parameters", {
					...props.parameters,
					...rootGroup.value.getParameterValues()
				});
			} finally {
				pendingUpdateCount.value--;
			}
		}
		let pendingUpdate;
		function trackPendingUpdate(promise) {
			pendingUpdate = promise;
		}
		async function waitForPendingUpdate() {
			let awaited;
			while (pendingUpdate && pendingUpdate !== awaited) {
				awaited = pendingUpdate;
				await awaited;
			}
		}
		function handleAddButtonClick() {
			toggleAddDropdownMenu(rootGroup.value, addButton.value.$el);
		}
		const workingFilter = ref(new Filter());
		let workingFilterRequestSequence = 0;
		function updateWorkingFilter(filter) {
			workingFilterRequestSequence++;
			workingFilter.value = filter;
		}
		async function refreshWorkingFilterFromRootGroup(group) {
			const requestSequence = ++workingFilterRequestSequence;
			const filter = await group.toFilter();
			if (requestSequence !== workingFilterRequestSequence) return;
			workingFilter.value = filter;
		}
		watch(rootGroup, refreshWorkingFilterFromRootGroup, { immediate: true });
		const propertiesWithRules = computed(() => attributes.value.filter((a) => a instanceof ViewModelPropertyBase && a.filterValidationRules.count > 0));
		function collectParameterConditions(item) {
			if (item instanceof FilterBuilderGroup) return item.items.flatMap(collectParameterConditions);
			return item instanceof FilterBuilderCondition && item.attribute instanceof ViewModelEntityViewParameter ? [item] : [];
		}
		const parameterViolations = computed(() => {
			const violations = [];
			for (const condition of collectParameterConditions(rootGroup.value)) {
				const parameter = condition.attribute;
				if (parameter.filterValidationRules.count === 0) continue;
				const value1 = getParameterValueFromFilterValue(parameter, condition.value1, "start");
				const value2 = parameter.filterValue2Parameter ? getParameterValueFromFilterValue(parameter.filterValue2Parameter, condition.value2, "end") : void 0;
				const rowCondition = new FilterCondition(parameter.camelCaseName, condition.operator, value1, value2);
				const message = evaluateFilterValidationRules(parameter.filterValidationRules.getRules("simple"), rowCondition, workingFilter.value);
				if (message) violations.push({
					caption: parameter.filterCaption,
					text: message.text,
					severity: message.severityLevel
				});
			}
			return violations;
		});
		const violationRecapLines = computed(() => {
			const propertyViolations = collectPropertyViolations(propertiesWithRules.value, workingFilter.value);
			return groupFilterViolations([...propertyViolations, ...parameterViolations.value], (captions, text) => translate("FilterValidationLine", captions, text)).map((line) => ({
				text: line.text,
				severity: convertValidationMessageSeverity(line.severity)
			}));
		});
		__expose({
			addDropdownMenu,
			addDropdownMenuItems,
			rootGroup,
			waitForPendingUpdate,
			workingFilter
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				class: "filter-builder",
				"data-filter": filterText.value,
				"data-advanced-mode": isAdvancedMode.value,
				"data-pending": isPendingUpdate.value
			}, {
				default: withCtx(() => [
					createVNode(unref(VerticalLayout$1), {
						align: "left",
						class: "neos-fill-parent-height"
					}, {
						default: withCtx(() => [canAdd.value ? (openBlock(), createBlock(unref(Button$1), {
							key: 0,
							ref_key: "addButton",
							ref: addButton,
							icon: "add",
							label: unref(translate)("FilterBuilder_AddFilterConditionOn"),
							size: "small",
							class: "filter-builder-add-button",
							onClick: handleAddButtonClick
						}, null, 8, ["label"])) : createCommentVNode("", true), noFilter.value ? (openBlock(), createBlock(unref(Text$2), {
							key: 1,
							class: "filter-builder-no-filter"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("NoFilter")), 1)]),
							_: 1
						})) : (openBlock(), createBlock(FilterBuilderGroupEntry_default, {
							key: 2,
							group: rootGroup.value,
							"read-only": __props.readOnly
						}, null, 8, ["group", "read-only"]))]),
						_: 1
					}),
					createVNode(unref(DropdownMenu), {
						ref_key: "addDropdownMenu",
						ref: addDropdownMenu,
						items: unref(addDropdownMenuItems),
						size: "small"
					}, null, 8, ["items"]),
					displayAdvancedModeCheckbox.value || _ctx.$slots.default ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Divider$1), { class: "filter-builder-divider" }), createVNode(unref(HorizontalLayout$1), {
						align: "space-between",
						class: "filter-builder-footer"
					}, {
						default: withCtx(() => [displayAdvancedModeCheckbox.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
							key: 0,
							"vertical-align": "center",
							space: "extrasmall",
							title: advancedModeTooltip.value
						}, {
							default: withCtx(() => [withDirectives(createElementVNode("input", {
								id: "filter-builder-advanced-mode-checkbox",
								"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isAdvancedMode.value = $event),
								type: "checkbox",
								disabled: advancedModeLocked.value
							}, null, 8, _hoisted_1$16), [[vModelCheckbox, isAdvancedMode.value]]), createElementVNode("label", _hoisted_2$10, toDisplayString(unref(translate)("AdvancedMode")), 1)]),
							_: 1
						}, 8, ["title"])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
						_: 3
					})], 64)) : createCommentVNode("", true),
					violationRecapLines.value.length > 0 ? (openBlock(), createBlock(unref(VerticalLayout$1), {
						key: 1,
						class: "filter-builder-violation-recap"
					}, {
						default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(violationRecapLines.value, (line, index) => {
							return openBlock(), createBlock(unref(InputMessage), {
								key: index,
								text: line.text,
								severity: line.severity,
								"max-lines": 0,
								"show-icon": "",
								class: "filter-builder-violation-recap-message"
							}, null, 8, ["text", "severity"]);
						}), 128))]),
						_: 1
					})) : createCommentVNode("", true)
				]),
				_: 3
			}, 8, [
				"data-filter",
				"data-advanced-mode",
				"data-pending"
			]);
		};
	}
}), [["__scopeId", "data-v-8263e2be"]]);
//#endregion
//#region src/components/FilterChipToggleButton/FilterChipToggleButton.vue
var FilterChipToggleButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterChipToggleButton",
	props: {
		active: { type: Boolean },
		size: {}
	},
	emits: ["toggleActive"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isTogglePreviewActive = ref(false);
		const toggleIcon = computed(() => props.active ? "validate" : "pause");
		const previewToggleIcon = computed(() => props.active ? "pause" : "validate");
		const displayedToggleIcon = computed(() => isTogglePreviewActive.value ? previewToggleIcon.value : toggleIcon.value);
		watch(() => props.active, () => {
			isTogglePreviewActive.value = false;
		});
		function handleClick() {
			isTogglePreviewActive.value = false;
			emit("toggleActive");
		}
		function handleMouseenter() {
			isTogglePreviewActive.value = true;
		}
		function handleMouseleave() {
			isTogglePreviewActive.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("button", {
				tabindex: "-1",
				class: "filter-chip-toggle-button",
				onClick: withModifiers(handleClick, ["stop"]),
				onMouseenter: handleMouseenter,
				onMouseleave: handleMouseleave
			}, [createVNode(Transition, {
				name: "filter-chip-toggle-icon",
				mode: "out-in"
			}, {
				default: withCtx(() => [(openBlock(), createBlock(unref(Image$2), {
					key: displayedToggleIcon.value,
					name: displayedToggleIcon.value,
					size: __props.size,
					class: "filter-chip-toggle-icon"
				}, null, 8, ["name", "size"]))]),
				_: 1
			})], 32);
		};
	}
}), [["__scopeId", "data-v-ec16531a"]]);
//#endregion
//#region src/components/EditableFilterNamedFilterChip/EditableFilterNamedFilterChip.vue
var EditableFilterNamedFilterChip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "EditableFilterNamedFilterChip",
	props: /*@__PURE__*/ mergeModels({
		definition: {},
		filter: {},
		size: {}
	}, {
		"modelValue": { required: true },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const popoverElement = useTemplateRef("popover");
		const moreDropdownMenuElement = useTemplateRef("moreDropdownMenu");
		const { translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		const commitQueue = useFilterCommitQueue();
		const filterBuilderFilter = computed(() => {
			const clonedFilter = props.filter.clone();
			delete clonedFilter.namedFilterId;
			return clonedFilter;
		});
		const { chipSize, chipSecondaryIconSize } = useEditableFilterChipSizes(props);
		const canToggle = computed(() => !props.filter.readOnly);
		const moreDropdownMenuItems = computed(() => {
			return [{
				label: translate("RemoveFilter"),
				icon: "remove",
				attributes: { "data-command": "REMOVE" },
				command() {
					removeNamedFilter();
					popoverElement.value.hide();
				}
			}];
		});
		function togglePopover(event) {
			popoverElement.value.toggle(event);
		}
		function toggleMoreDropdownMenu(event) {
			moreDropdownMenuElement.value.toggle(event);
		}
		function handleRemoveButtonClick() {
			removeNamedFilter();
		}
		function handleToggleActive() {
			commitQueue.enqueue(async () => {
				const newFilter = modelValue.value.clone();
				const targetFilter = newFilter.namedFilterId === props.definition.id ? newFilter : newFilter.children.find((filter) => filter.namedFilterId === props.definition.id);
				targetFilter.active = !targetFilter.active;
				modelValue.value = newFilter;
			});
			popoverElement.value?.hide();
		}
		function removeNamedFilter() {
			commitQueue.enqueue(async () => {
				const newFilter = modelValue.value.clone();
				newFilter.remove(props.filter);
				modelValue.value = newFilter;
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(Button$1), {
				size: __props.size,
				class: "named-filter-chip",
				"data-named-filter": __props.definition.id,
				"data-active": __props.filter.active,
				onClick: togglePopover
			}, {
				default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
					"vertical-align": "center",
					space: "extrasmall",
					wrap: false
				}, {
					default: withCtx(() => [
						canToggle.value ? (openBlock(), createBlock(FilterChipToggleButton_default, {
							key: 0,
							active: __props.filter.active,
							size: unref(chipSize),
							onToggleActive: handleToggleActive
						}, null, 8, ["active", "size"])) : (openBlock(), createBlock(unref(Image$2), {
							key: 1,
							name: "filter",
							size: unref(chipSize),
							class: "named-filter-chip-image"
						}, null, 8, ["size"])),
						createVNode(unref(Text$2), {
							"max-lines": 1,
							size: unref(chipSize),
							class: "named-filter-chip-name"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.definition.name), 1)]),
							_: 1
						}, 8, ["size"]),
						__props.filter.readOnly ? (openBlock(), createBlock(unref(Image$2), {
							key: 2,
							name: "lock",
							size: unref(chipSecondaryIconSize),
							class: "filter-chip-lock-icon"
						}, null, 8, ["size"])) : (openBlock(), createBlock(unref(Button$1), {
							key: 3,
							icon: "erase",
							size: unref(chipSecondaryIconSize),
							variant: "link",
							class: "filter-chip-remove-button",
							onClick: withModifiers(handleRemoveButtonClick, ["stop"])
						}, null, 8, ["size"]))
					]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"size",
				"data-named-filter",
				"data-active"
			]), createVNode(unref(Popover), {
				ref: "popover",
				class: "named-filter-chip-popover",
				"data-named-filter": __props.definition.id
			}, {
				default: withCtx(() => [createVNode(unref(VerticalLayout$1), { space: "medium" }, {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
						"vertical-align": "center",
						align: "space-between",
						space: "extrasmall"
					}, {
						default: withCtx(() => [createVNode(unref(Text$2), { weight: "strong" }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.definition.name), 1)]),
							_: 1
						}), !__props.filter.readOnly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Button$1), {
							icon: "dotsHorizontal",
							animated: "",
							variant: "ghost",
							size: "extrasmall",
							class: "editable-filter-chip-more-button",
							onClick: toggleMoreDropdownMenu
						}), createVNode(unref(DropdownMenu), {
							ref: "moreDropdownMenu",
							items: moreDropdownMenuItems.value,
							size: "small"
						}, null, 8, ["items"])], 64)) : createCommentVNode("", true)]),
						_: 1
					}), createVNode(FilterBuilder_default, {
						"model-value": filterBuilderFilter.value,
						"view-model": unref(viewModel),
						"read-only": true
					}, null, 8, ["model-value", "view-model"])]),
					_: 1
				})]),
				_: 1
			}, 8, ["data-named-filter"])], 64);
		};
	}
}), [["__scopeId", "data-v-ee048a37"]]);
//#endregion
//#region src/components/FilterChipContent/FilterChipContent.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$15 = {
	key: 5,
	class: "filter-chip-required-indicator"
};
//#endregion
//#region src/components/FilterChipContent/FilterChipContent.vue
var FilterChipContent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterChipContent",
	props: {
		attribute: {},
		operator: {},
		value: {},
		hasValue: { type: Boolean },
		active: { type: Boolean },
		readOnly: { type: Boolean },
		customText: {},
		validationMessage: {},
		showToggle: { type: Boolean },
		showRequiredIndicator: { type: Boolean },
		size: {}
	},
	emits: ["remove", "toggleActive"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const { chipSize, chipSecondaryIconSize } = useEditableFilterChipSizes(props);
		const chipIcon = computed(() => props.attribute.filterIcon ?? getFilterDataTypeIcon(props.attribute));
		const showToggle = computed(() => props.showToggle && props.hasValue);
		const effectiveOperator = computed(() => props.operator ? getEffectiveBetweenOperator(props.operator, props.value) : void 0);
		const operatorIcon = computed(() => props.hasValue && isExplicitOperator(effectiveOperator.value) ? allOperators[effectiveOperator.value].image : void 0);
		const operatorText = computed(() => props.hasValue && !isExplicitOperator(effectiveOperator.value) ? allOperators[effectiveOperator.value].lowerCaseCaption : void 0);
		const tooltip = computed(() => {
			let text = props.customText ?? props.attribute.filterCaption;
			if (!props.customText && !loading.value) {
				const operator = effectiveOperator.value ? allOperators[effectiveOperator.value] : void 0;
				if (operator) text += ` ${operator.lowerCaseCaption}`;
				if (displayValue.value) text += ` ${displayValue.value.long}`;
			}
			if (props.validationMessage) text += ` — ${props.validationMessage.text}`;
			return text;
		});
		const requiredIndicator = computed(() => props.showRequiredIndicator && props.attribute.filterRequired);
		function isExplicitOperator(operator) {
			switch (operator) {
				case FilterOperator.equal:
				case FilterOperator.notEqual:
				case FilterOperator.greater:
				case FilterOperator.greaterOrEqual:
				case FilterOperator.less:
				case FilterOperator.lessOrEqual: return true;
				default: return false;
			}
		}
		function getEffectiveBetweenOperator(operator, value) {
			if (operator !== FilterOperator.between || !Array.isArray(value)) return operator;
			const flat = value.flat();
			const hasStart = flat[0] != null && flat[0] !== "";
			const hasEnd = flat[1] != null && flat[1] !== "";
			if (hasStart && !hasEnd) return FilterOperator.greaterOrEqual;
			if (!hasStart && hasEnd) return FilterOperator.lessOrEqual;
			return FilterOperator.between;
		}
		const displayValue = shallowRef();
		const loading = ref(false);
		watch([
			() => props.attribute,
			() => props.operator,
			() => props.value
		], ([attribute, operator, value]) => setDisplayValue(attribute, operator, value), { immediate: true });
		async function setDisplayValue(attribute, operator, value) {
			if (operator === void 0 || value == null) {
				displayValue.value = void 0;
				return;
			}
			const values = Array.isArray(value) ? value.flat() : [value];
			const effectiveOp = getEffectiveBetweenOperator(operator, value);
			let formattedValues;
			if (isLookupPropertyWithDisplayProperty(attribute) && isFilterOperatorOnLookupValueProperty(operator)) {
				displayValue.value = void 0;
				try {
					loading.value = true;
					formattedValues = await getLookupDisplayPropertyValues(attribute, values);
				} finally {
					loading.value = false;
				}
			} else formattedValues = formatValues(values, attribute.getFilterFormatOptions(), attribute.owner);
			if (effectiveOp !== FilterOperator.between) formattedValues = formattedValues.filter((v) => v !== "");
			const long = getFormattedValues(effectiveOp, formattedValues);
			displayValue.value = {
				long,
				short: formattedValues.length > 2 ? `${formattedValues[0]}, ${formattedValues[1]} + ${formattedValues.length - 2}` : long
			};
		}
		function getFormattedValues(operator, values) {
			if (operator === FilterOperator.between) return values.join(` ${translate("And_LowerCase")} `);
			if (isArrayFilterOperator(operator)) return values.length > 1 ? `${values.slice(0, -1).join(", ")} ${translate("Or_LowerCase")} ${values[values.length - 1]}` : values[0];
			return values.join(", ");
		}
		function handleRemoveButtonClick() {
			emit("remove");
		}
		function handleToggleActive() {
			emit("toggleActive");
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(HorizontalLayout$1), {
				"vertical-align": "center",
				space: "extrasmall",
				wrap: false,
				title: tooltip.value
			}, {
				default: withCtx(() => [
					showToggle.value ? (openBlock(), createBlock(FilterChipToggleButton_default, {
						key: 0,
						active: __props.active,
						size: unref(chipSize),
						onToggleActive: handleToggleActive
					}, null, 8, ["active", "size"])) : (openBlock(), createBlock(unref(Image$2), {
						key: 1,
						name: chipIcon.value,
						size: unref(chipSize),
						class: "filter-chip-data-type-image"
					}, null, 8, ["name", "size"])),
					__props.customText ? (openBlock(), createBlock(unref(Text$2), {
						key: 2,
						class: "filter-chip-custom-text",
						"max-lines": 1,
						size: unref(chipSize)
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(__props.customText), 1)]),
						_: 1
					}, 8, ["size"])) : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
						createVNode(unref(Text$2), {
							class: "filter-chip-attribute",
							size: unref(chipSize)
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.attribute.filterCaption), 1)]),
							_: 1
						}, 8, ["size"]),
						operatorText.value ? (openBlock(), createBlock(unref(Text$2), {
							key: 0,
							class: "filter-chip-operator-text",
							size: unref(chipSize),
							"data-operator": __props.operator
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(operatorText.value), 1)]),
							_: 1
						}, 8, ["size", "data-operator"])) : operatorIcon.value ? (openBlock(), createBlock(unref(Image$2), {
							key: 1,
							name: operatorIcon.value,
							size: unref(chipSize),
							class: "filter-chip-operator-image",
							"data-operator": __props.operator
						}, null, 8, [
							"name",
							"size",
							"data-operator"
						])) : createCommentVNode("", true),
						displayValue.value ? (openBlock(), createBlock(unref(Text$2), {
							key: 2,
							class: "filter-chip-value",
							size: unref(chipSize),
							"max-lines": 1
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(displayValue.value.short), 1)]),
							_: 1
						}, 8, ["size"])) : createCommentVNode("", true)
					], 64)),
					loading.value ? (openBlock(), createBlock(unref(Spinner$1), {
						key: 4,
						class: "filter-chip-spinner"
					})) : createCommentVNode("", true),
					requiredIndicator.value ? (openBlock(), createElementBlock("span", _hoisted_1$15, "*")) : createCommentVNode("", true),
					__props.hasValue ? (openBlock(), createElementBlock(Fragment, { key: 6 }, [__props.readOnly ? (openBlock(), createBlock(unref(Image$2), {
						key: 0,
						name: "lock",
						size: unref(chipSecondaryIconSize),
						class: "filter-chip-lock-icon"
					}, null, 8, ["size"])) : (openBlock(), createBlock(unref(Button$1), {
						key: 1,
						icon: "erase",
						size: unref(chipSecondaryIconSize),
						variant: "link",
						class: "filter-chip-remove-button",
						tabindex: "-1",
						onClick: withModifiers(handleRemoveButtonClick, ["stop"])
					}, null, 8, ["size"]))], 64)) : createCommentVNode("", true)
				]),
				_: 1
			}, 8, ["title"]);
		};
	}
}), [["__scopeId", "data-v-0ce4ff45"]]);
//#endregion
//#region src/components/EditableFilterChip/EditableFilterChip.vue
var EditableFilterChip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "EditableFilterChip",
	props: {
		attribute: {},
		operator: {},
		value: {},
		hasValue: { type: Boolean },
		active: { type: Boolean },
		readOnly: { type: Boolean },
		customText: {},
		validationMessage: {},
		size: {}
	},
	emits: [
		"togglePopover",
		"clear",
		"apply",
		"toggleActive"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const popoverElement = useTemplateRef("popover");
		const moreDropdownMenuElement = useTemplateRef("moreDropdownMenu");
		const { translate } = useGlobalResourceManager();
		const { preventPopoverHide, setPreventPopoverHide } = usePreventPopoverHide();
		function handleUpdateFilterComponent(filterComponent) {
			props.attribute.userFilterComponent = filterComponent;
		}
		const showToggle = computed(() => props.hasValue && !props.readOnly && !props.attribute.filterRequired);
		const validationSeverity = computed(() => {
			if (!props.validationMessage) return;
			return convertValidationMessageSeverity(props.validationMessage.severityLevel);
		});
		const chipValidationSeverity = computed(() => {
			if (props.attribute.filterRequirementUnfulfilled) return;
			return validationSeverity.value === "information" ? void 0 : validationSeverity.value;
		});
		const moreDropdownMenuItems = computed(() => {
			const items = [];
			if (isDateDataType(props.attribute.getFilterDataType())) {
				const getIcon = (filterComponent) => props.attribute.userFilterComponent == filterComponent ? "validate" : "empty";
				items.push({
					label: translate("FilterDateDisplayMode"),
					attributes: { "data-command": "DISPLAY_MODE" },
					icon: "calendar",
					items: [
						{
							label: translate("Default"),
							icon: getIcon(FilterComponent.default),
							attributes: { "data-display-mode": "DEFAULT" },
							command() {
								handleUpdateFilterComponent(FilterComponent.default);
							}
						},
						{
							label: translate("Day"),
							icon: getIcon(FilterComponent.calendarDay),
							attributes: { "data-display-mode": "DAY" },
							command() {
								handleUpdateFilterComponent(FilterComponent.calendarDay);
							}
						},
						{
							label: translate("Month"),
							icon: getIcon(FilterComponent.calendarMonth),
							attributes: { "data-display-mode": "MONTH" },
							command() {
								handleUpdateFilterComponent(FilterComponent.calendarMonth);
							}
						},
						{
							label: translate("Year"),
							icon: getIcon(FilterComponent.calendarYear),
							attributes: { "data-display-mode": "YEAR" },
							command() {
								handleUpdateFilterComponent(FilterComponent.calendarYear);
							}
						},
						{
							label: translate("Advanced"),
							icon: getIcon(FilterComponent.advanced),
							attributes: { "data-display-mode": "ADVANCED" },
							command() {
								handleUpdateFilterComponent(FilterComponent.advanced);
							}
						}
					]
				});
			}
			if (props.hasValue) items.push({
				label: translate("ResetFilter"),
				icon: "erase",
				attributes: { "data-command": "RESET" },
				command() {
					emit("clear", false);
					popoverElement.value.hide();
				}
			});
			items.push({
				label: translate("RemoveFilter"),
				icon: "remove",
				attributes: { "data-command": "REMOVE" },
				command() {
					emit("clear", true);
					popoverElement.value.hide();
				}
			});
			return items;
		});
		function togglePopover(event) {
			emit("togglePopover");
			popoverElement.value.toggle(event, { hideOthers: true });
		}
		function toggleMoreDropdownMenu(event) {
			moreDropdownMenuElement.value.toggle(event);
		}
		function handleEnterKeydown(event) {
			if (isDropdownActive()) return;
			if (event.target instanceof HTMLButtonElement) return;
			if (!props.readOnly) {
				triggerChangeOnActiveInput();
				emit("apply");
			}
			popoverElement.value.hide();
		}
		function handleApplyButtonClick() {
			triggerChangeOnActiveInput();
			emit("apply");
			popoverElement.value.hide();
		}
		function handleChipRemove() {
			emit("clear", false);
			popoverElement.value.hide();
		}
		function handleToggleActive() {
			emit("toggleActive");
			popoverElement.value?.hide();
		}
		__expose({
			setPreventPopoverHide,
			popoverElement
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(Button$1), {
				size: __props.size,
				class: "editable-filter-chip",
				"data-attribute": __props.attribute.name,
				"data-active": __props.hasValue ? __props.active : void 0,
				"data-required": __props.attribute.filterRequirementUnfulfilled,
				"data-validation-severity": chipValidationSeverity.value,
				onClick: togglePopover
			}, {
				default: withCtx(() => [createVNode(FilterChipContent_default, {
					attribute: __props.attribute,
					operator: __props.operator,
					value: __props.value,
					"has-value": __props.hasValue,
					active: __props.active,
					"read-only": __props.readOnly,
					"show-toggle": showToggle.value,
					"show-required-indicator": true,
					"custom-text": __props.customText,
					"validation-message": __props.validationMessage,
					size: __props.size,
					onRemove: handleChipRemove,
					onToggleActive: handleToggleActive
				}, null, 8, [
					"attribute",
					"operator",
					"value",
					"has-value",
					"active",
					"read-only",
					"show-toggle",
					"custom-text",
					"validation-message",
					"size"
				])]),
				_: 1
			}, 8, [
				"size",
				"data-attribute",
				"data-active",
				"data-required",
				"data-validation-severity"
			]), createVNode(unref(Popover), {
				ref: "popover",
				class: "editable-filter-chip-popover",
				"prevent-hide": unref(preventPopoverHide),
				"data-attribute": __props.attribute.name,
				onKeydown: withKeys(handleEnterKeydown, ["enter"])
			}, {
				default: withCtx(() => [createVNode(unref(VerticalLayout$1), { space: "medium" }, {
					default: withCtx(() => [
						createVNode(unref(HorizontalLayout$1), {
							"vertical-align": "center",
							align: "space-between",
							space: "extrasmall"
						}, {
							default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
								"vertical-align": "center",
								space: "extrasmall"
							}, {
								default: withCtx(() => [createVNode(unref(Text$2), { weight: "strong" }, {
									default: withCtx(() => [createTextVNode(toDisplayString(__props.attribute.filterCaption), 1)]),
									_: 1
								}), renderSlot(_ctx.$slots, "operator", {}, void 0, true)]),
								_: 3
							}), !__props.readOnly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Button$1), {
								icon: "dotsHorizontal",
								animated: "",
								variant: "ghost",
								size: "extrasmall",
								class: "editable-filter-chip-more-button",
								onClick: toggleMoreDropdownMenu
							}), createVNode(unref(DropdownMenu), {
								ref: "moreDropdownMenu",
								items: moreDropdownMenuItems.value,
								size: "small"
							}, null, 8, ["items"])], 64)) : createCommentVNode("", true)]),
							_: 3
						}),
						renderSlot(_ctx.$slots, "component", { setPreventPopoverHide: unref(setPreventPopoverHide) }, void 0, true),
						!__props.readOnly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Divider$1), { class: "popover-divider" }), createVNode(unref(HorizontalLayout$1), {
							align: "right",
							space: "extrasmall"
						}, {
							default: withCtx(() => [createVNode(unref(Button$1), {
								type: "submit",
								icon: "validate",
								label: unref(translate)("Apply"),
								animated: "",
								variant: "primary",
								size: "extrasmall",
								class: "editable-filter-chip-apply-button",
								onClick: handleApplyButtonClick
							}, null, 8, ["label"])]),
							_: 1
						})], 64)) : createCommentVNode("", true),
						__props.validationMessage ? (openBlock(), createBlock(unref(InputMessage), {
							key: 1,
							text: __props.validationMessage.text,
							severity: validationSeverity.value,
							"max-lines": 0,
							"show-icon": "",
							class: "editable-filter-chip-validation-message"
						}, null, 8, ["text", "severity"])) : createCommentVNode("", true)
					]),
					_: 3
				})]),
				_: 3
			}, 8, ["prevent-hide", "data-attribute"])], 64);
		};
	}
}), [["__scopeId", "data-v-9ffc4882"]]);
//#endregion
//#region src/components/EditableFilterParameterChip/EditableFilterParameterChip.vue
var EditableFilterParameterChip_default = /* @__PURE__ */ defineComponent({
	__name: "EditableFilterParameterChip",
	props: {
		parameter: {},
		size: {}
	},
	setup(__props) {
		const parameter = toRef(__props, "parameter");
		const viewModel = useViewModel();
		const operator = computed(() => getParameterOperator(parameter.value));
		const operatorMetadata = computed(() => allOperators[operator.value]);
		const useRangeValue = computed(() => parameter.value.filterValue2Parameter && operator.value === FilterOperator.between && isDateDataType(parameter.value.dataType));
		const currentValue = ref();
		const draftCondition = computed(() => {
			if (useRangeValue.value) {
				const [rawValue1, rawValue2] = Array.isArray(currentValue.value) ? currentValue.value : [currentValue.value, void 0];
				const value1 = getParameterValueFromFilterValue(parameter.value, rawValue1, "start");
				const value2 = getParameterValueFromFilterValue(parameter.value.filterValue2Parameter, rawValue2, "end");
				return new FilterCondition(parameter.value.camelCaseName, FilterOperator.between, value1, value2);
			}
			const value = getParameterValueFromFilterValue(parameter.value, currentValue.value);
			return new FilterCondition(parameter.value.camelCaseName, parameter.value.filterDefaultOperator, value);
		});
		const validationMessage = computed(() => {
			if (parameter.value.filterRequirementUnfulfilled) return;
			if (!parameter.value.active) return;
			return evaluateFilterValidationRules(parameter.value.filterValidationRules.getRules("simple"), draftCondition.value, viewModel.dataFilter);
		});
		const { editingComponent, editingComponentProps, showValue, required, messageText, messageSeverity } = useFilterAttribute(parameter, operator, true, validationMessage);
		const hasValue = computed(() => parameter.value.value != null || !!parameter.value.filterValue2Parameter && parameter.value.filterValue2Parameter.value != null);
		const active = computed(() => parameter.value.active && hasValue.value);
		const chipValue = computed(() => {
			if (useRangeValue.value) {
				const values = [parameter.value.value, parameter.value.filterValue2Parameter.value].filter((value) => value != null);
				return values.length > 0 ? values : void 0;
			}
			return parameter.value.value;
		});
		watch(() => [parameter.value.value, parameter.value.filterValue2Parameter?.value], () => {
			if (useRangeValue.value) currentValue.value = [getParameterFilterValue(parameter.value), getParameterFilterValue(parameter.value.filterValue2Parameter)];
			else currentValue.value = getParameterFilterValue(parameter.value);
		}, { immediate: true });
		async function handleClear(remove) {
			setActiveState(true);
			parameter.value.value = null;
			if (parameter.value.filterValue2Parameter) parameter.value.filterValue2Parameter.value = null;
			if (remove) parameter.value.filterVisible = false;
			await viewModel.checkAndLoadDataAsync();
		}
		async function handleToggleActive() {
			setActiveState(!parameter.value.active);
			await viewModel.checkAndLoadDataAsync();
		}
		async function handleApply() {
			setActiveState(true);
			if (useRangeValue.value) {
				const [value1, value2] = Array.isArray(currentValue.value) ? currentValue.value : [currentValue.value, void 0];
				const nextValue1 = getParameterValueFromFilterValue(parameter.value, value1, "start");
				const nextValue2 = getParameterValueFromFilterValue(parameter.value.filterValue2Parameter, value2, "end");
				parameter.value.value = nextValue1;
				parameter.value.filterValue2Parameter.value = nextValue2;
			} else parameter.value.value = getParameterValueFromFilterValue(parameter.value, currentValue.value);
			await viewModel.checkAndLoadDataAsync();
		}
		function setActiveState(active) {
			parameter.value.active = active;
			if (parameter.value.filterValue2Parameter) parameter.value.filterValue2Parameter.active = active;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(EditableFilterChip_default, {
				ref: "chip",
				attribute: parameter.value,
				operator: operator.value,
				value: chipValue.value,
				"has-value": hasValue.value,
				active: active.value,
				"validation-message": validationMessage.value,
				size: __props.size,
				onToggleActive: handleToggleActive,
				onApply: handleApply,
				onClear: handleClear
			}, {
				operator: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
					space: "extrasmall",
					class: "editable-filter-chip-operator",
					"vertical-align": "center",
					"data-operator": operator.value
				}, {
					default: withCtx(() => [createVNode(unref(Image$2), {
						name: operatorMetadata.value.image,
						size: "small"
					}, null, 8, ["name"]), createVNode(unref(Text$2), null, {
						default: withCtx(() => [createTextVNode(toDisplayString(operatorMetadata.value.caption.toLowerCase()), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["data-operator"])]),
				component: withCtx(({ setPreventPopoverHide }) => [unref(showValue) ? (openBlock(), createBlock(resolveDynamicComponent(unref(editingComponent)), mergeProps({
					key: 0,
					modelValue: currentValue.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentValue.value = $event),
					required: unref(required),
					"message-text": unref(messageText),
					"message-severity": unref(messageSeverity),
					"message-position": "hidden"
				}, unref(editingComponentProps), {
					class: "editable-filter-chip-component",
					focused: true,
					"data-value": "1",
					onToggleModal: setPreventPopoverHide
				}), null, 16, [
					"modelValue",
					"required",
					"message-text",
					"message-severity",
					"onToggleModal"
				])) : createCommentVNode("", true)]),
				_: 1
			}, 8, [
				"attribute",
				"operator",
				"value",
				"has-value",
				"active",
				"validation-message",
				"size"
			]);
		};
	}
});
//#endregion
//#region src/components/EditableFilterPropertyChip/EditableFilterPropertyChip.vue
var EditableFilterPropertyChip_default = /* @__PURE__ */ defineComponent({
	__name: "EditableFilterPropertyChip",
	props: /*@__PURE__*/ mergeModels({
		property: {},
		size: {}
	}, {
		"modelValue": { required: true },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const property = toRef(props, "property");
		const { translate } = useGlobalResourceManager();
		const commitQueue = useFilterCommitQueue();
		const currentOperator = ref(property.value.filterDefaultOperator);
		const currentValue1 = ref();
		const currentValue2 = ref();
		const conditionFilter = computed(() => modelValue.value.isSimple ? findCondition(modelValue.value) : void 0);
		const condition = computed(() => conditionFilter.value?.condition);
		const draftCondition = ref();
		const draftResolved = ref(false);
		let draftConditionRequestSequence = 0;
		watch([
			currentOperator,
			currentValue1,
			currentValue2
		], async ([operator, rawValue1, rawValue2]) => {
			const requestSequence = ++draftConditionRequestSequence;
			draftResolved.value = false;
			const [value1, value2] = normalizeConditionValues(property.value, operator, rawValue1, rawValue2);
			const newCondition = (await property.value.createFilterCondition(operator, value1, value2))?.condition ?? void 0;
			if (requestSequence !== draftConditionRequestSequence) return;
			draftCondition.value = newCondition;
			draftResolved.value = true;
		}, { immediate: true });
		const filterForValidation = computed(() => {
			if (conditionFilter.value != null && !conditionFilter.value.active) return modelValue.value;
			if (!draftResolved.value) return modelValue.value;
			const clone = modelValue.value.clone();
			removeCondition(clone);
			if (draftCondition.value) clone.add(new Filter(draftCondition.value));
			return clone;
		});
		const validationMessage = computed(() => {
			if (property.value.filterRequirementUnfulfilled) return;
			const emptyCondition = getConditionForValidation(property.value, new Filter());
			const isInactiveFilter = conditionFilter.value != null && !conditionFilter.value.active;
			let conditionForValidation;
			if (isInactiveFilter) conditionForValidation = emptyCondition;
			else if (draftResolved.value) conditionForValidation = draftCondition.value ?? emptyCondition;
			else conditionForValidation = getConditionForValidation(property.value, modelValue.value);
			return evaluateFilterValidationRules(property.value.filterValidationRules.getRules("simple"), conditionForValidation, filterForValidation.value);
		});
		const { operators, headerComponent, headerComponentProps, editingComponent, editingComponentProps, showValue, showValue2, required, messageText, messageSeverity } = useFilterAttribute(property, currentOperator, true, validationMessage);
		const active = computed(() => !!conditionFilter.value?.active);
		const readOnly = computed(() => !modelValue.value.isSimple || !!condition.value && condition.value.readOnly);
		const customText = computed(() => {
			if (condition.value?.customOperatorId) return props.property.findCustomFilterOperator(condition.value.customOperatorId)?.getText?.();
		});
		watch(condition, (newCondition) => {
			if (newCondition) {
				const { operator, value1, value2 } = property.value.extractOperatorAndValuesFromFilterCondition(newCondition);
				currentOperator.value = operator;
				if (isDateDataType(property.value.dataType) && operator === FilterOperator.between) currentValue1.value = [value1, value2];
				else {
					currentValue1.value = value1;
					currentValue2.value = value2;
				}
			} else {
				currentValue1.value = void 0;
				currentValue2.value = void 0;
			}
		}, {
			immediate: true,
			deep: true
		});
		function handleUpdateOperator(operator) {
			const [value1, value2] = normalizeConditionValues(property.value, operator, currentValue1.value, currentValue2.value);
			currentOperator.value = operator;
			currentValue1.value = value1;
			currentValue2.value = value2;
		}
		function handleUpdateValue1(value1) {
			currentOperator.value = normalizeConditionOperator(property.value, currentOperator.value, value1);
			currentValue1.value = value1;
		}
		function findCondition(filter) {
			if (filter.visible && filter.condition?.isEmpty === false && props.property.isFilterPath(filter.condition.propertyPath)) return filter;
			for (const childFilter of filter.children) {
				const foundFilter = findCondition(childFilter);
				if (foundFilter) return foundFilter;
			}
		}
		function removeCondition(filter) {
			if (filter.writable && filter.condition && props.property.isFilterPath(filter.condition.propertyPath)) {
				filter.clear();
				return true;
			}
			let removed = false;
			for (let index = filter.children.length - 1; index >= 0; index--) {
				const childFilter = filter.children[index];
				if (removeCondition(childFilter)) {
					removed = true;
					if (childFilter.isEmpty) filter.children.splice(index, 1);
				}
			}
			return removed;
		}
		function handleClear(remove) {
			commitQueue.enqueue(async () => {
				const filter = modelValue.value.clone();
				if (removeCondition(filter)) modelValue.value = filter;
			});
			if (remove) property.value.filterVisible = false;
		}
		function handleToggleActive() {
			commitQueue.enqueue(async () => {
				const filter = modelValue.value.clone();
				const activeFilter = findCondition(filter);
				activeFilter.active = !activeFilter.active;
				modelValue.value = filter;
			});
		}
		function handlePopoverToggle() {
			if (!condition.value || condition.value.filterOperator === FilterOperator.isNotNull || condition.value.filterOperator === FilterOperator.isNull) currentOperator.value = property.value.filterDefaultOperator;
		}
		function handleApply() {
			const [value1, value2] = normalizeConditionValues(property.value, currentOperator.value, currentValue1.value, currentValue2.value);
			const operator = currentOperator.value;
			commitQueue.enqueue(async () => {
				const wasInactive = conditionFilter.value?.active === false;
				const filter = modelValue.value.clone();
				const removed = removeCondition(filter);
				const newCondition = await property.value.createFilterCondition(operator, value1, value2);
				if (newCondition) {
					filter.add(newCondition);
					if (wasInactive) {
						const activeFilter = findCondition(filter);
						activeFilter.active = true;
					}
				}
				if ((removed || newCondition) && !modelValue.value.equals(filter)) modelValue.value = filter;
			}, property.value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(EditableFilterChip_default, {
				ref: "chip",
				attribute: property.value,
				operator: condition.value?.filterOperator,
				value: condition.value?.values,
				"has-value": !!condition.value,
				active: active.value,
				"read-only": readOnly.value,
				"custom-text": customText.value,
				"validation-message": validationMessage.value,
				size: __props.size,
				onTogglePopover: handlePopoverToggle,
				onToggleActive: handleToggleActive,
				onApply: handleApply,
				onClear: handleClear
			}, {
				operator: withCtx(() => [createVNode(unref(Combobox), {
					"model-value": currentOperator.value,
					values: unref(operators),
					"value-property": "value",
					"display-property": "lowerCaseCaption",
					readonly: readOnly.value,
					required: "",
					class: "editable-filter-chip-operator-combobox",
					"onUpdate:modelValue": handleUpdateOperator
				}, {
					option: withCtx(({ option }) => [createVNode(unref(HorizontalLayout$1), {
						space: "small",
						class: "editable-filter-chip-operator-combobox-option",
						"vertical-align": "center",
						"data-operator": option.value
					}, {
						default: withCtx(() => [createVNode(unref(Image$2), {
							name: option.image,
							size: "small"
						}, null, 8, ["name"]), createVNode(unref(Text$2), null, {
							default: withCtx(() => [createTextVNode(toDisplayString(option.lowerCaseCaption), 1)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, ["data-operator"])]),
					_: 1
				}, 8, [
					"model-value",
					"values",
					"readonly"
				]), !readOnly.value ? (openBlock(), createBlock(resolveDynamicComponent(unref(headerComponent)), normalizeProps(mergeProps({ key: 0 }, unref(headerComponentProps))), null, 16)) : createCommentVNode("", true)]),
				component: withCtx(({ setPreventPopoverHide }) => [unref(showValue) ? (openBlock(), createBlock(resolveDynamicComponent(unref(editingComponent)), mergeProps({
					key: 0,
					"model-value": currentValue1.value,
					readonly: readOnly.value,
					required: unref(required),
					"message-text": unref(messageText),
					"message-severity": unref(messageSeverity),
					"message-position": "hidden"
				}, unref(editingComponentProps), {
					class: "editable-filter-chip-component",
					focused: true,
					"data-value": "1",
					"onUpdate:modelValue": handleUpdateValue1,
					onToggleModal: setPreventPopoverHide
				}), null, 16, [
					"model-value",
					"readonly",
					"required",
					"message-text",
					"message-severity",
					"onToggleModal"
				])) : createCommentVNode("", true), unref(showValue2) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(unref(Text$2), null, {
					default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("And_LowerCase")), 1)]),
					_: 1
				}), (openBlock(), createBlock(resolveDynamicComponent(unref(editingComponent)), mergeProps({
					modelValue: currentValue2.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => currentValue2.value = $event),
					readonly: readOnly.value,
					required: unref(required),
					"message-text": unref(messageText),
					"message-severity": unref(messageSeverity),
					"message-position": "hidden"
				}, unref(editingComponentProps), {
					class: "editable-filter-chip-component",
					"data-value": "2"
				}), null, 16, [
					"modelValue",
					"readonly",
					"required",
					"message-text",
					"message-severity"
				]))], 64)) : createCommentVNode("", true)]),
				_: 1
			}, 8, [
				"attribute",
				"operator",
				"value",
				"has-value",
				"active",
				"read-only",
				"custom-text",
				"validation-message",
				"size"
			]);
		};
	}
});
//#endregion
//#region src/components/FilterBuilderPopover/FilterBuilderPopover.vue
var FilterBuilderPopover_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterBuilderPopover",
	props: { advancedMode: { type: [Boolean, String] } },
	setup(__props, { expose: __expose }) {
		const { translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		const filter = ref();
		const parameters = ref();
		const popover = ref();
		const filterBuilder = ref();
		const { preventPopoverHide, setPreventPopoverHide } = usePreventPopoverHide();
		async function handleApplyButtonClick() {
			triggerChangeOnActiveInput();
			await filterBuilder.value.waitForPendingUpdate();
			const areParameterChanged = !isEquivalentValues(getFilterableParameterValues(), parameters.value);
			if (areParameterChanged) viewModel.entityViewParameters.setValues(parameters.value);
			const isFilterChanged = !viewModel.dataFilter.equals(filter.value);
			if (isFilterChanged) await viewModel.filterDataAsync(filter.value);
			if ((!isFilterChanged || viewModel.clientSideFilter) && areParameterChanged) await viewModel.checkAndLoadDataAsync();
			popover.value.hide();
		}
		function getFilterableParameterValues() {
			return viewModel.entityViewParameters.getValues((parameter) => parameter.filterable);
		}
		__expose({
			toggle(event) {
				filter.value = viewModel.dataFilter.clone();
				parameters.value = getFilterableParameterValues();
				popover.value.toggle(event);
			},
			hide() {
				popover.value.hide();
			},
			async flushPendingInput() {
				triggerChangeOnActiveInput();
				await filterBuilder.value.waitForPendingUpdate();
				return {
					filter: filter.value,
					parameters: parameters.value
				};
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Popover), {
				ref_key: "popover",
				ref: popover,
				class: "filter-builder-popover",
				"prevent-hide": unref(preventPopoverHide)
			}, {
				default: withCtx(() => [createVNode(FilterBuilder_default, {
					ref_key: "filterBuilder",
					ref: filterBuilder,
					modelValue: filter.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => filter.value = $event),
					parameters: parameters.value,
					"onUpdate:parameters": _cache[1] || (_cache[1] = ($event) => parameters.value = $event),
					"advanced-mode": __props.advancedMode,
					onToggleModal: unref(setPreventPopoverHide)
				}, {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
						align: "right",
						"vertical-align": "center",
						space: "extrasmall",
						class: "neos-fill-parent-width"
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "default", { filter: filter.value }, void 0, true), createVNode(unref(Button$1), {
							icon: "validate",
							label: unref(translate)("Apply"),
							animated: "",
							variant: "primary",
							size: "small",
							class: "filter-builder-apply-button",
							onClick: handleApplyButtonClick
						}, null, 8, ["label"])]),
						_: 3
					})]),
					_: 3
				}, 8, [
					"modelValue",
					"parameters",
					"advanced-mode",
					"onToggleModal"
				])]),
				_: 3
			}, 8, ["prevent-hide"]);
		};
	}
}), [["__scopeId", "data-v-ad9b135e"]]);
//#endregion
//#region src/components/ServerFilterChips/ServerFilterChips.vue
var ServerFilterChips_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ServerFilterChips",
	props: {
		chips: {},
		size: {}
	},
	setup(__props) {
		const props = __props;
		const computedChips = computed(() => {
			if (Array.isArray(props.chips)) return props.chips;
			return props.chips ? [props.chips] : [];
		});
		const { chipSize, chipSecondaryIconSize } = useEditableFilterChipSizes(props);
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(computedChips.value, (chip) => {
				return openBlock(), createBlock(unref(Chip$1), {
					key: chip,
					class: normalizeClass(["server-filter-chip", `server-filter-chip-${__props.size}`])
				}, {
					default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
						"vertical-align": "center",
						space: "extrasmall"
					}, {
						default: withCtx(() => [createVNode(unref(Text$2), { size: unref(chipSize) }, {
							default: withCtx(() => [createTextVNode(toDisplayString(chip), 1)]),
							_: 2
						}, 1032, ["size"]), createVNode(unref(Image$2), {
							name: "lock",
							size: unref(chipSecondaryIconSize)
						}, null, 8, ["size"])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, ["class"]);
			}), 128);
		};
	}
}), [["__scopeId", "data-v-7a9fee76"]]);
//#endregion
//#region src/components/EditableFilterChips/EditableFilterChips.vue
var EditableFilterChips_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "EditableFilterChips",
	props: {
		serverFilterChips: { default: void 0 },
		advancedMode: {
			type: Boolean,
			default: true
		},
		size: { default: "extrasmall" }
	},
	setup(__props) {
		const props = __props;
		const root = ref();
		const attrs = useAttrs();
		useComponentAutomationProperties(root, "FilterBar");
		const { globalResourceManager, translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		const commitQueue = provideFilterCommitQueue();
		const { chipSize: actionChipIconSize } = useEditableFilterChipSizes(props);
		const filterBarId = computed(() => {
			const value = attrs.id;
			return typeof value === "string" && value.length > 0 ? value : void 0;
		});
		function matchesFilterBar(attributeFilterBarId) {
			return (typeof attributeFilterBarId === "string" && attributeFilterBarId.length === 0 ? void 0 : attributeFilterBarId) === filterBarId.value;
		}
		const filterableAttributes = computed(() => viewModel.getFilterableAttributes().filter((p) => matchesFilterBar(p.filterBarId)).sort((p1, p2) => p1.filterCaption.localeCompare(p2.filterCaption)));
		const displayFilterBar = computed(() => filterableAttributes.value.length > 0 || viewModel.namedFilters.length > 0 || !!props.serverFilterChips);
		const filter = computed({
			get: () => viewModel.dataFilter,
			set: (filter) => viewModel.filterDataAsync(filter)
		});
		const advancedModeDisabled = computed(() => !filter.value.isSimple);
		const isAdvancedMode = ref(advancedModeDisabled.value);
		const advancedFilterButtonVariant = computed(() => filter.value.isEmpty ? "default" : "primary");
		const advancedFilterViolations = computed(() => [...collectPropertyViolations(viewModel.properties.filter((p) => p.filterable && p.filterValidationRules.count > 0), viewModel.dataFilter), ...collectParameterViolations(viewModel.entityViewParameters.filter((p) => p.filterable && p.filterValidationRules.count > 0), viewModel.dataFilter)]);
		function worstViolationSeverity(violations) {
			return violations.reduce((worst, violation) => worst === void 0 || violation.severity > worst ? violation.severity : worst, void 0);
		}
		const advancedFilterSeverity = computed(() => {
			const worstSeverity = worstViolationSeverity(advancedFilterViolations.value);
			return worstSeverity === void 0 ? void 0 : convertValidationMessageSeverity(worstSeverity);
		});
		const advancedFilterTooltip = computed(() => groupFilterViolations(advancedFilterViolations.value, (captions, text) => translate("FilterValidationLine", captions, text)).map((line) => line.text).join("\n"));
		const inputAttributes = computed(() => {
			const attributes = filterableAttributes.value.filter((p) => p.filterVisible).sort((p1, p2) => p1.filterPosition - p2.filterPosition);
			if (!filter.value.isEmpty && filter.value.isSimple) appendInputPropertiesFromFilter(attributes, filter.value);
			return attributes;
		});
		const activeNamedFilters = computed(() => {
			const namedFilters = [];
			function add(filter) {
				const definition = viewModel.namedFilters.find((nf) => nf.id === filter.namedFilterId);
				if (definition) namedFilters.push({
					definition,
					filter
				});
			}
			if (viewModel.dataFilter.namedFilterId) add(viewModel.dataFilter);
			else for (const childFilter of filter.value.children) if (childFilter.namedFilterId) add(childFilter);
			return namedFilters;
		});
		watch(filter, (newFilter) => {
			isAdvancedMode.value ||= !newFilter.isSimple;
		}, { deep: true });
		const addDropdownMenu = ref();
		const addDropdownMenuItems = ref([]);
		const displayAddFilterButton = computed(() => props.advancedMode || inputAttributes.value.length < filterableAttributes.value.length || activeNamedFilters.value.length < viewModel.namedFilters.length);
		const displayResetFilterButton = computed(() => !filter.value.extractWritableFilter().isEmpty);
		function appendInputPropertiesFromFilter(attributes, filter) {
			if (filter.namedFilterId) return;
			if (filter.condition) {
				const propertyPath = filter.condition.propertyPath;
				const property = viewModel.properties.find((p) => p.isFilterPath(propertyPath));
				if (property && property.filterable && matchesFilterBar(property.filterBarId) && !attributes.includes(property)) attributes.push(property);
			}
			for (const childFilter of filter.children) appendInputPropertiesFromFilter(attributes, childFilter);
		}
		function handleAddFilterButtonClick(event) {
			hideAllPopovers();
			addDropdownMenuItems.value = createAddDropdownMenuItems();
			addDropdownMenu.value.toggle(event);
		}
		function handleResetFilterButtonClick() {
			commitQueue.enqueue(async () => {
				filter.value = filter.value.extractNonWritableFilter();
			});
		}
		function createAddDropdownMenuItems() {
			const menuItems = [];
			const unactiveNamedFilters = viewModel.namedFilters.filter((namedFilter) => !activeNamedFilters.value.some((n) => n.definition.id === namedFilter.id));
			const namedFiltersMenuItem = getNamedFiltersMenuItem(globalResourceManager, unactiveNamedFilters, (namedFilter) => {
				commitQueue.enqueue(async () => {
					const newFilter = filter.value.clone();
					newFilter.add(await namedFilter.getFilter());
					filter.value = newFilter;
				});
				addDropdownMenu.value.hide();
			});
			if (namedFiltersMenuItem) menuItems.push(namedFiltersMenuItem);
			const attributeMenuItems = getAttributeMenuItems();
			if (attributeMenuItems.length > 0) {
				if (menuItems.length > 0) menuItems.push({ separator: true });
				menuItems.push(...attributeMenuItems);
			}
			if (props.advancedMode) {
				if (menuItems.length > 0) menuItems.push({ separator: true });
				menuItems.push({
					label: translate("AdvancedFilter"),
					icon: "filterOutline",
					attributes: { "data-command": "ADVANCED_FILTER" },
					async command() {
						isAdvancedMode.value = true;
						addDropdownMenu.value.hide();
						await clickOnChip(".advanced-filter-chip");
					}
				});
			}
			return menuItems;
		}
		function getAttributeMenuItems() {
			const attributes = filterableAttributes.value.filter((p) => p.filterVisibleInPanel && !inputAttributes.value.includes(p));
			const moreAttributes = filterableAttributes.value.filter((p) => !p.filterVisibleInPanel && !inputAttributes.value.includes(p));
			if (attributes.length === 0) return mapAttributesToMenuItems(moreAttributes);
			const attributeMenuItems = mapAttributesToMenuItems(attributes);
			if (moreAttributes.length > 0) attributeMenuItems.push({
				label: translate("MoreFilters"),
				icon: "empty",
				items: mapAttributesToMenuItems(moreAttributes),
				attributes: { "data-command": "MORE_FILTERS" }
			});
			return attributeMenuItems;
		}
		function mapAttributesToMenuItems(attributes) {
			return attributes.map((attribute) => ({
				label: attribute.filterCaption,
				icon: getFilterDataTypeIcon(attribute),
				attributes: { "data-attribute": attribute.name },
				async command() {
					attribute.filterVisible = true;
					attribute.filterPosition = Math.max(...inputAttributes.value.map((p) => p.filterPosition), 0) + 1;
					addDropdownMenu.value.hide();
					await clickOnChip(`.editable-filter-chip[data-attribute="${attribute.name}"]`);
				}
			}));
		}
		const filterBuilderPopover = ref();
		async function handleDisableAdvancedModeButtonClick() {
			const { filter: filterBuilderFilter, parameters: filterBuilderParameters } = await filterBuilderPopover.value.flushPendingInput();
			filterBuilderPopover.value.hide();
			isAdvancedMode.value = false;
			viewModel.entityViewParameters.setValues(filterBuilderParameters);
			revealValuedParameters();
			filter.value = filterBuilderFilter;
		}
		function revealValuedParameters() {
			const parameters = filterableAttributes.value.filter((attribute) => attribute instanceof ViewModelEntityViewParameter && !attribute.filterVisible && parameterHasValue(attribute));
			for (const parameter of parameters) {
				parameter.filterVisible = true;
				parameter.filterPosition = Math.max(...inputAttributes.value.map((p) => p.filterPosition), 0) + 1;
			}
		}
		function parameterHasValue(parameter) {
			return parameter.value != null || !!parameter.filterValue2Parameter && parameter.filterValue2Parameter.value != null;
		}
		function handleRemoveAdvancedFilterButtonClick() {
			filterBuilderPopover.value.hide();
			isAdvancedMode.value = false;
			filter.value = filter.value.extractNonWritableFilter();
		}
		async function clickOnChip(selector) {
			await nextTick();
			root.value.$el.querySelector(selector).click();
		}
		return (_ctx, _cache) => {
			return displayFilterBar.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
				key: 0,
				ref_key: "root",
				ref: root,
				class: "editable-filter-chips",
				"vertical-align": "bottom"
			}, {
				default: withCtx(() => [isAdvancedMode.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
					createVNode(unref(Button$1), {
						size: __props.size,
						icon: "filterOutline",
						"icon-size": unref(actionChipIconSize),
						label: unref(translate)("AdvancedFilter"),
						class: "action-filter-chip advanced-filter-chip",
						variant: advancedFilterButtonVariant.value,
						"data-validation-severity": advancedFilterSeverity.value,
						tooltip: advancedFilterTooltip.value || void 0,
						onClick: _cache[0] || (_cache[0] = ($event) => filterBuilderPopover.value.toggle($event))
					}, null, 8, [
						"size",
						"icon-size",
						"label",
						"variant",
						"data-validation-severity",
						"tooltip"
					]),
					createVNode(ServerFilterChips_default, {
						chips: __props.serverFilterChips,
						size: __props.size
					}, null, 8, ["chips", "size"]),
					createVNode(FilterBuilderPopover_default, {
						ref_key: "filterBuilderPopover",
						ref: filterBuilderPopover,
						"advanced-mode": "only"
					}, {
						default: withCtx(({ filter: filterBuilderFilter }) => [filterBuilderFilter.isSimple ? (openBlock(), createBlock(unref(Button$1), {
							key: 0,
							icon: "arrowLeft",
							variant: "ghost",
							size: "small",
							label: unref(translate)("BackToSimpleFilter"),
							class: "editable-filter-chips-disable-advanced-mode-button",
							onClick: handleDisableAdvancedModeButtonClick
						}, null, 8, ["label"])) : (openBlock(), createBlock(unref(Button$1), {
							key: 1,
							icon: "remove",
							variant: "ghost-danger",
							size: "small",
							label: unref(translate)("RemoveAdvancedFilter"),
							class: "editable-filter-chips-disable-advanced-mode-button",
							onClick: handleRemoveAdvancedFilterButtonClick
						}, null, 8, ["label"]))]),
						_: 1
					}, 512)
				], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
					createVNode(ServerFilterChips_default, {
						chips: __props.serverFilterChips,
						size: __props.size
					}, null, 8, ["chips", "size"]),
					(openBlock(true), createElementBlock(Fragment, null, renderList(activeNamedFilters.value, (namedFilter) => {
						return openBlock(), createBlock(EditableFilterNamedFilterChip_default, {
							key: namedFilter.definition.id,
							modelValue: filter.value,
							"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => filter.value = $event),
							definition: namedFilter.definition,
							filter: namedFilter.filter,
							size: __props.size
						}, null, 8, [
							"modelValue",
							"definition",
							"filter",
							"size"
						]);
					}), 128)),
					(openBlock(true), createElementBlock(Fragment, null, renderList(inputAttributes.value, (inputAttribute) => {
						return openBlock(), createElementBlock(Fragment, { key: inputAttribute.name }, [inputAttribute instanceof unref(ViewModelEntityViewParameter) ? (openBlock(), createBlock(EditableFilterParameterChip_default, {
							key: 0,
							parameter: inputAttribute,
							size: __props.size
						}, null, 8, ["parameter", "size"])) : (openBlock(), createBlock(EditableFilterPropertyChip_default, {
							key: 1,
							modelValue: filter.value,
							"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => filter.value = $event),
							property: inputAttribute,
							size: __props.size
						}, null, 8, [
							"modelValue",
							"property",
							"size"
						]))], 64);
					}), 128)),
					displayAddFilterButton.value ? (openBlock(), createBlock(unref(Button$1), {
						key: 0,
						size: __props.size,
						variant: "ghost",
						icon: "add",
						"icon-size": unref(actionChipIconSize),
						label: unref(translate)("AddFilter"),
						class: "action-filter-chip add-filter-chip",
						onClick: handleAddFilterButtonClick
					}, null, 8, [
						"size",
						"icon-size",
						"label"
					])) : createCommentVNode("", true),
					displayResetFilterButton.value ? (openBlock(), createBlock(unref(Button$1), {
						key: 1,
						size: __props.size,
						variant: "ghost",
						icon: "clear",
						"icon-size": unref(actionChipIconSize),
						label: unref(translate)("ResetFilters"),
						class: "action-filter-chip reset-filter-chip",
						onClick: handleResetFilterButtonClick
					}, null, 8, [
						"size",
						"icon-size",
						"label"
					])) : createCommentVNode("", true),
					createVNode(unref(DropdownMenu), {
						ref_key: "addDropdownMenu",
						ref: addDropdownMenu,
						items: addDropdownMenuItems.value,
						size: "small"
					}, null, 8, ["items"])
				], 64))]),
				_: 1
			}, 512)) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-a16c0f92"]]);
//#endregion
//#region src/components/FilterBarInput/FilterBarInput.ts?vue&type=script&src=true&lang.ts
var FilterBarInput_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "FilterBarInput",
	components: {
		Button: Button$1,
		Combobox,
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		Text: Text$2
	},
	props: {
		property: {
			type: Object,
			required: true
		},
		modelValue: {
			type: Object,
			required: true
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const commitQueue = useFilterCommitQueue();
		const property = toRef(props, "property");
		const currentOperator = ref(props.property.filterDefaultOperator);
		const currentOperatorMetadata = computed(() => property.value.getFilterOperators()[currentOperator.value]);
		const { operators, editingComponent, editingComponentProps, showValue, showValue2, required, messageText, messageSeverity } = useFilterAttribute(property, currentOperator);
		const currentValue1 = ref();
		const currentValue2 = ref();
		const readOnlyCondition = ref(false);
		const readOnly = computed(() => !props.modelValue.isSimple || readOnlyCondition.value);
		const readOnlyValue = computed(() => readOnly.value || !showValue.value);
		watch(() => props.modelValue, (filter) => {
			const condition = filter.isSimple ? findCondition(filter) : void 0;
			if (condition) {
				const { operator, value1, value2 } = props.property.extractOperatorAndValuesFromFilterCondition(condition);
				currentOperator.value = operator;
				currentValue1.value = value1;
				currentValue2.value = value2;
				readOnlyCondition.value = condition.readOnly;
			} else {
				currentValue1.value = void 0;
				currentValue2.value = void 0;
				readOnlyCondition.value = false;
			}
		}, {
			immediate: true,
			deep: true
		});
		function emitNewFilter(operator, value1, value2) {
			commitQueue.enqueue(async () => {
				const filter = props.modelValue.clone();
				const removed = removeCondition(filter);
				operator = normalizeConditionOperator(props.property, operator, value1);
				const [newValue1, newValue2] = normalizeConditionValues(props.property, operator, value1, value2);
				const condition = await props.property.createFilterCondition(operator, newValue1, newValue2);
				if (condition) filter.add(condition);
				if (removed || condition) emit("update:modelValue", filter);
			}, props.property);
		}
		function findCondition(filter) {
			for (const path of props.property.getFilterPaths()) {
				const foundFilter = filter.find(path);
				if (foundFilter) return foundFilter.condition;
			}
		}
		function removeCondition(filter) {
			let removed = false;
			for (const path of props.property.getFilterPaths()) removed ||= filter.removeByName(path, true);
			return removed;
		}
		return {
			translate,
			operators,
			currentOperator,
			currentOperatorMetadata,
			editingComponent,
			editingComponentProps,
			showValue2,
			currentValue1,
			currentValue2,
			readOnly,
			readOnlyValue,
			required,
			messageText,
			messageSeverity,
			emitNewFilter
		};
	}
});
//#endregion
//#region src/components/FilterBarInput/FilterBarInput.vue
var _hoisted_1$14 = { class: "sr-only" };
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Combobox = resolveComponent("Combobox");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		class: "filter-bar-input",
		"data-property": _ctx.property.name
	}, {
		default: withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent(_ctx.editingComponent), mergeProps({
			"model-value": _ctx.currentValue1,
			label: _ctx.property.datagridCaption,
			readonly: _ctx.readOnlyValue,
			required: _ctx.required,
			"message-text": _ctx.messageText,
			"message-severity": _ctx.messageSeverity
		}, _ctx.editingComponentProps, {
			class: "filter-bar-input-component",
			"data-value": "1",
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.emitNewFilter(_ctx.currentOperator, $event, _ctx.currentValue2))
		}), {
			before: withCtx(() => [createVNode(_component_Combobox, {
				"model-value": _ctx.currentOperator,
				values: _ctx.operators,
				"value-property": "value",
				"display-property": "caption",
				readonly: _ctx.readOnly,
				required: "",
				caret: false,
				class: "filter-bar-input-operator-combobox",
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.emitNewFilter($event, _ctx.currentValue1, _ctx.currentValue2))
			}, {
				value: withCtx(() => [createVNode(_component_Image, {
					name: _ctx.currentOperatorMetadata.image,
					size: "small",
					"aria-hidden": "true"
				}, null, 8, ["name"]), createElementVNode("span", _hoisted_1$14, toDisplayString(_ctx.currentOperatorMetadata.caption), 1)]),
				option: withCtx(({ option }) => [createVNode(_component_HorizontalLayout, {
					space: "small",
					class: "filter-bar-input-operator-combobox-option",
					"vertical-align": "center",
					"data-operator": option.value
				}, {
					default: withCtx(() => [createVNode(_component_Image, {
						name: option.image,
						size: "small"
					}, null, 8, ["name"]), createVNode(_component_Text, null, {
						default: withCtx(() => [createTextVNode(toDisplayString(option.caption), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, ["data-operator"])]),
				_: 1
			}, 8, [
				"model-value",
				"values",
				"readonly"
			])]),
			_: 1
		}, 16, [
			"model-value",
			"label",
			"readonly",
			"required",
			"message-text",
			"message-severity"
		])), _ctx.showValue2 ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.editingComponent), mergeProps({
			key: 0,
			"model-value": _ctx.currentValue2,
			label: _ctx.translate("And"),
			readonly: _ctx.readOnlyValue,
			required: _ctx.required
		}, _ctx.editingComponentProps, {
			class: "filter-bar-input-component",
			"data-value": "2",
			"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.emitNewFilter(_ctx.currentOperator, _ctx.currentValue1, $event))
		}), {
			before: withCtx(() => [createVNode(_component_HorizontalLayout, { "vertical-align": "center" }, {
				default: withCtx(() => [createVNode(_component_Image, {
					name: "lessOrEqual",
					size: "small"
				})]),
				_: 1
			})]),
			_: 1
		}, 16, [
			"model-value",
			"label",
			"readonly",
			"required"
		])) : createCommentVNode("", true)]),
		_: 1
	}, 8, ["data-property"]);
}
var FilterBarInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FilterBarInput_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$18], ["__scopeId", "data-v-e27b63b5"]]);
//#endregion
//#region src/components/FilterChips/FilterChips.vue
var FilterChips_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FilterChips",
	props: { serverFilterChips: {} },
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const viewModel = useViewModel();
		const chips = computed(() => {
			const chips = [];
			appendChips(chips, viewModel.dataFilter, viewModel.getFilterableProperties());
			return chips;
		});
		const showChips = computed(() => viewModel.dataFilter.isSimple && chips.value.length > 0 || !!props.serverFilterChips);
		function appendChips(chips, filter, properties) {
			if (filter.visible && filter.condition && !filter.condition.isEmpty && filter.condition.filterOperator !== FilterOperator.isMatch) {
				const property = properties.find((p) => !p.filterVisible && p.isFilterPath(filter.condition.propertyPath));
				if (property) chips.push({
					property,
					filter
				});
			}
			for (const child of filter.children) appendChips(chips, child, properties);
		}
		async function handleChipRemove(chip) {
			viewModel.dataFilter.removeByName(chip.filter.condition.propertyPath);
			await viewModel.filterDataAsync(viewModel.dataFilter);
		}
		return (_ctx, _cache) => {
			return showChips.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
				key: 0,
				class: "filter-chips"
			}, {
				default: withCtx(() => [createVNode(ServerFilterChips_default, {
					chips: __props.serverFilterChips,
					size: "extrasmall"
				}, null, 8, ["chips"]), (openBlock(true), createElementBlock(Fragment, null, renderList(chips.value, (chip) => {
					return openBlock(), createBlock(unref(Chip$1), {
						key: chip.filter.condition.propertyPath,
						class: "filter-chip",
						"data-attribute": chip.property.name
					}, {
						default: withCtx(() => [createVNode(FilterChipContent_default, {
							attribute: chip.property,
							operator: chip.filter.condition.filterOperator,
							value: chip.filter.condition.values,
							"has-value": true,
							active: chip.filter.active,
							"read-only": chip.filter.readOnly,
							"show-toggle": false,
							"show-required-indicator": false,
							size: "extrasmall",
							onRemove: ($event) => handleChipRemove(chip)
						}, null, 8, [
							"attribute",
							"operator",
							"value",
							"active",
							"read-only",
							"onRemove"
						])]),
						_: 2
					}, 1032, ["data-attribute"]);
				}), 128))]),
				_: 1
			})) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-1e556a50"]]);
//#endregion
//#region src/components/QuickSearch/QuickSearch.ts?vue&type=script&src=true&lang.ts
var QuickSearch_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "QuickSearch",
	components: {
		Button: Button$1,
		Textbox: Textbox$1
	},
	props: { labelPosition: {
		type: String,
		default: "top"
	} },
	setup(props) {
		const { translate } = useGlobalResourceManager();
		const viewModel = useViewModel();
		useComponentAutomationProperties();
		const visible = computed(() => viewModel.quickSearchPlaceHolder);
		const displayAiModeButton = computed(() => viewModel.applicationContext.has("SmartSearch") && !viewModel.clientSideFilter);
		const aiMode = ref(false);
		const aiModeButtonVariant = computed(() => aiMode.value ? "ghost-primary" : "ghost");
		const aiModeButtonTooltip = computed(() => aiMode.value ? translate("SmartSearch_Disable") : translate("SmartSearch_Enable"));
		const label = computed(() => {
			return aiMode.value ? translate("SmartSearch") : translate("SearchIn");
		});
		const placeholder = computed(() => {
			if (aiMode.value) return translate("SmartSearch_Placeholder");
			return props.labelPosition === "hidden" ? `${translate("SearchIn")} ${viewModel.quickSearchPlaceHolder}` : viewModel.quickSearchPlaceHolder;
		});
		const filterValue = ref();
		function applyQuickSearchValue(rawValue) {
			const dataFilter = viewModel.dataFilter.clone();
			dataFilter.removeByName("isMatch");
			if (aiMode.value) {
				filterValue.value = void 0;
				viewModel.filterPrompt = rawValue;
			} else {
				filterValue.value = rawValue;
				viewModel.filterPrompt = void 0;
				if (rawValue) dataFilter.add(Filter.create("isMatch", FilterOperator.isMatch, rawValue));
			}
			viewModel.dataFilter = dataFilter;
		}
		const value = computed({
			get: () => {
				if (aiMode.value) return viewModel.filterPrompt;
				return filterValue.value;
			},
			set: (value) => {
				applyQuickSearchValue(value);
				viewModel.filterDataAsync();
			}
		});
		function handleKeyDown(event) {
			if (event.key === "Enter") {
				applyQuickSearchValue(event.target.value || void 0);
				viewModel.filterDataAsync(void 0, true);
			}
		}
		watch(() => viewModel.dataFilter, (filter) => {
			const quickSearchFilter = filter.find("isMatch");
			filterValue.value = quickSearchFilter?.condition?.firstValue;
		}, {
			immediate: true,
			deep: true
		});
		function toggleAiMode() {
			aiMode.value = !aiMode.value;
		}
		return {
			visible,
			displayAiModeButton,
			label,
			value,
			placeholder,
			aiMode,
			aiModeButtonVariant,
			aiModeButtonTooltip,
			toggleAiMode,
			handleKeyDown
		};
	}
});
//#endregion
//#region src/components/QuickSearch/QuickSearch.vue
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Textbox = resolveComponent("Textbox");
	return _ctx.visible ? (openBlock(), createBlock(_component_Textbox, {
		key: 0,
		modelValue: _ctx.value,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		placeholder: _ctx.placeholder,
		tooltip: _ctx.placeholder,
		clear: true,
		speech: _ctx.aiMode,
		class: "quick-search",
		onKeydown: _ctx.handleKeyDown
	}, {
		before: withCtx(() => [_ctx.displayAiModeButton ? (openBlock(), createBlock(_component_Button, {
			key: 0,
			variant: _ctx.aiModeButtonVariant,
			size: "small",
			icon: "sparkles",
			class: "quick-search-button quick-search-ai-mode-button",
			title: _ctx.aiModeButtonTooltip,
			onClick: _ctx.toggleAiMode
		}, null, 8, [
			"variant",
			"title",
			"onClick"
		])) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"modelValue",
		"label",
		"label-position",
		"placeholder",
		"tooltip",
		"speech",
		"onKeydown"
	])) : createCommentVNode("", true);
}
var QuickSearch_default = /*#__PURE__*/ _plugin_vue_export_helper_default(QuickSearch_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$17]]);
//#endregion
//#region src/components/InputsFilterBar/InputsFilterBar.vue
var InputsFilterBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputsFilterBar",
	props: {
		chips: {
			type: Boolean,
			default: true
		},
		quickSearch: {
			type: Boolean,
			default: true
		},
		serverFilterChips: { default: void 0 },
		advancedMode: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const themeManager = useThemeManager(false);
		const viewModel = useViewModel();
		provideFilterCommitQueue();
		const inputProperties = computed(() => viewModel.getFilterableProperties().filter((p) => p.filterVisible).sort((p1, p2) => p1.filterPosition - p2.filterPosition));
		const filter = computed({
			get: () => viewModel.dataFilter,
			set: (filter) => viewModel.filterDataAsync(filter)
		});
		const paddingTop = computed(() => toggleFilterBuilderButtonVisible.value && inputProperties.value.length === 0 && !themeManager?.currentTheme.animatedButtons ? "0.375rem" : void 0);
		const verticalAlign = computed(() => inputProperties.value.length > 0 ? "bottom" : "center");
		const quickSearchVisible = computed(() => props.quickSearch && viewModel.quickSearchPlaceHolder);
		const quickSearchLabelPosition = computed(() => inputProperties.value.length > 0 ? "top" : "hidden");
		const toggleFilterBuilderButtonVisible = computed(() => viewModel.getFilterableProperties().length > 0);
		const toggleFilterBuilderButtonSize = computed(() => quickSearchVisible.value || inputProperties.value.length > 0 ? "small" : "medium");
		const toggleFilterBuilderButtonIcon = computed(() => filter.value.isEmpty ? "filterOutline" : "filter");
		const toggleFilterBuilderButtonBadge = computed(() => {
			const filterablePropertyPaths = viewModel.getFilterableProperties().flatMap((property) => property.getFilterPaths());
			const count = getConditionsCount(filter.value, filterablePropertyPaths);
			return count > 0 ? count.toString() : void 0;
		});
		function getConditionsCount(filter, filterablePropertyPaths) {
			if (filter.isEmpty) return 0;
			if (!filter.condition) return filter.children.reduce((count, child) => count + getConditionsCount(child, filterablePropertyPaths), 0);
			return filterablePropertyPaths.includes(filter.condition.propertyPath.toLowerCase()) ? 1 : 0;
		}
		const filterBuilderPopover = ref();
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), {
				class: "filter-bar",
				style: normalizeStyle({ paddingTop: paddingTop.value })
			}, {
				default: withCtx(() => [createVNode(unref(HorizontalLayout$1), { "vertical-align": verticalAlign.value }, {
					default: withCtx(() => [
						toggleFilterBuilderButtonVisible.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Button$1), {
							size: toggleFilterBuilderButtonSize.value,
							icon: toggleFilterBuilderButtonIcon.value,
							animated: "",
							badge: toggleFilterBuilderButtonBadge.value,
							"badge-severity": "info",
							class: "filter-bar-toggle-builder-button",
							title: unref(translate)("FilterBuilder"),
							onClick: _cache[0] || (_cache[0] = ($event) => filterBuilderPopover.value.toggle($event))
						}, null, 8, [
							"size",
							"icon",
							"badge",
							"title"
						]), createVNode(FilterBuilderPopover_default, {
							ref_key: "filterBuilderPopover",
							ref: filterBuilderPopover,
							"advanced-mode": __props.advancedMode
						}, null, 8, ["advanced-mode"])], 64)) : createCommentVNode("", true),
						quickSearchVisible.value ? (openBlock(), createBlock(QuickSearch_default, {
							key: 1,
							"label-position": quickSearchLabelPosition.value,
							class: "filter-bar-quick-search neos-fill-parent-width"
						}, null, 8, ["label-position"])) : createCommentVNode("", true),
						(openBlock(true), createElementBlock(Fragment, null, renderList(inputProperties.value, (inputProperty) => {
							return openBlock(), createBlock(FilterBarInput_default, {
								key: inputProperty.name,
								modelValue: filter.value,
								"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => filter.value = $event),
								property: inputProperty
							}, null, 8, ["modelValue", "property"]);
						}), 128))
					]),
					_: 1
				}, 8, ["vertical-align"]), __props.chips ? (openBlock(), createBlock(FilterChips_default, {
					key: 0,
					"server-filter-chips": __props.serverFilterChips
				}, null, 8, ["server-filter-chips"])) : createCommentVNode("", true)]),
				_: 1
			}, 8, ["style"]);
		};
	}
}), [["__scopeId", "data-v-e50238dc"]]);
//#endregion
//#region src/components/FilterBar/FilterBar.vue
var FilterBar_default = /* @__PURE__ */ defineComponent({
	__name: "FilterBar",
	props: {
		displayMode: { default: void 0 },
		size: {},
		chips: {
			type: Boolean,
			default: true
		},
		quickSearch: {
			type: Boolean,
			default: true
		},
		serverFilterChips: { default: void 0 },
		advancedMode: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		const computedDisplayMode = computed(() => props.displayMode ?? viewModel.behavior.filterBarDisplayMode);
		const isEditableFilterChips = computed(() => computedDisplayMode.value === "editable-chips");
		return (_ctx, _cache) => {
			return isEditableFilterChips.value ? (openBlock(), createBlock(EditableFilterChips_default, {
				key: 0,
				size: __props.size,
				"server-filter-chips": __props.serverFilterChips,
				"advanced-mode": __props.advancedMode
			}, null, 8, [
				"size",
				"server-filter-chips",
				"advanced-mode"
			])) : (openBlock(), createBlock(InputsFilterBar_default, {
				key: 1,
				chips: __props.chips,
				"quick-search": __props.quickSearch,
				"server-filter-chips": __props.serverFilterChips,
				"advanced-mode": __props.advancedMode
			}, null, 8, [
				"chips",
				"quick-search",
				"server-filter-chips",
				"advanced-mode"
			]));
		};
	}
});
//#endregion
//#region src/composables/useFormField.ts
function useFormField(props, emit) {
	const { viewModel, property, item, visible, required, aiSuggestion, handleAiApply, handleAiCancel } = useViewModelProperty(props);
	const { messageText, messageSeverity } = useValidationMessage(property, item);
	const value = computed({
		get() {
			return item.value ? property.value.getValue(item.value) : null;
		},
		set(v) {
			if (item.value) {
				property.value.setValue(item.value, v);
				if (toRaw(v) !== toRaw(property.value.getValue(item.value))) forceUpdate();
			}
		}
	});
	const invalidValue = computed({
		get() {
			return item.value ? item.value.getInvalidValue(property.value.camelCaseName) : null;
		},
		set(v) {
			if (item.value) item.value.setInvalidValue(property.value.camelCaseName, v);
		}
	});
	const readonly = computed(() => {
		if (!item.value) return true;
		if (viewModel.busy) return true;
		if (!item.value.$new && viewModel.canNeverExecuteEditAction) return true;
		if (!item.value.$new && !viewModel.getUpdateAllowed(item.value)) return true;
		return property.value.getReadOnly(item.value);
	});
	const tabStop = computed(() => item.value && !readonly.value ? property.value.getTabStop(item.value) : false);
	const focused = useVModel(props, "focused", emit);
	const updateKey = shallowRef(0);
	function forceUpdate() {
		updateKey.value++;
	}
	return {
		viewModel,
		property,
		item,
		visible,
		required,
		value,
		invalidValue,
		readonly,
		messageText,
		messageSeverity,
		tabStop,
		focused,
		updateKey,
		aiSuggestion,
		handleAiApply,
		handleAiCancel
	};
}
//#endregion
//#region src/components/FormFields/BooleanFormField/BooleanFormField.vue
var BooleanFormField_default = /* @__PURE__ */ defineComponent({
	__name: "BooleanFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		trueLabel: {},
		falseLabel: {},
		nullLabel: {},
		displayMode: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(DynamicCheckbox$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"true-label": __props.trueLabel,
				"false-label": __props.falseLabel,
				"null-label": __props.nullLabel,
				"display-mode": __props.displayMode,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"true-label",
				"false-label",
				"null-label",
				"display-mode",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/ColorFormField/ColorFormField.vue
var ColorFormField_default = /* @__PURE__ */ defineComponent({
	__name: "ColorFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { item, property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		const itemKey = ref(0);
		watch(item, () => itemKey.value++);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputColor$1), {
				key: `${itemKey.value}-${unref(updateKey)}`,
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/composables/useConstrainedFormField.ts
function useConstrainedFormField(props, emit) {
	const formField = useFormField(props, emit);
	const format = computed(() => formField.property.value.getFormat(formField.item.value));
	const minValue = computed(() => formField.item.value ? formField.property.value.getMinValue(formField.item.value) : void 0);
	const maxValue = computed(() => formField.item.value ? formField.property.value.getMaxValue(formField.item.value) : void 0);
	return {
		...formField,
		format,
		minValue,
		maxValue
	};
}
//#endregion
//#region src/components/FormFields/DateFormField/DateFormField.vue
var DateFormField_default = /* @__PURE__ */ defineComponent({
	__name: "DateFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, format, minValue, maxValue, invalidValue, aiSuggestion, handleAiApply, handleAiCancel } = useConstrainedFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputDate$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				"invalid-value": unref(invalidValue),
				"onUpdate:invalidValue": _cache[2] || (_cache[2] = ($event) => isRef(invalidValue) ? invalidValue.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				format: unref(format),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"invalid-value",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"format",
				"message-text",
				"message-severity",
				"message-position",
				"min-value",
				"max-value",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/DateTimeFormField/DateTimeFormField.vue
var DateTimeFormField_default = /* @__PURE__ */ defineComponent({
	__name: "DateTimeFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, format, minValue, maxValue, invalidValue, aiSuggestion, handleAiApply, handleAiCancel } = useConstrainedFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputDateTime$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				"invalid-value": unref(invalidValue),
				"onUpdate:invalidValue": _cache[2] || (_cache[2] = ($event) => isRef(invalidValue) ? invalidValue.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				format: unref(format),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"invalid-value",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"format",
				"message-text",
				"message-severity",
				"message-position",
				"min-value",
				"max-value",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/EnumFormField/EnumFormField.vue
var EnumFormField_default = /* @__PURE__ */ defineComponent({
	__name: "EnumFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		values: {},
		valueProperty: {},
		displayProperty: {},
		displayMode: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const { viewModel, property, item, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, invalidValue, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(props, __emit);
		const comboboxValues = computed(() => {
			if (props.values !== void 0) return props.values;
			return property.value.getEnabledEnumMembers(item.value);
		});
		const comboboxValueProperty = computed(() => props.values !== void 0 ? props.valueProperty : "name");
		const comboboxDisplayProperty = computed(() => {
			if (props.values !== void 0) {
				if (props.displayProperty) return props.displayProperty;
				if (props.valueProperty) return props.valueProperty;
				if (property.value.dataType === DataType$1.localizableString) return viewModel.localizator.currentLanguage;
				return;
			}
			return "caption";
		});
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(DynamicCombobox$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				"invalid-value": unref(invalidValue),
				"onUpdate:invalidValue": _cache[2] || (_cache[2] = ($event) => isRef(invalidValue) ? invalidValue.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				values: comboboxValues.value,
				"value-property": comboboxValueProperty.value,
				"display-property": comboboxDisplayProperty.value,
				"display-mode": __props.displayMode,
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, createSlots({ _: 2 }, [_ctx.$slots.value ? {
				name: "value",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "value", { option })]),
				key: "0"
			} : void 0, _ctx.$slots.option ? {
				name: "option",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
				key: "1"
			} : void 0]), 1032, [
				"modelValue",
				"focused",
				"invalid-value",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"values",
				"value-property",
				"display-property",
				"display-mode",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/composables/useInputFileReference.ts
function useInputFileReference(props, emit) {
	const { translate } = useGlobalResourceManager();
	const src = computed(() => props.modelValue?.url);
	const isUploadFailed = computed(() => props.modelValue?.uploadState === FileUploadState.failed);
	const uploadProgress = computed(() => {
		if (props.modelValue?.uploadState === FileUploadState.inProgress) return props.modelValue.uploadPercentCompleted ?? 0;
	});
	const customMessageText = computed(() => isUploadFailed.value ? translate("FileUpload_HasFailed", props.label) : props.messageText);
	const customMessageSeverity = computed(() => isUploadFailed.value ? "error" : props.messageSeverity);
	const { id, classes, isLabelVisible, isMessageVisible } = useInput(reactiveComputed(() => ({
		...props,
		messageText: customMessageText.value,
		messageSeverity: customMessageSeverity.value
	})), emit);
	return {
		classes,
		customMessageSeverity,
		customMessageText,
		id,
		isLabelVisible,
		isMessageVisible,
		isUploadFailed,
		src,
		translate,
		uploadProgress
	};
}
//#endregion
//#region src/components/InputFile/InputFile.ts?vue&type=script&src=true&lang.ts
var InputFile_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputFile",
	components: {
		InputLabel,
		Spinner: Spinner$1,
		InputMessage,
		Image: Image$2,
		Button: Button$1
	},
	props: {
		...inputProps,
		modelValue: {
			type: [FileReference, null],
			default: null
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { classes, customMessageSeverity, customMessageText, id, isLabelVisible, isMessageVisible, isUploadFailed, src, translate, uploadProgress } = useInputFileReference(props, emit);
		function handleOpenAsync() {
			window.open(src.value, "_blank");
		}
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			translate,
			src,
			uploadProgress,
			isUploadFailed,
			customMessageText,
			customMessageSeverity,
			handleOpenAsync
		};
	}
});
//#endregion
//#region src/components/InputFile/InputFile.vue
var _hoisted_1$13 = {
	key: 0,
	class: "progress-bar"
};
var _hoisted_2$9 = ["data-src"];
var _hoisted_3$7 = {
	key: 2,
	class: "input-file-no-file"
};
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Button = resolveComponent("Button");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-file neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["input-file-content neos-input-content", {
		"neos-input-disabled": _ctx.readonly || _ctx.disabled,
		"has-label": !!_ctx.label
	}]) }, [_ctx.uploadProgress !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$13, [createElementVNode("div", {
		class: "progress",
		style: normalizeStyle({ width: `${_ctx.uploadProgress}%` })
	}, null, 4)])) : createCommentVNode("", true), _ctx.src ? (openBlock(), createElementBlock("div", {
		key: 1,
		class: normalizeClass(["input-file-button", { "is-upload-failed": _ctx.isUploadFailed }]),
		"data-src": _ctx.src
	}, [createVNode(_component_Button, {
		icon: "eye",
		variant: "ghost",
		size: "small",
		onClick: _cache[2] || (_cache[2] = ($event) => _ctx.handleOpenAsync())
	})], 10, _hoisted_2$9)) : (openBlock(), createElementBlock("div", _hoisted_3$7, [createElementVNode("span", null, toDisplayString(_ctx.translate("NoFile")), 1)]))], 2)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.customMessageText,
		severity: _ctx.customMessageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputFile_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputFile_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$16], ["__scopeId", "data-v-eb6b1fe9"]]);
//#endregion
//#region src/components/FormFields/FileFormField/FileFormField.vue
var FileFormField_default = /* @__PURE__ */ defineComponent({
	__name: "FileFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(InputFile_default, {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/InputImage/InputImage.ts?vue&type=script&src=true&lang.ts
var InputImage_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputImage",
	components: {
		NeosImage: Image$2,
		InputLabel,
		Spinner: Spinner$1,
		InputMessage
	},
	props: {
		...inputProps,
		modelValue: {
			type: [FileReference, null],
			default: null
		},
		delegatedLoading: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const applicationContext = useApplicationContext();
		const { classes, customMessageSeverity, customMessageText, id, isLabelVisible, isMessageVisible, isUploadFailed, src, translate, uploadProgress } = useInputFileReference(props, emit);
		const { componentSource } = useImageDelegatedLoading(applicationContext, props, src);
		const isLoading = ref(false);
		const isValid = ref(false);
		const isCached = (src) => {
			const image = new Image();
			image.src = src;
			return image.complete;
		};
		watch(src, (value) => {
			isValid.value = value === void 0;
			isLoading.value = value !== void 0 && (props.delegatedLoading ? componentSource.value === void 0 : !isCached(value));
		}, { immediate: true });
		const onLoad = () => {
			isLoading.value = false;
			isValid.value = true;
		};
		const onError = () => {
			isLoading.value = false;
			isValid.value = false;
		};
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			translate,
			src,
			componentSource,
			isLoading,
			onLoad,
			onError,
			isValid,
			uploadProgress,
			isUploadFailed,
			customMessageText,
			customMessageSeverity
		};
	}
});
//#endregion
//#region src/components/InputImage/InputImage.vue
var _hoisted_1$12 = {
	key: 0,
	class: "progress-bar"
};
var _hoisted_2$8 = ["alt", "src"];
var _hoisted_3$6 = {
	key: 1,
	class: "input-image-no-image"
};
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Spinner = resolveComponent("Spinner");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-image neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["input-image-content neos-input-content", {
		"neos-input-disabled": _ctx.readonly || _ctx.disabled,
		"has-label": !!_ctx.label
	}]) }, [
		_ctx.uploadProgress !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$12, [createElementVNode("div", {
			class: "progress",
			style: normalizeStyle({ width: `${_ctx.uploadProgress}%` })
		}, null, 4)])) : createCommentVNode("", true),
		withDirectives(createElementVNode("img", {
			class: normalizeClass({
				"is-valid": _ctx.isValid,
				"is-upload-failed": _ctx.isUploadFailed
			}),
			alt: _ctx.src,
			src: _ctx.componentSource,
			onLoad: _cache[2] || (_cache[2] = (...args) => _ctx.onLoad && _ctx.onLoad(...args)),
			onError: _cache[3] || (_cache[3] = (...args) => _ctx.onError && _ctx.onError(...args))
		}, null, 42, _hoisted_2$8), [[vShow, !_ctx.isLoading && _ctx.componentSource]]),
		!_ctx.src ? (openBlock(), createElementBlock("div", _hoisted_3$6, [createElementVNode("span", null, toDisplayString(_ctx.translate("NoImage")), 1)])) : createCommentVNode("", true),
		_ctx.isLoading ? (openBlock(), createBlock(_component_Spinner, {
			key: 2,
			class: "input-image-spinner"
		})) : createCommentVNode("", true)
	], 2)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.customMessageText,
		severity: _ctx.customMessageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputImage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputImage_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$15], ["__scopeId", "data-v-f8639bf6"]]);
//#endregion
//#region src/components/FormFields/ImageFormField/ImageFormField.vue
var ImageFormField_default = /* @__PURE__ */ defineComponent({
	__name: "ImageFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(InputImage_default, {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/LocalizableStringFormField/LocalizableStringFormField.vue
var LocalizableStringFormField_default = /* @__PURE__ */ defineComponent({
	__name: "LocalizableStringFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		rows: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { viewModel, property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		const smartTranslate = getSmartTranslateFunction(viewModel.applicationContext, viewModel.eventManager, viewModel.globalResourceManager, viewModel.apiClient);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputLocalizableString$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				"max-length": unref(property).maxLength,
				"multi-lines": unref(property).multiLines,
				rows: __props.rows,
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"smart-translate": unref(smartTranslate),
				"white-space-handling": unref(property).whiteSpaceHandling,
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"max-length",
				"multi-lines",
				"rows",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"smart-translate",
				"white-space-handling",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/LookupFormField/LookupFormField.vue
var LookupFormField_default = /* @__PURE__ */ defineComponent({
	__name: "LookupFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, invalidValue, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, item, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(Lookup_default, {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				"invalid-value": unref(invalidValue),
				"onUpdate:invalidValue": _cache[2] || (_cache[2] = ($event) => isRef(invalidValue) ? invalidValue.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				item: unref(item),
				property: unref(property),
				definition: unref(property).lookupDefinition,
				"is-reference": !unref(property).dataType,
				"reference-entity-view-name": unref(property).referenceEntityViewName,
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"invalid-value",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"item",
				"property",
				"definition",
				"is-reference",
				"reference-entity-view-name",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/MaskFormField/MaskFormField.vue
var MaskFormField_default = /* @__PURE__ */ defineComponent({
	__name: "MaskFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		mask: {},
		updateMode: { default: "default" },
		valueMode: { default: "raw" }
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputMask$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				tooltip: unref(value),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"update-mode": __props.updateMode,
				mask: __props.mask,
				"value-mode": __props.valueMode,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"tooltip",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"update-mode",
				"mask",
				"value-mode",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/MultiSelectFormField/MultiSelectFormField.vue
var MultiSelectFormField_default = /* @__PURE__ */ defineComponent({
	__name: "MultiSelectFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		values: {},
		valueProperty: {},
		displayProperty: {},
		searchable: { type: Boolean },
		maxDisplayedChips: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(MultiSelect$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				readonly: unref(readonly),
				required: unref(required),
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty ?? __props.valueProperty,
				searchable: __props.searchable,
				"max-displayed-chips": __props.maxDisplayedChips,
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop)
			}, createSlots({ _: 2 }, [_ctx.$slots.chip ? {
				name: "chip",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "chip", { option })]),
				key: "0"
			} : void 0, _ctx.$slots.option ? {
				name: "option",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
				key: "1"
			} : void 0]), 1032, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"readonly",
				"required",
				"values",
				"value-property",
				"display-property",
				"searchable",
				"max-displayed-chips",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/NumberCalculableFormField/NumberCalculableFormField.vue
var NumberCalculableFormField_default = /* @__PURE__ */ defineComponent({
	__name: "NumberCalculableFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		alignment: { default: "right" },
		step: { default: void 0 }
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, format, minValue, maxValue } = useConstrainedFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputNumberCalculable$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				format: unref(format),
				required: unref(required),
				"max-value": unref(maxValue),
				"min-value": unref(minValue),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				alignment: __props.alignment,
				"tab-stop": unref(tabStop),
				step: __props.step
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"format",
				"required",
				"max-value",
				"min-value",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"alignment",
				"tab-stop",
				"step"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/NumberFormField/NumberFormField.vue
var NumberFormField_default = /* @__PURE__ */ defineComponent({
	__name: "NumberFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		alignment: { default: "right" },
		step: { default: void 0 }
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, format, minValue, maxValue, aiSuggestion, handleAiApply, handleAiCancel } = useConstrainedFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputNumber$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				format: unref(format),
				required: unref(required),
				"max-value": unref(maxValue),
				"min-value": unref(minValue),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				alignment: __props.alignment,
				"tab-stop": unref(tabStop),
				step: __props.step,
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"format",
				"required",
				"max-value",
				"min-value",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"alignment",
				"tab-stop",
				"step",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/PasswordFormField/PasswordFormField.vue
var PasswordFormField_default = /* @__PURE__ */ defineComponent({
	__name: "PasswordFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		updateMode: { default: "default" },
		revealable: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputPassword$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				tooltip: unref(value),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"update-mode": __props.updateMode,
				revealable: __props.revealable,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"tooltip",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"update-mode",
				"revealable",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/SliderDiscreteFormField/SliderDiscreteFormField.vue
var SliderDiscreteFormField_default = /* @__PURE__ */ defineComponent({
	__name: "SliderDiscreteFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		values: {},
		isRange: { type: Boolean },
		trackColor: {},
		selectedTrackColor: {},
		selectedThumbColor: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputSliderDiscrete$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": props.labelPosition,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				values: __props.values,
				"is-range": __props.isRange,
				"track-color": __props.trackColor,
				"selected-track-color": __props.selectedTrackColor,
				"selected-thumb-color": __props.selectedThumbColor,
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"values",
				"is-range",
				"track-color",
				"selected-track-color",
				"selected-thumb-color",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/StringArrayFormField/StringArrayFormField.vue
var StringArrayFormField_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "StringArrayFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { property, value, visible, readonly, required, messageText, messageSeverity, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(props, emit);
		const { id, classes, isLabelVisible, isMessageVisible } = useInput(reactiveComputed(() => ({
			...props,
			label: property.value.caption,
			readonly: readonly.value,
			tabStop: tabStop.value,
			messageText: messageText.value,
			messageSeverity: messageSeverity.value
		})), emit);
		function addInput() {
			if (value.value == null) value.value = [];
			updateInput(value.value.length, "");
		}
		function removeInput(index) {
			const newArray = value.value.filter((v, i) => i !== index);
			if (newArray.length === 0 && !required.value) value.value = null;
			else value.value = newArray;
		}
		function updateInput(index, newValue) {
			const newArray = [...value.value];
			newArray[index] = newValue;
			value.value = newArray;
		}
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(["string-array-form-field neos-input", unref(classes)])
			}, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(unref(InputLabel), {
				key: 0,
				label: unref(property).caption,
				required: unref(required),
				documentation: unref(property).documentation,
				"html-for": unref(id),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true), createVNode(unref(VerticalLayout$1), { class: "string-array-form-field-content" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(value), (input, index) => {
					return openBlock(), createBlock(unref(HorizontalLayout$1), { key: index }, {
						default: withCtx(() => [
							createVNode(unref(Textbox$1), {
								"model-value": input,
								"max-length": unref(property).maxLength,
								readonly: unref(readonly),
								class: "neos-fill-parent-width",
								"onUpdate:modelValue": (value) => updateInput(index, value)
							}, null, 8, [
								"model-value",
								"max-length",
								"readonly",
								"onUpdate:modelValue"
							]),
							!unref(readonly) ? (openBlock(), createBlock(unref(Button$1), {
								key: 0,
								class: "string-array-form-field-button-remove",
								icon: "remove",
								size: "small",
								onClick: ($event) => removeInput(index)
							}, null, 8, ["onClick"])) : createCommentVNode("", true),
							index === 0 && !unref(readonly) ? (openBlock(), createBlock(unref(Button$1), {
								key: 1,
								class: "string-array-form-field-button-add",
								icon: "add",
								size: "small",
								onClick: _cache[0] || (_cache[0] = ($event) => addInput())
							})) : createCommentVNode("", true)
						]),
						_: 2
					}, 1024);
				}), 128)), (unref(value) == null || unref(value).length === 0) && !unref(readonly) ? (openBlock(), createBlock(unref(Button$1), {
					key: 0,
					class: "string-array-form-field-button-add",
					icon: "add",
					size: "small",
					onClick: _cache[1] || (_cache[1] = ($event) => addInput())
				})) : createCommentVNode("", true)]),
				_: 1
			})]), unref(isMessageVisible) && unref(messageText) ? (openBlock(), createBlock(unref(InputMessage), {
				key: 0,
				text: unref(messageText),
				severity: unref(messageSeverity)
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-ef03a184"]]);
//#endregion
//#region src/components/FormFields/StringFormField/StringFormField.vue
var StringFormField_default = /* @__PURE__ */ defineComponent({
	__name: "StringFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {},
		rows: { default: void 0 },
		updateMode: { default: "default" },
		clear: { type: Boolean },
		speech: { type: Boolean }
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(Textbox$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				tooltip: unref(value),
				"max-length": unref(property).maxLength,
				"multi-lines": unref(property).multiLines,
				rows: __props.rows,
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"update-mode": __props.updateMode,
				clear: __props.clear,
				speech: __props.speech,
				"tab-stop": unref(tabStop),
				"character-casing": unref(property).characterCasing,
				"white-space-handling": unref(property).whiteSpaceHandling,
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"tooltip",
				"max-length",
				"multi-lines",
				"rows",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"update-mode",
				"clear",
				"speech",
				"tab-stop",
				"character-casing",
				"white-space-handling",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FormFields/TimeFormField/TimeFormField.vue
var TimeFormField_default = /* @__PURE__ */ defineComponent({
	__name: "TimeFormField",
	props: {
		labelPosition: {},
		messagePosition: {},
		focused: { type: Boolean },
		propertyName: {},
		item: {}
	},
	emits: ["update:focused"],
	setup(__props, { emit: __emit }) {
		const { property, value, focused, visible, readonly, required, messageText, messageSeverity, updateKey, tabStop, aiSuggestion, handleAiApply, handleAiCancel } = useFormField(__props, __emit);
		return (_ctx, _cache) => {
			return unref(visible) ? (openBlock(), createBlock(unref(InputTime$1), {
				key: unref(updateKey),
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: unref(property).caption,
				"label-position": __props.labelPosition,
				placeholder: unref(property).placeholder,
				readonly: unref(readonly),
				required: unref(required),
				"message-text": unref(messageText),
				"message-severity": unref(messageSeverity),
				"message-position": __props.messagePosition,
				documentation: unref(property).documentation,
				"tab-stop": unref(tabStop),
				"ai-suggestion": unref(aiSuggestion),
				onAiApply: unref(handleAiApply),
				onAiCancel: unref(handleAiCancel)
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"placeholder",
				"readonly",
				"required",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion",
				"onAiApply",
				"onAiCancel"
			])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/FrameTab/useFrameTabCloseButton.ts
function useFrameTabCloseButton(props, emit) {
	const closeButtonVisible = computed(() => props.closeable && props.frame.closeable);
	const closeButtonDisabled = computed(() => !!props.frame.viewModel?.waitingOverlayMessage);
	const closeButtonClasses = computed(() => ({ "always-visible": props.closeButtonDisplayMode === "always" }));
	function onCloseButtonClick() {
		emit("close");
	}
	return {
		closeButtonVisible,
		closeButtonDisabled,
		closeButtonClasses,
		onCloseButtonClick
	};
}
//#endregion
//#region src/components/FrameTab/FrameTab.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = ["title"];
var _hoisted_2$7 = ["disabled"];
//#endregion
//#region src/components/FrameTab/FrameTab.vue
var FrameTab_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "FrameTab",
	props: {
		frame: {},
		mode: { default: "tabs" },
		selected: {
			type: Boolean,
			default: false
		},
		closeable: {
			type: Boolean,
			default: true
		},
		closeButtonDisplayMode: { default: "default" }
	},
	emits: ["close", "contextmenu"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const visible = computed(() => props.mode === "stack" ? props.selected : true);
		const classes = computed(() => ({
			"stack-tab": props.mode === "stack",
			"nested-tab": props.mode === "nested",
			"selected-tab": props.selected
		}));
		const icon = computed(() => props.mode === "nested" ? void 0 : props.frame.icon);
		const iconSize = computed(() => props.mode === "stack" ? "medium" : "small");
		const textSize = computed(() => props.mode === "stack" ? "large" : "small");
		const textWeight = computed(() => props.selected ? "stronger" : void 0);
		const hasChanges = computed(() => props.frame.hasChanges || props.mode !== "nested" && props.frame.children.some((t) => t.hasChanges));
		const { closeButtonVisible, closeButtonDisabled, closeButtonClasses, onCloseButtonClick } = useFrameTabCloseButton(props, emit);
		function handleMouseUp(e) {
			if (e.button === 1 && closeButtonVisible.value && !closeButtonDisabled.value) emit("close");
		}
		function handleContextMenu(event) {
			emit("contextmenu", event);
		}
		return (_ctx, _cache) => {
			return visible.value ? (openBlock(), createElementBlock("button", {
				key: 0,
				class: normalizeClass(["frame-tab", classes.value]),
				title: __props.frame.title,
				onContextmenu: handleContextMenu,
				onMouseup: handleMouseUp
			}, [
				__props.frame.busy ? (openBlock(), createBlock(unref(Spinner$1), {
					key: 0,
					class: "frame-tab-spinner",
					size: iconSize.value
				}, null, 8, ["size"])) : icon.value ? (openBlock(), createBlock(unref(Image$2), {
					key: 1,
					name: icon.value,
					size: iconSize.value,
					class: "frame-tab-icon"
				}, null, 8, ["name", "size"])) : createCommentVNode("", true),
				__props.frame.title ? (openBlock(), createBlock(unref(Text$2), {
					key: 2,
					class: "frame-tab-title",
					size: textSize.value,
					weight: textWeight.value
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(__props.frame.title), 1)]),
					_: 1
				}, 8, ["size", "weight"])) : createCommentVNode("", true),
				hasChanges.value ? (openBlock(), createBlock(unref(Image$2), {
					key: 3,
					name: "circle",
					class: "frame-tab-has-changes-icon"
				})) : createCommentVNode("", true),
				unref(closeButtonVisible) ? (openBlock(), createElementBlock("button", {
					key: 4,
					disabled: unref(closeButtonDisabled),
					class: normalizeClass(["frame-tab-close-button neos-close-button", unref(closeButtonClasses)]),
					onClick: _cache[0] || (_cache[0] = withModifiers(($event) => unref(onCloseButtonClick)(), ["stop"]))
				}, [createVNode(unref(Image$2), {
					name: "close",
					size: iconSize.value
				}, null, 8, ["size"])], 10, _hoisted_2$7)) : createCommentVNode("", true)
			], 42, _hoisted_1$11)) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-489a0ec6"]]);
//#endregion
//#region src/components/FrameContent/FrameContent.ts?vue&type=script&src=true&lang.ts
var FrameContent_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "FrameContent",
	components: {
		LoadingOverlay,
		HorizontalLayout: HorizontalLayout$1,
		VerticalLayout: VerticalLayout$1,
		FrameTab: FrameTab_default,
		ProgressIndicator,
		Text: Text$2
	},
	props: { frame: {
		type: Object,
		required: true
	} },
	setup(props) {
		const initialRoute = inject("initialRoute", void 0);
		const router = inject("router", void 0);
		const framesManager = inject("framesManager", void 0);
		const containerViewModel = useViewModel(false);
		const isMainFrameVisible = computed(() => props.frame.ready && props.frame.activeChildFrameIndex === -1);
		const displayNestedTabs = computed(() => props.frame.childMode === FrameDisplayMode.nestedTab && props.frame.children.length > 0);
		function closeNestedTab(frame) {
			framesManager.closeFrameAsync(frame);
		}
		function handleViewReady(frame) {
			frame.ready = true;
		}
		watch(() => props.frame.viewModel, () => {
			const frame = props.frame;
			frame.containerFrame = containerViewModel?.ownerFrame;
			if (frame.displayMode === FrameDisplayMode.page && initialRoute.single) router.pushFrame(frame, true);
		}, { once: true });
		const initialized = ref(false);
		watch(() => props.frame.viewModel?.initialized, (v) => initialized.value = v ?? false, { flush: "post" });
		const isIdle = ref(false);
		watch(() => props.frame.viewModel?.isIdleAfterInitialization, (v) => isIdle.value = v ?? false, { flush: "post" });
		const waitingOverlayMessage = ref();
		watch(() => props.frame.viewModel?.waitingOverlayMessage, (v) => waitingOverlayMessage.value = v);
		return {
			isMainFrameVisible,
			displayNestedTabs,
			initialized,
			closeNestedTab,
			handleViewReady,
			waitingOverlayMessage,
			isIdle
		};
	}
});
//#endregion
//#region src/components/FrameContent/FrameContent.vue
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_LoadingOverlay = resolveComponent("LoadingOverlay");
	const _component_FrameTab = resolveComponent("FrameTab");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_ProgressIndicator = resolveComponent("ProgressIndicator");
	const _component_FrameContent = resolveComponent("FrameContent", true);
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		class: "frame-content-wrapper neos-fill-parent-height",
		space: "none",
		"data-initialized": _ctx.initialized,
		"data-frame-idle": _ctx.isIdle
	}, {
		default: withCtx(() => [
			createVNode(_component_LoadingOverlay, {
				message: _ctx.waitingOverlayMessage,
				"focus-trap": ""
			}, null, 8, ["message"]),
			_ctx.displayNestedTabs ? (openBlock(), createBlock(_component_HorizontalLayout, {
				key: 0,
				space: "none",
				class: "nested-frames-container-header"
			}, {
				default: withCtx(() => [createVNode(_component_FrameTab, {
					frame: _ctx.frame,
					selected: _ctx.frame.selectedNestedTabIndex === -1,
					closeable: false,
					mode: "nested",
					onClick: _cache[0] || (_cache[0] = ($event) => _ctx.frame.setNestedTabIndex(-1))
				}, null, 8, ["frame", "selected"]), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.frame.children, (childFrame, index) => {
					return openBlock(), createBlock(_component_FrameTab, {
						key: childFrame.guid,
						frame: childFrame,
						selected: _ctx.frame.selectedNestedTabIndex === index,
						mode: "nested",
						class: "with-divider",
						onClick: ($event) => _ctx.frame.setNestedTabIndex(index),
						onClose: ($event) => _ctx.closeNestedTab(childFrame)
					}, null, 8, [
						"frame",
						"selected",
						"onClick",
						"onClose"
					]);
				}), 128))]),
				_: 1
			})) : createCommentVNode("", true),
			!_ctx.frame.ready ? (openBlock(), createBlock(_component_ProgressIndicator, {
				key: 1,
				class: "frame-content-loading"
			})) : createCommentVNode("", true),
			(openBlock(), createBlock(resolveDynamicComponent(_ctx.frame.component), {
				frame: _ctx.frame,
				visible: _ctx.isMainFrameVisible,
				class: "frame-content",
				onViewReady: _cache[1] || (_cache[1] = () => _ctx.handleViewReady(_ctx.frame))
			}, null, 40, ["frame", "visible"])),
			(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.frame.children, (childFrame, index) => {
				return withDirectives((openBlock(), createBlock(_component_FrameContent, {
					key: childFrame.guid,
					frame: childFrame
				}, null, 8, ["frame"])), [[vShow, _ctx.frame.activeChildFrameIndex === index]]);
			}), 128))
		]),
		_: 1
	}, 8, ["data-initialized", "data-frame-idle"]);
}
var FrameContent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FrameContent_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$14], ["__scopeId", "data-v-f534003a"]]);
//#endregion
//#region src/components/FramesContainer/useFramesContainerDragAndDrop.ts
function useFramesContainerDragAndDrop(framesManager, tabs, selectedTabIndex, onTabMoved) {
	const draggedTab = shallowRef();
	const dragOverTab = shallowRef();
	const dropPosition = shallowRef();
	function handleTabDragStart(event, tab) {
		draggedTab.value = tab;
		if (event.dataTransfer) {
			event.dataTransfer.effectAllowed = "move";
			event.dataTransfer.setData("text/plain", tab.guid);
		}
	}
	function canDropTab(targetTab) {
		return !!draggedTab.value && tabs.value.includes(draggedTab.value) && framesManager.canMoveTab(draggedTab.value, targetTab);
	}
	function getTabDragClasses(tab) {
		return {
			"dragging-tab": draggedTab.value === tab,
			"drop-target-forbidden": dragOverTab.value === tab && draggedTab.value !== tab && !canDropTab(tab)
		};
	}
	function isTabDropIndicatorVisible(tab, position) {
		return dragOverTab.value === tab && dropPosition.value === position;
	}
	function clearTabDropTarget() {
		dragOverTab.value = void 0;
		dropPosition.value = void 0;
	}
	function resetTabDragState() {
		draggedTab.value = void 0;
		clearTabDropTarget();
	}
	function handleTabDragOver(event, targetTab) {
		dragOverTab.value = targetTab;
		const tab = draggedTab.value;
		if (tab && canDropTab(targetTab)) {
			dropPosition.value = tabs.value.indexOf(tab) < tabs.value.indexOf(targetTab) ? "after" : "before";
			event.preventDefault();
			if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
		} else {
			dropPosition.value = void 0;
			if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
		}
	}
	function handleTabDragLeave(event, tab) {
		if (event.currentTarget instanceof HTMLElement && event.relatedTarget instanceof Node && event.currentTarget.contains(event.relatedTarget)) return;
		if (dragOverTab.value === tab) clearTabDropTarget();
	}
	async function handleTabDrop(event, targetTab) {
		const tab = draggedTab.value;
		if (!tab || !canDropTab(targetTab)) {
			resetTabDragState();
			return;
		}
		event.preventDefault();
		const previousTabs = [...tabs.value];
		const previouslySelectedTab = tabs.value[selectedTabIndex.value];
		const tabMoved = framesManager.moveTab(tab, targetTab);
		if (tabMoved) selectedTabIndex.value = tabs.value.indexOf(previouslySelectedTab);
		resetTabDragState();
		if (tabMoved && await onTabMoved?.(tab) === false) {
			tabs.value.splice(0, tabs.value.length, ...previousTabs);
			selectedTabIndex.value = previousTabs.indexOf(previouslySelectedTab);
		}
	}
	function handleTabDragEnd() {
		resetTabDragState();
	}
	return {
		getTabDragClasses,
		handleTabDragEnd,
		handleTabDragLeave,
		handleTabDragOver,
		handleTabDragStart,
		handleTabDrop,
		isTabDropIndicatorVisible
	};
}
//#endregion
//#region src/components/FramesContainer/useFramesContainerDropdownMenu.ts
function useFramesContainerDropdownMenu(tabs, selectedTab, selectTab, closeFrame) {
	const { translate } = useGlobalResourceManager();
	const closeableTabs = computed(() => tabs.value.filter((tab) => tab.closeable));
	const dropdownMenu = ref();
	const dropdownMenuItems = computed(() => {
		if (closeableTabs.value.length === 0) return [];
		return [
			{
				label: translate("CloseAllTabs"),
				icon: "closeTabs",
				async command() {
					dropdownMenu.value.hide();
					closeAllTabs(true);
				}
			},
			{
				label: translate("CloseOtherTabs"),
				icon: "empty",
				async command() {
					dropdownMenu.value.hide();
					closeAllTabs(false);
				}
			},
			{ separator: true },
			...closeableTabs.value.map((tab) => ({
				tab,
				label: tab.title,
				icon: tab.icon ?? void 0,
				hasChanges: tab.hasChanges,
				weight: tab === selectedTab.value ? "stronger" : void 0,
				class: tab === selectedTab.value ? "selected-tab" : void 0,
				async command() {
					dropdownMenu.value.hide();
					selectTab(tab);
				}
			}))
		];
	});
	function handleDropdownButtonClick(event) {
		dropdownMenu.value.toggle(event);
	}
	async function closeAllTabs(removeCurrent) {
		const currentTab = selectedTab.value;
		for (const tab of tabs.value) {
			if (!removeCurrent && currentTab === tab) continue;
			if (tab.hasChanges) selectTab(tab);
			await closeFrame(tab);
		}
	}
	async function closeFrameByDropdown(frame) {
		await closeFrame(frame);
		if (dropdownMenu.value && closeableTabs.value.length === 0) dropdownMenu.value.hide();
	}
	return {
		dropdownMenu,
		dropdownMenuItems,
		closeFrameByDropdown,
		handleDropdownButtonClick
	};
}
//#endregion
//#region src/components/FramesContainer/useFramesContainerInitialNavigation.ts
function useFramesContainerInitialNavigation(framesManager, tabs, selectedTabIndex, isMainFramesContainer, openStartupTabs) {
	const viewModel = useViewModel(false);
	const initialRoute = inject("initialRoute", RouteInfo.empty);
	const preventSelectTabOnAdd = ref(false);
	async function onMountedCallback() {
		if (!isMainFramesContainer.value) return;
		let initialTab;
		preventSelectTabOnAdd.value = true;
		try {
			await openStartupTabs();
			const navigationOptions = initialRoute.toNavigationOptions();
			if (navigationOptions && framesManager.checkCanNavigate(navigationOptions)) {
				navigationOptions.delegateToVsCode = false;
				initialTab = await framesManager.openFrame(navigationOptions);
			}
		} finally {
			preventSelectTabOnAdd.value = false;
		}
		selectedTabIndex.value = initialTab ? tabs.value.indexOf(initialTab) : 0;
		const selectedTab = tabs.value[selectedTabIndex.value];
		if (selectedTab) selectedTab.activated = true;
	}
	if (viewModel && !viewModel.initialized) watch(() => viewModel.initialized, onMountedCallback, { once: true });
	else onMounted(onMountedCallback);
	return { preventSelectTabOnAdd };
}
//#endregion
//#region src/composables/useApiClient.ts
function provideApiClient(apiClient) {
	provide("apiClient", apiClient);
	return apiClient;
}
function useApiClient() {
	const apiClient = inject("apiClient");
	if (!apiClient) throw new Error("ApiClient not provided");
	return apiClient;
}
//#endregion
//#region src/components/FramesContainer/useFramesContainerStartupTabs.ts
function useFramesContainerStartupTabs(framesManager, tabs, isMainFramesContainer) {
	const applicationContext = useApplicationContext();
	const apiClient = useApiClient();
	const eventManager = useEventManager(false);
	const canHaveStartupTabs = computed(() => isMainFramesContainer.value && applicationContext.has("UserStartupTabs"));
	const startupTabs = computed({
		get: () => applicationContext.getValue("UserStartupTabs", []),
		set: (tabs) => applicationContext.set("UserStartupTabs", tabs)
	});
	async function openStartupTabs() {
		for (const startupTab of startupTabs.value) {
			const navigationOptions = Router.createRouteInfo(startupTab.route).toNavigationOptions();
			if (navigationOptions && framesManager.checkCanNavigate(navigationOptions)) {
				navigationOptions.startupTabMetadata = startupTab;
				await framesManager.openFrame(navigationOptions);
			}
		}
	}
	async function toggleStartupTab(frame) {
		if (frame.startupTabPending) return;
		frame.startupTabPending = true;
		if (isStartupTab(frame)) await unsetAsStartupTab(frame);
		else await setAsStartupTab(frame);
		frame.startupTabPending = false;
	}
	function isStartupTab(frame) {
		return !!frame.startupTabMetadata && startupTabs.value.some((startupTab) => startupTab.route === frame.startupTabMetadata.route);
	}
	async function unsetAsStartupTab(frame) {
		if (!await saveStartupTabs(startupTabs.value.filter((startupTab) => startupTab.route !== frame.startupTabMetadata?.route))) return false;
		frame.startupTabMetadata = void 0;
		return true;
	}
	async function setAsStartupTab(frame) {
		const startupTabMetadata = {
			route: Router.getFrameRoute(frame),
			title: frame.title || void 0,
			icon: frame.icon || void 0
		};
		if (!await saveStartupTabs([...startupTabs.value, startupTabMetadata])) return false;
		frame.startupTabMetadata = startupTabMetadata;
		return true;
	}
	function persistStartupTabs() {
		const openStartupTabs = tabs.value.filter(isStartupTab).map((tab) => tab.startupTabMetadata);
		const openStartupTabRoutes = new Set(openStartupTabs.map((tab) => tab.route));
		let openStartupTabIndex = 0;
		return saveStartupTabs(startupTabs.value.map((startupTab) => openStartupTabRoutes.has(startupTab.route) ? openStartupTabs[openStartupTabIndex++] : startupTab));
	}
	async function saveStartupTabs(updatedStartupTabs) {
		try {
			await apiClient.putAsync({
				path: "users/settings/startup-tabs",
				data: updatedStartupTabs
			});
		} catch (error) {
			console.error("Failed to update startup tabs:", error);
			eventManager?.emit("viewModel:showError", error);
			return false;
		}
		startupTabs.value = updatedStartupTabs;
		return true;
	}
	return {
		canHaveStartupTabs,
		startupTabs,
		openStartupTabs,
		persistStartupTabs,
		isStartupTab,
		toggleStartupTab
	};
}
//#endregion
//#region src/components/FramesContainer/useFramesContainerTabContextMenu.ts
function useFramesContainerTabContextMenu(closeFrame, canHaveStartupTabs, isStartupTab, toggleStartupTab) {
	const { translate } = useGlobalResourceManager();
	const tabContextMenu = ref();
	const tabContextMenuItems = ref([]);
	function handleTabContextMenu(event, tab) {
		tabContextMenuItems.value = createContextTabMenuItems(tab);
		if (tabContextMenuItems.value.length === 0) return;
		event.preventDefault();
		tabContextMenu.value.show(event);
	}
	function createContextTabMenuItems(tab) {
		const items = [];
		if (tab.closeable) items.push({
			label: translate("Close"),
			icon: "close",
			disabled: !!tab.viewModel?.waitingOverlayMessage,
			async command() {
				tabContextMenu.value.hide();
				await closeFrame(tab);
			}
		});
		if (canHaveStartupTabs.value && tab.parameters.size === 0) {
			if (items.length > 0) items.push({ separator: true });
			items.push({
				label: translate(isStartupTab(tab) ? "DoNotOpenAtStartup" : "OpenAtStartup"),
				icon: "empty",
				disabled: tab.startupTabPending,
				async command() {
					tabContextMenu.value.hide();
					await toggleStartupTab(tab);
				}
			});
		}
		return items;
	}
	return {
		handleTabContextMenu,
		tabContextMenu,
		tabContextMenuItems
	};
}
//#endregion
//#region src/components/FramesContainer/FramesContainer.ts?vue&type=script&src=true&lang.ts
var FramesContainer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "FramesContainer",
	components: {
		Button: Button$1,
		ContextMenu,
		DropdownMenu,
		FrameContent: FrameContent_default,
		FrameTab: FrameTab_default,
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		Text: Text$2
	},
	props: {
		containerId: {
			type: String,
			default: void 0
		},
		mode: {
			type: String,
			default: "tabs"
		},
		modelValue: {
			type: Array,
			default: void 0
		},
		selectedTabIndex: {
			type: Number,
			default: void 0
		},
		tabCloseButtonDisplayMode: {
			type: String,
			default: "default"
		}
	},
	emits: ["update:modelValue", "update:selectedTabIndex"],
	setup(props, { slots, emit }) {
		const uniqueId = createGuid();
		const mainFramesContainerId = inject("mainFramesContainerId", void 0);
		const router = inject("router", {});
		const framesManager = inject("framesManager", {});
		const internalSelectedTabIndex = ref(-1);
		const computedSelectedTabIndex = computed({
			get: () => props.selectedTabIndex ?? internalSelectedTabIndex.value,
			set: (value) => {
				if (props.selectedTabIndex !== void 0) emit("update:selectedTabIndex", value);
				else internalSelectedTabIndex.value = value;
			}
		});
		const tabs = computed(() => framesManager.tabs.filter(isTargetContainer));
		const displayHeader = computed(() => tabs.value.length > 0 || props.mode === "tabs" && slots.actions);
		const isMainFramesContainer = computed(() => mainFramesContainerId === props.containerId);
		const selectedTab = computed(() => tabs.value[computedSelectedTabIndex.value]);
		const loading = computed(() => selectedTab.value ? selectedTab.value.loading : false);
		useComponentAutomationProperties();
		if (props.modelValue && props.containerId) framesManager.setFramesProvidedByContainer(props.containerId, toRef(props, "modelValue"));
		onBeforeMount(() => {
			framesManager.registerTabContainer(uniqueId);
			framesManager.subscribe("selectTab", selectTab);
			framesManager.subscribe("frameAdded", frameAdded);
			framesManager.subscribe("frameRemoving", frameRemoving);
		});
		onUnmounted(() => {
			framesManager.unSubscribe("selectTab", selectTab);
			framesManager.unSubscribe("frameAdded", frameAdded);
			framesManager.unSubscribe("frameRemoving", frameRemoving);
			framesManager.unregisterTabContainer(uniqueId);
			if (props.containerId) framesManager.unsetFramesProvidedByContainer(props.containerId);
		});
		const { canHaveStartupTabs, isStartupTab, openStartupTabs, persistStartupTabs, toggleStartupTab } = useFramesContainerStartupTabs(framesManager, tabs, isMainFramesContainer);
		const { preventSelectTabOnAdd } = useFramesContainerInitialNavigation(framesManager, tabs, computedSelectedTabIndex, isMainFramesContainer, openStartupTabs);
		const { getTabDragClasses, handleTabDragEnd, handleTabDragLeave, handleTabDragOver, handleTabDragStart, handleTabDrop, isTabDropIndicatorVisible } = useFramesContainerDragAndDrop(framesManager, tabs, computedSelectedTabIndex, onTabMoved);
		const { dropdownMenu, dropdownMenuItems, handleDropdownButtonClick, closeFrameByDropdown } = useFramesContainerDropdownMenu(tabs, selectedTab, selectTab, closeFrame);
		const { handleTabContextMenu, tabContextMenu, tabContextMenuItems } = useFramesContainerTabContextMenu(closeFrame, canHaveStartupTabs, isStartupTab, toggleStartupTab);
		watch(() => selectedTab.value?.viewModel, (viewModel) => {
			if (!isMainFramesContainer.value) return;
			framesManager.activeTab = selectedTab.value;
			if (viewModel) router.pushFrame(selectedTab.value, true);
			else if (!selectedTab.value) router.pushQuery("", false);
		});
		function selectTab(tab) {
			if (isTargetContainer(tab)) {
				tab.activated = true;
				computedSelectedTabIndex.value = tabs.value.indexOf(tab);
			}
		}
		async function closeFrame(tab) {
			await framesManager.closeFrameAsync(tab);
		}
		function frameAdded(tab) {
			if (!preventSelectTabOnAdd.value && isTargetContainer(tab)) computedSelectedTabIndex.value = tabs.value.indexOf(tab);
		}
		function frameRemoving(tab) {
			if (isTargetContainer(tab)) {
				const tabIndex = tabs.value.findIndex((t) => t.guid === tab.guid);
				if (tabIndex === -1) return;
				const nextSelectedTabIndex = framesManager.setSelectedIndexBeforeRemove(computedSelectedTabIndex.value, tabIndex, tabs.value.length);
				computedSelectedTabIndex.value = nextSelectedTabIndex;
				const nextSelectedTabIndexBeforeRemoval = nextSelectedTabIndex + (tabIndex <= nextSelectedTabIndex ? 1 : 0);
				const nextSelectedTab = tabs.value[nextSelectedTabIndexBeforeRemoval];
				if (nextSelectedTab) nextSelectedTab.activated = true;
			}
		}
		function isTargetContainer(tab) {
			return tab.containerId === props.containerId || tab.containerId === void 0 && props.containerId === mainFramesContainerId;
		}
		async function onTabMoved(tab) {
			return isStartupTab(tab) ? persistStartupTabs() : true;
		}
		return {
			closeFrame,
			closeFrameByDropdown,
			computedSelectedTabIndex,
			displayHeader,
			dropdownMenu,
			dropdownMenuItems,
			getTabDragClasses,
			handleDropdownButtonClick,
			handleTabContextMenu,
			handleTabDragEnd,
			handleTabDragLeave,
			handleTabDragOver,
			handleTabDragStart,
			handleTabDrop,
			isTabDropIndicatorVisible,
			loading,
			selectTab,
			tabContextMenu,
			tabContextMenuItems,
			tabs
		};
	}
});
//#endregion
//#region src/components/FramesContainer/FramesContainer.vue
var _hoisted_1$10 = { class: "frames-container" };
var _hoisted_2$6 = {
	key: 0,
	class: "frame-tab-drop-indicator frame-tab-drop-indicator-before"
};
var _hoisted_3$5 = {
	key: 1,
	class: "frame-tab-drop-indicator frame-tab-drop-indicator-after"
};
var _hoisted_4$3 = {
	key: 1,
	style: { "width": "var(--image-small-size)" },
	class: "dropdown-menu-item-image"
};
var _hoisted_5$2 = ["onClick"];
var _hoisted_6 = ["data-loading"];
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_FrameTab = resolveComponent("FrameTab");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Button = resolveComponent("Button");
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_DropdownMenu = resolveComponent("DropdownMenu");
	const _component_ContextMenu = resolveComponent("ContextMenu");
	const _component_FrameContent = resolveComponent("FrameContent");
	return openBlock(), createElementBlock("div", _hoisted_1$10, [_ctx.displayHeader ? (openBlock(), createBlock(_component_HorizontalLayout, {
		key: 0,
		class: "frames-container-header",
		wrap: false,
		space: "none"
	}, {
		default: withCtx(() => [
			createVNode(_component_HorizontalLayout, {
				space: "none",
				class: "frames-container-header-tabs neos-fill-parent-width",
				wrap: false
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab, index) => {
					return openBlock(), createElementBlock(Fragment, { key: tab.guid }, [
						_ctx.isTabDropIndicatorVisible(tab, "before") ? (openBlock(), createElementBlock("div", _hoisted_2$6)) : createCommentVNode("", true),
						createVNode(_component_FrameTab, {
							class: normalizeClass(_ctx.getTabDragClasses(tab)),
							draggable: _ctx.mode === "tabs",
							frame: tab,
							mode: _ctx.mode,
							selected: _ctx.computedSelectedTabIndex === index,
							"close-button-display-mode": _ctx.tabCloseButtonDisplayMode,
							onClick: ($event) => _ctx.selectTab(tab),
							onClose: ($event) => _ctx.closeFrame(tab),
							onContextmenu: ($event) => _ctx.handleTabContextMenu($event, tab),
							onDragend: _ctx.handleTabDragEnd,
							onDragleave: ($event) => _ctx.handleTabDragLeave($event, tab),
							onDragover: ($event) => _ctx.handleTabDragOver($event, tab),
							onDragstart: ($event) => _ctx.handleTabDragStart($event, tab),
							onDrop: ($event) => _ctx.handleTabDrop($event, tab)
						}, null, 8, [
							"class",
							"draggable",
							"frame",
							"mode",
							"selected",
							"close-button-display-mode",
							"onClick",
							"onClose",
							"onContextmenu",
							"onDragend",
							"onDragleave",
							"onDragover",
							"onDragstart",
							"onDrop"
						]),
						_ctx.isTabDropIndicatorVisible(tab, "after") ? (openBlock(), createElementBlock("div", _hoisted_3$5)) : createCommentVNode("", true),
						_cache[0] || (_cache[0] = createElementVNode("div", { class: "frame-tab-divider" }, null, -1))
					], 64);
				}), 128))]),
				_: 1
			}),
			_ctx.mode === "tabs" ? (openBlock(), createBlock(_component_HorizontalLayout, {
				key: 0,
				space: "extrasmall",
				wrap: false,
				class: "frames-container-header-actions",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [
					_ctx.dropdownMenuItems.length ? (openBlock(), createBlock(_component_Button, {
						key: 0,
						class: "frames-container-dropdown-menu-button",
						icon: "chevronDown",
						variant: "link",
						onClick: _ctx.handleDropdownButtonClick
					}, null, 8, ["onClick"])) : createCommentVNode("", true),
					createVNode(_component_DropdownMenu, {
						ref: "dropdownMenu",
						items: _ctx.dropdownMenuItems,
						size: "small",
						class: "frames-container-dropdown-menu"
					}, {
						item: withCtx(({ item, props }) => [item.tab ? (openBlock(), createBlock(_component_HorizontalLayout, mergeProps({
							key: 0,
							"vertical-align": "center",
							wrap: false,
							title: item.label,
							class: ["frames-container-dropdown-menu-item", item.class]
						}, {
							...props.action,
							...item.attributes
						}), {
							default: withCtx(() => [createVNode(_component_HorizontalLayout, {
								class: "neos-fill-parent-width",
								"vertical-align": "center",
								wrap: false
							}, {
								default: withCtx(() => [
									item.icon ? (openBlock(), createBlock(_component_Image, {
										key: 0,
										name: item.icon,
										size: "small",
										class: "dropdown-menu-item-image"
									}, null, 8, ["name"])) : (openBlock(), createElementBlock("div", _hoisted_4$3)),
									createVNode(_component_Text, {
										weight: item.weight,
										"max-lines": 1
									}, {
										default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1)]),
										_: 2
									}, 1032, ["weight"]),
									item.hasChanges ? (openBlock(), createBlock(_component_Image, {
										key: 2,
										name: "circle",
										size: "extrasmall",
										class: "frame-tab-has-changes-icon"
									})) : createCommentVNode("", true)
								]),
								_: 2
							}, 1024), createElementVNode("button", {
								class: "frame-tab-close-button neos-close-button",
								onClick: withModifiers(($event) => _ctx.closeFrameByDropdown(item.tab), ["stop"])
							}, [createVNode(_component_Image, {
								name: "close",
								size: "small"
							})], 8, _hoisted_5$2)]),
							_: 2
						}, 1040, ["title", "class"])) : createCommentVNode("", true)]),
						_: 1
					}, 8, ["items"]),
					renderSlot(_ctx.$slots, "actions", {}, void 0, true)
				]),
				_: 3
			})) : createCommentVNode("", true),
			createVNode(_component_ContextMenu, {
				ref: "tabContextMenu",
				items: _ctx.tabContextMenuItems,
				size: "small"
			}, null, 8, ["items"])
		]),
		_: 3
	})) : createCommentVNode("", true), createElementVNode("div", {
		class: "frames-container-content neos-vertical-content",
		"data-loading": _ctx.loading
	}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab, index) => {
		return openBlock(), createElementBlock(Fragment, { key: tab.guid }, [tab.activated ? withDirectives((openBlock(), createBlock(_component_FrameContent, {
			key: 0,
			frame: tab
		}, null, 8, ["frame"])), [[vShow, _ctx.computedSelectedTabIndex === index]]) : createCommentVNode("", true)], 64);
	}), 128))], 8, _hoisted_6)]);
}
var FramesContainer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FramesContainer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$13], ["__scopeId", "data-v-bd69d773"]]);
//#endregion
//#region src/components/GlobalSearchResult/GlobalSearchResult.ts?vue&type=script&src=true&lang.ts
var GlobalSearchResult_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GlobalSearchResult",
	components: {
		Image: Image$2,
		Text: Text$2
	},
	props: {
		mode: {
			type: String,
			default: "inline"
		},
		result: {
			type: Array,
			default: void 0
		},
		isSearching: {
			type: Boolean,
			default: false
		}
	},
	emits: ["itemSelected", "escape"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const eventManager = useEventManager();
		const { mode, result, isSearching } = toRefs(props);
		const offset = computed(() => mode.value === "modal" ? 4 : 0);
		const resultHeight = useSearchModalResultHeight(result, offset);
		const { selectedElement, selectedItem, handleItemElementCreated, handleItemSelected } = useSearchModalItem(eventManager, result, isSearching, () => emit("itemSelected"));
		const highlightY = useGlobalSearchHighlightItem(result, offset, selectedElement);
		useEventListener(document, "keydown", (event) => {
			if (event.key === "Escape") {
				event.preventDefault();
				emit("escape");
			}
		});
		function getItemTooltip(item) {
			let tooltip = item.caption;
			if (item.description) tooltip += ` [${item.description}]`;
			return tooltip;
		}
		return {
			translate,
			resultHeight,
			selectedItem,
			highlightY,
			handleItemElementCreated,
			handleItemSelected,
			getItemTooltip
		};
	}
});
function useSearchModalResultHeight(result, offset) {
	return computed(() => {
		if (!result.value) return 0;
		if (result.value.length === 0) return 30;
		return result.value.reduce((height, group, index) => {
			height += group.caption ? 24 + offset.value : 0;
			height += group.items.reduce((h) => h + 36 + offset.value, 0);
			height += index === result.value.length - 1 ? 10 : 32;
			return height;
		}, 0);
	});
}
function useSearchModalItem(eventManager, result, isSearching, emitItemSelected) {
	const elementItemMap = /* @__PURE__ */ new Map();
	const selectedElement = ref();
	const selectedItem = computed(() => selectedElement.value && elementItemMap.get(selectedElement.value));
	watch(result, () => {
		elementItemMap.clear();
		selectedElement.value = void 0;
	});
	useEventListener(document, "keydown", (event) => {
		if (event.key === "ArrowUp" || event.shiftKey && event.key === "Tab") {
			event.preventDefault();
			selectSiblingElement("previous");
			return;
		}
		if (event.key === "ArrowDown" || !event.shiftKey && event.key === "Tab") {
			event.preventDefault();
			selectSiblingElement("next");
			return;
		}
		if (event.key === "Enter" && selectedItem.value && !isSearching.value) {
			event.preventDefault();
			handleItemSelected(selectedItem.value);
		}
	});
	function handleItemElementCreated(element, item) {
		elementItemMap.set(element, item);
		selectedElement.value ??= element;
	}
	function selectSiblingElement(direction) {
		if (selectedElement.value) {
			let siblingElement;
			const siblingProperty = `${direction}ElementSibling`;
			if (selectedElement.value[siblingProperty]) siblingElement = selectedElement.value[siblingProperty];
			else siblingElement = (selectedElement.value.parentElement.parentElement[siblingProperty]?.lastElementChild)?.[`${direction === "previous" ? "last" : "first"}ElementChild`];
			if (siblingElement) {
				selectedElement.value = siblingElement;
				selectedElement.value.scrollIntoView({ block: "nearest" });
			}
		}
	}
	function handleItemSelected(item) {
		if (item.menuItem) item.menuItem.execute();
		if (item.uiViewName) navigate(eventManager, new NavigationOptions(item.uiViewName).withNewParameters(new NavigationParameters(item.parameters)).withId(item.itemId).withFrameId(item.frameId));
		emitItemSelected(item);
	}
	return {
		selectedElement,
		selectedItem,
		handleItemElementCreated,
		handleItemSelected
	};
}
function useGlobalSearchHighlightItem(result, offset, selectedElement) {
	const { x, y } = useMouse({ type: "client" });
	const highlightY = computed(() => {
		if (selectedElement.value) return selectedElement.value.offsetTop;
		if (result.value && result.value[0] && result.value[0].caption) return 20 + offset.value;
		return 0;
	});
	watch([x, y], () => {
		const element = document.elementFromPoint(x.value, y.value);
		if (element && element.classList.contains("global-search-item")) selectedElement.value = element;
	});
	return highlightY;
}
//#endregion
//#region src/components/GlobalSearchResult/GlobalSearchResult.vue
var _hoisted_1$9 = ["data-mode"];
var _hoisted_2$5 = { class: "global-search-items" };
var _hoisted_3$4 = [
	"aria-selected",
	"title",
	"onClick"
];
var _hoisted_4$2 = { class: "global-search-item-image" };
var _hoisted_5$1 = {
	key: 1,
	class: "global-search-result-no-result"
};
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_Image = resolveComponent("Image");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["global-search-result", { "global-search-result-expanded": _ctx.resultHeight }]),
		style: normalizeStyle({ height: `${_ctx.resultHeight}px` }),
		"data-mode": _ctx.mode
	}, [_ctx.result && _ctx.result.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
		class: "global-search-item-highlight",
		style: normalizeStyle({ transform: `translateY(${_ctx.highlightY}px)` })
	}, null, 4), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.result, (group, groupIndex) => {
		return openBlock(), createElementBlock("div", {
			key: groupIndex,
			class: "global-search-group"
		}, [group.caption ? (openBlock(), createBlock(_component_Text, {
			key: 0,
			"max-lines": 1,
			class: "global-search-group-caption"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(group.caption), 1)]),
			_: 2
		}, 1024)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$5, [(openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item, itemIndex) => {
			return openBlock(), createElementBlock("div", {
				key: itemIndex,
				ref_for: true,
				ref: (el) => _ctx.handleItemElementCreated(el, item),
				"aria-selected": item === _ctx.selectedItem,
				class: "global-search-item",
				title: _ctx.getItemTooltip(item),
				onClick: ($event) => _ctx.handleItemSelected(item)
			}, [
				createElementVNode("div", _hoisted_4$2, [item.icon ? (openBlock(), createBlock(_component_Image, {
					key: 0,
					name: item.icon
				}, null, 8, ["name"])) : createCommentVNode("", true)]),
				createVNode(_component_Text, {
					weight: "strong",
					"max-lines": 1,
					class: "global-search-item-caption"
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(item.caption), 1)]),
					_: 2
				}, 1024),
				createVNode(_component_Text, {
					"max-lines": 1,
					class: "global-search-item-description",
					size: "extrasmall"
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(item.description), 1)]),
					_: 2
				}, 1024)
			], 8, _hoisted_3$4);
		}), 128))])]);
	}), 128))], 64)) : _ctx.result ? (openBlock(), createElementBlock("div", _hoisted_5$1, [createVNode(_component_Text, null, {
		default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate("NoResultFound")), 1)]),
		_: 1
	})])) : createCommentVNode("", true)], 14, _hoisted_1$9);
}
var GlobalSearchResult_default = /*#__PURE__*/ _plugin_vue_export_helper_default(GlobalSearchResult_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$12], ["__scopeId", "data-v-1d033c19"]]);
//#endregion
//#region src/components/GlobalSearchInput/GlobalSearchInput.ts?vue&type=script&src=true&lang.ts
var GlobalSearchInput_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GlobalSearchInput",
	components: {
		GlobalSearchResult: GlobalSearchResult_default,
		Image: Image$2,
		Spinner: Spinner$1,
		Textbox: Textbox$1
	},
	props: {
		onSearch: {
			type: Function,
			default: void 0
		},
		onKeyEnter: {
			type: Function,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		}
	},
	emits: ["close"],
	setup(props, { slots, emit }) {
		useComponentAutomationProperties();
		const applicationContext = useApplicationContext();
		const uiPermitter = useUIPermitter();
		const { globalResourceManager, translate } = useGlobalResourceManager();
		const input = ref();
		const inputValue = ref(null);
		const isSearching = ref(false);
		const result = ref(void 0);
		const resultStyle = ref({});
		const search = getGlobalSearchFunction(applicationContext.menuItems, globalResourceManager, uiPermitter, props.onSearch);
		async function performSearchAsync(newValue = inputValue.value) {
			result.value = newValue && newValue.length > 0 ? await search(newValue) : void 0;
			updateResultStyle();
			isSearching.value = false;
		}
		watch(inputValue, (newValue) => isSearching.value = newValue != null && newValue.length > 0);
		const watchStopHandle = watchDebounced(inputValue, async (newValue) => {
			await performSearchAsync(newValue);
		}, { debounce: 500 });
		onMounted(() => {
			if (!slots.default) {
				useEventListener(window, "resize", updateResultStyle);
				useEventListener(document, "keydown", handleKeydown);
				onClickOutside(input, () => reset(false), { ignore: [".global-search-result"] });
			}
			const inputElement = input.value?.$el;
			useEventListener(inputElement, "keyup", handleKeyUpAsync);
		});
		function updateResultStyle() {
			const inputElement = input.value?.$el;
			if (!slots.default && result.value && inputElement) resultStyle.value = {
				left: `${inputElement.offsetLeft}px`,
				top: `${inputElement.offsetTop + inputElement.offsetHeight + 2}px`,
				width: `auto`,
				minWidth: `${inputElement.offsetWidth}px`,
				maxWidth: `${window.innerWidth - inputElement.offsetLeft}px`
			};
		}
		function reset(resetInput = true) {
			result.value = void 0;
			if (resetInput) inputValue.value = "";
		}
		function handleKeydown(event) {
			if (event.ctrlKey && event.shiftKey && event.code === "KeyF") (input.value?.$el?.querySelector("input"))?.focus();
		}
		async function handleKeyUpAsync(event) {
			const searchText = inputValue.value;
			if (event.code === "Enter" && props.onKeyEnter && searchText) {
				event.stopPropagation();
				event.preventDefault();
				watchStopHandle();
				await performSearchAsync();
				if (props.onKeyEnter(searchText, result.value)) emit("close");
			}
		}
		return {
			translate,
			input,
			inputValue,
			isSearching,
			result,
			resultStyle,
			reset
		};
	}
});
//#endregion
//#region src/components/GlobalSearchInput/GlobalSearchInput.vue
var _hoisted_1$8 = { class: "global-search-image" };
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Spinner = resolveComponent("Spinner");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_GlobalSearchResult = resolveComponent("GlobalSearchResult");
	return openBlock(), createElementBlock("div", null, [createVNode(_component_Textbox, {
		ref: "input",
		modelValue: _ctx.inputValue,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.inputValue = $event),
		class: "global-search-input",
		placeholder: _ctx.translate("Search"),
		"update-mode": "immediate"
	}, {
		before: withCtx(() => [createElementVNode("div", _hoisted_1$8, [withDirectives(createVNode(_component_Image, {
			name: "search",
			size: _ctx.iconSize
		}, null, 8, ["size"]), [[vShow, !_ctx.isSearching]]), withDirectives(createVNode(_component_Spinner, {
			class: "global-search-spinner",
			size: _ctx.iconSize
		}, null, 8, ["size"]), [[vShow, _ctx.isSearching]])])]),
		default: withCtx(() => [renderSlot(_ctx.$slots, "after-input", {}, void 0, true)]),
		_: 3
	}, 8, ["modelValue", "placeholder"]), renderSlot(_ctx.$slots, "default", {
		result: _ctx.result,
		isSearching: _ctx.isSearching
	}, () => [_ctx.result ? (openBlock(), createBlock(Teleport, {
		key: 0,
		to: "body"
	}, [createVNode(_component_GlobalSearchResult, {
		mode: "inline",
		result: _ctx.result,
		"is-searching": _ctx.isSearching,
		style: normalizeStyle(_ctx.resultStyle),
		onItemSelected: _cache[1] || (_cache[1] = ($event) => _ctx.reset()),
		onEscape: _cache[2] || (_cache[2] = ($event) => _ctx.reset())
	}, null, 8, [
		"result",
		"is-searching",
		"style"
	])])) : createCommentVNode("", true)], true)]);
}
var GlobalSearchInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(GlobalSearchInput_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$11], ["__scopeId", "data-v-100a3205"]]);
//#endregion
//#region src/components/GlobalSearchModal/GlobalSearchModal.ts?vue&type=script&src=true&lang.ts
var GlobalSearchModal_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GlobalSearchModal",
	components: {
		Image: Image$2,
		GlobalSearchInput: GlobalSearchInput_default,
		GlobalSearchResult: GlobalSearchResult_default
	},
	props: {
		onSearch: {
			type: Function,
			default: void 0
		},
		onKeyEnter: {
			type: Function,
			default: void 0
		}
	},
	emits: ["close"],
	setup(props, { emit }) {
		const modal = ref();
		const { translate } = useGlobalResourceManager();
		useFocusTrap(modal, {
			immediate: true,
			fallbackFocus: document.createElement("div"),
			allowOutsideClick: true
		});
		onMounted(() => {
			modal.value.querySelector("input").focus();
		});
		function close() {
			emit("close");
		}
		return {
			modal,
			translate,
			close
		};
	}
});
//#endregion
//#region src/components/GlobalSearchModal/GlobalSearchModal.vue
var _hoisted_1$7 = {
	ref: "modal",
	class: "global-search-modal"
};
var _hoisted_2$4 = ["title"];
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_GlobalSearchResult = resolveComponent("GlobalSearchResult");
	const _component_Image = resolveComponent("Image");
	const _component_GlobalSearchInput = resolveComponent("GlobalSearchInput");
	return openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(Transition, {
		name: "fade",
		appear: ""
	}, {
		default: withCtx(() => [createElementVNode("div", {
			class: "global-search-modal-overlay",
			onClick: _cache[4] || (_cache[4] = withModifiers(($event) => _ctx.close(), ["self"]))
		}, [createVNode(Transition, {
			name: "zoom",
			appear: ""
		}, {
			default: withCtx(() => [createElementVNode("div", _hoisted_1$7, [createVNode(_component_GlobalSearchInput, {
				"on-search": _ctx.onSearch,
				"on-key-enter": _ctx.onKeyEnter,
				"icon-size": "large",
				onClose: _cache[3] || (_cache[3] = ($event) => _ctx.close())
			}, {
				default: withCtx(({ result, isSearching }) => [createVNode(_component_GlobalSearchResult, {
					mode: "modal",
					result,
					"is-searching": isSearching,
					onItemSelected: _cache[0] || (_cache[0] = ($event) => _ctx.close()),
					onEscape: _cache[1] || (_cache[1] = ($event) => _ctx.close())
				}, null, 8, ["result", "is-searching"])]),
				"after-input": withCtx(() => [createElementVNode("button", {
					class: "global-search-modal-close-button",
					title: _ctx.translate("Close"),
					onClick: _cache[2] || (_cache[2] = ($event) => _ctx.close())
				}, [createVNode(_component_Image, {
					name: "close",
					size: "large"
				})], 8, _hoisted_2$4)]),
				_: 1
			}, 8, ["on-search", "on-key-enter"])], 512)]),
			_: 1
		})])]),
		_: 1
	})]);
}
var GlobalSearchModal_default = /*#__PURE__*/ _plugin_vue_export_helper_default(GlobalSearchModal_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$10], ["__scopeId", "data-v-49f39cd0"]]);
//#endregion
//#region src/components/GlobalSearchButton/GlobalSearchButton.vue
var GlobalSearchButton_default = /* @__PURE__ */ defineComponent({
	__name: "GlobalSearchButton",
	props: {
		label: {
			type: [Boolean, String],
			default: true
		},
		onSearch: {
			type: Function,
			default: void 0
		},
		onKeyEnter: {
			type: Function,
			default: void 0
		}
	},
	setup(__props) {
		const props = __props;
		const open = ref(false);
		const { translate } = useGlobalResourceManager();
		const buttonLabel = computed(() => {
			if (typeof props.label === "string") return props.label;
			return props.label ? translate("Search") : void 0;
		});
		useEventListener(document, "keydown", handleKeydown);
		function handleKeydown(event) {
			if (event.ctrlKey && event.shiftKey && event.code === "KeyF") openModal();
		}
		function openModal() {
			open.value = true;
		}
		function closeModal() {
			open.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Button$1), {
				variant: "link",
				class: "global-search-button",
				onClick: _cache[1] || (_cache[1] = ($event) => openModal())
			}, {
				default: withCtx(() => [
					createVNode(unref(Image$2), { name: "search" }),
					buttonLabel.value ? (openBlock(), createBlock(unref(Text$2), { key: 0 }, {
						default: withCtx(() => [createTextVNode(toDisplayString(buttonLabel.value), 1)]),
						_: 1
					})) : createCommentVNode("", true),
					open.value ? (openBlock(), createBlock(GlobalSearchModal_default, {
						key: 1,
						"on-search": __props.onSearch,
						"on-key-enter": __props.onKeyEnter,
						onClose: _cache[0] || (_cache[0] = ($event) => closeModal())
					}, null, 8, ["on-search", "on-key-enter"])) : createCommentVNode("", true)
				]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/IdentifiedModal/IdentifiedModal.vue
var IdentifiedModal_default = /* @__PURE__ */ defineComponent({
	__name: "IdentifiedModal",
	props: { overlayId: {} },
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		const isOpen = ref(false);
		viewModel.eventManager.on("overlay:toggle", handleOverlayToggle);
		onUnmounted(() => {
			viewModel.eventManager.off("overlay:toggle", handleOverlayToggle);
		});
		function handleOverlayToggle(args) {
			if (viewModel === args.viewModel && props.overlayId === args.options.id) isOpen.value = args.options.state ?? !isOpen.value;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Modal$1), {
				"is-open": isOpen.value,
				"onUpdate:isOpen": _cache[0] || (_cache[0] = ($event) => isOpen.value = $event)
			}, createSlots({ _: 2 }, [
				_ctx.$slots.header ? {
					name: "header",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
					key: "0"
				} : void 0,
				_ctx.$slots.body ? {
					name: "body",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "body")]),
					key: "1"
				} : void 0,
				_ctx.$slots.footer ? {
					name: "footer",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
					key: "2"
				} : void 0
			]), 1032, ["is-open"]);
		};
	}
});
//#endregion
//#region src/components/IdentifiedPopover/IdentifiedPopover.vue
var IdentifiedPopover_default = /* @__PURE__ */ defineComponent({
	__name: "IdentifiedPopover",
	props: { overlayId: {} },
	setup(__props) {
		const props = __props;
		const viewModel = useViewModel();
		const popoverElement = useTemplateRef("popover");
		viewModel.eventManager.on("overlay:toggle", handleOverlayToggle);
		onUnmounted(() => {
			viewModel.eventManager.off("overlay:toggle", handleOverlayToggle);
		});
		function handleOverlayToggle(args) {
			if (popoverElement.value && viewModel === args.viewModel && props.overlayId === args.options.id) {
				const event = args.options.event ?? { currentTarget: args.options.target };
				if (args.options.state === true) popoverElement.value.show(event);
				else if (args.options.state === false) popoverElement.value.hide();
				else popoverElement.value.toggle(event);
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Popover), { ref: "popover" }, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/PaginationBar/PaginationBar.ts?vue&type=script&src=true&lang.ts
var PaginationBar_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "PaginationBar",
	components: { InnerPaginationBar: PaginationBar },
	props: { alwaysDisplay: {
		type: Boolean,
		defaultValue: false
	} },
	setup(props) {
		const viewModel = useViewModel();
		const pageNumber = computed({
			get: () => viewModel.pageNumber,
			set: (value) => viewModel.moveToSpecificPage(value)
		});
		const recordsByPage = computed({
			get: () => viewModel.recordsByPage,
			set: (value) => {
				viewModel.recordsByPage = value;
				viewModel.loadDataAsync();
			}
		});
		const showPaginationBar = ref(props.alwaysDisplay);
		watch([() => props.alwaysDisplay, () => viewModel.totalRecordCount], () => {
			showPaginationBar.value = props.alwaysDisplay || viewModel.totalRecordCount > viewModel.recordsByPage;
		});
		return {
			viewModel,
			pageNumber,
			recordsByPage,
			showPaginationBar
		};
	}
});
//#endregion
//#region src/components/PaginationBar/PaginationBar.vue
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InnerPaginationBar = resolveComponent("InnerPaginationBar");
	return _ctx.showPaginationBar ? (openBlock(), createBlock(_component_InnerPaginationBar, {
		key: 0,
		"page-number": _ctx.pageNumber,
		"onUpdate:pageNumber": _cache[0] || (_cache[0] = ($event) => _ctx.pageNumber = $event),
		"records-by-page": _ctx.recordsByPage,
		"onUpdate:recordsByPage": _cache[1] || (_cache[1] = ($event) => _ctx.recordsByPage = $event),
		"can-move-to-next-page": _ctx.viewModel.canMoveNextPage,
		"records-by-page-list": _ctx.viewModel.recordsByPageList,
		"total-record-count": _ctx.viewModel.totalRecordCount
	}, null, 8, [
		"page-number",
		"records-by-page",
		"can-move-to-next-page",
		"records-by-page-list",
		"total-record-count"
	])) : createCommentVNode("", true);
}
var PaginationBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PaginationBar_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$9]]);
//#endregion
//#region src/components/Lookup/LookupModal.vue
var LookupModal_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "LookupModal",
	setup(__props) {
		const viewModel = useViewModel();
		const { translate } = useGlobalResourceManager();
		const editableChipsFilterBar = computed(() => viewModel.behavior.filterBarDisplayMode === "editable-chips");
		const showAddButton = computed(() => !!viewModel.addingUIViewName);
		const showPaginationBar = computed(() => !viewModel.behavior.datagridInfiniteScrolling);
		const multiSelection = computed(() => !!viewModel.viewContext.get("neos-lookup-multi-selection"));
		function handleOkButtonClick() {
			viewModel.returnItemsAsync(viewModel.selectedItems);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(VerticalLayout$1), { class: "neos-fill-parent-width neos-fill-parent-height" }, {
				default: withCtx(() => [
					editableChipsFilterBar.value ? (openBlock(), createBlock(unref(VerticalLayout$1), { key: 0 }, {
						default: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
							align: "stretch",
							"vertical-align": "center",
							wrap: false
						}, {
							default: withCtx(() => [createVNode(unref(HorizontalLayout$1), { class: "neos-fill-parent-width" }, {
								default: withCtx(() => [createVNode(QuickSearch_default, {
									"label-position": "hidden",
									class: "lookup-modal-quick-search neos-fill-parent-width"
								})]),
								_: 1
							}), showAddButton.value ? (openBlock(), createBlock(ActionButton_default, {
								key: 0,
								"action-name": "Add"
							})) : createCommentVNode("", true)]),
							_: 1
						}), createVNode(EditableFilterChips_default)]),
						_: 1
					})) : (openBlock(), createBlock(unref(HorizontalLayout$1), {
						key: 1,
						align: "stretch",
						"vertical-align": "bottom",
						wrap: false
					}, {
						default: withCtx(() => [createVNode(unref(HorizontalLayout$1), { class: "neos-fill-parent-width" }, {
							default: withCtx(() => [createVNode(InputsFilterBar_default, { class: "neos-fill-parent-width" })]),
							_: 1
						}), showAddButton.value ? (openBlock(), createBlock(ActionButton_default, {
							key: 0,
							"action-name": "Add"
						})) : createCommentVNode("", true)]),
						_: 1
					})),
					createVNode(Datagrid_default, {
						"selection-column": multiSelection.value,
						class: "neos-fill-parent-height"
					}, null, 8, ["selection-column"]),
					showPaginationBar.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
						key: 2,
						align: "center"
					}, {
						default: withCtx(() => [createVNode(PaginationBar_default, { "always-display": true })]),
						_: 1
					})) : createCommentVNode("", true),
					multiSelection.value ? (openBlock(), createBlock(unref(HorizontalLayout$1), {
						key: 3,
						align: "right"
					}, {
						default: withCtx(() => [createVNode(unref(Button$1), {
							variant: "primary",
							label: unref(translate)("Ok"),
							icon: "validate",
							class: "lookup-modal-ok-button",
							onClick: handleOkButtonClick
						}, null, 8, ["label"])]),
						_: 1
					})) : createCommentVNode("", true)
				]),
				_: 1
			});
		};
	}
}), [["__scopeId", "data-v-e6a90ed5"]]);
//#endregion
//#region src/components/MenuButton/MenuButton.ts?vue&type=script&src=true&lang.ts
var MenuButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "MenuButton",
	components: {
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		Text: Text$2,
		Button: Button$1,
		DropdownMenu
	},
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		name: {
			type: String,
			default: void 0
		},
		items: {
			type: Array,
			default: void 0
		},
		variant: {
			type: String,
			default: "default"
		},
		size: {
			type: String,
			default: "medium"
		},
		badge: {
			type: String,
			default: void 0
		},
		badgeSeverity: {
			type: String,
			default: "none"
		},
		animated: {
			type: Boolean,
			default: true
		},
		...focusableElementProps
	},
	emits: [...focusableElementEmits],
	setup(props, { emit }) {
		const applicationContext = useApplicationContext();
		const root = ref();
		const loading = ref(false);
		const focused = useVModel(props, "focused", emit);
		const dropdownMenu = ref();
		const dropdownItems = computed(() => {
			return getDropdownMenuItems(props.items ?? applicationContext.get(`Menus.${props.name ?? "$Default"}`) ?? []);
		});
		function getDropdownMenuItems(menuItems) {
			const fallbackIcon = menuItems.some((menuItem) => menuItem.icon) ? "empty" : void 0;
			return menuItems.map((menuItem) => ({
				label: menuItem.caption,
				icon: menuItem.icon ?? fallbackIcon,
				disabled: menuItem.isBusy,
				items: menuItem.children ? getDropdownMenuItems(menuItem.children) : void 0,
				command: menuItem.children ? void 0 : async () => {
					dropdownMenu.value.hide();
					menuItem.execute();
				}
			}));
		}
		function handleButtonClick() {
			dropdownMenu.value.toggle({ currentTarget: root.value });
		}
		useComponentAutomationProperties(root);
		return {
			root,
			loading,
			focused,
			dropdownItems,
			dropdownMenu,
			handleButtonClick
		};
	}
});
//#endregion
//#region src/components/MenuButton/MenuButton.vue
var _hoisted_1$6 = {
	ref: "root",
	class: "menu-button"
};
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_DropdownMenu = resolveComponent("DropdownMenu");
	return openBlock(), createElementBlock("div", _hoisted_1$6, [createVNode(_component_Button, {
		focused: _ctx.focused,
		"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => _ctx.focused = $event),
		variant: _ctx.variant,
		size: _ctx.size,
		label: _ctx.label,
		icon: _ctx.icon,
		autofocus: _ctx.autofocus,
		loading: _ctx.loading,
		badge: _ctx.badge,
		"badge-severity": _ctx.badgeSeverity,
		animated: _ctx.animated,
		disabled: _ctx.dropdownItems.length === 0,
		onClick: _cache[1] || (_cache[1] = ($event) => _ctx.handleButtonClick())
	}, null, 8, [
		"focused",
		"variant",
		"size",
		"label",
		"icon",
		"autofocus",
		"loading",
		"badge",
		"badge-severity",
		"animated",
		"disabled"
	]), createVNode(_component_DropdownMenu, {
		ref: "dropdownMenu",
		items: _ctx.dropdownItems,
		class: "menu-button-dropdown",
		size: _ctx.size,
		"item-class": "menu-button-item"
	}, null, 8, ["items", "size"])], 512);
}
var MenuButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(MenuButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$8]]);
//#endregion
//#region src/components/ReportDesigner/ReportDesigner.ts?vue&type=script&src=true&lang.ts
var ReportDesigner_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ReportDesigner",
	components: { WebView: WebView_default },
	setup() {
		/************\
		* VIEW MODEL *
		\************/
		const viewModel = useViewModel();
		/*********\
		* HELPERS *
		\*********/
		const getAppCtxValue = (key) => {
			return viewModel.applicationContext.getValue(key, void 0);
		};
		const getRecordPropertyValue = (record, propertyName) => {
			return viewModel.findProperty(propertyName)?.getValue(record) ?? void 0;
		};
		/***************\
		* COMPOSITE KEY *
		\***************/
		function getCompositeKey(record) {
			const mainKeyValue = viewModel.getProperty("name").getValue(record);
			const reportAsContainer = getRecordPropertyValue(record, "reportAsStylesEditionAndPreviewContainer");
			const businessClusterName = viewModel.applicationContext.editedCluster?.name;
			return reportAsContainer ? {
				reportName: reportAsContainer,
				businessClusterName,
				stylesBundleName: mainKeyValue
			} : {
				reportName: mainKeyValue,
				businessClusterName,
				stylesBundleName: void 0
			};
		}
		/******************\
		* OPTIONS & CONFIG *
		\******************/
		function getReportingAssetDesignerOptions(record) {
			const getPropertyValue = (propertyName) => {
				return getRecordPropertyValue(record, propertyName);
			};
			return {
				renderingOptions: {
					tenantDataIdentifier: getPropertyValue("currentTenantDataIdentifierView"),
					reportGenerationConfigName: getPropertyValue("currentReportGenConfigNameView")
				},
				styleDesignerOptions: {
					isAutoApply: getPropertyValue("isAutoApply"),
					isShowNativeStyles: getPropertyValue("isShowNativeNonAutoApplyStyles")
				},
				override: {
					allowOverride: getAppCtxValue("AllowOverride"),
					workingModuleName: getAppCtxValue("WorkingModuleName")
				}
			};
		}
		/********\
		* EXPORT *
		\********/
		return { url: computed(() => {
			if (!viewModel.current) return;
			const monoRecord = viewModel.current;
			const assets = getCompositeKey(monoRecord);
			if (!assets.reportName || typeof assets.reportName !== "string") return;
			const options = getReportingAssetDesignerOptions(monoRecord);
			return Reporting.getReportDesignerUrl(assets, options);
		}) };
	}
});
//#endregion
//#region src/components/ReportDesigner/ReportDesigner.vue
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_WebView = resolveComponent("WebView");
	return _ctx.url ? (openBlock(), createBlock(_component_WebView, {
		key: 0,
		source: _ctx.url,
		"delegated-loading": false
	}, null, 8, ["source"])) : createCommentVNode("", true);
}
var ReportDesigner_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ReportDesigner_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$7]]);
//#endregion
//#region src/components/SidebarItem/SidebarItem.ts?vue&type=script&src=true&lang.ts
var SidebarItem_ts_vue_type_script_src_true_lang_default = defineComponent({
	components: {
		Image: Image$2,
		Spinner: Spinner$1,
		Text: Text$2
	},
	props: {
		item: {
			type: Object,
			required: true
		},
		parentExpanded: {
			type: Boolean,
			default: true
		},
		level: {
			type: Number,
			default: 0
		},
		displayIcon: {
			type: Boolean,
			default: true
		},
		fallbackIcon: {
			type: String,
			default: void 0
		}
	},
	emits: ["click", "updateHeight"],
	setup(props, { emit }) {
		let hoverPathTimeoutHandle = -1;
		const sidebarState = inject("sidebarState");
		const button = ref();
		const childrenContainer = ref();
		const icon = computed(() => props.item.icon ?? props.fallbackIcon);
		const captionWeight = computed(() => props.level === 0 || props.item.children ? "strong" : "regular");
		const expanded = computed(() => props.parentExpanded && props.item.expanded);
		const isInHoverPath = computed(() => {
			if ((!props.parentExpanded || !props.item.expanded) && props.item.path && props.item.children) {
				if (sidebarState.hoverPath.split("/").length === props.item.path.split("/").length) return sidebarState.hoverPath === props.item.path;
				return sidebarState.hoverPath.startsWith(`${props.item.path}/`);
			}
			return false;
		});
		const displayChildIcon = computed(() => !isInHoverPath.value || props.item.children && props.item.children.some((i) => i.icon));
		const displayChildrenContainerCaption = computed(() => !sidebarState.expanded && props.level === 0);
		const { x, y, width } = useElementBounding(button);
		watch(expanded, () => updateHeight(0), { flush: "post" });
		watch([
			isInHoverPath,
			childrenContainer,
			x,
			y,
			width
		], () => {
			if (isInHoverPath.value && childrenContainer.value) {
				ZIndex.clear(childrenContainer.value);
				ZIndex.set("sidebar-item", childrenContainer.value, 500);
				childrenContainer.value.style.left = `${x.value + width.value}px`;
				childrenContainer.value.style.top = childrenContainer.value.clientHeight + y.value > window.innerHeight ? `${window.innerHeight - childrenContainer.value.clientHeight}px` : `${y.value}px`;
			} else ZIndex.clear(childrenContainer.value);
		}, { flush: "post" });
		onBeforeUnmount(() => ZIndex.clear(childrenContainer.value));
		function handleClick() {
			emit("click", props.item);
		}
		function handleChildClick(item, parentItem) {
			emit("click", item, parentItem ?? props.item);
		}
		function handleMouseEnter() {
			if (sidebarState.isLargeScreen) {
				sidebarState.stopResetHoverPathTimeout();
				window.clearTimeout(hoverPathTimeoutHandle);
				hoverPathTimeoutHandle = window.setTimeout(() => {
					sidebarState.hoverPath = props.item.path;
				}, 50);
			}
		}
		function handleMouseLeave() {
			window.clearTimeout(hoverPathTimeoutHandle);
			sidebarState.startResetHoverPathTimeout();
		}
		function updateHeight(h) {
			if (childrenContainer.value) {
				const height = expanded.value ? childrenContainer.value.scrollHeight + h : 0;
				childrenContainer.value.style.setProperty("--panel-menu-item-children-height", `${height}px`);
				emit("updateHeight", height);
			}
		}
		return {
			button,
			childrenContainer,
			icon,
			captionWeight,
			expanded,
			displayChildrenContainerCaption,
			displayChildIcon,
			isInHoverPath,
			handleClick,
			handleChildClick,
			handleMouseEnter,
			handleMouseLeave,
			updateHeight
		};
	}
});
//#endregion
//#region src/components/SidebarItem/SidebarItem.vue
var _hoisted_1$5 = ["data-path"];
var _hoisted_2$3 = ["disabled", "title"];
var _hoisted_3$3 = {
	key: 0,
	class: "sidebar-item-image"
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Spinner = resolveComponent("Spinner");
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_SidebarItem = resolveComponent("SidebarItem", true);
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["sidebar-item", { expanded: _ctx.expanded }]),
		"data-path": _ctx.item.path
	}, [createElementVNode("button", {
		ref: "button",
		class: normalizeClass(["sidebar-item-button", { hover: _ctx.isInHoverPath }]),
		disabled: _ctx.item.isBusy,
		title: _ctx.item.caption,
		style: normalizeStyle(`--panel-menu-item-level: ${_ctx.level}`),
		onClick: _cache[0] || (_cache[0] = ($event) => _ctx.handleClick()),
		onMouseenter: _cache[1] || (_cache[1] = ($event) => _ctx.handleMouseEnter()),
		onMouseleave: _cache[2] || (_cache[2] = ($event) => _ctx.handleMouseLeave())
	}, [
		_ctx.displayIcon ? (openBlock(), createElementBlock("div", _hoisted_3$3, [_ctx.item.isBusy ? (openBlock(), createBlock(_component_Spinner, { key: 0 })) : (openBlock(), createBlock(_component_Image, {
			key: 1,
			name: _ctx.icon
		}, null, 8, ["name"]))])) : createCommentVNode("", true),
		createVNode(_component_Text, {
			size: "small",
			weight: _ctx.captionWeight,
			class: "sidebar-item-caption"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.item.caption), 1)]),
			_: 1
		}, 8, ["weight"]),
		_ctx.item.children ? (openBlock(), createBlock(_component_Image, {
			key: 1,
			name: "chevronRight",
			class: "sidebar-item-chevron"
		})) : createCommentVNode("", true)
	], 46, _hoisted_2$3), (openBlock(), createBlock(Teleport, {
		to: "body",
		disabled: !_ctx.isInHoverPath
	}, [_ctx.item.children ? (openBlock(), createElementBlock("div", {
		key: 0,
		ref: "childrenContainer",
		class: normalizeClass(["sidebar-item-children", { overlay: _ctx.isInHoverPath }])
	}, [_ctx.displayChildrenContainerCaption ? (openBlock(), createBlock(_component_Text, {
		key: 0,
		class: "sidebar-item-caption",
		weight: _ctx.captionWeight
	}, {
		default: withCtx(() => [createTextVNode(toDisplayString(_ctx.item.caption), 1)]),
		_: 1
	}, 8, ["weight"])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.item.children, (subItem) => {
		return openBlock(), createBlock(_component_SidebarItem, {
			key: subItem.caption,
			item: subItem,
			level: _ctx.level + 1,
			"parent-expanded": _ctx.item.expanded,
			"display-icon": _ctx.displayChildIcon,
			onClick: _ctx.handleChildClick,
			onUpdateHeight: _ctx.updateHeight
		}, null, 8, [
			"item",
			"level",
			"parent-expanded",
			"display-icon",
			"onClick",
			"onUpdateHeight"
		]);
	}), 128))], 2)) : createCommentVNode("", true)], 8, ["disabled"]))], 10, _hoisted_1$5);
}
var SidebarItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SidebarItem_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$6], ["__scopeId", "data-v-6515e6f3"]]);
//#endregion
//#region src/components/Sidebar/Sidebar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = {
	key: 0,
	class: "sidebar-header"
};
var _hoisted_2$2 = {
	key: 1,
	class: "sidebar-footer"
};
var _hoisted_3$2 = { class: "sidebar-logo" };
var _hoisted_4$1 = {
	key: 1,
	class: "sidebar-auto-logo"
};
//#endregion
//#region src/components/Sidebar/Sidebar.vue
var Sidebar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Sidebar",
	props: /*@__PURE__*/ mergeModels({
		title: { default: void 0 },
		logo: { default: void 0 },
		name: { default: void 0 },
		items: { default: void 0 },
		expandedByDefault: {
			type: Boolean,
			default: false
		},
		toggleButtonVisible: {
			type: Boolean,
			default: true
		},
		collapseMode: { default: "collapse" },
		collapseOtherMenusOnMenuExpand: {
			type: Boolean,
			default: false
		},
		collapseOnItemClick: {
			type: Boolean,
			default: false
		}
	}, {
		"expanded": {
			type: Boolean,
			default: void 0
		},
		"expandedModifiers": {}
	}),
	emits: ["update:expanded"],
	setup(__props, { expose: __expose }) {
		const props = __props;
		const expanded = useModel(__props, "expanded");
		const slots = useSlots();
		let timeoutHandleId = -1;
		const root = ref();
		const itemsContainer = ref();
		const applicationContext = useApplicationContext();
		const { translate } = useGlobalResourceManager();
		const isLargeScreen = useMediaQuery("(min-width: 768px)");
		const state = ref({
			get expanded() {
				return expanded.value ?? props.expandedByDefault;
			},
			set expanded(value) {
				expanded.value = value;
			},
			hoverPath: "",
			isLargeScreen,
			startResetHoverPathTimeout,
			stopResetHoverPathTimeout
		});
		const displayHeader = computed(() => !!slots.header || props.toggleButtonVisible);
		const displayFooter = computed(() => !!slots.footer || !!props.title || !!props.logo);
		const sidebarClasses = computed(() => ({
			expanded: state.value.expanded,
			scrollable: scrollable.value,
			"collapse-mode": props.collapseMode === "collapse"
		}));
		const expandButtonItem = computed(() => ({
			path: "",
			caption: translate("Collapse")
		}));
		const menuItems = computed(() => props.items ?? applicationContext.get(`Menus.${props.name ?? "$Default"}`) ?? []);
		const windowFocused = useWindowFocus();
		watch(windowFocused, () => {
			if (!windowFocused.value) state.value.hoverPath = "";
		});
		useComponentAutomationProperties();
		const { height } = useElementBounding(itemsContainer);
		const scrollable = computed(() => itemsContainer.value && itemsContainer.value.scrollHeight > height.value);
		watch([() => state.value.expanded, root], ([isExpanded, element]) => {
			if (isExpanded) ZIndex.set("sidebar", element, 500);
			else ZIndex.clear(element);
		}, { flush: "post" });
		provide("sidebarState", state.value);
		onBeforeUnmount(() => {
			ZIndex.clear(root.value);
			collapseItems(menuItems.value);
		});
		onClickOutside(root, () => state.value.hoverPath = "", { ignore: [".sidebar-item-caption", ".sidebar-item-button"] });
		function handleExpandButtonClick() {
			state.value.hoverPath = "";
			state.value.expanded = !state.value.expanded;
			if (!state.value.expanded) collapseItems(menuItems.value);
		}
		function handleItemClick(item, parentItem) {
			if (item.children && parentItem && !parentItem.expanded) state.value.hoverPath = item.path;
			else {
				state.value.hoverPath = "";
				if (item.children) toggleSidebarItem(item, parentItem);
				else executeSidebarItem(item);
			}
		}
		function handleOverlayClick() {
			state.value.hoverPath = "";
			state.value.expanded = false;
		}
		function toggleSidebarItem(item, parentItem) {
			if (props.collapseOtherMenusOnMenuExpand) collapseItems((parentItem && parentItem.children ? parentItem.children : menuItems.value).filter((i) => i !== item));
			if (state.value.expanded || !item.expanded) item.expanded = !item.expanded;
			state.value.expanded = true;
		}
		function executeSidebarItem(item) {
			item.execute();
			if (props.collapseOnItemClick || !isLargeScreen.value) {
				state.value.expanded = false;
				collapseItems(menuItems.value);
			}
		}
		function collapseItems(items) {
			for (const item of items) item.collapse();
		}
		function startResetHoverPathTimeout() {
			clearTimeout(timeoutHandleId);
			timeoutHandleId = window.setTimeout(() => state.value.hoverPath = "", 500);
		}
		function stopResetHoverPathTimeout() {
			clearTimeout(timeoutHandleId);
		}
		__expose({ state });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "root",
				ref: root,
				class: normalizeClass(["sidebar", sidebarClasses.value])
			}, [
				displayHeader.value ? (openBlock(), createElementBlock("div", _hoisted_1$4, [
					__props.toggleButtonVisible ? (openBlock(), createBlock(SidebarItem_default, {
						key: 0,
						item: expandButtonItem.value,
						"fallback-icon": "doubleChevronRight",
						class: "sidebar-expand-button",
						onClick: handleExpandButtonClick
					}, null, 8, ["item"])) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "header", {}, void 0, true),
					createVNode(unref(Divider$1), { class: "sidebar-divider" })
				])) : createCommentVNode("", true),
				createElementVNode("div", {
					ref_key: "itemsContainer",
					ref: itemsContainer,
					class: "sidebar-items"
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(menuItems.value, (item) => {
					return openBlock(), createBlock(SidebarItem_default, {
						key: item.caption,
						item,
						"fallback-icon": "folder",
						"parent-expanded": state.value.expanded,
						onClick: handleItemClick
					}, null, 8, ["item", "parent-expanded"]);
				}), 128))], 512),
				displayFooter.value ? (openBlock(), createElementBlock("div", _hoisted_2$2, [createVNode(unref(Divider$1), { class: "sidebar-divider" }), renderSlot(_ctx.$slots, "footer", {}, () => [createElementVNode("div", _hoisted_3$2, [__props.logo ? (openBlock(), createBlock(unref(Image$2), {
					key: 0,
					name: __props.logo
				}, null, 8, ["name"])) : (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString(__props.title[0]), 1))])], true)])) : createCommentVNode("", true),
				(openBlock(), createBlock(Teleport, { to: "body" }, [withDirectives(createElementVNode("div", {
					class: "sidebar-overlay",
					onClick: handleOverlayClick
				}, null, 512), [[vShow, state.value.expanded]])]))
			], 2);
		};
	}
}), [["__scopeId", "data-v-ad5e0be0"]]);
//#endregion
//#region src/components/Toolbar/Toolbar.ts?vue&type=script&src=true&lang.ts
var Toolbar_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Toolbar",
	components: {
		ActionButton: ActionButton_default,
		HorizontalLayout: HorizontalLayout$1,
		CustomViewButton: CustomViewButton_default
	},
	props: {
		save: {
			type: Boolean,
			default: true
		},
		refresh: {
			type: Boolean,
			default: true
		},
		add: {
			type: Boolean,
			default: true
		},
		remove: {
			type: Boolean,
			default: true
		},
		actions: {
			type: Boolean,
			default: true
		},
		close: {
			type: Boolean,
			default: void 0
		},
		clone: {
			type: Boolean,
			default: false
		},
		dataExport: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: void 0
		},
		customViews: {
			type: Boolean,
			default: true
		},
		animated: {
			type: Boolean,
			default: void 0
		}
	},
	setup(props) {
		const themeManager = useThemeManager(false);
		const viewModel = useViewModel();
		const buttonContainerSpace = useButtonContainerSpace(themeManager, props);
		const toolbarActions = computed(() => {
			const { current, selectedItems } = viewModel;
			return viewModel.actions.filterByLocation(ViewModelActionLocation.toolbar, void 0, (action) => isVisibleAccordingToProps(action) && viewModel.canExecuteAction(action) && action.getVisible(current, selectedItems));
		});
		useComponentAutomationProperties();
		function isVisibleAccordingToProps(action) {
			switch (action.name) {
				case ViewModelStandardAction.save: return props.save;
				case ViewModelStandardAction.refresh: return props.refresh;
				case ViewModelStandardAction.add: return props.add;
				case ViewModelStandardAction.remove: return props.remove;
				case ViewModelStandardAction.close:
					if (props.close == null) return viewModel.ownerFrame?.displayMode === FrameDisplayMode.stack;
					return props.close;
				case ViewModelStandardAction.clone: return props.clone;
				case ViewModelStandardAction.export: return props.dataExport;
				case ViewModelStandardAction.more: return true;
				default: return props.actions;
			}
		}
		return {
			toolbarActions,
			buttonContainerSpace
		};
	}
});
//#endregion
//#region src/components/Toolbar/Toolbar.vue
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_CustomViewButton = resolveComponent("CustomViewButton");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		class: "toolbar",
		wrap: false,
		space: _ctx.buttonContainerSpace
	}, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.toolbarActions, (action) => {
			return openBlock(), createBlock(_component_ActionButton, {
				key: action.name,
				action,
				add: _ctx.add,
				clone: _ctx.clone,
				remove: _ctx.remove,
				"data-export": _ctx.dataExport,
				size: _ctx.size,
				animated: _ctx.animated
			}, null, 8, [
				"action",
				"add",
				"clone",
				"remove",
				"data-export",
				"size",
				"animated"
			]);
		}), 128)), _ctx.customViews ? (openBlock(), createBlock(_component_CustomViewButton, {
			key: 0,
			size: _ctx.size,
			animated: _ctx.animated
		}, null, 8, ["size", "animated"])) : createCommentVNode("", true)]),
		_: 1
	}, 8, ["space"]);
}
var Toolbar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Toolbar_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$5], ["__scopeId", "data-v-095cffbb"]]);
//#endregion
//#region src/startup/i18n.ts
/**
* Gets the navigator culture (IETF language tag).
*
* We retrieve the culture from the local storage.
* If there is no value in the local storage, we use the navigator culture.
*
* @retuns The navigator culture.
*/
function getNavigatorCulture() {
	let lang = localStorage.getItem("lang");
	if (!lang) lang = navigator.language;
	return lang;
}
/**
* Gets the navigator language.
*
* We retrieve the language from the local storage.
* If there is no value in the local storage, we use the navigator language.
*
* @returns The navigator language.
*/
function getNavigatorLanguage() {
	return ResourceManager.getTwoLetterLanguage(getNavigatorCulture());
}
function initializeLocalizator(localizator, applicationCulture, inputCultures) {
	const currentLanguage = applicationCulture ? getApplicationLanguageFromCulture(localizator.languages, applicationCulture) ?? getNavigatorLanguage() : getNavigatorLanguage();
	if (inputCultures) inputCultures = inputCultures.map((c) => getApplicationLanguageFromCulture(localizator.languages, c) ?? c);
	const localizableStringRequiredLanguage = inputCultures?.[0] ?? localizator.languages[0];
	const sortedLanguages = moveElementFirst([...localizator.languages], currentLanguage);
	inputCultures ??= sortedLanguages;
	const localizableStringCurrentLanguage = inputCultures.includes(currentLanguage) ? currentLanguage : inputCultures?.[0];
	localizator.init({
		currentLanguage,
		currentCulture: applicationCulture ?? getNavigatorCulture(),
		localizableStringLanguages: inputCultures,
		localizableStringDefaultLanguage: inputCultures?.[0],
		localizableStringCurrentLanguage,
		localizableStringRequiredLanguage
	});
}
function getApplicationLanguageFromCulture(languagesOrCultures, culture) {
	if (languagesOrCultures.includes(culture)) return culture;
	const languageOnly = culture.slice(0, 2);
	if (languagesOrCultures.includes(languageOnly)) return languageOnly;
}
//#endregion
//#region src/notifications/reportNotifications.ts
/**
* Subscribes to report notifications.
* This is only used when the cluster does not contain module NeosNotificationCenter or any module
* implementing IUserNotification.
* Otherwise, report generation notifications are managed by the notification center.
*/
function subscribeToReportNotifications(connection, eventManager, globalResourceManager, apiClient, baseUrl) {
	async function handleReportGenerationNotification(args) {
		const notificationArgs = args;
		if (notificationArgs.succeeded === true) await handleReportGenerationSucceededNotification(notificationArgs, eventManager, globalResourceManager, apiClient, baseUrl);
		else await handleReportGenerationFailedNotification(notificationArgs, eventManager, globalResourceManager);
	}
	connection.addHandler("ReportGeneration", handleReportGenerationNotification);
}
async function handleReportGenerationSucceededNotification(notificationArgs, eventManager, globalResourceManager, apiClient, baseUrl) {
	if (!(await reportEvents.generationSucceeded.raiseWithNotificationArgsAsync(notificationArgs, baseUrl)).displayToast) return;
	eventManager.emit("viewModel:showToast", {
		buttons: [new ViewModelToastButton(globalResourceManager.get("Download"), "download", () => apiClient.downloadFileAsync(Reporting.getReportFileUrl(baseUrl, notificationArgs.generationIdentifier, notificationArgs.fileIdentifier, true))), new ViewModelToastButton(globalResourceManager.get("Print"), "print", () => apiClient.printFileAsync(Reporting.getReportFileUrl(baseUrl, notificationArgs.generationIdentifier, notificationArgs.fileIdentifier, false)))],
		dismissible: true,
		duration: void 0,
		title: globalResourceManager.get("Reporting_ReportGenerationSucceeded_Title"),
		text: globalResourceManager.get("Reporting_ReportGenerationSucceeded_Text"),
		type: ViewModelMessageType.positive
	});
}
async function handleReportGenerationFailedNotification(notificationArgs, eventManager, globalResourceManager) {
	if (!(await reportEvents.generationFailed.raiseWithNotificationArgsAsync(notificationArgs)).displayToast) return;
	eventManager.emit("viewModel:showToast", {
		buttons: [new ViewModelToastButton(globalResourceManager.get("ShowError"), "info", () => {
			const error = new ViewModelError(globalResourceManager.get("ErrorHasOccurred"), notificationArgs.errorMessage);
			error.advancedText = notificationArgs.errorDetails;
			eventManager.emit("viewModel:showError", error);
		})],
		dismissible: true,
		duration: void 0,
		title: globalResourceManager.get("Reporting_ReportGenerationFailed_Title"),
		text: notificationArgs.errorMessage,
		type: ViewModelMessageType.danger
	});
}
//#endregion
//#region src/notifications/serverDataExportNotifications.ts
/**
* Subscribes to server data export notifications.
*/
function subscribeToServerDataExportNotifications(connection, eventManager, globalResourceManager, apiClient) {
	connection.addHandler("ExportCompleted", (args) => showToast(args, eventManager, globalResourceManager, apiClient));
}
/**
* Shows a toast for a server data export notification.
* @param args Notification arguments.
*/
function showToast(args, eventManager, globalResourceManager, apiClient) {
	const response = args;
	if (response.succeeded) eventManager.emit("viewModel:showToast", {
		buttons: [new ViewModelToastButton(globalResourceManager.get("Download"), "download", () => apiClient.downloadFileAsync(`$neos/exports/download/${response.identifier}`))],
		dismissible: true,
		duration: void 0,
		text: globalResourceManager.get("ServerDataExport_ClickToDownload"),
		title: globalResourceManager.get("ServerDataExport_ExportCompletedTitleSuccess"),
		type: ViewModelMessageType.positive
	});
	else eventManager.emit("viewModel:showToast", {
		buttons: [new ViewModelToastButton(globalResourceManager.get("ShowError"), "info", () => {
			const error = new ViewModelError(globalResourceManager.get("ErrorHasOccurred"), response.errorMessage);
			error.advancedText = response.errorDetails;
			eventManager.emit("viewModel:showError", error);
		})],
		dismissible: true,
		duration: void 0,
		text: response.errorMessage,
		title: globalResourceManager.get("ServerDataExport_ExportCompletedTitleFailed"),
		type: ViewModelMessageType.danger
	});
}
//#endregion
//#region src/notifications/connection.ts
function getNotificationConnectionUrl(baseUrl, devBaseUrl) {
	return devBaseUrl ? `${devBaseUrl}notifications` : `${baseUrl}/notifications`;
}
async function startNotificationConnection(connection, applicationContext, eventManager, globalResourceManager, apiClient, baseUrl) {
	await connection.startAsync(apiClient.getHeaders());
	connection.subscribeConnectionId((connectionId) => applicationContext.notificationConnectionId = connectionId);
	subscribeToReportNotifications(connection, eventManager, globalResourceManager, apiClient, baseUrl);
	subscribeToServerDataExportNotifications(connection, eventManager, globalResourceManager, apiClient);
}
//#endregion
//#region src/startup/applicationResourceManagerRegistry.ts
var registry = createRegistry("Application resource manager");
var registerApplicationResourceManager = registry.register.bind(registry);
var getApplicationResourceManager = registry.get.bind(registry);
//#endregion
//#region src/startup/services.ts
function configureReactivity() {
	if (!hasReactivity()) setReactivity({
		reactive: (value) => ref(value).value,
		computed: (get) => computed(get),
		writableComputed: (options) => computed(options),
		watch: (source, cb, options) => watch(source, cb, options)
	});
}
function configureWijmo$1() {
	configureWijmo("groupe isagri services,358378762383674#B0bbMJye0ICRiwiI34zdstmbaJXZjJUWxIlRutWc8RWWJJ6QB3mMCNHRWhXYU54bHljNxQTYQhEUUpGNzRkbHtUOmhjWvhndhZ7dGJXdC3EWaFkT5dnMuRlcyMHbM5kWqBVeV5Ed5lXZ4FmY5MUcRRjaLN5Q83UV5NWRpNWRrU6VLV6Z4smWwx6MndmYl96bppnT9cXVsZHeC3kUvYzZjZmZrcnQtJ6NhhXall6byR7NMN7UL3CVWxmWlZmbUdUbBhWbClHWVZEeQRlTMJVN6Vzbp5mWNR6ZjRmcWpld5Z4RW5kRONDcVlTR6MlTs5Wc7lEbOFncvxkQhJ6NWdjTy3GW9YjaDJUTYNDRkVzcrMHeoRXT7Z5VhJmNh9WRtdXYyIEOQNlT4oFMrpnTR5WTqZEd85kN4gHaxBDcsFVc89GdV3SUV3SMBlmahZzK494QGRXUQZHW93yLyJUdwNjT4FUchZlI0IyUiwiI4ETQyAzQ5QjI0ICSiwSO9YTO8QTNzUTM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsISNyQTMwEDIzEjNwUjMwIjI0ICdyNkIsIyclNWa6JXZTBSaydWYzlEIlBXdvJ7RiojIh94QiwiI4cjNzgzMyYzN8czM8UzMiojIklkIs4XXbpjInxmZiwiIxYXNyAjMiojIyVmdiwSZzxWYmpjIyNHZisIONw");
}
function configureApplicationContext(config, parentApplicationContext) {
	const applicationContext = new ApplicationContext(Object.entries({
		...globalThis.context,
		ClusterName: config.name,
		ClusterTitle: config.title,
		ClusterVersion: config.version,
		ClusterCompany: config.company
	}));
	applicationContext.parent = parentApplicationContext;
	const reactiveApplicationContext = ref(applicationContext).value;
	registerApplicationContext(config.name, reactiveApplicationContext);
	return reactiveApplicationContext;
}
function configureEventManager() {
	const eventManager = new EventManager();
	registerEventManager(eventManager);
	return eventManager;
}
function configureLocalizator(config) {
	const localizator = new Localizator(config.languages);
	registerLocalizator(config.name, localizator);
	return localizator;
}
function configureGlobalResourceManager(name) {
	const resources = /* #__PURE__ */ Object.assign({
		"../resources/en-GB.ts": () => import("./en-GB-B2f6BGxg.js"),
		"../resources/en.ts": () => import("./en-BSpv3fgu.js"),
		"../resources/fr.ts": () => import("./fr-Dx33RLGH.js")
	});
	const globalResourceManager = ref(new ResourceManager((lang) => resources[`../resources/${lang}.ts`])).value;
	registerGlobalResourceManager(name, globalResourceManager);
	return globalResourceManager;
}
function configureApplicationResourceManager(config) {
	const applicationResourceManager = ref(new ResourceManager(config.importResources)).value;
	registerApplicationResourceManager(config.name, applicationResourceManager);
	return applicationResourceManager;
}
function configureApiClient(name, baseUrl, applicationContext, eventManager, globalResourceManager) {
	const apiClient = new FetchApiClient(getApiClientBaseUrl(baseUrl), applicationContext, eventManager, globalResourceManager);
	registerApiClient(name, apiClient);
	return apiClient;
}
function configureNotificationConnection(config, baseUrlWithoutTenant) {
	return new NotificationConnection(getNotificationConnectionUrl(baseUrlWithoutTenant, config.devBaseUrl));
}
function configureThemeManager(config) {
	const themeManager = ref(new ThemeManager(config.themes, config.importTheme)).value;
	registerThemeManager(themeManager);
	return themeManager;
}
function configureUIPermitter(name, mainUIViewName) {
	const uiPermitter = ref(new UIPermitter(mainUIViewName, true)).value;
	registerUIPermitter(name, uiPermitter);
	return uiPermitter;
}
function configureCustomViewManager(eventManager, globalResourceManager, apiClient) {
	return ref(new CustomViewManager(eventManager, globalResourceManager, apiClient)).value;
}
function configureNotificationRegistryFactory(config, notificationConnection) {
	return () => config.importNotifications(notificationConnection);
}
function getBaseUrlWithoutTenant(tenantIdentifier) {
	let baseUrl = getBaseUrl();
	if (tenantIdentifier && baseUrl.endsWith(`/${tenantIdentifier}`)) baseUrl = stripLastUrlSegment(baseUrl);
	return baseUrl;
}
//#endregion
//#region src/startup/auth.ts
async function authenticate(config, applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, uiPermitter) {
	const result = config.name !== "Manager" ? await callOnAuthenticatedApi(apiClient) : { authorized: true };
	initializeLocalizator(localizator, result.applicationCulture, result.inputCultures);
	apiClient.setAcceptLanguageHeader(localizator.currentCulture);
	initializeDefaultLocale(result.applicationCulture);
	setTenant(applicationContext, result);
	await Promise.all([globalResourceManager.load(localizator), applicationResourceManager.load(localizator)]);
	if (!result.authorized) {
		displayUnauthorizedPage(globalResourceManager, applicationContext.tenantIdentifier, result.unauthorizedTitle, result.unauthorizedMessage);
		return false;
	}
	setContextInApplicationContext(applicationContext, result.context, result.clientOnlyContext);
	setThemeInApplicationContext(applicationContext, result.theme);
	uiPermitter.init(result.permissions, result.serverMethods);
	initializeMenus(applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, uiPermitter, config.menuItems, result.menus);
	return true;
}
function setTenant(applicationContext, result) {
	applicationContext.set("Tenants", result.tenants);
	if (result.tenantId && result.tenantId !== "__default__") setTenantContext(applicationContext, result.tenants?.find((t) => t.identifier == result.tenantId) ?? {
		identifier: result.tenantId,
		name: result.tenantId
	});
	if (result.tenants && result.tenants.length === 1) setTenantContext(applicationContext, result.tenants[0]);
}
function setTenantContext(applicationContext, tenantInfo) {
	applicationContext.set("TenantInfo", tenantInfo);
	applicationContext.setTenantIdentifier(tenantInfo.identifier);
}
function logOut(tenantIdentifier) {
	window.location.replace(`${getBaseUrlWithoutTenant(tenantIdentifier)}/logout`);
}
function changeTenant(tenantIdentifier) {
	window.location.replace(getBaseUrlWithoutTenant(tenantIdentifier));
}
function displayUnauthorizedPage(globalResourceManager, tenantIdentifier, unauthorizedTitle, unauthorizedMessage) {
	const title = document.createElement("div");
	title.textContent = globalResourceManager.get(unauthorizedTitle);
	title.style.fontSize = "32px";
	title.style.lineHeight = "48px";
	const message = document.createElement("div");
	message.textContent = globalResourceManager.get(unauthorizedMessage);
	message.style.fontSize = "18px";
	message.style.lineHeight = "48px";
	const logoutButton = document.createElement("button");
	logoutButton.textContent = globalResourceManager.get("Logout");
	logoutButton.style.fontSize = "18px";
	logoutButton.style.lineHeight = "32px";
	logoutButton.style.color = "black";
	logoutButton.style.textDecoration = "none";
	logoutButton.addEventListener("click", () => logOut(tenantIdentifier));
	const container = document.createElement("div");
	container.style.padding = "200px 80px";
	container.append(title, message, logoutButton);
	document.getElementById("app").append(container);
}
async function callOnAuthenticatedApi(apiClient) {
	try {
		const response = await apiClient.postAsync({ path: "$neos/ui/on-authenticated" });
		const tenantId = response.data?.tenantId;
		if (!response.succeeded) return {
			authorized: false,
			unauthorizedTitle: "UnauthorizedPage_FailedTitle",
			unauthorizedMessage: "UnauthorizedPage_FailedMessage",
			tenantId
		};
		if (!response.data.authorized) return {
			authorized: false,
			unauthorizedTitle: "UnauthorizedPage_UnauthorizedTitle",
			unauthorizedMessage: "UnauthorizedPage_UnauthorizedMessage",
			tenantId
		};
		return response.data;
	} catch {
		return {
			authorized: false,
			unauthorizedTitle: "UnauthorizedPage_FailedTitle",
			unauthorizedMessage: "UnauthorizedPage_FailedMessage"
		};
	}
}
function setContextInApplicationContext(applicationContext, context, clientOnlyContext) {
	if (context) for (const key in context) {
		const value = context[key];
		applicationContext.set(key, value);
		applicationContext.setApiContextValue(key, value);
	}
	if (clientOnlyContext) for (const key in clientOnlyContext) applicationContext.set(key, clientOnlyContext[key]);
	applicationContext.set("UserName", applicationContext.userIdentifier);
}
function setThemeInApplicationContext(applicationContext, theme) {
	theme ??= applicationContext.clusterName === "Manager" ? "NeosStudio" : "NeosV3";
	applicationContext.set("Theme", theme);
}
function initializeMenus(applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, uiPermitter, definitions, menus) {
	const allMenuItems = [];
	let principalMenu = [];
	if (menus) {
		const menuItemDependencies = {
			applicationContext,
			eventManager,
			globalResourceManager,
			apiClient,
			uiPermitter
		};
		for (const menuName in menus) {
			const menuItems = createMenuItems(menuItemDependencies, localizator, applicationResourceManager, definitions, menus[menuName]);
			applicationContext.set(`Menus.${menuName}`, menuItems);
			allMenuItems.push(...menuItems);
			if (menuName === "$Default") {
				principalMenu = menuItems;
				applicationContext.set("Menus.$Default", principalMenu);
			}
		}
		applicationContext.set("Menus.$All", allMenuItems);
		applicationContext.set("MenuItems", allMenuItems);
	} else {
		applicationContext.set("Menus.$All", []);
		applicationContext.set("MenuItems", []);
	}
	return principalMenu;
}
function createMenuItems(dependencies, localizator, applicationResourceManager, definitions, menu, path) {
	return menu.map((menuDetail) => {
		const name = menuDetail.name ?? menuDetail.menuItemName;
		const menuDetailPath = path ? `${path}/${name}` : name;
		const children = menuDetail.children ? createMenuItems(dependencies, localizator, applicationResourceManager, definitions, menuDetail.children, menuDetailPath) : void 0;
		if (menuDetail.menuItemName) {
			const definition = definitions[menuDetail.menuItemName];
			const caption = localizator.translate(menuDetail.caption) ?? applicationResourceManager.find(`menuItems.${menuDetail.menuItemName}`) ?? name.substring(name.indexOf("/") + 1);
			return new MenuItem(dependencies, menuDetailPath, caption, menuDetail.icon ?? definition.icon, definition.to, definition.code, children);
		}
		const caption = localizator.translate(menuDetail.caption) ?? name.substring(name.indexOf("/") + 1);
		return new MenuItem(dependencies, menuDetailPath, caption, menuDetail.icon, void 0, void 0, children);
	});
}
//#endregion
//#region src/components/UserButton/UserButton.ts?vue&type=script&src=true&lang.ts
var UserButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "UserButton",
	components: {
		Button: Button$1,
		Divider: Divider$1,
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		Modal: Modal$1,
		Popover,
		Text: Text$2,
		VerticalLayout: VerticalLayout$1
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		const eventManager = useEventManager();
		const applicationContext = useApplicationContext();
		const isAuthenticated = !!applicationContext.userIdentifier;
		const tenants = applicationContext.tenants;
		const showTenants = tenants != null && tenants.length > 1;
		const headerText = applicationContext.tenant?.name ?? applicationContext.clusterTitle;
		const firstName = applicationContext.userFirstName;
		const lastName = applicationContext.userLastName;
		const fullName = firstName && lastName ? `${firstName.trim()} ${lastName.trim()}` : void 0;
		const email = applicationContext.userEmail;
		const popover = ref();
		function getInitial(name) {
			if (name) {
				const trimmedName = name.trim();
				if (trimmedName.length > 0) return trimmedName[0];
			}
			return "";
		}
		const initial = computed(() => `${getInitial(firstName)}${getInitial(lastName)}`.toUpperCase());
		function handleUserButtonClick(event) {
			popover.value.toggle(event);
		}
		function handleActionButtonClick() {
			popover.value.hide();
		}
		function handleLogoutButtonClick() {
			logOut(applicationContext.tenantIdentifier);
		}
		function handleChangeTenantButtonClick() {
			eventManager.emit("viewModel:showMessage", {
				type: ViewModelMessageType.info,
				title: translate("TenantsChoice"),
				text: translate("ChangeTenants"),
				dismissible: false,
				buttons: [{
					...new ViewModelMessageButton(ViewModelMessageButtonType.yes, void 0, void 0, "validate"),
					text: translate("Yes"),
					onClick() {
						changeTenant(applicationContext.tenantIdentifier);
					}
				}, {
					...new ViewModelMessageButton(ViewModelMessageButtonType.no, void 0, void 0, "close"),
					text: translate("No"),
					onClick() {}
				}]
			});
		}
		useComponentAutomationProperties();
		return {
			translate,
			popover,
			isAuthenticated,
			showTenants,
			headerText,
			fullName,
			tenants,
			email,
			initial,
			handleUserButtonClick,
			handleActionButtonClick,
			handleChangeTenantButtonClick,
			handleLogoutButtonClick
		};
	}
});
//#endregion
//#region src/components/UserButton/UserButton.vue
var _hoisted_1$3 = ["tooltip"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_Image = resolveComponent("Image");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_Divider = resolveComponent("Divider");
	const _component_Button = resolveComponent("Button");
	const _component_Popover = resolveComponent("Popover");
	return _ctx.isAuthenticated ? (openBlock(), createElementBlock("button", {
		key: 0,
		class: "user-button",
		tooltip: _ctx.fullName ?? _ctx.email,
		onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleUserButtonClick && _ctx.handleUserButtonClick(...args))
	}, [_ctx.initial ? (openBlock(), createBlock(_component_Text, {
		key: 0,
		size: "large"
	}, {
		default: withCtx(() => [createTextVNode(toDisplayString(_ctx.initial), 1)]),
		_: 1
	})) : (openBlock(), createBlock(_component_Image, {
		key: 1,
		name: "user",
		size: "large"
	})), createVNode(_component_Popover, {
		ref: "popover",
		class: "user-button-popover"
	}, {
		default: withCtx(() => [
			createVNode(_component_HorizontalLayout, { class: "user-button-header" }, {
				default: withCtx(() => [createVNode(_component_Text, { weight: "strong" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.headerText), 1)]),
					_: 1
				})]),
				_: 1
			}),
			createVNode(_component_HorizontalLayout, {
				class: "user-button-content",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(_component_Text, {
					class: "user-initial",
					weight: "strong",
					size: "extralarge"
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.initial), 1)]),
					_: 1
				}), createVNode(_component_VerticalLayout, { space: "none" }, {
					default: withCtx(() => [createVNode(_component_Text, {
						class: "user-full-name",
						weight: "strong"
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.fullName), 1)]),
						_: 1
					}), createVNode(_component_Text, {
						class: "user-email",
						style: { "font-size": "12px" }
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.email), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}),
			createVNode(_component_Divider),
			createVNode(_component_VerticalLayout, {
				space: "none",
				onClick: _ctx.handleActionButtonClick
			}, {
				default: withCtx(() => [
					renderSlot(_ctx.$slots, "default", {}, void 0, true),
					_ctx.showTenants ? (openBlock(), createBlock(_component_Button, {
						key: 0,
						label: _ctx.translate("TenantsChoice"),
						variant: "link",
						size: "small",
						icon: "homeGroup",
						class: "user-button-change-tenant-button",
						onClick: _ctx.handleChangeTenantButtonClick
					}, null, 8, ["label", "onClick"])) : createCommentVNode("", true),
					createVNode(_component_Button, {
						label: _ctx.translate("Logout"),
						variant: "link",
						size: "small",
						icon: "logout",
						class: "user-button-logout-button",
						onClick: _ctx.handleLogoutButtonClick
					}, null, 8, ["label", "onClick"])
				]),
				_: 3
			}, 8, ["onClick"])
		]),
		_: 3
	}, 512)], 8, _hoisted_1$3)) : createCommentVNode("", true);
}
var UserButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(UserButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$4], ["__scopeId", "data-v-7dfc5205"]]);
//#endregion
//#region src/components/ValidationMessage/ValidationMessage.vue
var ValidationMessage_default = /* @__PURE__ */ defineComponent({
	__name: "ValidationMessage",
	props: {
		propertyName: {},
		item: {}
	},
	setup(__props) {
		const { property, item, visible } = useViewModelProperty(__props);
		const { messageText, messageSeverity } = useValidationMessage(property, item);
		return (_ctx, _cache) => {
			return unref(visible) && unref(messageText) ? (openBlock(), createBlock(unref(InputMessage), {
				key: 0,
				text: unref(messageText),
				type: unref(messageSeverity)
			}, null, 8, ["text", "type"])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/ViewContainer/ViewContainer.ts?vue&type=script&src=true&lang.ts
var ViewContainer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ViewContainer",
	components: { FrameContent: FrameContent_default },
	props: { containerId: {
		type: String,
		default: void 0
	} },
	setup(props) {
		const mainViewName = inject("mainUIViewName");
		const initialRoute = inject("initialRoute", RouteInfo.empty);
		const initialNavigationOptions = inject("initialNavigationOptions", void 0);
		const framesManager = inject("framesManager", {});
		const currentFrame = computed(() => props.containerId ? framesManager.allFrames.find((t) => t.containerId === props.containerId) : framesManager.page);
		if (props.containerId) {
			const viewModel = useViewModel();
			watch(() => currentFrame.value?.viewModel, (frameViewModel) => {
				if (frameViewModel && props.containerId) viewModel.registerViewContainer(props.containerId, frameViewModel);
			});
		}
		if (__NEOS_STUDIO_VSCODE__) watchEffect(() => {
			if (currentFrame.value?.viewModel?.isIdleAfterInitialization) postMessageToVsCode({
				command: "frameTabInfo",
				icon: currentFrame.value.icon,
				title: currentFrame.value.title,
				hasChanges: currentFrame.value.hasChanges
			});
		});
		useComponentAutomationProperties();
		onMounted(() => {
			if (props.containerId) framesManager.registerViewContainer(props.containerId);
			else {
				const navigationOptions = initialNavigationOptions ?? initialRoute.toNavigationOptions(initialRoute.single ? void 0 : mainViewName);
				if (navigationOptions) {
					navigationOptions.onTarget(NavigationTarget.newFrame);
					navigationOptions.delegateToVsCode = false;
					framesManager.openFrame(navigationOptions);
				}
			}
		});
		onUnmounted(() => {
			if (props.containerId) framesManager.unregisterViewContainer(props.containerId);
		});
		return { currentFrame };
	}
});
//#endregion
//#region src/components/ViewContainer/ViewContainer.vue
var _hoisted_1$2 = { class: "neos-vertical-content" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_FrameContent = resolveComponent("FrameContent");
	return openBlock(), createElementBlock("div", _hoisted_1$2, [_ctx.currentFrame ? (openBlock(), createBlock(_component_FrameContent, {
		key: 0,
		frame: _ctx.currentFrame
	}, null, 8, ["frame"])) : createCommentVNode("", true)]);
}
var ViewContainer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ViewContainer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$3]]);
//#endregion
//#region src/components/ViewModelLoadDataOnScroll/ViewModelLoadDataOnScroll.vue
var ViewModelLoadDataOnScroll_default = /* @__PURE__ */ defineComponent({
	__name: "ViewModelLoadDataOnScroll",
	props: { direction: {} },
	setup(__props) {
		const viewModel = useViewModel();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(LoadDataOnScroll$1), {
				direction: __props.direction,
				"has-more-data": unref(viewModel).hasMoreData,
				"on-load": () => unref(viewModel).loadMoreData()
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"direction",
				"has-more-data",
				"on-load"
			]);
		};
	}
});
//#endregion
//#region src/composables/useApplicationResourceManager.ts
function provideApplicationResourceManager(applicationResourceManager) {
	provide("applicationResourceManager", applicationResourceManager);
	return applicationResourceManager;
}
function useApplicationResourceManager() {
	const applicationResourceManager = inject("applicationResourceManager");
	if (!applicationResourceManager) throw new Error("ApplicationResourceManager not provided");
	return applicationResourceManager;
}
//#endregion
//#region src/utils/format.ts
/**
* Checks if the input is a LocalizableString and returns its current translation.
* If the object is not translatable, returns the object which will be formatted via its native toString method.
*
* @param input - Any object.
* @returns a translated string if the object is a LocalizableString or the object instance.
*/
function format(localizator, input) {
	if (input instanceof Date) return defaultFormatDateTime(input);
	if (typeof input === "object") return localizator.translate(input);
	return input;
}
//#endregion
//#region src/composables/useFormat.ts
/**
* A composable that returns a function to format an input using the localizator.
* The returned function takes a string, number, boolean, Date, or a record of localized strings and returns a formatted string.
*/
function useFormat() {
	const localizator = useLocalizator();
	return (input) => format(localizator, input);
}
//#endregion
//#region src/utils/viewModelInspector.ts
/** Gets the vuejs component to which the element belongs */
function getVueComponentOwner(element) {
	const component = element.__vueParentComponent;
	if (component) return component;
	if (element.parentElement) return getVueComponentOwner(element.parentElement);
}
/**
* Gets the viewmodel contextual to the HTML element
*
* @param element - Html element
* @returns ViewModel found or undefined if the element is not in the context of a viewModel.
*/
function getViewModelOfElement(element) {
	let component = getVueComponentOwner(getViewModelElement(element));
	while (component) {
		const vm = component.setupState.mainViewModel ?? component.setupState.viewModel ?? component.provides["viewModel"];
		if (vm) return vm;
		component = component.parent;
	}
}
function getRootViewModelOfElement(element) {
	let viewModel = getViewModelOfElement(element);
	if (!viewModel) return;
	while (viewModel.parentViewModel) viewModel = viewModel.parentViewModel;
	return viewModel;
}
function getViewModelElement(element) {
	const tab = element.closest(".tab");
	if (tab) {
		const tabIndex = tab.getAttribute("data-tab-index");
		const tabItem = tab.closest(".tabs-container").querySelector(`.tab-item[data-tab-index="${tabIndex}"]`);
		if (tabItem && tabItem.firstElementChild) return getViewModelElement(tabItem.firstElementChild);
	}
	const datagrid = element.closest(".wj-flexgrid");
	if (datagrid) return datagrid;
	return element;
}
//#endregion
//#region src/debug/debugHelper.ts
var ComponentDebugger = class {
	/**
	* Gets the viewmodel contextual to the HTML element
	*
	* @param element - Html element
	* @returns ViewModel found or undefined if the element is not in the context of a viewModel.
	*/
	vm(element) {
		return getViewModelOfElement(element);
	}
	/**
	* Gets the root viewmodel contextual to the HTML element
	*
	* @param element - Html element
	* @returns ViewModel found or undefined if the element is not in the context of a viewModel.
	*/
	rootVm(element) {
		return getRootViewModelOfElement(element);
	}
	/** Flattening an object, useful to get a copy of the target of a proxy.*/
	toJS(object) {
		return { ...object };
	}
	/** Gets the vuejs component to which the element belongs */
	getComponentOwner(element) {
		return getVueComponentOwner(element);
	}
};
window.neos = new ComponentDebugger();
//#endregion
//#region src/directives/dragdrop.ts
var NeosDragdrop = {
	mounted(el, binding) {
		onMountedOrUpdated(el, binding);
	},
	updated(el, binding) {
		onMountedOrUpdated(el, binding);
	},
	beforeUpdate(el, binding) {
		onBeforeUpdateOrBeforeUnmount(el, binding);
	},
	beforeUnmount(el, binding) {
		onBeforeUpdateOrBeforeUnmount(el, binding);
	}
};
var currentDragInternalObject;
var counter = 0;
function onMountedOrUpdated(el, binding) {
	if (binding.arg === "draggable") toggleDraggableAttribute(el, binding.value);
	if (binding.arg === "data") addDragstartHandlerOnDataBinding(el, binding);
	if (binding.arg === "dragstart") addDragstartHandler(el, binding);
	if (binding.arg === "dragover") addDragoverHandler(el, binding);
	if (binding.arg === "dragenter") addDragenterHandler(el, binding);
	if (binding.arg === "dragleave") addDragleaveHandler(el, binding);
	if (binding.arg === "dragend") addDragendHandler(el, binding);
	if (binding.arg === "drop") addDropHandler(el, binding);
}
function onBeforeUpdateOrBeforeUnmount(el, binding) {
	if (binding.arg === "data" || binding.arg === "dragstart") removeDragDropEventListener(el, "dragstart");
	if (binding.arg === "dragover") removeDragDropEventListener(el, "dragover");
	if (binding.arg === "dragenter") removeDragDropEventListener(el, "dragenter");
	if (binding.arg === "dragleave") removeDragDropEventListener(el, "dragleave");
	if (binding.arg === "dragend") removeDragDropEventListener(el, "dragend");
	if (binding.arg === "drop") removeDragDropEventListener(el, "drop");
}
function addDragstartHandlerOnDataBinding(el, binding) {
	addDragDropEventListener(el, "dragstart", (event) => {
		if (event.dataTransfer && typeof binding.value === "string") event.dataTransfer.setData("text/plain", binding.value);
		else currentDragInternalObject = binding.value;
	});
}
function addDragstartHandler(el, binding) {
	addDragDropEventListener(el, "dragstart", (event) => {
		if (isFunction(binding.value)) binding.value(buildDragStartArguments(event));
	});
}
function addDragoverHandler(el, binding) {
	addDragDropEventListener(el, "dragover", (event) => {
		if (isFunction(binding.value) && binding.value(buildDragArguments(event))) event.preventDefault();
	});
}
function addDragenterHandler(el, binding) {
	addDragDropEventListener(el, "dragenter", (event) => {
		if (counter === 0 && isFunction(binding.value)) binding.value(buildDragArguments(event));
		counter++;
	});
}
function addDragleaveHandler(el, binding) {
	addDragDropEventListener(el, "dragleave", (event) => {
		counter--;
		if (counter === 0 && isFunction(binding.value)) binding.value(buildDragArguments(event));
	});
}
function addDragendHandler(el, binding) {
	addDragDropEventListener(el, "dragend", (event) => {
		counter = 0;
		if (isFunction(binding.value)) binding.value(buildDragArguments(event));
	});
}
function addDropHandler(el, binding) {
	addDragDropEventListener(el, "drop", (event) => {
		counter = 0;
		if (isFunction(binding.value)) {
			event.preventDefault();
			binding.value(buildDropArguments(event));
		}
	});
}
function toggleDraggableAttribute(element, value) {
	element.setAttribute("draggable", value ? "true" : "false");
}
function addDragDropEventListener(el, name, handler) {
	const property = `__neos_${name}Handler`;
	el[property] = handler;
	el.addEventListener(name, handler);
}
function removeDragDropEventListener(el, name) {
	const property = `__neos_${name}Handler`;
	el.removeEventListener(name, el[property]);
	delete el[property];
}
function buildDragStartArguments(event) {
	return {
		setStringData(data) {
			event.dataTransfer?.setData("text/plain", data);
		},
		setInternalObjectData(data) {
			currentDragInternalObject = data;
		}
	};
}
function buildDragArguments(event) {
	return {
		getStringData() {
			if (event.dataTransfer) return event.dataTransfer.getData("text/plain") || void 0;
		},
		getInternalObjectData() {
			return currentDragInternalObject;
		},
		hasFiles() {
			if (event.dataTransfer) {
				for (const item of Array.from(event.dataTransfer.items)) if (item.kind === "file") return true;
			}
			return false;
		}
	};
}
function buildDropArguments(event) {
	return {
		...buildDragArguments(event),
		getFiles() {
			const files = ref([]);
			if (event.dataTransfer) {
				const apiClient = getViewModelOfElement(event.target)?.apiClient ?? getApiClient(void 0);
				for (const item of Array.from(event.dataTransfer.items)) {
					const file = item.getAsFile();
					if (file) files.value.push(FileReference.fromFile(apiClient, URL.createObjectURL(file), file.name, file.size));
				}
			}
			return files.value;
		}
	};
}
function isFunction(x) {
	return x instanceof Function;
}
//#endregion
//#region src/navigation/FrameWithComponent.ts
var FrameWithComponent = class extends Frame {
	get activeChildFrameIndex() {
		if (this.childMode === FrameDisplayMode.nestedTab) return this.selectedNestedTabIndex;
		if (this.childMode === FrameDisplayMode.stack) return this.children.length - 1;
		return -1;
	}
	get title() {
		if (this.childMode === FrameDisplayMode.stack) {
			const activeChildFrame = this.getActiveChildFrame();
			if (activeChildFrame) return activeChildFrame.title;
		}
		return super.title;
	}
	get loading() {
		return this.activated && (!this.ready || this.children.some((f) => f.loading));
	}
	get busy() {
		return this.loading || this.viewModel?.busy || this.children.some((f) => f.busy);
	}
	constructor(options, displayMode, component) {
		super(options, displayMode);
		this.selectedNestedTabIndex = -1;
		this.children = [];
		this.activated = true;
		this.containerId = options.containerId;
		this.component = component;
		this.activated = !options.startupTabMetadata;
	}
	setNestedTabIndex(index) {
		this.selectedNestedTabIndex = index;
	}
	getActiveChildFrame() {
		if (this.childMode) {
			const index = this.childMode === FrameDisplayMode.stack ? this.children.length - 1 : this.selectedNestedTabIndex;
			return this.children[index];
		}
	}
};
//#endregion
//#region src/navigation/FramesManager.ts
function getTabOrderGroup(frame) {
	if (!frame.closeable) return 0;
	return 1;
}
/** Represents the frames manager */
var FramesManager = class FramesManager {
	static {
		this.standardViews = [{
			name: "NeosReportViewerUI",
			component: () => import("./ReportViewerUI-B2QdT_e-.js"),
			openMode: OpenModeType.newFrame,
			popupPosition: PopupPosition.center
		}];
	}
	get allFrames() {
		return Array.from(this.framesProvidedByContainer).flatMap(([containerId, containerFrames]) => containerFrames.value.map((frame) => {
			frame.containerId = containerId;
			return frame;
		})).concat(this.frames);
	}
	/** Gets the tab frames */
	get tabs() {
		return this.allFrames.filter((f) => f.displayMode === FrameDisplayMode.tab);
	}
	/** Gets the popup frames */
	get popups() {
		return this.allFrames.filter((f) => f.displayMode === FrameDisplayMode.popup);
	}
	/** Gets the page frame */
	get page() {
		return this.allFrames.find((f) => f.displayMode === FrameDisplayMode.page);
	}
	/** Gets the background frames */
	get backgroundFrames() {
		return this.allFrames.filter((f) => f.displayMode === FrameDisplayMode.background);
	}
	get hasTabContainer() {
		return this.tabContainers.length > 0;
	}
	constructor(applicationContext, eventManager, globalResourceManager, uiPermitter, views, router, mainFramesContainerId) {
		this.frames = ref([]).value;
		this.viewModelNavigateHandler = this.handleViewModelNavigate.bind(this);
		this.viewModelCloseHandler = this.handleViewModelClose.bind(this);
		this.viewModelCurrentIdChangedHandler = this.handleViewModelCurrentIdChanged.bind(this);
		this.beforeUnloadHandler = this.handleBeforeUnload.bind(this);
		this.keydownHandler = this.handleKeydown.bind(this);
		this.eventHandlers = /* @__PURE__ */ new Map();
		this.tabContainers = [];
		this.viewContainers = [];
		this.framesProvidedByContainer = /* @__PURE__ */ new Map();
		this.shortcuts = /* @__PURE__ */ new Map();
		this.applicationContext = applicationContext;
		this.eventManager = eventManager;
		this.globalResourceManager = globalResourceManager;
		this.uiPermitter = uiPermitter;
		this.router = router;
		this.views = views;
		this.mainFramesContainerId = mainFramesContainerId;
		this.shortcuts.set(new ShortcutTrigger("E", true, true).toString(), () => this.handleOpenNeosStudioShortcut());
		this.shortcuts.set(new ShortcutTrigger("Y", true, true).toString(), () => this.handleOpenYamlEditorShortcut());
		this.eventManager.on("viewModel:navigate", this.viewModelNavigateHandler);
		this.eventManager.on("viewModel:close", this.viewModelCloseHandler);
		this.eventManager.on("viewModel:currentIdChanged", this.viewModelCurrentIdChangedHandler);
		window.addEventListener("beforeunload", this.beforeUnloadHandler);
		document.addEventListener("keydown", this.keydownHandler);
	}
	async handleViewModelNavigate(options) {
		if (!this.checkCanNavigate(options)) {
			options.callback?.(new NavigationResult(NavigationResultState.fail));
			this.eventManager.emit("viewModel:showError", new ViewModelError(this.globalResourceManager.get("AccessDenied_Title"), this.globalResourceManager.get("AccessDenied_Message")));
			return;
		}
		await this.openFrame(options);
	}
	handleViewModelClose(viewModel) {
		if (viewModel.ownerFrame) this.closeFrame(viewModel.ownerFrame);
	}
	handleViewModelCurrentIdChanged(viewModel) {
		if (this.activeTab && viewModel.ownerFrame && this.activeTab === viewModel.ownerFrame) this.router.pushFrame(this.activeTab, false);
	}
	/**
	* Subscribes to an event
	* @param eventName - the name of event
	* @param handler - the handler
	*/
	subscribe(eventName, handler) {
		let handlers = this.eventHandlers.get(eventName);
		if (!handlers) {
			handlers = [];
			this.eventHandlers.set(eventName, handlers);
		}
		handlers.push(handler);
	}
	/**
	* Unsubscribes to an event
	* @param eventName - the name of event
	* @param handler - the handler
	*/
	unSubscribe(eventName, handler) {
		const handlers = this.eventHandlers.get(eventName);
		if (handlers) remove(handlers, handler);
	}
	/**
	* Register a tabContainer component
	* @param tabContainerId
	*/
	registerTabContainer(tabContainerId) {
		this.tabContainers.push(tabContainerId);
	}
	/**
	* Unregister a tabContainer component
	* @param tabContainerId
	*/
	unregisterTabContainer(tabContainerId) {
		remove(this.tabContainers, tabContainerId);
	}
	/**
	* Register a viewContainer component
	* @param tabContainerId
	*/
	registerViewContainer(viewContainerId) {
		this.viewContainers.push(viewContainerId);
	}
	/**
	* Unregister a viewContainer component
	* @param viewContainerId
	*/
	unregisterViewContainer(viewContainerId) {
		remove(this.viewContainers, viewContainerId);
	}
	/** set array of frames provided by a frame container component. */
	setFramesProvidedByContainer(containerId, frames) {
		this.framesProvidedByContainer.set(containerId, frames);
	}
	/** unset array of frames provided by a frame container component. */
	unsetFramesProvidedByContainer(containerId) {
		this.framesProvidedByContainer.delete(containerId);
	}
	checkCanNavigate(options) {
		const remote = options.remote ?? options.callerRemote;
		const uiPermitter = remote ? findUIPermitter(remote) : this.uiPermitter;
		return !uiPermitter || uiPermitter.canNavigate(options);
	}
	/**
	* Opens a new frame.
	* @param options - Navigation options.
	*/
	async openFrame(options) {
		const remote = options.remote ?? options.callerRemote;
		const view = remote ? await this.getRemoteView(remote, options.uiViewName) : this.getView(options.uiViewName);
		this.overrideNavigationOptionsWithViewDefaultValues(options, view);
		if (this.delegateToVsCode(options)) return;
		if (options.remote && !view.remoteEntry) throw new Error(stringFormat(this.globalResourceManager.get("RemoteDoesNotExposeUIView"), remote, options.uiViewName));
		if (options.target === NavigationTarget.nestedFrame || options.target === NavigationTarget.sameFrame) return this.addChildFrame(options, view);
		return this.addFrame(options, view);
	}
	getView(uiViewName) {
		const view = this.views.default.find((v) => v.name === uiViewName) ?? FramesManager.standardViews.find((v) => v.name === uiViewName);
		if (!view) throw new Error(stringFormat(this.globalResourceManager.get("UIViewDoesNotExist"), uiViewName));
		return view;
	}
	delegateToVsCode(options) {
		if (__NEOS_STUDIO_VSCODE__ && options.target !== NavigationTarget.popup && options.delegateToVsCode) {
			const vsCodeOptions = {
				...options,
				filter: options.filter ? options.filter.convertToJSON() : null,
				parameters: {
					...options.parameters,
					...Object.fromEntries(options.parameters),
					id: options.parameters.id ? Object.fromEntries(options.parameters.id) : null
				}
			};
			vsCodeOptions.callback = void 0;
			vsCodeOptions.itemAddedCallback = void 0;
			vsCodeOptions.dataSavedCallback = void 0;
			postMessageToVsCode({
				command: "navigate",
				options: vsCodeOptions
			});
			return true;
		}
		return false;
	}
	async getRemoteView(remote, uiViewName) {
		const remoteViewsFn = this.views.remotes?.[remote];
		if (!remoteViewsFn) throw new Error(stringFormat(this.globalResourceManager.get("RemoteDoesNotExist"), remote));
		let views;
		try {
			views = await remoteViewsFn();
		} catch (error) {
			throw new Error(stringFormat(this.globalResourceManager.get("RemoteViewsImportError"), remote), { cause: error });
		}
		const view = views.default.find((v) => v.name === uiViewName);
		if (!view) throw new Error(stringFormat(this.globalResourceManager.get("RemoteDoesNotExposeUIView"), remote, uiViewName));
		return view;
	}
	addFrame(options, view) {
		const displayMode = this.getDisplayMode(options);
		let frame = this.findExistingFrame(options, displayMode);
		if (frame && displayMode === FrameDisplayMode.container) {
			remove(this.frames, frame);
			frame = void 0;
		}
		if (frame) this.updateExistingFrame(options, frame);
		else {
			frame = this.createFrame(view, options, displayMode, this.removeFrame.bind(this));
			const frames = this.getTargetFrameList(frame);
			if (frame.displayMode === FrameDisplayMode.page && this.page) remove(frames, this.page);
			if (frame.displayMode === FrameDisplayMode.tab) {
				const insertionIndex = this.getTabInsertionIndex(frames, frame);
				frames.splice(insertionIndex, 0, frame);
				frame = frames[insertionIndex];
			} else {
				frames.push(frame);
				frame = frames[frames.length - 1];
			}
			if (frame.displayMode === FrameDisplayMode.tab) this.on("frameAdded", frame);
		}
		return frame;
	}
	getTabInsertionIndex(frames, frame) {
		const frameOrderGroup = getTabOrderGroup(frame);
		const lastTabInSameOrPreviousGroupIndex = findLastIndex(frames, (existingFrame) => existingFrame.containerId === frame.containerId && getTabOrderGroup(existingFrame) <= frameOrderGroup);
		if (lastTabInSameOrPreviousGroupIndex !== -1) return lastTabInSameOrPreviousGroupIndex + 1;
		const firstTabIndex = frames.findIndex((existingFrame) => existingFrame.containerId === frame.containerId);
		if (firstTabIndex !== -1) return firstTabIndex;
		return frames.length;
	}
	addChildFrame(options, view) {
		const activeFrame = this.getActiveFrame(false);
		if (!activeFrame) return;
		const target = options.target;
		activeFrame.childMode ??= target === NavigationTarget.nestedFrame ? FrameDisplayMode.nestedTab : FrameDisplayMode.stack;
		let frame = this.findExistingChildFrame(activeFrame, options);
		if (frame) this.updateExistingFrame(options, frame);
		else {
			frame = this.createFrame(view, options, activeFrame.childMode, this.removeChildFrame.bind(this));
			activeFrame.children.push(frame);
		}
		if (activeFrame.childMode === FrameDisplayMode.nestedTab) activeFrame.selectedNestedTabIndex = activeFrame.children.indexOf(frame);
		return frame;
	}
	getDisplayMode(options) {
		if (options.containerId && this.viewContainers.includes(options.containerId)) return FrameDisplayMode.container;
		if (!this.hasTabContainer && options.target === NavigationTarget.newFrame) return FrameDisplayMode.page;
		if (options.target === NavigationTarget.popup) return FrameDisplayMode.popup;
		if (options.target === NavigationTarget.background) return FrameDisplayMode.background;
		return FrameDisplayMode.tab;
	}
	getTargetFrameList(newFrame) {
		if (newFrame.displayMode !== FrameDisplayMode.popup && newFrame.displayMode !== FrameDisplayMode.background) {
			if (newFrame.containerId) return this.framesProvidedByContainer.get(newFrame.containerId)?.value ?? this.frames;
			if (this.mainFramesContainerId) return this.framesProvidedByContainer.get(this.mainFramesContainerId)?.value ?? this.frames;
		}
		return this.frames;
	}
	canMoveTab(tab, targetTab) {
		return tab !== targetTab && tab.closeable === targetTab.closeable && this.getTargetFrameList(tab) === this.getTargetFrameList(targetTab);
	}
	moveTab(tab, targetTab) {
		if (!this.canMoveTab(tab, targetTab)) return false;
		const frames = this.getTargetFrameList(tab);
		const tabIndex = frames.indexOf(tab);
		const targetTabIndex = frames.indexOf(targetTab);
		frames.splice(tabIndex, 1);
		const offset = tabIndex < targetTabIndex ? 1 : 0;
		const insertionIndex = frames.indexOf(targetTab) + offset;
		frames.splice(insertionIndex, 0, tab);
		return true;
	}
	findExistingFrame(options, displayMode) {
		if (displayMode === FrameDisplayMode.container) return this.allFrames.find((f) => f.containerId === options.containerId);
		if (this.hasTabContainer && options.target === NavigationTarget.newFrame) return this.findOpenTab(this.tabs, options);
	}
	findExistingChildFrame(activeFrame, options) {
		if (activeFrame && activeFrame.childMode === FrameDisplayMode.nestedTab) return this.findOpenTab(activeFrame.children, options);
	}
	resolveMenuBasedTitle(options) {
		return recursiveFindMenuItem(this.applicationContext.menuItems ?? [], options.menuItemName)?.caption;
	}
	updateExistingFrame(options, existingFrame) {
		existingFrame.parameters = options.parameters;
		if (options.icon) existingFrame.icon = options.icon;
		if (options.closeable != null) existingFrame.closeable = options.closeable;
		if (existingFrame.displayMode === FrameDisplayMode.tab) this.on("selectTab", existingFrame);
	}
	createFrame(view, options, displayMode, removeFrame) {
		const frame = new FrameWithComponent(options, displayMode, markRaw(defineAsyncComponent({
			loader: view.component,
			onError: (error) => {
				if (error.message.startsWith("Failed to fetch dynamically imported module")) {
					if (removeFrame(frame)) {
						error.message = this.globalResourceManager.get(error.message.includes("remoteEntry.js") ? "RemoteViewImportError" : "ViewImportError");
						this.eventManager.emit("viewModel:showError", error);
					}
					return;
				}
				throw error;
			}
		})));
		if (!options.explicitTitle) frame.menuBasedTitle = this.resolveMenuBasedTitle(options);
		return frame;
	}
	closeFrame(frame) {
		if (frame.displayMode === FrameDisplayMode.nestedTab || frame.displayMode === FrameDisplayMode.stack) return this.removeChildFrame(frame);
		return this.removeFrame(frame);
	}
	removeFrame(frame) {
		const frames = this.getTargetFrameList(frame);
		const index = frames.indexOf(frame);
		if (index === -1) return false;
		this.on("frameRemoving", frame);
		frames.splice(index, 1);
		if (this.activeTab === frame) this.activeTab = void 0;
		return true;
	}
	removeChildFrame(frame) {
		const parentFrame = this.findParentFrame(frame);
		if (!parentFrame) return false;
		const index = parentFrame.children.indexOf(frame);
		if (parentFrame.childMode === FrameDisplayMode.nestedTab) parentFrame.selectedNestedTabIndex = this.setSelectedIndexBeforeRemove(parentFrame.selectedNestedTabIndex, index, parentFrame.children.length);
		this.on("frameRemoving", frame);
		parentFrame.children.splice(index, 1);
		if (parentFrame.children.length === 0) parentFrame.childMode = void 0;
		return true;
	}
	findParentFrame(childFrame) {
		for (const frame of this.allFrames) if (frame.children.includes(childFrame)) return frame;
	}
	/**
	* Closes the specified frame.
	* @param frame
	* @returns
	*/
	async closeFrameAsync(frame) {
		if (!frame.closeable) return false;
		for (const childFrame of [...frame.children].reverse()) if (!await this.closeFrameAsync(childFrame)) return false;
		if (frame.viewModel) return frame.viewModel.closeAsync(true, new NavigationResult(NavigationResultState.cancel));
		return this.closeFrame(frame);
	}
	setSelectedIndexBeforeRemove(selectedIndex, tabIndex, tabsCount) {
		if (tabIndex === selectedIndex) return Math.min(tabIndex, tabsCount - 2);
		if (tabIndex < selectedIndex) return selectedIndex - 1;
		return selectedIndex;
	}
	/**
	* Disposes this instances.
	*/
	dispose() {
		this.eventManager.off("viewModel:navigate", this.viewModelNavigateHandler);
		this.eventManager.off("viewModel:close", this.viewModelCloseHandler);
		this.eventManager.off("viewModel:currentIdChanged", this.viewModelCurrentIdChangedHandler);
		window.removeEventListener("beforeunload", this.beforeUnloadHandler);
		document.removeEventListener("keydown", this.keydownHandler);
	}
	on(eventName, frame) {
		const handlers = this.eventHandlers.get(eventName);
		if (handlers) handlers.forEach((h) => h(frame));
	}
	/** handle unload of browser */
	handleBeforeUnload(e) {
		if (this.allFrames.some((f) => f.hasChanges)) e.preventDefault();
	}
	getActiveFrame(includeChildFrames) {
		const frame = this.popups[this.popups.length - 1] ?? this.activeTab ?? this.page ?? this.frames[0];
		if (frame && includeChildFrames) return frame.getActiveChildFrame() ?? frame;
		return frame;
	}
	/** handle the keydown event for active frame */
	async handleKeydown(event) {
		const enterKeyActsAsTab = shouldHandleEnterKeyActsAsTab(event, this.applicationContext);
		if (!enterKeyActsAsTab && !ShortcutTrigger.isValid(event.key, event.ctrlKey, event.shiftKey, event.altKey)) return;
		if (this.getActiveFrame(true)?.viewModel?.waitingOverlayMessage) {
			event.preventDefault();
			event.stopImmediatePropagation();
			return;
		}
		if (enterKeyActsAsTab) {
			handleEnterKeyActsAsTab(event);
			return;
		}
		const keyboardShortcut = new ShortcutTrigger(event.key, event.ctrlKey, event.shiftKey, event.altKey).toString();
		if (this.executeViewModelActionShortcut(event, keyboardShortcut)) return;
		this.executeGlobalShortcut(event, keyboardShortcut);
	}
	executeViewModelActionShortcut(event, keyboardShortcut) {
		const viewModel = this.findActiveFrameViewModel(true);
		if (!viewModel) return false;
		const action = this.findViewModelActionByKeyboardShortcut(viewModel, keyboardShortcut);
		if (!action) return false;
		event.preventDefault();
		triggerChangeOnActiveInput();
		const item = viewModel.current;
		const items = viewModel.selectedItems;
		if (action.canBeRunByKeyboardShortcut(item, items)) {
			if (action.actionType === ViewModelActionType.none) this.toggleActionDropdown(viewModel, action);
			else action.run(item, items, event);
		}
		return true;
	}
	toggleActionDropdown(viewModel, action) {
		const buttons = document.querySelectorAll(`.action-button[data-action-name="${action.name}"] > button`);
		for (const button of buttons) if (getViewModelOfElement(button) === viewModel) {
			const event = new Event("click", { bubbles: true });
			Object.defineProperty(event, "currentTarget", { value: button });
			button.dispatchEvent(event);
			return;
		}
	}
	executeGlobalShortcut(event, keyboardShortcut) {
		const shortcut = this.shortcuts.get(keyboardShortcut);
		if (shortcut) {
			event.preventDefault();
			shortcut();
		}
	}
	findViewModelActionByKeyboardShortcut(viewModel, keyboardShortcut) {
		const action = viewModel.findActionByKeyboardShortcut(keyboardShortcut);
		if (action) return action;
		if (viewModel.parentViewModel) return this.findViewModelActionByKeyboardShortcut(viewModel.parentViewModel, keyboardShortcut);
		const containerViewModel = viewModel.ownerFrame?.containerFrame?.viewModel;
		if (containerViewModel) return this.findViewModelActionByKeyboardShortcut(containerViewModel, keyboardShortcut);
	}
	handleOpenNeosStudioShortcut() {
		if (this.applicationContext.editedCluster && this.applicationContext.editedCluster.name !== "DesignerNeos" || this.applicationContext.getValue("ClusterInProduction", false)) return;
		const viewModel = this.findActiveFrameViewModel(false);
		if (!viewModel) return;
		if (this.applicationContext.clusterName !== "DesignerNeos") {
			if (viewModel.getRemote()) return;
			if (this.applicationContext.getValue("vscode-extension", false)) {
				const navigationOptions = encodeURIComponent(JSON.stringify({ parameters: { id: { Name: viewModel.uiViewName } } }));
				window.open(`vscode://agis-neos.neosstudio/openUIView?clusterName=${this.applicationContext.clusterName}&clusterVersion=${this.applicationContext.clusterVersion}&uiViewName=UIViewUI&navigationOptions=${navigationOptions}`);
				return;
			}
			window.open(`${getBaseUrlWithoutTenant(this.applicationContext.tenantIdentifier)}/designer?ui=UIViewUI&id=Name:${viewModel.uiViewName}`);
		} else {
			const id = /* @__PURE__ */ new Map();
			id.set("Name", viewModel.uiViewName);
			navigate(this.eventManager, new NavigationOptions("UIViewUI").withId(id));
		}
	}
	handleOpenYamlEditorShortcut() {
		if (this.applicationContext.clusterName !== "DesignerNeos") return;
		const viewModel = this.findActiveFrameViewModel(false)?.mainViewModel;
		if (!viewModel?.entityViewName) return;
		const options = new NavigationOptions("NeosYamlEditorUI");
		options.delegateToVsCode = false;
		options.withParameter("SourceViewModel", viewModel);
		navigate(this.eventManager, options);
	}
	getActiveFrameViewModel() {
		return this.getActiveFrame(true)?.viewModel;
	}
	findActiveFrameViewModel(findByActiveElement) {
		let viewModel;
		if (findByActiveElement && document.activeElement) {
			if (document.activeElement.classList.contains("frame-tab")) return this.getActiveFrameViewModel();
			if (!this.isActiveElementOutsidePopup(document.activeElement)) viewModel = getViewModelOfElement(document.activeElement);
		}
		viewModel ??= this.getActiveFrameViewModel();
		const customModalViewModel = this.getCustomModalViewModel(viewModel);
		if (customModalViewModel) {
			if (customModalViewModel === viewModel) return;
			viewModel = customModalViewModel;
		}
		return viewModel;
	}
	/**
	* When a Neos popup is open, `document.activeElement` can briefly still point at an
	* element in the parent view (focus has not moved into the popup's DOM yet). In that
	* case, resolving the shortcut's view model from `activeElement` would wrongly target
	* the parent view instead of the popup. This returns true only when a popup is open
	* AND `activeElement` is outside that popup's DOM subtree.
	*/
	isActiveElementOutsidePopup(activeElement) {
		if (this.popups.length === 0) return false;
		const popupElements = document.querySelectorAll(".frame-popup");
		const activePopupElement = popupElements[popupElements.length - 1];
		if (!activePopupElement) return false;
		return activeElement.closest(".frame-popup") !== activePopupElement;
	}
	getCustomModalViewModel(viewModel) {
		const modals = document.querySelectorAll(".modal");
		const lastModal = modals[modals.length - 1];
		if (!lastModal || lastModal.classList.contains("frame-popup")) return;
		const lastModalBody = lastModal.querySelector(".modal-body");
		if (!lastModalBody?.firstElementChild) return viewModel;
		return getViewModelOfElement(lastModalBody.firstElementChild) ?? viewModel;
	}
	overrideNavigationOptionsWithViewDefaultValues(options, view) {
		options.popupPosition ??= view.popupPosition;
		options.originalTarget = options.target;
		if (options.target === NavigationTarget.default) switch (view.openMode) {
			case OpenModeType.popupFullSize:
				options.target = NavigationTarget.popup;
				options.popupSize = PopupSize.full;
				break;
			case OpenModeType.popupAutoSize:
				options.target = NavigationTarget.popup;
				options.popupSize = PopupSize.auto;
				break;
			case OpenModeType.nestedFrame:
				options.target = NavigationTarget.nestedFrame;
				break;
			case OpenModeType.sameFrame:
				options.target = NavigationTarget.sameFrame;
				break;
			default: options.target = NavigationTarget.newFrame;
		}
		if (options.target === NavigationTarget.newFrame && document.querySelector(".modal:not(.message-modal)") && !options.containerId) {
			options.target = NavigationTarget.popup;
			options.popupSize = PopupSize.full;
		}
	}
	findOpenTab(tabs, options) {
		return tabs.find((tab) => {
			if (options.uiViewName !== tab.uiViewName) return false;
			if (options.frameId || tab.id) return options.frameId === tab.id;
			if (!tab.viewModel) return this.checkUnicityOfTabWithoutViewModel(options, tab);
			if (options.parameters.id == null && tab.viewModel.currentId == null) return true;
			if (options.parameters.id == null || tab.viewModel.currentId == null) return false;
			return Router.isSameId(options.parameters.id, tab.viewModel.currentId);
		});
	}
	checkUnicityOfTabWithoutViewModel(options, tab) {
		if (tab.ready) return false;
		if (options.parameters.id && tab.parameters.id) return Router.isSameId(options.parameters.id, tab.parameters.id);
		return options.parameters.id == null && tab.parameters.id == null;
	}
};
//#endregion
//#region src/composables/useErrorReport.ts
function useErrorReport() {
	const applicationContext = useApplicationContext();
	const eventManager = useEventManager();
	const localizator = useLocalizator();
	const { globalResourceManager } = useGlobalResourceManager();
	const globalApiClient = useApiClient();
	const themeManager = useThemeManager();
	const apiClient = computed(() => {
		if (applicationContext.clusterName === "SupportCenter") return globalApiClient;
		if (!applicationContext.getValue("IsSupportCenterEnabled", false)) return;
		const supportCenterBaseUrl = `${getBaseUrlWithoutTenant(applicationContext.tenantIdentifier)}/support`;
		return new FetchApiClient(getApiClientBaseUrl(supportCenterBaseUrl), applicationContext, eventManager, globalResourceManager);
	});
	const canReportError = computed(() => !!apiClient.value);
	function getErrorReportPayload(error, stringifyJsonProperties, userAdditionalDetails) {
		const environmentDataJson = getEnvironmentDataJson();
		return {
			errorText: error.text,
			errorJson: stringifyJsonProperties ? JSON.stringify(error) : error,
			clusterName: applicationContext.clusterName,
			clusterVersion: applicationContext.clusterVersion,
			tenantIdentifier: applicationContext.tenantIdentifier,
			userAdditionalDetails,
			environmentDataJson: stringifyJsonProperties ? JSON.stringify(environmentDataJson) : environmentDataJson
		};
	}
	async function reportError(error, includeScreenshot, userAdditionalDetails) {
		try {
			const formData = new FormData();
			formData.append("payload", JSON.stringify(getErrorReportPayload(error, true, userAdditionalDetails)));
			if (includeScreenshot) {
				const screenshot = await captureScreenshot();
				if (screenshot) formData.append("screenshot", screenshot, `error-report-${Date.now()}.png`);
			}
			return (await apiClient.value.postAsync({
				path: "report-error",
				data: formData
			})).succeeded;
		} catch (error) {
			console.error(error);
			return false;
		}
	}
	function getEnvironmentDataJson() {
		const environment = {
			clusterInProduction: String(applicationContext.clusterInProduction),
			pageUrl: window.location.href,
			pageTitle: document.title,
			localizatorCurrentCulture: localizator.currentCulture,
			localizatorCurrentLanguage: localizator.currentLanguage,
			localizatorDefaultLanguage: localizator.defaultLanguage,
			localizatorLanguages: localizator.languages.join(", "),
			localizatorLocalizableStringCurrentLanguage: localizator.localizableStringCurrentLanguage,
			localizatorLocalizableStringDefaultLanguage: localizator.localizableStringDefaultLanguage,
			localizatorLocalizableStringLanguages: localizator.localizableStringLanguages.join(", "),
			localizatorLocalizableStringRequiredLanguage: localizator.localizableStringRequiredLanguage,
			themeName: themeManager.currentTheme.name,
			themeColorScheme: themeManager.currentTheme.colorScheme,
			utcDate: (/* @__PURE__ */ new Date()).toISOString(),
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			viewportWidth: String(window.innerWidth),
			viewportHeight: String(window.innerHeight),
			screenWidth: String(window.screen.width),
			screenHeight: String(window.screen.height),
			screenAvailableWidth: String(window.screen.availWidth),
			screenAvailableHeight: String(window.screen.availHeight),
			devicePixelRatio: String(window.devicePixelRatio),
			navigatorCookieEnabled: String(navigator.cookieEnabled),
			navigatorLanguage: navigator.language,
			navigatorLanguages: navigator.languages.join(", "),
			navigatorPlatform: navigator.platform,
			navigatorUserAgent: navigator.userAgent,
			navigatorVendor: navigator.vendor,
			navigatorWebdriver: String(navigator.webdriver)
		};
		if ("userAgentData" in navigator) {
			const userAgentData = navigator.userAgentData;
			environment.navigatorUserAgentDataBrands = userAgentData.brands.map((brand) => `${brand.brand} ${brand.version}`).join(", ");
			environment.navigatorUserAgentDataPlatform = userAgentData.platform;
			environment.navigatorUserAgentDataMobile = String(userAgentData.mobile);
		}
		if ("memory" in performance) {
			const memoryInfo = performance.memory;
			environment.memoryJsHeapSizeLimit = String(memoryInfo.jsHeapSizeLimit);
			environment.memoryUsedJsHeapSize = String(memoryInfo.usedJSHeapSize);
			environment.memoryTotalJsHeapSize = String(memoryInfo.totalJSHeapSize);
		}
		const applicationInsights = getApplicationInsights();
		if (applicationInsights) environment.applicationInsightsSessionId = applicationInsights.context.getSessionId();
		return environment;
	}
	return {
		canReportError,
		getErrorReportPayload,
		reportError
	};
}
async function captureScreenshot() {
	try {
		const { snapdom } = await import("@zumer/snapdom");
		return await snapdom.toBlob(document.body, {
			type: "png",
			filter(node) {
				return !(node instanceof HTMLElement) || !node.classList.contains("error-modal") && !node.classList.contains("p-dialog-mask");
			}
		});
	} catch (error) {
		console.error(error);
		return;
	}
}
//#endregion
//#region src/components/ErrorHandler/ErrorHandler.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = {
	key: 0,
	class: "error-report-preview-content"
};
var _hoisted_2$1 = { class: "text text-small error-report-preview" };
var _hoisted_3$1 = { key: 0 };
var _hoisted_4 = { key: 1 };
var _hoisted_5 = {
	key: 2,
	class: "error-modal-additional-data"
};
var ViewModelErrorModal = class {
	constructor(error) {
		this.error = error;
		this.hasErrors = error.errors !== void 0 && error.errors.length > 0;
		this.hasAdvancedErrors = error.advancedErrors !== void 0 && error.advancedErrors.length > 0;
		this.hasAdditionalData = error.additionalData !== void 0 && Object.keys(error.additionalData).length > 0;
		this.mustRefreshPage = error.additionalData?.Status === "401";
		this.hasDetails = !this.mustRefreshPage && (error.advancedText !== void 0 || this.hasAdvancedErrors || this.hasAdditionalData);
	}
	error;
	hasErrors;
	hasAdvancedErrors;
	hasAdditionalData;
	hasDetails;
	mustRefreshPage;
	detailsExpanded = navigator.webdriver;
	view = "error";
	reportState = "idle";
	reportConsent = false;
	reportIncludeScreenshot = false;
	reportUserAdditionalDetails = null;
	reportPreviewExpanded = false;
	get reportFieldsDisabled() {
		return this.reportState === "loading" || !this.reportConsent;
	}
};
//#endregion
//#region src/components/ErrorHandler/ErrorHandler.vue
var ErrorHandler_default = /* @__PURE__ */ defineComponent({
	__name: "ErrorHandler",
	setup(__props) {
		const applicationContext = useApplicationContext();
		const eventManager = useEventManager();
		const { globalResourceManager, translate } = useGlobalResourceManager();
		const modals = ref([]);
		const consoleLogger = new ConsoleLogger({ isDebugEnabled: applicationContext.debug });
		const { canReportError, getErrorReportPayload, reportError } = useErrorReport();
		eventManager.on("viewModel:showError", (err) => {
			if (err instanceof Error) {
				consoleLogger.errorException(err);
				err = createErrorViewModel(err);
			}
			showError(err);
		});
		onErrorCaptured((e) => {
			showError(createErrorViewModel(e));
			consoleLogger.errorException(e);
			return false;
		});
		window.addEventListener("unhandledrejection", (e) => {
			const error = e.reason;
			if (error.message.includes("Cannot read properties of null (reading 'nextSibling')")) {
				e.preventDefault();
				return;
			}
			showError(createErrorViewModel(error));
			consoleLogger.errorException(error);
		});
		/**
		* Creates an error view model from an error.
		* @param e Error.
		* @returns Error view model.
		*/
		function createErrorViewModel(e) {
			const apiError = e.apiError;
			let error;
			if (apiError) error = ViewModelError.fromApiError(globalResourceManager, apiError);
			else {
				const sessionId = getApplicationInsights()?.context.getSessionId();
				error = {
					title: translate("TechnicalErrorHasOccurred"),
					text: e.message,
					advancedText: applicationContext.clusterInProduction ? void 0 : e.stack,
					additionalData: navigator.webdriver ? {
						sessionId: sessionId ?? "No session ID",
						date: (/* @__PURE__ */ new Date()).toISOString()
					} : void 0
				};
			}
			if (e instanceof FetchError) {
				error.additionalData = {
					...error.additionalData,
					method: e.request.method,
					url: e.request.url
				};
				if (e.innerError) error.additionalData.error = e.innerError.message;
			}
			return error;
		}
		function showError(err) {
			modals.value.push(new ViewModelErrorModal(err));
		}
		function handleToggleDetailsButtonClick(modal) {
			if (modal.hasDetails && !modal.mustRefreshPage) modal.detailsExpanded = !modal.detailsExpanded;
		}
		function handleOkButtonClick(modal) {
			closeModal(modal);
		}
		function handleRefreshPageButtonClick() {
			location.reload();
		}
		function handleModalClose(modal) {
			closeModal(modal);
		}
		function handleOpenReportModal(modal) {
			if (modal.reportState === "failed") modal.reportState = "idle";
			modal.reportPreviewExpanded = false;
			modal.view = "report";
		}
		function handleReportBackButtonClick(modal) {
			modal.view = "error";
		}
		function handleReportPreviewToggle(modal) {
			modal.reportPreviewExpanded = !modal.reportPreviewExpanded;
		}
		async function handleSendReportButtonClick(modal) {
			modal.reportState = "loading";
			const succeeded = await reportError(modal.error, modal.reportIncludeScreenshot, modal.reportUserAdditionalDetails);
			modal.reportState = succeeded ? "sent" : "failed";
			if (succeeded) closeModal(modal);
		}
		function closeModal(modal) {
			modals.value = modals.value.filter((currentModal) => currentModal !== modal);
		}
		function getErrorReportPayloadPreview(modal) {
			return JSON.stringify(getErrorReportPayload(modal.error, false, modal.reportUserAdditionalDetails), null, 2);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [renderSlot(_ctx.$slots, "default"), (openBlock(true), createElementBlock(Fragment, null, renderList(modals.value, (modal, index) => {
				return openBlock(), createBlock(unref(Modal$1), {
					key: index,
					"is-open": true,
					class: "error-modal",
					maximizable: false,
					onClose: ($event) => handleModalClose(modal)
				}, {
					header: withCtx(() => [createVNode(unref(HorizontalLayout$1), { "vertical-align": "center" }, {
						default: withCtx(() => [createVNode(unref(Image$2), {
							title: modal.view === "error" && modal.hasDetails ? unref(translate)(modal.detailsExpanded ? "ClickToHideErrorDetails" : "ClickToSeeErrorDetails") : null,
							name: "danger",
							size: "large",
							class: normalizeClass(["error-modal-icon", { "error-modal-icon-clickable": modal.view === "error" && modal.hasDetails }]),
							onClick: ($event) => handleToggleDetailsButtonClick(modal)
						}, null, 8, [
							"title",
							"class",
							"onClick"
						]), createVNode(unref(Text$2), {
							class: "error-modal-title",
							size: "extralarge",
							weight: "strong"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(modal.view === "report" ? unref(translate)("ReportErrorModalTitle") : modal.error.title), 1)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]),
					body: withCtx(() => [modal.view === "report" ? (openBlock(), createBlock(unref(VerticalLayout$1), {
						key: 0,
						class: "error-report-modal-content neos-fill-parent-height"
					}, {
						default: withCtx(() => [
							createVNode(unref(Text$2), null, {
								default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("ErrorReportIncludeScreenshotText")), 1)]),
								_: 1
							}),
							createVNode(unref(VerticalLayout$1), { space: "small" }, {
								default: withCtx(() => [
									createVNode(unref(Checkbox), {
										modelValue: modal.reportConsent,
										"onUpdate:modelValue": ($event) => modal.reportConsent = $event,
										label: unref(translate)("ErrorReportConsentLabel"),
										disabled: modal.reportState === "loading",
										class: "error-report-consent-checkbox"
									}, null, 8, [
										"modelValue",
										"onUpdate:modelValue",
										"label",
										"disabled"
									]),
									createVNode(unref(Checkbox), {
										modelValue: modal.reportIncludeScreenshot,
										"onUpdate:modelValue": ($event) => modal.reportIncludeScreenshot = $event,
										label: unref(translate)("ErrorReportIncludeScreenshotLabel"),
										disabled: modal.reportFieldsDisabled,
										class: "error-report-screenshot-checkbox"
									}, null, 8, [
										"modelValue",
										"onUpdate:modelValue",
										"label",
										"disabled"
									]),
									createVNode(unref(Textbox$1), {
										modelValue: modal.reportUserAdditionalDetails,
										"onUpdate:modelValue": ($event) => modal.reportUserAdditionalDetails = $event,
										label: unref(translate)("ErrorReportUserAdditionalDetailsLabel"),
										placeholder: unref(translate)("ErrorReportUserAdditionalDetailsPlaceholder"),
										disabled: modal.reportFieldsDisabled,
										"multi-lines": true,
										rows: 4,
										class: "error-report-user-additional-details-textbox"
									}, null, 8, [
										"modelValue",
										"onUpdate:modelValue",
										"label",
										"placeholder",
										"disabled"
									])
								]),
								_: 2
							}, 1024),
							createVNode(unref(Button$1), {
								class: "error-report-preview-toggle neos-align-self-horizontal-left",
								size: "small",
								variant: "ghost-danger",
								label: unref(translate)(modal.reportPreviewExpanded ? "HideSentInformation" : "ShowSentInformation"),
								animated: "",
								onClick: ($event) => handleReportPreviewToggle(modal)
							}, null, 8, ["label", "onClick"]),
							modal.reportPreviewExpanded ? (openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("pre", _hoisted_2$1, toDisplayString(getErrorReportPayloadPreview(modal)), 1)])) : createCommentVNode("", true),
							modal.reportState === "failed" ? (openBlock(), createBlock(unref(Text$2), { key: 1 }, {
								default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("ErrorReportFailed")), 1)]),
								_: 1
							})) : createCommentVNode("", true)
						]),
						_: 2
					}, 1024)) : (openBlock(), createBlock(unref(VerticalLayout$1), {
						key: 1,
						class: "neos-fill-parent-height"
					}, {
						default: withCtx(() => [
							createVNode(unref(Text$2), { class: "error-modal-text" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(modal.error.text), 1)]),
								_: 2
							}, 1024),
							modal.hasErrors ? (openBlock(), createElementBlock("div", _hoisted_3$1, [(openBlock(true), createElementBlock(Fragment, null, renderList(modal.error.errors, (subError) => {
								return openBlock(), createElementBlock("div", { key: subError }, [createVNode(unref(Text$2), { class: "error-modal-text" }, {
									default: withCtx(() => [createTextVNode(toDisplayString(subError), 1)]),
									_: 2
								}, 1024)]);
							}), 128))])) : createCommentVNode("", true),
							withDirectives(createElementVNode("div", null, [
								modal.error.advancedText ? (openBlock(), createBlock(unref(Text$2), {
									key: 0,
									class: "error-modal-text"
								}, {
									default: withCtx(() => [createTextVNode(toDisplayString(modal.error.advancedText), 1)]),
									_: 2
								}, 1024)) : createCommentVNode("", true),
								modal.hasAdvancedErrors ? (openBlock(), createElementBlock("div", _hoisted_4, [(openBlock(true), createElementBlock(Fragment, null, renderList(modal.error.advancedErrors, (subError) => {
									return openBlock(), createElementBlock("div", { key: subError }, [createVNode(unref(Text$2), { class: "error-modal-text" }, {
										default: withCtx(() => [createTextVNode(toDisplayString(subError), 1)]),
										_: 2
									}, 1024)]);
								}), 128))])) : createCommentVNode("", true),
								modal.hasAdditionalData ? (openBlock(), createElementBlock("div", _hoisted_5, [createVNode(unref(Text$2), { weight: "strong" }, {
									default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("AdditionalData")), 1)]),
									_: 1
								}), (openBlock(true), createElementBlock(Fragment, null, renderList(modal.error.additionalData, (value, key) => {
									return openBlock(), createElementBlock("div", { key }, [createVNode(unref(Text$2), { size: "small" }, {
										default: withCtx(() => [createTextVNode(toDisplayString(key) + " : " + toDisplayString(value), 1)]),
										_: 2
									}, 1024)]);
								}), 128))])) : createCommentVNode("", true)
							], 512), [[vShow, modal.detailsExpanded]])
						]),
						_: 2
					}, 1024))]),
					footer: withCtx(() => [createVNode(unref(Divider$1)), createVNode(unref(ButtonsLayout$1), { class: "error-modal-buttons" }, {
						default: withCtx(() => [modal.view === "report" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(unref(Button$1), {
							class: "error-modal-button error-report-send-button",
							icon: "send",
							variant: "danger",
							label: unref(translate)(modal.reportState === "loading" ? "SendingErrorReport" : "Send"),
							animated: "",
							loading: modal.reportState === "loading",
							disabled: !modal.reportConsent || modal.reportState === "loading",
							focused: "",
							onClick: ($event) => handleSendReportButtonClick(modal)
						}, null, 8, [
							"label",
							"loading",
							"disabled",
							"onClick"
						]), createVNode(unref(Button$1), {
							class: "error-modal-button error-report-back-button",
							variant: "ghost-danger",
							label: unref(translate)("BackToError"),
							animated: "",
							disabled: modal.reportState === "loading",
							onClick: ($event) => handleReportBackButtonClick(modal)
						}, null, 8, [
							"label",
							"disabled",
							"onClick"
						])], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [modal.mustRefreshPage ? (openBlock(), createBlock(unref(Button$1), {
							key: 0,
							class: "error-modal-button error-modal-ok-button",
							icon: "refresh",
							label: unref(translate)("RefreshPage"),
							animated: "",
							focused: "",
							onClick: _cache[0] || (_cache[0] = ($event) => handleRefreshPageButtonClick())
						}, null, 8, ["label"])) : (openBlock(), createBlock(unref(Button$1), {
							key: 1,
							class: "error-modal-button error-modal-ok-button",
							icon: "validate",
							variant: "danger",
							label: unref(translate)("Ok"),
							animated: "",
							focused: "",
							onClick: ($event) => handleOkButtonClick(modal)
						}, null, 8, ["label", "onClick"])), unref(canReportError) && modal.hasDetails ? (openBlock(), createBlock(unref(Button$1), {
							key: 2,
							class: "error-modal-button error-modal-report-button",
							icon: "send",
							variant: "ghost-danger",
							label: unref(translate)("ReportError"),
							animated: "",
							onClick: ($event) => handleOpenReportModal(modal)
						}, null, 8, ["label", "onClick"])) : createCommentVNode("", true)], 64))]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, ["onClose"]);
			}), 128))], 64);
		};
	}
});
//#endregion
//#region src/components/ViewModelMessageHandler/ViewModelMessageHandler.ts?vue&type=script&src=true&lang.ts
var messageLineRegex = /^\d\d:\d\d:\d\d (?<type>(ERR|WRN|DBG)) /;
var ViewModelMessageHandler_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ViewModelMessageHandler",
	components: {
		Button: Button$1,
		Divider: Divider$1,
		HorizontalLayout: HorizontalLayout$1,
		Image: Image$2,
		Modal: Modal$1,
		ButtonsLayout: ButtonsLayout$1,
		Text: Text$2,
		Textbox: Textbox$1,
		VerticalLayout: VerticalLayout$1
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		const eventManager = useEventManager();
		const { isOpen, open, close } = useModal();
		const invalidValueMessageSeverity = "error";
		const message = ref({
			dismissible: true,
			text: "",
			title: "",
			type: ViewModelMessageType.info,
			buttons: []
		});
		const messageLines = computed(() => {
			return message.value.text.split(/[\r\n]{1,2}/g).map((t) => t.replace(/^$/, "\r\n"));
		});
		const invalidValueMessage = computed(() => message.value.input?.validateInput?.(message.value.input.value));
		useComponentAutomationProperties();
		eventManager.on("viewModel:showMessage", (msg) => {
			message.value.onDismiss?.();
			message.value = msg;
			open();
		});
		function getMessageLineStyle(index) {
			const line = messageLines.value[index];
			let color = void 0;
			const match = messageLineRegex.exec(line);
			if (match?.groups) switch (match.groups.type) {
				case "ERR":
					color = "var(--danger-600)";
					break;
				case "WRN":
					color = "var(--warning-600)";
					break;
				case "DBG": color = "var(--info-600)";
			}
			return { color };
		}
		function getButtonClass(index) {
			return index === 0 ? `message-modal-primary-button` : `message-modal-secondary-button`;
		}
		function closeMessage() {
			message.value.onDismiss?.();
		}
		function handleButtonClick(button) {
			button.onClick();
			close();
		}
		return {
			closeMessage,
			getButtonClass,
			getMessageLineStyle,
			handleButtonClick,
			invalidValueMessage,
			invalidValueMessageSeverity,
			isOpen,
			message,
			messageLines,
			translate
		};
	}
});
//#endregion
//#region src/components/ViewModelMessageHandler/ViewModelMessageHandler.vue
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_Divider = resolveComponent("Divider");
	const _component_Button = resolveComponent("Button");
	const _component_ButtonsLayout = resolveComponent("ButtonsLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createBlock(_component_Modal, {
		key: _ctx.message,
		"is-open": _ctx.isOpen,
		"onUpdate:isOpen": _cache[1] || (_cache[1] = ($event) => _ctx.isOpen = $event),
		class: normalizeClass(["message-modal", `message-modal-${_ctx.message.type}`]),
		size: "auto",
		dismissible: _ctx.message.dismissible,
		maximizable: false,
		onClose: _ctx.closeMessage
	}, {
		header: withCtx(() => [createVNode(_component_HorizontalLayout, { "vertical-align": "center" }, {
			default: withCtx(() => [createVNode(_component_Image, {
				name: _ctx.message.type,
				size: "large",
				class: "message-modal-icon"
			}, null, 8, ["name"]), createVNode(_component_Text, {
				class: "message-modal-title",
				size: "extralarge",
				weight: "strong"
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.message.title), 1)]),
				_: 1
			})]),
			_: 1
		})]),
		body: withCtx(() => [createVNode(_component_VerticalLayout, null, {
			default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.messageLines, (line, index) => {
				return openBlock(), createBlock(_component_Text, {
					key: index,
					class: "message-modal-text",
					style: normalizeStyle(_ctx.getMessageLineStyle(index))
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(line), 1)]),
					_: 2
				}, 1032, ["style"]);
			}), 128)), _ctx.message.input ? (openBlock(), createBlock(_component_Textbox, {
				key: 0,
				modelValue: _ctx.message.input.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.message.input.value = $event),
				focused: true,
				"message-text": _ctx.invalidValueMessage,
				"message-severity": _ctx.invalidValueMessageSeverity,
				"update-mode": "immediate",
				"data-message-modal-input": ""
			}, null, 8, [
				"modelValue",
				"message-text",
				"message-severity"
			])) : createCommentVNode("", true)]),
			_: 1
		})]),
		footer: withCtx(() => [createVNode(_component_Divider), createVNode(_component_ButtonsLayout, { class: "message-modal-buttons" }, {
			default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.message.buttons, (button, i) => {
				return openBlock(), createBlock(_component_Button, {
					key: button.text,
					class: normalizeClass(["message-modal-button", _ctx.getButtonClass(i)]),
					focused: button.autofocus,
					"data-type": button.type,
					label: button.text,
					animated: "",
					icon: button.icon,
					"data-custom-id": button.customId,
					disabled: button.isDisabled?.(_ctx.message.input?.value),
					onClick: ($event) => _ctx.handleButtonClick(button)
				}, null, 8, [
					"class",
					"focused",
					"data-type",
					"label",
					"icon",
					"data-custom-id",
					"disabled",
					"onClick"
				]);
			}), 128))]),
			_: 1
		})]),
		_: 1
	}, 8, [
		"is-open",
		"class",
		"dismissible",
		"onClose"
	]);
}
var ViewModelMessageHandler_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ViewModelMessageHandler_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$2]]);
//#endregion
//#region src/components/ViewModelSelectFileHandler/ViewModelSelectFileHandler.ts?vue&type=script&src=true&lang.ts
var ViewModelSelectFileHandler_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ViewModelSelectFileHandler",
	setup() {
		const { translate } = useGlobalResourceManager();
		const eventManager = useEventManager();
		const fileInput = ref();
		const fileSelection = ref();
		function isExpectedType(file) {
			if (fileSelection.value.types.length === 0) return true;
			const types = fileSelection.value.types.map((type) => type.toLowerCase());
			let parts = file.type.toLowerCase().split("/");
			if (parts.length === 2) {
				const [type, subtype] = parts;
				for (const acceptedType of types) {
					parts = acceptedType.split("/");
					if (parts.length !== 2) continue;
					const [expectedType, expectedSubtype] = parts;
					if (expectedType === type && (expectedSubtype === subtype || expectedSubtype === "*")) return true;
				}
			}
			const extIndex = file.name.lastIndexOf(".");
			if (extIndex !== -1) {
				const ext = file.name.substring(extIndex).toLowerCase();
				return types.some((type) => type === ext);
			}
			return false;
		}
		function showMessageAndCancel(text) {
			eventManager.emit("viewModel:showMessage", {
				type: ViewModelMessageType.danger,
				title: translate("ValidationError"),
				text,
				buttons: [{
					type: ViewModelMessageButtonType.ok,
					text: translate("ok"),
					onClick: () => {}
				}],
				dismissible: true
			});
			fileSelection.value.onCancel?.();
		}
		function byteConverter(bytes) {
			const K_UNIT = 1024;
			const SIZES = translate("FileSizes").split("|");
			const i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
			return `${Number.parseFloat((bytes / K_UNIT ** i).toFixed(2))} ${SIZES[i]}`;
		}
		function fileChanged() {
			if (fileInput.value.files?.length === 1) {
				const file = fileInput.value.files[0];
				if (!isExpectedType(file)) showMessageAndCancel(translate("WrongFileType"));
				else if (fileSelection.value.maxSize > 0 && file.size > fileSelection.value.maxSize) showMessageAndCancel(translate("FileTooLargeError", byteConverter(file.size), byteConverter(fileSelection.value.maxSize)));
				else {
					const objectURL = URL.createObjectURL(file);
					fileSelection.value.onOk(file.name, file.size, objectURL);
				}
			}
		}
		function cancelled() {
			fileSelection.value.onCancel?.();
		}
		const eventCallback = (args) => {
			fileInput.value.value = "";
			fileInput.value.accept = args.types.join(",");
			if (!navigator.webdriver) fileInput.value.click();
			fileSelection.value = args;
		};
		eventManager.on("viewModel:selectFile", eventCallback);
		onUnmounted(() => {
			eventManager.off("viewModel:selectFile", eventCallback);
		});
		return {
			fileInput,
			fileChanged,
			cancelled
		};
	}
});
//#endregion
//#region src/components/ViewModelSelectFileHandler/ViewModelSelectFileHandler.vue
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("input", {
		ref: "fileInput",
		class: "select-file-handler",
		type: "file",
		onChange: _cache[0] || (_cache[0] = (...args) => _ctx.fileChanged && _ctx.fileChanged(...args)),
		onCancel: _cache[1] || (_cache[1] = (...args) => _ctx.cancelled && _ctx.cancelled(...args))
	}, null, 544);
}
var ViewModelSelectFileHandler_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ViewModelSelectFileHandler_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$1], ["__scopeId", "data-v-51037927"]]);
//#endregion
//#region src/components/ViewModelToastHandler/ViewModelToastHandler.ts?vue&type=script&src=true&lang.ts
function mapMessageTypeToToastSeverity(type) {
	switch (type) {
		case ViewModelMessageType.positive: return "success";
		case ViewModelMessageType.warning: return "warn";
		case ViewModelMessageType.danger: return "error";
		default: return "info";
	}
}
var ViewModelToastHandler_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "ViewModelToastHandler",
	components: { Toast },
	setup() {
		const eventManager = useEventManager();
		const { add, remove } = useToast();
		eventManager.on("viewModel:showToast", (toast) => {
			if (__NEOS_STUDIO_VSCODE__) {
				postMessageToVsCode({
					command: "showToast",
					message: toast
				});
				return;
			}
			const toastInstance = add({
				buttons: toast.buttons.map((b) => ({
					...b,
					action: () => {
						b.action?.();
						remove(toastInstance);
					}
				})),
				dismissible: toast.dismissible,
				duration: toast.duration,
				severity: mapMessageTypeToToastSeverity(toast.type),
				text: toast.text,
				title: toast.title
			});
		});
		useComponentAutomationProperties();
	}
});
//#endregion
//#region src/components/ViewModelToastHandler/ViewModelToastHandler.vue
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Toast = resolveComponent("Toast");
	return openBlock(), createBlock(_component_Toast, { position: "bottom-right" });
}
var ViewModelToastHandler_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ViewModelToastHandler_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render]]);
//#endregion
//#region src/components/Application/Application.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["data-hasframecontainer"];
var _hoisted_2 = {
	key: 0,
	class: "application-content"
};
var _hoisted_3 = { key: 2 };
//#endregion
//#region src/components/Application/Application.vue
var Application_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Application",
	props: {
		title: {
			type: String,
			required: true
		},
		config: {
			type: Object,
			required: true
		}
	},
	setup(__props) {
		const props = __props;
		const mainViewName = inject("mainUIViewName");
		const initialRoute = inject("initialRoute", RouteInfo.empty);
		const framesManager = inject("framesManager", {});
		const applicationContext = useApplicationContext();
		const localizator = useLocalizator();
		const menuItems = ref(applicationContext.menuItems);
		const fullTitle = getFullTitle(props.title);
		document.title = fullTitle;
		const { updateUILocale } = useUILocale(localizator);
		const isStandardLayout = !initialRoute.single && mainViewName == null;
		updateUILocale();
		executeInitializationMethods(props.config);
		function getFullTitle(title) {
			const editedCluster = applicationContext.editedCluster;
			if (editedCluster && editedCluster.name !== "DesignerNeos") return `${title} (${editedCluster.title})`;
			return title;
		}
		function executeInitializationMethods(config) {
			for (const method of config.initializationMethods) method();
		}
		function closePopup(popup) {
			framesManager.closeFrameAsync(popup);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(ErrorHandler_default, null, {
				default: withCtx(() => [
					createElementVNode("div", {
						class: "application neos-vertical-content",
						"data-hasframecontainer": unref(isStandardLayout)
					}, [unref(isStandardLayout) ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(Sidebar_default, {
						title: unref(fullTitle),
						items: menuItems.value,
						"expanded-by-default": true
					}, null, 8, ["title", "items"]), createVNode(FramesContainer_default, { id: "main-frames-container" }, {
						actions: withCtx(() => [createVNode(GlobalSearchButton_default), createVNode(UserButton_default)]),
						_: 1
					})])) : (openBlock(), createBlock(ViewContainer_default, {
						key: 1,
						id: "main-view"
					}))], 8, _hoisted_1),
					(openBlock(true), createElementBlock(Fragment, null, renderList(unref(framesManager).popups, (popup) => {
						return openBlock(), createBlock(unref(Modal$1), {
							key: popup.guid,
							class: "frame-popup",
							"is-open": true,
							size: popup.popupSize,
							maximizable: popup.popupMaximizable,
							position: popup.popupPosition,
							"dismiss-on-click-outside": popup.closeableOnClickOutside,
							dismissible: popup.closeable,
							focus: false,
							onClose: ($event) => closePopup(popup)
						}, {
							header: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
								"vertical-align": "center",
								class: "frame-popup-header"
							}, {
								default: withCtx(() => [popup.busy ? (openBlock(), createBlock(unref(Spinner$1), {
									key: 0,
									class: "frame-popup-header-spinner"
								})) : popup.icon ? (openBlock(), createBlock(unref(Image$2), {
									key: 1,
									name: popup.icon
								}, null, 8, ["name"])) : createCommentVNode("", true), popup.title ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(popup.title), 1)) : createCommentVNode("", true)]),
								_: 2
							}, 1024), createVNode(unref(HorizontalLayout$1), {
								id: `modal-header-${popup.guid}`,
								class: "frame-popup-custom-header neos-fill-parent-width"
							}, null, 8, ["id"])]),
							body: withCtx(() => [createVNode(FrameContent_default, { frame: popup }, null, 8, ["frame"])]),
							footer: withCtx(() => [createVNode(unref(HorizontalLayout$1), {
								id: `modal-footer-${popup.guid}`,
								class: "frame-popup-custom-footer neos-fill-parent-width",
								align: "right"
							}, null, 8, ["id"])]),
							_: 2
						}, 1032, [
							"size",
							"maximizable",
							"position",
							"dismiss-on-click-outside",
							"dismissible",
							"onClose"
						]);
					}), 128)),
					(openBlock(true), createElementBlock(Fragment, null, renderList(unref(framesManager).backgroundFrames, (frame) => {
						return openBlock(), createBlock(FrameContent_default, {
							key: frame.guid,
							frame,
							style: { "display": "none" }
						}, null, 8, ["frame"]);
					}), 128)),
					createVNode(ViewModelMessageHandler_default),
					createVNode(ViewModelToastHandler_default),
					createVNode(ViewModelSelectFileHandler_default)
				]),
				_: 1
			});
		};
	}
}), [["__scopeId", "data-v-11b58df8"]]);
//#endregion
//#region src/startup/hmr.ts
/**
* Workaround to avoid reload when connection to server is lost
*/
function initializeHmr(hot) {
	if (!hot) return;
	hot.on("vite:beforeFullReload", (payload) => {
		payload.path = "foo.html";
	});
	if (!(new URLSearchParams(window.location.search).get("hotreload") !== "false")) {
		hot.on("vite:beforeUpdate", (payload) => {
			payload.updates = [];
		});
		hot.on("vite:ws:disconnect", () => {
			location["reload"] = () => {};
		});
	}
}
//#endregion
//#region src/startup/theme.ts
async function applyTheme(themeManager, currentThemeName) {
	if (window.parent === window) await applyThemeFromMainWindow(themeManager, currentThemeName);
	else await applyThemeFromParentWindow(themeManager, currentThemeName);
}
async function applyThemeFromMainWindow(themeManager, currentThemeName) {
	themeManager.changedEvent.add((theme) => {
		getGlobalLocalStorage().set("Neos_CurrentTheme", theme);
		for (const iframe of document.getElementsByTagName("iframe")) iframe.contentWindow.postMessage("ThemeChanged", window.origin);
	});
	if (__NEOS_STUDIO_VSCODE__) currentThemeName = getThemeForVsCode() ?? currentThemeName;
	await themeManager.setThemeByNameAsync(currentThemeName);
}
async function applyThemeFromParentWindow(themeManager, currentThemeName) {
	await applyThemeFromLocalStorage(themeManager, currentThemeName);
	window.addEventListener("message", async (event) => {
		if (event.origin === window.origin && event.data === "ThemeChanged") await applyThemeFromLocalStorage(themeManager, currentThemeName);
	});
}
async function applyThemeFromLocalStorage(themeManager, currentThemeName) {
	const parentTheme = getGlobalLocalStorage().findValue("Neos_CurrentTheme");
	if (parentTheme) await themeManager.setThemeAsync(parentTheme, parentTheme.cssContent);
	else await themeManager.setThemeByNameAsync(currentThemeName);
}
//#endregion
//#region src/startup/app.ts
async function createApp(config) {
	if (__NEOS_STUDIO_VSCODE__) initVsCodeOptions();
	initializeHmr(config.hotModuleReload);
	await initializeApplicationInsights();
	const applicationContext = initializeApplicationContext(config);
	const eventManager = configureEventManager();
	const localizator = configureLocalizator(config);
	const globalResourceManager = configureGlobalResourceManager(config.name);
	const applicationResourceManager = configureApplicationResourceManager(config);
	const apiClient = configureApiClient(config.name, getBaseUrl(), applicationContext, eventManager, globalResourceManager);
	const uiPermitter = configureUIPermitter(config.name, config.mainUIViewName);
	if (await authenticate(config, applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, uiPermitter)) {
		const notificationConnection = configureNotificationConnection(config, getBaseUrl());
		const themeManager = configureThemeManager(config);
		const customViewManager = configureCustomViewManager(eventManager, globalResourceManager, apiClient);
		await Promise.all([startNotificationConnection(notificationConnection, applicationContext, eventManager, globalResourceManager, apiClient, getBaseUrl()), applyTheme(themeManager, applicationContext.theme)]);
		customViewManager.initAsync(applicationContext.userCustomViewMode, applicationContext.userCanAssignDefaultCustomView);
		configureReactivity();
		configureWijmo$1();
		await initializeVueApp(config, applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, notificationConnection, uiPermitter, themeManager, customViewManager);
		if (__NEOS_STUDIO_VSCODE__) await initMonacoForVsCodeAsync();
	}
}
function initializeApplicationContext(config) {
	const applicationContext = configureApplicationContext(config);
	applicationContext.set("ClusterInProduction", config.production);
	applicationContext.set("UIDefaultBehavior", config.uiDefaultBehavior);
	applicationContext.set("MainUIViewName", config.mainUIViewName);
	if (applicationContext.uiDefaultBehavior.layoutOverflowFix != null) setLayoutOverflowFixOption(applicationContext.uiDefaultBehavior.layoutOverflowFix);
	applicationContext.appendSsoContext();
	if (__NEOS_STUDIO_VSCODE__) {
		applicationContext.addValue("IDE", "VsCode");
		initializeApiApplicationContext(applicationContext, globalThis.apiContext);
		window.addEventListener("message", (event) => {
			if (event.origin.startsWith("vscode-webview://") && event.data.command === "updateContext") updateApiContextValue(applicationContext, event);
		});
	}
	return applicationContext;
}
function updateApiContextValue(applicationContext, event) {
	const { key, value } = event.data;
	if (value === void 0) {
		applicationContext.delete(key);
		applicationContext.deleteApiContextValue(key);
	} else {
		applicationContext.set(key, value);
		applicationContext.setApiContextValue(key, value);
	}
}
async function initializeApiApplicationContext(applicationContext, values) {
	if (!values) return;
	for (const [key, value] of Object.entries(values)) applicationContext.setApiContextValue(key, value);
}
async function initializeVueApp(config, applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClient, notificationConnection, uiPermitter, themeManager, customViewManager) {
	const router = new Router(eventManager, config.mainUIViewName);
	const framesManager = new FramesManager(applicationContext, eventManager, globalResourceManager, uiPermitter, config.views, router, config.mainFramesContainerId);
	const initialRoute = router.createRouteInfoForVueApp();
	router.start();
	const urlSearchParams = new URLSearchParams(window.location.search);
	if (urlSearchParams.has("automation") || navigator.webdriver) {
		setAutomationMode();
		applicationContext.set("Automation", true);
	}
	const debug = urlSearchParams.get("debug");
	if (debug !== "n" && (!config.production || debug !== null)) applicationContext.set("Debug", true);
	if (urlSearchParams.has("vscode-extension")) applicationContext.set("vscode-extension", true);
	const app = createApp$1(Application_default, {
		title: `${config.title} ${config.version}`,
		config
	});
	app.use(plugin);
	app.provide("applicationContext", applicationContext);
	app.provide("eventManager", eventManager);
	app.provide("localizator", localizator);
	app.provide("globalResourceManager", globalResourceManager);
	app.provide("applicationResourceManager", applicationResourceManager);
	app.provide("apiClient", apiClient);
	app.provide("uiPermitter", uiPermitter);
	app.provide("themeManager", themeManager);
	app.provide("customViewManager", customViewManager);
	app.provide("framesManager", framesManager);
	app.provide("images", config.images);
	app.provide("initialRoute", initialRoute);
	app.provide("mainFramesContainerId", config.mainFramesContainerId);
	app.provide("notificationRegistryFactory", configureNotificationRegistryFactory(config, notificationConnection));
	app.provide("remotes", config.remotes);
	app.provide("router", router);
	if (__NEOS_STUDIO_VSCODE__) await provideForVsCode(app);
	else app.provide("mainUIViewName", config.mainUIViewName);
	app.mount("#app");
}
//#endregion
//#region src/composables/useRootElement.ts
function useRootElement() {
	const currentElement = useCurrentElement();
	return computed(() => {
		if (currentElement.value instanceof HTMLElement) return currentElement.value;
		if (currentElement.value instanceof Text) return currentElement.value.parentElement;
		return null;
	});
}
//#endregion
//#region src/startup/component.ts
/**
* Defines a UI component.
*
* @returns A Vue component.
*/
function defineUIComponent(config) {
	return defineComponent({
		name: config.name,
		components: config.components,
		directives: config.directives,
		inheritAttrs: false,
		props: { ...config.props },
		emits: getEmits(config.twoWayBoundParameters),
		setup(props, { emit }) {
			if (isAutomationMode()) {
				const rootElement = useRootElement();
				watch(rootElement, (element) => {
					element.__neosUIComponent = config.name;
				});
			}
			const parentViewModel = useViewModel();
			const applicationResourceManager = useApplicationResourceManager();
			const notificationRegistryFactory = useNotificationRegistryFactory();
			const viewModel = config.createViewModel({
				notifications: notificationRegistryFactory(),
				logger: new ConsoleLogger({
					name: config.name,
					isDebugEnabled: parentViewModel.logger.isDebugEnabled
				}),
				parentViewModel,
				wrapInstance: (instance) => ref(instance).value,
				getParameterValue: (name) => props[name],
				setParameterValue: (name, value) => {
					if (config.twoWayBoundParameters?.some((p) => p === name)) emit(`update:${name}`, value);
				}
			});
			viewModel.initAsync();
			onUnmounted(() => {
				viewModel.disposeAsync();
			});
			for (const parameter in viewModel.parameterChangedHandler) watch(() => props[parameter], (value, oldValue) => viewModel.onParameterChanged(parameter, value, oldValue));
			provideViewModel(viewModel.parentViewModel);
			return {
				viewModel,
				...config.unboundLookupDefinitions,
				format: format.bind(void 0, viewModel.localizator),
				applicationContext: viewModel.applicationContext,
				applicationResourceManager,
				device: ReactiveDevice.instance
			};
		}
	});
}
/**
* Gets the events that the UI component can emit.
* @param twoWayBoundParameters - Name of the two-way bound parameters of the UI component.
* @returns Emits.
*/
function getEmits(twoWayBoundParameters) {
	const emits = ["update:viewCreated", "update:viewReady"];
	if (twoWayBoundParameters) emits.push(...twoWayBoundParameters.map((p) => `update:${p}`));
	return emits;
}
//#endregion
//#region src/startup/mf/externalHost.ts
function configureExternalHost(app) {
	if (!app.config.globalProperties.$neos) app.use(plugin);
}
//#endregion
//#region src/startup/mf/remote.ts
var initializedRemotes = /* @__PURE__ */ new Set();
function configureRemote(remote, remoteConfig, parentApplicationContext, parentEventManager, parentThemeManager) {
	configureReactivity();
	configureWijmo$1();
	const configuredRemote = remote;
	configuredRemote.images = remoteConfig.images;
	configuredRemote.applicationContext = configureApplicationContext(remoteConfig, parentApplicationContext);
	configuredRemote.eventManager = parentEventManager ?? configureEventManager();
	configuredRemote.localizator = configureLocalizator(remoteConfig);
	configuredRemote.globalResourceManager = configureGlobalResourceManager(configuredRemote.name);
	configuredRemote.applicationResourceManager = configureApplicationResourceManager(remoteConfig);
	const tenantIdentifier = configuredRemote.applicationContext.tenantIdentifier;
	const baseUrlWithoutTenant = getRemoteBaseUrlWithoutTenant(remote, tenantIdentifier);
	configuredRemote.baseUrl = getRemoteBaseUrl(remote, tenantIdentifier, baseUrlWithoutTenant);
	configuredRemote.reportingBaseUrl = Reporting.getBaseUrl(configuredRemote.baseUrl);
	configuredRemote.apiClient = configureApiClient(configuredRemote.name, configuredRemote.baseUrl, configuredRemote.applicationContext, configuredRemote.eventManager, configuredRemote.globalResourceManager);
	configuredRemote.notificationConnection = configureNotificationConnection(remoteConfig, baseUrlWithoutTenant);
	configuredRemote.notificationRegistryFactory = configureNotificationRegistryFactory(remoteConfig, configuredRemote.notificationConnection);
	configuredRemote.themeManager = parentThemeManager ? void 0 : configureThemeManager(remoteConfig);
	configuredRemote.uiPermitter = configureUIPermitter(configuredRemote.name);
	configuredRemote.customViewManager = configureCustomViewManager(configuredRemote.eventManager, configuredRemote.globalResourceManager, configuredRemote.apiClient);
	return configuredRemote;
}
async function initRemote(remote) {
	if (initializedRemotes.has(remote.name)) return;
	if (!await loadContextAndPermissions(remote)) {
		initializedRemotes.add(remote.name);
		return;
	}
	await Promise.all([
		remote.globalResourceManager.load(remote.localizator),
		remote.applicationResourceManager.load(remote.localizator),
		startNotificationConnection(remote.notificationConnection, remote.applicationContext, remote.eventManager, remote.globalResourceManager, remote.apiClient, remote.baseUrl),
		remote.themeManager ? applyTheme(remote.themeManager, remote.applicationContext.theme) : void 0
	]);
	remote.customViewManager.initAsync(remote.applicationContext.userCustomViewMode, remote.applicationContext.userCanAssignDefaultCustomView);
	initializedRemotes.add(remote.name);
}
function getRemoteBaseUrlWithoutTenant(remote, tenantIdentifier) {
	if ("baseUrl" in remote) return remote.baseUrl;
	return `${getBaseUrlWithoutTenant(tenantIdentifier)}/${remote.prefix}`;
}
function getRemoteBaseUrl(remote, tenantIdentifier, baseUrlWithoutTenant) {
	if ("baseUrl" in remote) return remote.baseUrl;
	if (tenantIdentifier && remote.supportsMultiTenancy !== false) baseUrlWithoutTenant += `/${tenantIdentifier}`;
	return baseUrlWithoutTenant;
}
async function loadContextAndPermissions(remote) {
	const response = await remote.apiClient.postAsync({ path: "$neos/ui/on-authenticated" });
	if (response.succeeded && response.data.authorized) {
		initializeLocalizator(remote.localizator, response.data.applicationCulture, response.data.inputCultures);
		remote.apiClient.setAcceptLanguageHeader(remote.localizator.currentCulture);
		setContextInApplicationContext(remote.applicationContext, response.data.context, response.data.clientOnlyContext);
		if (remote.themeManager) setThemeInApplicationContext(remote.applicationContext, response.data.theme);
		remote.uiPermitter.init(response.data.permissions, response.data.serverMethods);
		return response.data.authorized;
	}
	remote.uiPermitter.init({}, []);
	return false;
}
//#endregion
//#region src/composables/useVsCodeSnapshot.ts
function useVsCodeSnapshot(viewModel) {
	if (viewModel.getOwnerFrame()?.displayMode === FrameDisplayMode.popup) return;
	async function handleMessage(event) {
		if (event.origin.startsWith("vscode-webview://")) {
			if (event.data.command === "ask-unload") postMessageToVsCode({
				command: "unload",
				snapshot: await viewModel.createSnapshot()
			});
			else if (event.data.command === "ask-snapshot") postMessageToVsCode({
				command: "snapshot",
				snapshot: await viewModel.createSnapshot()
			});
		}
	}
	window.addEventListener("message", handleMessage);
	onScopeDispose(() => {
		window.removeEventListener("message", handleMessage);
	});
	return popSnapshot();
}
function popSnapshot() {
	const global = globalThis;
	const vmSnapshot = global.vmSnapshot;
	if (!vmSnapshot) return;
	delete global.vmSnapshot;
	document.querySelector("#vm-snapshot-script")?.remove();
	return vmSnapshot;
}
//#endregion
//#region src/startup/focus.ts
var notBarParent = `.neos-input:not(.quick-search, .filter-bar-input-component, .filter-bar-input-component .neos-input, .pagination-records-by-page)`;
var enabledInput = `input:not([disabled], [readonly])`;
var enabledSelect = `.select:not([aria-disabled="true"])`;
var focusableElementsOnOpenSelectors = [
	`[autofocus]:not([disabled])`,
	`${notBarParent} ${enabledInput}, ${notBarParent} ${enabledSelect}`,
	`.neos-input ${enabledInput}, .neos-input ${enabledSelect}`,
	`button:not([disabled])`
];
var focusableElementsOnAddSelectors = [`${notBarParent} ${enabledInput}, ${notBarParent} ${enabledSelect}`, `.neos-input ${enabledInput}, .neos-input ${enabledSelect}`];
function useViewFocus(rootElement) {
	return {
		focusDefaultElementOnOpen: () => focusDefaultElementOnOpen(rootElement),
		focusDefaultElementOnAdd: (viewModel) => focusDefaultElementOnAdd(rootElement, viewModel)
	};
}
/**
* Focus the default element on opening.
*/
function focusDefaultElementOnOpen(rootElement) {
	if (rootElement.value && !isTouchDevice()) for (const selector of focusableElementsOnOpenSelectors) {
		const element = rootElement.value.querySelector(selector);
		if (element) {
			element.focus();
			return;
		}
	}
}
/**
* Focus the default element on add.
*/
function focusDefaultElementOnAdd(rootElement, viewModel) {
	if (!rootElement.value || isTouchDevice() || hasEditableDatagrid(rootElement.value, viewModel)) return;
	const focusableViewModels = getFocusableViewModels(viewModel);
	for (const selector of focusableElementsOnAddSelectors) {
		const focusableElements = Array.from(rootElement.value.querySelectorAll(selector));
		for (const element of focusableElements) {
			const elementViewModel = getViewModelOfElement(element);
			if (elementViewModel && focusableViewModels.includes(elementViewModel)) {
				element.focus();
				return;
			}
		}
	}
}
function hasEditableDatagrid(rootElement, viewModel) {
	return Array.from(rootElement.querySelectorAll(".datagrid[data-editable=\"true\"], .data-cards[data-editable=\"true\"]")).some((datagrid) => getViewModelOfElement(datagrid) === viewModel);
}
function getFocusableViewModels(viewModel) {
	const focusableViewModels = [viewModel];
	for (const subViewModel of viewModel.subViews) if (subViewModel.parentRelation.type === RelationType.editableReference) focusableViewModels.push(...getFocusableViewModels(subViewModel));
	return focusableViewModels;
}
//#endregion
//#region src/startup/view.ts
/**
* Creates a view model.
*
* @param viewModelConfig - View model configuration.
*/
function createViewModel(viewModelConfig) {
	return viewModelConfig.createViewModel({
		applicationContext: viewModelConfig.applicationContext,
		eventManager: viewModelConfig.eventManager,
		localizator: viewModelConfig.localizator,
		globalResourceManager: viewModelConfig.globalResourceManager,
		apiClient: viewModelConfig.apiClient,
		notifications: viewModelConfig.notifications,
		uiPermitter: viewModelConfig.uiPermitter,
		customViewManager: viewModelConfig.customViewManager,
		logger: new ConsoleLogger({
			name: viewModelConfig.loggerName,
			isDebugEnabled: viewModelConfig.applicationContext.debug
		}),
		resourceManager: new ResourceManager(viewModelConfig.importResources),
		wrapInstance: (instance) => ref(instance).value,
		frame: viewModelConfig.frame,
		remote: viewModelConfig.remote,
		id: viewModelConfig.id,
		parameters: viewModelConfig.parameters,
		rootViewModel: viewModelConfig.rootViewModel
	});
}
/**
* Creates the sub view models.
*
* @param viewModels - Exposed view models.
* @param initializations - Initializations.
* @param viewModel - Parent view model.
* @param subViewModelConfigs - Sub view model configs.
* @param apiClientFactory - API client factory.
* @param notificationRegistryFactory - Notification registry factory.
*/
function createSubViewModels(viewModels, resourcesLoadings, initializations, viewModel, subViewModelConfigs, apiClientFactory, notificationRegistryFactory) {
	for (const subViewModelConfig of subViewModelConfigs) {
		let subViewModel = viewModel.findSubViewModel(subViewModelConfig.relationName);
		if (!subViewModel) {
			subViewModel = createViewModel({
				...subViewModelConfig,
				applicationContext: viewModel.applicationContext,
				eventManager: viewModel.eventManager,
				localizator: viewModel.localizator,
				globalResourceManager: viewModel.globalResourceManager,
				apiClient: apiClientFactory(),
				notifications: notificationRegistryFactory(),
				uiPermitter: viewModel.uiPermitter,
				customViewManager: viewModel.customViewManager
			});
			viewModel.addSubViewModel(subViewModelConfig.relationName, subViewModel);
			resourcesLoadings.push(() => subViewModel.resourceManager.load(viewModel.localizator));
			initializations.push((preventLoadData) => subViewModel.initAsync(preventLoadData));
		}
		createSubViewModels(viewModels, resourcesLoadings, initializations, subViewModel, subViewModelConfig.subViewModels, apiClientFactory, notificationRegistryFactory);
		if (subViewModelConfig.name) viewModels.set(subViewModelConfig.name, subViewModel);
	}
}
/**
* Creates the nested view models.
*
* @param viewModels - Exposed view models.
* @param viewModel - Parent view model.
* @param nestedViewModelConfigs - Nested view model configs.
* @param apiClientFactory - API client factory.
* @param notificationRegistryFactory - Notification registry factory.
*/
function createNestedViewModels(viewModels, viewModel, nestedViewModelConfigs, apiClientFactory, notificationRegistryFactory) {
	const nestedViewModels = [];
	for (const nestedViewModelConfig of nestedViewModelConfigs) {
		const nestedViewModel = toRef(createViewModel({
			...nestedViewModelConfig,
			subViewModels: [],
			rootViewModel: viewModel,
			applicationContext: viewModel.applicationContext,
			eventManager: viewModel.eventManager,
			localizator: viewModel.localizator,
			globalResourceManager: viewModel.globalResourceManager,
			apiClient: apiClientFactory(),
			notifications: notificationRegistryFactory(),
			uiPermitter: viewModel.uiPermitter,
			customViewManager: viewModel.customViewManager
		}));
		viewModel.addNestedViewModel(nestedViewModelConfig.name, nestedViewModel);
		viewModels.set(nestedViewModelConfig.name, nestedViewModel.value);
		nestedViewModels.push(nestedViewModel.value);
	}
	return nestedViewModels;
}
/**
* Shares the datasource of a parent view model with a view model.
* @param viewModel View model that receives the shared datasource.
* @param parentViewModel Parent view model that shares its datasource.
* @param dataSharedWith Identifier of the shared view model.
*/
function setSharedDatasource(viewModel, parentViewModel, dataSharedWith) {
	let viewModelThatShares;
	if (dataSharedWith === "#Main") viewModelThatShares = parentViewModel;
	else if (dataSharedWith.startsWith("#Main")) {
		viewModelThatShares = parentViewModel;
		const relations = dataSharedWith.slice(6).split(".");
		for (const relation of relations) {
			viewModelThatShares = viewModelThatShares.findSubViewModel(relation);
			if (!viewModelThatShares) break;
		}
	} else viewModelThatShares = parentViewModel.findViewModelById(dataSharedWith);
	if (viewModelThatShares !== void 0) {
		viewModel.dataSharingManager.checkCoherence(viewModelThatShares);
		viewModelThatShares.shareDatasource(viewModel);
	}
}
function watchViewModelComputeds(viewModel) {
	if (viewModel.computedChangedEvent.handlers.length > 0 && !viewModel.isOnComputedChangedCallConfigured) {
		Object.getOwnPropertyNames(Object.getPrototypeOf(viewModel.computeds)).filter((c) => c !== "constructor").forEach((c) => {
			let oldValue = void 0;
			const onComputedChangedInProgress = [];
			watch(() => !viewModel.datasource.suspendsListChangedEvent && viewModel.computeds[c], (currentValue) => {
				if (!viewModel.datasource.suspendsListChangedEvent && !onComputedChangedInProgress.includes(c)) {
					onComputedChangedInProgress.push(c);
					try {
						viewModel.onComputedChanged(c, oldValue, currentValue);
					} finally {
						remove(onComputedChangedInProgress, c);
					}
					oldValue = currentValue;
				}
			}, { flush: "sync" });
		});
		viewModel.isOnComputedChangedCallConfigured = true;
	}
}
function useForEachViewModel(mainViewModel, nestedViewModels) {
	function forEachSubViewModel(viewModel, fn) {
		for (const subViewModel of viewModel.subViews) {
			fn(subViewModel);
			forEachSubViewModel(subViewModel, fn);
		}
	}
	return (fn) => {
		fn(mainViewModel);
		forEachSubViewModel(mainViewModel, fn);
		for (const nestedViewModel of nestedViewModels) fn(nestedViewModel);
	};
}
function getRemoteFromProps(props) {
	if (props.remote !== null && typeof props.remote === "object") return props.remote;
	const remoteName = typeof props.remote === "string" ? props.remote : props.frame?.remote;
	if (remoteName) {
		const remote = inject("remotes", []).find((r) => r.name === remoteName);
		if (!remote) throw new Error(`The remote application "${remoteName}" does not exist.`);
		return remote;
	}
}
function getConfigureRemote(viewName, props, remoteConfig) {
	if (props.viewModel) return props.viewModel.getRemote();
	const remote = getRemoteFromProps(props);
	if (remote) {
		if ("apiClient" in remote) return remote;
		if (!remoteConfig) throw new Error(`The view "${viewName}" is not exposed as entry of the remote application "${remote.name}"`);
		return configureRemote(remote, remoteConfig, useApplicationContext(false), useEventManager(false), useThemeManager(false));
	}
	return props.parentViewModel?.getRemote();
}
function getViewDependencies(remote) {
	let applicationContext;
	let eventManager;
	let localizator;
	let globalResourceManager;
	let applicationResourceManager;
	let apiClient;
	let notificationRegistryFactory;
	let uiPermitter;
	let customViewManager;
	if (remote) {
		provideImages(remote.images);
		if (remote.themeManager) provideThemeManager(remote.themeManager);
		applicationContext = provideApplicationContext(remote.applicationContext);
		eventManager = provideEventManager(remote.eventManager);
		localizator = provideLocalizator(remote.localizator);
		globalResourceManager = provideGlobalResourceManager(remote.globalResourceManager);
		applicationResourceManager = provideApplicationResourceManager(remote.applicationResourceManager);
		apiClient = provideApiClient(remote.apiClient);
		notificationRegistryFactory = provideNotificationRegistryFactory(remote.notificationRegistryFactory);
		uiPermitter = provideUIPermitter(remote.uiPermitter);
		customViewManager = provideCustomViewManager(remote.customViewManager);
	} else {
		applicationContext = useApplicationContext();
		eventManager = useEventManager();
		localizator = useLocalizator();
		globalResourceManager = useGlobalResourceManager().globalResourceManager;
		applicationResourceManager = useApplicationResourceManager();
		apiClient = useApiClient();
		notificationRegistryFactory = useNotificationRegistryFactory();
		uiPermitter = useUIPermitter();
		customViewManager = useCustomViewManager();
	}
	return {
		applicationContext,
		eventManager,
		localizator,
		globalResourceManager,
		applicationResourceManager,
		apiClientFactory: () => {
			const newApiClient = new FetchApiClient(apiClient.baseUrl, applicationContext, eventManager, globalResourceManager);
			newApiClient.setAcceptLanguageHeader(localizator.currentCulture);
			return newApiClient;
		},
		notificationRegistryFactory,
		uiPermitter,
		customViewManager
	};
}
/**
* Defines a UI view.
*
* @returns A Vue component.
*/
function defineUIView(config) {
	return defineComponent({
		name: config.name,
		components: config.components,
		directives: config.directives,
		inheritAttrs: false,
		props: {
			viewModel: {
				type: Object,
				default: void 0
			},
			frame: {
				type: Object,
				default: void 0
			},
			remote: {
				type: [String, Object],
				default: void 0
			},
			parameters: {
				type: Object,
				default: void 0
			},
			viewModelId: {
				type: String,
				default: void 0
			},
			parentViewModel: {
				type: Object,
				default: void 0
			},
			dataSharedWith: {
				type: String,
				default: void 0
			},
			visible: {
				type: Boolean,
				default: true
			}
		},
		emits: ["viewReady"],
		setup(props, { emit }) {
			const rootElement = useRootElement();
			const { focusDefaultElementOnOpen, focusDefaultElementOnAdd } = useViewFocus(rootElement);
			watch(rootElement, (element) => {
				mainViewModel.rootElement = element;
				if (element && isAutomationMode()) element.__neosUIView = config.name;
			});
			const viewModels = /* @__PURE__ */ new Map();
			const resourcesLoadings = [];
			const initializationsToStart = [];
			const remote = getConfigureRemote(config.name, props, config.remoteConfig);
			const { applicationContext, eventManager, localizator, globalResourceManager, applicationResourceManager, apiClientFactory, notificationRegistryFactory, uiPermitter, customViewManager } = getViewDependencies(remote);
			const mainViewModel = props.viewModel ?? createViewModel({
				...config.mainViewModel,
				applicationContext,
				eventManager,
				localizator,
				globalResourceManager,
				apiClient: apiClientFactory(),
				notifications: notificationRegistryFactory(),
				uiPermitter,
				customViewManager,
				frame: props.frame,
				remote,
				parameters: props.parameters,
				id: props.viewModelId,
				rootViewModel: props.parentViewModel
			});
			let snapshot;
			if (!props.viewModel) {
				if (props.parentViewModel) props.parentViewModel.addViewModel(mainViewModel, props.parameters == null);
				else if (__NEOS_STUDIO_VSCODE__) snapshot = useVsCodeSnapshot(mainViewModel);
				resourcesLoadings.push(() => mainViewModel.resourceManager.load(mainViewModel.localizator));
				initializationsToStart.push((preventLoadData) => mainViewModel.initAsync(preventLoadData));
			}
			viewModels.set(config.mainViewModel.name, mainViewModel);
			provideViewModel(mainViewModel);
			createSubViewModels(viewModels, resourcesLoadings, initializationsToStart, mainViewModel, config.mainViewModel.subViewModels, apiClientFactory, notificationRegistryFactory);
			const forEachViewModel = useForEachViewModel(mainViewModel, createNestedViewModels(viewModels, mainViewModel, config.nestedViewModels, apiClientFactory, notificationRegistryFactory));
			forEachViewModel((v) => watchViewModelComputeds(v));
			if (props.viewModel === void 0 && props.parentViewModel !== void 0 && props.dataSharedWith !== void 0) setSharedDatasource(mainViewModel, props.parentViewModel, props.dataSharedWith);
			initialize();
			async function initialize() {
				if (remote) await initRemote(remote);
				await Promise.all(resourcesLoadings.map((p) => p()));
				await Promise.all(initializationsToStart.map((p) => p(!!snapshot)));
				if (snapshot) await mainViewModel.applySnapshot(snapshot);
				if (props.viewModel) return;
				if (!props.parentViewModel) {
					emit("viewReady");
					const { trigger, stop } = watchTriggerable(() => mainViewModel.busy, () => {
						if (!mainViewModel.busy) {
							nextTick(focusDefaultElementOnOpen);
							stop();
						}
					});
					trigger();
				}
				forEachViewModel((v) => v.datasourceListChangedEvent.add(handleDatasourceChanged));
			}
			onUnmounted(() => {
				if (!props.viewModel) forEachViewModel((v) => {
					v.datasourceListChangedEvent.remove(handleDatasourceChanged);
					v.disposeAsync();
				});
				props.parentViewModel?.removeViewModel(mainViewModel);
			});
			function handleDatasourceChanged(viewModel, args) {
				if (args.type === ListChangedType.itemAdded) {
					const stop = watch(() => viewModel.busy, () => {
						nextTick(() => focusDefaultElementOnAdd(viewModel));
						stop();
					});
				}
			}
			return {
				...Object.fromEntries(viewModels),
				...config.unboundLookupDefinitions,
				format: (input) => format(localizator, input),
				applicationContext,
				applicationResourceManager,
				device: ReactiveDevice.instance,
				isDefaultLookupTemplate: mainViewModel.lookupContext?.templateMode === LookupTemplateMode.default
			};
		}
	});
}
//#endregion
export { ActionButton_default as ActionButton, ActionPanel_default as ActionPanel, Avatar, Badge, BooleanCombobox, BooleanFormField_default as BooleanFormField, BoundDocumentationButton_default as BoundDocumentationButton, BoundText_default as BoundText, Button, ButtonsLayout, Card, Carousel, Chart, Chip, ColorFormField_default as ColorFormField, ComponentDebugger, Context_default as Context, CustomViewButton_default as CustomViewButton, CustomViewPicker_default as CustomViewPicker, ResponsiveDatagrid_default as Datagrid, DateFormField_default as DateFormField, DateTimeFormField_default as DateTimeFormField, Divider, DocumentationButton, DynamicCheckbox, DynamicCombobox, EnumFormField_default as EnumFormField, FileFormField_default as FileFormField, FilterBar_default as FilterBar, FilterBuilder_default as FilterBuilder, FilterChips_default as FilterChips, FramesContainer_default as FramesContainer, FramesManager, GlobalSearchButton_default as GlobalSearchButton, GlobalSearchInput_default as GlobalSearchInput, GridLayout, GroupBox, Heading, HorizontalLayout, HtmlViewer, IdentifiedModal_default as IdentifiedModal, IdentifiedPopover_default as IdentifiedPopover, Image$1 as Image, ImageFormField_default as ImageFormField, InputColor, InputDate, InputDateTime, InputFile_default as InputFile, InputImage_default as InputImage, InputLocalizableString, InputMask, InputNumber, InputNumberCalculable, InputPassword, InputSliderDiscrete, InputTime, Label_default as Label, LoadDataOnScroll, LocalizableStringFormField_default as LocalizableStringFormField, Lookup_default as Lookup, LookupFormField_default as LookupFormField, LookupModal_default as LookupModal, MarkdownViewer, MaskFormField_default as MaskFormField, MenuButton_default as MenuButton, Message, MethodButton_default as MethodButton, Modal, MultiSelect, MultiSelectFormField_default as MultiSelectFormField, NeosAutomation, NeosDragdrop, NeosGrid, NeosLayout, NeosStyle, NeosTooltip, NumberCalculableFormField_default as NumberCalculableFormField, NumberFormField_default as NumberFormField, PaginationBar_default as PaginationBar, PasswordFormField_default as PasswordFormField, PopoverWithTarget, ProgressBar, QuickSearch_default as QuickSearch, ReportDesigner_default as ReportDesigner, ReportViewer_default as ReportViewer, Router, Sidebar_default as Sidebar, SliderDiscreteFormField_default as SliderDiscreteFormField, Spinner, Splitter, SplitterPanel, StringArrayFormField_default as StringArrayFormField, StringFormField_default as StringFormField, TabItem, Tabs, Text$1 as Text, Textbox, TimeFormField_default as TimeFormField, Timeline, ToggleOverlayButton_default as ToggleOverlayButton, Toolbar_default as Toolbar, TreeView, UserButton_default as UserButton, ValidationMessage_default as ValidationMessage, VerticalLayout, ViewContainer_default as ViewContainer, ViewModelLoadDataOnScroll_default as ViewModelLoadDataOnScroll, VirtualRepeat, WebView_default as WebView, configureExternalHost, configureRemote, createApp, defineUIComponent, defineUIView, getApplicationResourceManager, getSmartTranslateFunction, initRemote, useApplicationResourceManager, useFormField, useFormat, useViewModel, viewModelKey };

//# sourceMappingURL=app.js.map